(function () {
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}
function $parcel$exportWildcard(dest, source) {
  Object.keys(source).forEach(function(key) {
    if (key === 'default' || key === '__esModule' || dest.hasOwnProperty(key)) {
      return;
    }

    Object.defineProperty(dest, key, {
      enumerable: true,
      get: function get() {
        return source[key];
      }
    });
  });

  return dest;
}
var $parcel$global =
typeof globalThis !== 'undefined'
  ? globalThis
  : typeof self !== 'undefined'
  ? self
  : typeof window !== 'undefined'
  ? window
  : typeof global !== 'undefined'
  ? global
  : {};
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire99f6"];
if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire99f6"] = parcelRequire;
}
parcelRequire.register("31kbN", function(module, exports) {

var $aabtM = parcelRequire("aabtM");

var $eCXNS = parcelRequire("eCXNS");

var $7M9bt = parcelRequire("7M9bt");

var $5IDCd = parcelRequire("5IDCd");

var $8cFxo = parcelRequire("8cFxo");

var $1YTSz = parcelRequire("1YTSz");




/*!
  * Bootstrap base-component.js v5.3.2 (https://getbootstrap.com/)
  * Copyright 2011-2023 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory((parcelRequire("6wrqJ")), (parcelRequire("jYOfh")), (parcelRequire("2LdBZ")), (parcelRequire("c0GPz")));
})(undefined, function(Data, EventHandler, Config, index_js) {
    "use strict";
    /**
   * --------------------------------------------------------------------------
   * Bootstrap base-component.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ var VERSION = "5.3.2";
    /**
   * Class definition
   */ var BaseComponent = /*#__PURE__*/ function(Config) {
        (0, $5IDCd._)(BaseComponent, Config);
        var _super = (0, $1YTSz._)(BaseComponent);
        function BaseComponent(element, config) {
            (0, $eCXNS._)(this, BaseComponent);
            var _this;
            _this = _super.call(this);
            element = index_js.getElement(element);
            if (!element) return (0, $8cFxo._)(_this);
            _this._element = element;
            _this._config = _this._getConfig(config);
            Data.set(_this._element, _this.constructor.DATA_KEY, (0, $aabtM._)(_this));
            return _this;
        }
        (0, $7M9bt._)(BaseComponent, [
            {
                // Public
                key: "dispose",
                value: function dispose() {
                    Data.remove(this._element, this.constructor.DATA_KEY);
                    EventHandler.off(this._element, this.constructor.EVENT_KEY);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.getOwnPropertyNames(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var propertyName = _step.value;
                            this[propertyName] = null;
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            },
            {
                key: "_queueCallback",
                value: function _queueCallback(callback, element) {
                    var isAnimated = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                    index_js.executeAfterTransition(callback, element, isAnimated);
                }
            },
            {
                key: "_getConfig",
                value: function _getConfig(config) {
                    config = this._mergeConfigObj(config, this._element);
                    config = this._configAfterMerge(config);
                    this._typeCheckConfig(config);
                    return config;
                }
            }
        ], [
            {
                key: "getInstance",
                value: // Static
                function getInstance(element) {
                    return Data.get(index_js.getElement(element), this.DATA_KEY);
                }
            },
            {
                key: "getOrCreateInstance",
                value: function getOrCreateInstance(element) {
                    var config = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                    return this.getInstance(element) || new this(element, typeof config === "object" ? config : null);
                }
            },
            {
                key: "VERSION",
                get: function get() {
                    return VERSION;
                }
            },
            {
                key: "DATA_KEY",
                get: function get() {
                    return "bs.".concat(this.NAME);
                }
            },
            {
                key: "EVENT_KEY",
                get: function get() {
                    return ".".concat(this.DATA_KEY);
                }
            },
            {
                key: "eventName",
                value: function eventName(name) {
                    return "".concat(name).concat(this.EVENT_KEY);
                }
            }
        ]);
        return BaseComponent;
    }(Config);
    return BaseComponent;
});

});
parcelRequire.register("aabtM", function(module, exports) {

$parcel$export(module.exports, "_assert_this_initialized", function () { return $7663be19a9d89647$export$f3b8ed2e4a5d10b8; });
$parcel$export(module.exports, "_", function () { return $7663be19a9d89647$export$f3b8ed2e4a5d10b8; });
function $7663be19a9d89647$export$f3b8ed2e4a5d10b8(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}

});

parcelRequire.register("eCXNS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $aa63010954ffd74c$export$2996f80ef42b8419; });
function $aa63010954ffd74c$export$2996f80ef42b8419(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRequire.register("7M9bt", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $5a9423d6bdf9478a$export$d60067ff2358eee8; });
function $5a9423d6bdf9478a$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $5a9423d6bdf9478a$export$d60067ff2358eee8(Constructor, protoProps, staticProps) {
    if (protoProps) $5a9423d6bdf9478a$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $5a9423d6bdf9478a$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRequire.register("5IDCd", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $429fca99a37ce120$export$7e4530ad35d3bb8; });

var $cU6r8 = parcelRequire("cU6r8");
function $429fca99a37ce120$export$7e4530ad35d3bb8(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $cU6r8._set_prototype_of)(subClass, superClass);
}

});
parcelRequire.register("cU6r8", function(module, exports) {

$parcel$export(module.exports, "_set_prototype_of", function () { return $964fb531acf43ca5$export$c2c98ac76e997b63; });
function $964fb531acf43ca5$export$c2c98ac76e997b63(o, p) {
    $964fb531acf43ca5$export$c2c98ac76e997b63 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $964fb531acf43ca5$export$c2c98ac76e997b63(o, p);
}

});


parcelRequire.register("8cFxo", function(module, exports) {

$parcel$export(module.exports, "_possible_constructor_return", function () { return $5f8faa38aa7bcc75$export$ef97c660ca164e52; });
$parcel$export(module.exports, "_", function () { return $5f8faa38aa7bcc75$export$ef97c660ca164e52; });

var $aabtM = parcelRequire("aabtM");

var $22yUM = parcelRequire("22yUM");
function $5f8faa38aa7bcc75$export$ef97c660ca164e52(self, call) {
    if (call && ((0, $22yUM._type_of)(call) === "object" || typeof call === "function")) return call;
    return (0, $aabtM._assert_this_initialized)(self);
}

});
parcelRequire.register("22yUM", function(module, exports) {

$parcel$export(module.exports, "_type_of", function () { return $17c6da0aa640e82f$export$5f0017c582d45a2d; });
$parcel$export(module.exports, "_", function () { return $17c6da0aa640e82f$export$5f0017c582d45a2d; });
function $17c6da0aa640e82f$export$5f0017c582d45a2d(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});


parcelRequire.register("1YTSz", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1716bd7742cbe825$export$8dd05c13f5255580; });

var $hzVoy = parcelRequire("hzVoy");

var $wppeX = parcelRequire("wppeX");

var $8cFxo = parcelRequire("8cFxo");
function $1716bd7742cbe825$export$8dd05c13f5255580(Derived) {
    var hasNativeReflectConstruct = (0, $wppeX._is_native_reflect_construct)();
    return function _createSuperInternal() {
        var Super = (0, $hzVoy._get_prototype_of)(Derived), result;
        if (hasNativeReflectConstruct) {
            var NewTarget = (0, $hzVoy._get_prototype_of)(this).constructor;
            result = Reflect.construct(Super, arguments, NewTarget);
        } else result = Super.apply(this, arguments);
        return (0, $8cFxo._possible_constructor_return)(this, result);
    };
}

});
parcelRequire.register("hzVoy", function(module, exports) {

$parcel$export(module.exports, "_get_prototype_of", function () { return $ccc23a021f1e6bc0$export$f09211a7d3c496a1; });
$parcel$export(module.exports, "_", function () { return $ccc23a021f1e6bc0$export$f09211a7d3c496a1; });
function $ccc23a021f1e6bc0$export$f09211a7d3c496a1(o) {
    $ccc23a021f1e6bc0$export$f09211a7d3c496a1 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $ccc23a021f1e6bc0$export$f09211a7d3c496a1(o);
}

});

parcelRequire.register("wppeX", function(module, exports) {

$parcel$export(module.exports, "_is_native_reflect_construct", function () { return $0616b26550fb407b$export$685354647fba1516; });
function $0616b26550fb407b$export$685354647fba1516() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}

});


parcelRequire.register("6wrqJ", function(module, exports) {
/*!
  * Bootstrap data.js v5.3.2 (https://getbootstrap.com/)
  * Copyright 2011-2023 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/data.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ var elementMap = new Map();
    var data = {
        set: function(element, key, instance) {
            if (!elementMap.has(element)) elementMap.set(element, new Map());
            var instanceMap = elementMap.get(element);
            // make it clear we only want one instance per element
            // can be removed later when multiple key/instances are fine to be used
            if (!instanceMap.has(key) && instanceMap.size !== 0) {
                // eslint-disable-next-line no-console
                console.error("Bootstrap doesn't allow more than one instance per element. Bound instance: ".concat(Array.from(instanceMap.keys())[0], "."));
                return;
            }
            instanceMap.set(key, instance);
        },
        get: function(element, key) {
            if (elementMap.has(element)) return elementMap.get(element).get(key) || null;
            return null;
        },
        remove: function(element, key) {
            if (!elementMap.has(element)) return;
            var instanceMap = elementMap.get(element);
            instanceMap.delete(key);
            // free up element references if there are no instances left for an element
            if (instanceMap.size === 0) elementMap.delete(element);
        }
    };
    return data;
});

});

parcelRequire.register("jYOfh", function(module, exports) {

var $iFZdg = parcelRequire("iFZdg");

/*!
  * Bootstrap event-handler.js v5.3.2 (https://getbootstrap.com/)
  * Copyright 2011-2023 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory((parcelRequire("c0GPz")));
})(undefined, function(index_js) {
    "use strict";
    var makeEventUid = /**
   * Private methods
   */ function makeEventUid(element, uid) {
        return uid && "".concat(uid, "::").concat(uidEvent++) || element.uidEvent || uidEvent++;
    };
    var getElementEvents = function getElementEvents(element) {
        var uid = makeEventUid(element);
        element.uidEvent = uid;
        eventRegistry[uid] = eventRegistry[uid] || {};
        return eventRegistry[uid];
    };
    var bootstrapHandler = function bootstrapHandler(element, fn) {
        return function handler(event) {
            hydrateObj(event, {
                delegateTarget: element
            });
            if (handler.oneOff) EventHandler.off(element, event.type, fn);
            return fn.apply(element, [
                event
            ]);
        };
    };
    var bootstrapDelegationHandler = function bootstrapDelegationHandler(element, selector, fn) {
        return function handler(event) {
            var domElements = element.querySelectorAll(selector);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            for(var target = event.target; target && target !== this; target = target.parentNode)try {
                for(var _iterator = domElements[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var domElement = _step.value;
                    if (domElement !== target) continue;
                    hydrateObj(event, {
                        delegateTarget: target
                    });
                    if (handler.oneOff) EventHandler.off(element, event.type, selector, fn);
                    return fn.apply(target, [
                        event
                    ]);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
    };
    var findHandler = function findHandler(events, callable) {
        var delegationSelector = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null;
        return Object.values(events).find(function(event) {
            return event.callable === callable && event.delegationSelector === delegationSelector;
        });
    };
    var normalizeParameters = function normalizeParameters(originalTypeEvent, handler, delegationFunction) {
        var isDelegated = typeof handler === "string";
        // TODO: tooltip passes `false` instead of selector, so we need to check
        var callable = isDelegated ? delegationFunction : handler || delegationFunction;
        var typeEvent = getTypeEvent(originalTypeEvent);
        if (!nativeEvents.has(typeEvent)) typeEvent = originalTypeEvent;
        return [
            isDelegated,
            callable,
            typeEvent
        ];
    };
    var addHandler = function addHandler(element, originalTypeEvent, handler, delegationFunction, oneOff) {
        if (typeof originalTypeEvent !== "string" || !element) return;
        var _normalizeParameters = (0, $iFZdg._)(normalizeParameters(originalTypeEvent, handler, delegationFunction), 3), isDelegated = _normalizeParameters[0], callable = _normalizeParameters[1], typeEvent = _normalizeParameters[2];
        // in case of mouseenter or mouseleave wrap the handler within a function that checks for its DOM position
        // this prevents the handler from being dispatched the same way as mouseover or mouseout does
        if (originalTypeEvent in customEvents) {
            var wrapFunction = function(fn) {
                return function wrapFunction(event) {
                    if (!event.relatedTarget || event.relatedTarget !== event.delegateTarget && !event.delegateTarget.contains(event.relatedTarget)) return fn.call(this, event);
                };
            };
            callable = wrapFunction(callable);
        }
        var events = getElementEvents(element);
        var handlers = events[typeEvent] || (events[typeEvent] = {});
        var previousFunction = findHandler(handlers, callable, isDelegated ? handler : null);
        if (previousFunction) {
            previousFunction.oneOff = previousFunction.oneOff && oneOff;
            return;
        }
        var uid = makeEventUid(callable, originalTypeEvent.replace(namespaceRegex, ""));
        var fn = isDelegated ? bootstrapDelegationHandler(element, handler, callable) : bootstrapHandler(element, callable);
        fn.delegationSelector = isDelegated ? handler : null;
        fn.callable = callable;
        fn.oneOff = oneOff;
        fn.uidEvent = uid;
        handlers[uid] = fn;
        element.addEventListener(typeEvent, fn, isDelegated);
    };
    var removeHandler = function removeHandler(element, events, typeEvent, handler, delegationSelector) {
        var fn = findHandler(events[typeEvent], handler, delegationSelector);
        if (!fn) return;
        element.removeEventListener(typeEvent, fn, Boolean(delegationSelector));
        delete events[typeEvent][fn.uidEvent];
    };
    var removeNamespacedHandlers = function removeNamespacedHandlers(element, events, typeEvent, namespace) {
        var storeElementEvent = events[typeEvent] || {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = Object.entries(storeElementEvent)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $iFZdg._)(_step.value, 2), handlerKey = _step_value[0], event = _step_value[1];
                if (handlerKey.includes(namespace)) removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    var getTypeEvent = function getTypeEvent(event) {
        // allow to get the native events from namespaced events ('click.bs.button' --> 'click')
        event = event.replace(stripNameRegex, "");
        return customEvents[event] || event;
    };
    var hydrateObj = function hydrateObj(obj) {
        var meta = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            var _loop = function() {
                var _step_value = (0, $iFZdg._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
                try {
                    obj[key] = value;
                } catch (_unused) {
                    Object.defineProperty(obj, key, {
                        configurable: true,
                        get: function() {
                            return value;
                        }
                    });
                }
            };
            for(var _iterator = Object.entries(meta)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return obj;
    };
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/event-handler.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ var namespaceRegex = /[^.]*(?=\..*)\.|.*/;
    var stripNameRegex = /\..*/;
    var stripUidRegex = /::\d+$/;
    var eventRegistry = {}; // Events storage
    var uidEvent = 1;
    var customEvents = {
        mouseenter: "mouseover",
        mouseleave: "mouseout"
    };
    var nativeEvents = new Set([
        "click",
        "dblclick",
        "mouseup",
        "mousedown",
        "contextmenu",
        "mousewheel",
        "DOMMouseScroll",
        "mouseover",
        "mouseout",
        "mousemove",
        "selectstart",
        "selectend",
        "keydown",
        "keypress",
        "keyup",
        "orientationchange",
        "touchstart",
        "touchmove",
        "touchend",
        "touchcancel",
        "pointerdown",
        "pointermove",
        "pointerup",
        "pointerleave",
        "pointercancel",
        "gesturestart",
        "gesturechange",
        "gestureend",
        "focus",
        "blur",
        "change",
        "reset",
        "select",
        "submit",
        "focusin",
        "focusout",
        "load",
        "unload",
        "beforeunload",
        "resize",
        "move",
        "DOMContentLoaded",
        "readystatechange",
        "error",
        "abort",
        "scroll"
    ]);
    var EventHandler = {
        on: function(element, event, handler, delegationFunction) {
            addHandler(element, event, handler, delegationFunction, false);
        },
        one: function(element, event, handler, delegationFunction) {
            addHandler(element, event, handler, delegationFunction, true);
        },
        off: function(element, originalTypeEvent, handler, delegationFunction) {
            if (typeof originalTypeEvent !== "string" || !element) return;
            var _normalizeParameters = (0, $iFZdg._)(normalizeParameters(originalTypeEvent, handler, delegationFunction), 3), isDelegated = _normalizeParameters[0], callable = _normalizeParameters[1], typeEvent = _normalizeParameters[2];
            var inNamespace = typeEvent !== originalTypeEvent;
            var events = getElementEvents(element);
            var storeElementEvent = events[typeEvent] || {};
            var isNamespace = originalTypeEvent.startsWith(".");
            if (typeof callable !== "undefined") {
                // Simplest case: handler is passed, remove that listener ONLY.
                if (!Object.keys(storeElementEvent).length) return;
                removeHandler(element, events, typeEvent, callable, isDelegated ? handler : null);
                return;
            }
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            if (isNamespace) try {
                for(var _iterator = Object.keys(events)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var elementEvent = _step.value;
                    removeNamespacedHandlers(element, events, elementEvent, originalTypeEvent.slice(1));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                for(var _iterator1 = Object.entries(storeElementEvent)[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                    var _step_value = (0, $iFZdg._)(_step1.value, 2), keyHandlers = _step_value[0], event = _step_value[1];
                    var handlerKey = keyHandlers.replace(stripUidRegex, "");
                    if (!inNamespace || originalTypeEvent.includes(handlerKey)) removeHandler(element, events, typeEvent, event.callable, event.delegationSelector);
                }
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
        },
        trigger: function(element, event, args) {
            if (typeof event !== "string" || !element) return null;
            var $ = index_js.getjQuery();
            var typeEvent = getTypeEvent(event);
            var inNamespace = event !== typeEvent;
            var jQueryEvent = null;
            var bubbles = true;
            var nativeDispatch = true;
            var defaultPrevented = false;
            if (inNamespace && $) {
                jQueryEvent = $.Event(event, args);
                $(element).trigger(jQueryEvent);
                bubbles = !jQueryEvent.isPropagationStopped();
                nativeDispatch = !jQueryEvent.isImmediatePropagationStopped();
                defaultPrevented = jQueryEvent.isDefaultPrevented();
            }
            var evt = hydrateObj(new Event(event, {
                bubbles: bubbles,
                cancelable: true
            }), args);
            if (defaultPrevented) evt.preventDefault();
            if (nativeDispatch) element.dispatchEvent(evt);
            if (evt.defaultPrevented && jQueryEvent) jQueryEvent.preventDefault();
            return evt;
        }
    };
    return EventHandler;
});

});
parcelRequire.register("iFZdg", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d98b89efad01a571$export$fdf2a89c76341bbf; });

var $1SZ4G = parcelRequire("1SZ4G");

var $eXaIS = parcelRequire("eXaIS");

var $2XoEB = parcelRequire("2XoEB");

var $ghR52 = parcelRequire("ghR52");
function $d98b89efad01a571$export$fdf2a89c76341bbf(arr, i) {
    return (0, $1SZ4G._array_with_holes)(arr) || (0, $eXaIS._iterable_to_array_limit)(arr, i) || (0, $ghR52._unsupported_iterable_to_array)(arr, i) || (0, $2XoEB._non_iterable_rest)();
}

});
parcelRequire.register("1SZ4G", function(module, exports) {

$parcel$export(module.exports, "_array_with_holes", function () { return $15fa35b92343d82d$export$e6256bf45c68d561; });
function $15fa35b92343d82d$export$e6256bf45c68d561(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRequire.register("eXaIS", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array_limit", function () { return $ae2ee4b241bf08f3$export$2fd15edff6687200; });
function $ae2ee4b241bf08f3$export$2fd15edff6687200(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRequire.register("2XoEB", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_rest", function () { return $22743732e33643c8$export$60dbc22abd7da546; });
function $22743732e33643c8$export$60dbc22abd7da546() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRequire.register("ghR52", function(module, exports) {

$parcel$export(module.exports, "_unsupported_iterable_to_array", function () { return $bdb768849265fd3d$export$a5be06335b3a083c; });

var $2bDqK = parcelRequire("2bDqK");
function $bdb768849265fd3d$export$a5be06335b3a083c(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $2bDqK._array_like_to_array)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $2bDqK._array_like_to_array)(o, minLen);
}

});
parcelRequire.register("2bDqK", function(module, exports) {

$parcel$export(module.exports, "_array_like_to_array", function () { return $197b31e54e99ed29$export$79e617b1955a2616; });
function $197b31e54e99ed29$export$79e617b1955a2616(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRequire.register("c0GPz", function(module, exports) {

var $2b6Uo = parcelRequire("2b6Uo");
/*!
  * Bootstrap index.js v5.3.2 (https://getbootstrap.com/)
  * Copyright 2011-2023 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    factory(module.exports);
})(undefined, function(exports1) {
    "use strict";
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/index.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ var MAX_UID = 1000000;
    var MILLISECONDS_MULTIPLIER = 1000;
    var TRANSITION_END = "transitionend";
    /**
   * Properly escape IDs selectors to handle weird IDs
   * @param {string} selector
   * @returns {string}
   */ var parseSelector = function(selector) {
        if (selector && window.CSS && window.CSS.escape) // document.querySelector needs escaping to handle IDs (html5+) containing for instance /
        selector = selector.replace(/#([^\s"#']+)/g, function(match, id) {
            return "#".concat(CSS.escape(id));
        });
        return selector;
    };
    // Shout-out Angus Croll (https://goo.gl/pxwQGp)
    var toType = function(object) {
        if (object === null || object === undefined) return "".concat(object);
        return Object.prototype.toString.call(object).match(/\s([a-z]+)/i)[1].toLowerCase();
    };
    /**
   * Public Util API
   */ var getUID = function(prefix) {
        do prefix += Math.floor(Math.random() * MAX_UID);
        while (document.getElementById(prefix));
        return prefix;
    };
    var getTransitionDurationFromElement = function(element) {
        if (!element) return 0;
        // Get transition-duration of the element
        var _window_getComputedStyle = window.getComputedStyle(element), transitionDuration = _window_getComputedStyle.transitionDuration, transitionDelay = _window_getComputedStyle.transitionDelay;
        var floatTransitionDuration = Number.parseFloat(transitionDuration);
        var floatTransitionDelay = Number.parseFloat(transitionDelay);
        // Return 0 if element or transition duration is not found
        if (!floatTransitionDuration && !floatTransitionDelay) return 0;
        // If multiple durations are defined, take the first
        transitionDuration = transitionDuration.split(",")[0];
        transitionDelay = transitionDelay.split(",")[0];
        return (Number.parseFloat(transitionDuration) + Number.parseFloat(transitionDelay)) * MILLISECONDS_MULTIPLIER;
    };
    var triggerTransitionEnd = function(element) {
        element.dispatchEvent(new Event(TRANSITION_END));
    };
    var isElement = function(object) {
        if (!object || typeof object !== "object") return false;
        if (typeof object.jquery !== "undefined") object = object[0];
        return typeof object.nodeType !== "undefined";
    };
    var getElement = function(object) {
        // it's a jQuery object or a node element
        if (isElement(object)) return object.jquery ? object[0] : object;
        if (typeof object === "string" && object.length > 0) return document.querySelector(parseSelector(object));
        return null;
    };
    var isVisible = function(element) {
        if (!isElement(element) || element.getClientRects().length === 0) return false;
        var elementIsVisible = getComputedStyle(element).getPropertyValue("visibility") === "visible";
        // Handle `details` element as its content may falsie appear visible when it is closed
        var closedDetails = element.closest("details:not([open])");
        if (!closedDetails) return elementIsVisible;
        if (closedDetails !== element) {
            var summary = element.closest("summary");
            if (summary && summary.parentNode !== closedDetails) return false;
            if (summary === null) return false;
        }
        return elementIsVisible;
    };
    var isDisabled = function(element) {
        if (!element || element.nodeType !== Node.ELEMENT_NODE) return true;
        if (element.classList.contains("disabled")) return true;
        if (typeof element.disabled !== "undefined") return element.disabled;
        return element.hasAttribute("disabled") && element.getAttribute("disabled") !== "false";
    };
    var findShadowRoot = function(element) {
        if (!document.documentElement.attachShadow) return null;
        // Can find the shadow root otherwise it'll return the document
        if (typeof element.getRootNode === "function") {
            var root = element.getRootNode();
            return root instanceof ShadowRoot ? root : null;
        }
        if (element instanceof ShadowRoot) return element;
        // when we don't find a shadow root
        if (!element.parentNode) return null;
        return findShadowRoot(element.parentNode);
    };
    var noop = function() {};
    /**
   * Trick to restart an element's animation
   *
   * @param {HTMLElement} element
   * @return void
   *
   * @see https://www.charistheo.io/blog/2021/02/restart-a-css-animation-with-javascript/#restarting-a-css-animation
   */ var reflow = function(element) {
        element.offsetHeight; // eslint-disable-line no-unused-expressions
    };
    var getjQuery = function() {
        if (window.jQuery && !document.body.hasAttribute("data-bs-no-jquery")) return window.jQuery;
        return null;
    };
    var DOMContentLoadedCallbacks = [];
    var onDOMContentLoaded = function(callback) {
        if (document.readyState === "loading") {
            // add listener on the first call when the document is in loading state
            if (!DOMContentLoadedCallbacks.length) document.addEventListener("DOMContentLoaded", function() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = DOMContentLoadedCallbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _$callback = _step.value;
                        _$callback();
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            });
            DOMContentLoadedCallbacks.push(callback);
        } else callback();
    };
    var isRTL = function() {
        return document.documentElement.dir === "rtl";
    };
    var defineJQueryPlugin = function(plugin) {
        onDOMContentLoaded(function() {
            var $ = getjQuery();
            /* istanbul ignore if */ if ($) {
                var name = plugin.NAME;
                var JQUERY_NO_CONFLICT = $.fn[name];
                $.fn[name] = plugin.jQueryInterface;
                $.fn[name].Constructor = plugin;
                $.fn[name].noConflict = function() {
                    $.fn[name] = JQUERY_NO_CONFLICT;
                    return plugin.jQueryInterface;
                };
            }
        });
    };
    var execute = function(possibleCallback) {
        var args = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], defaultValue = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : possibleCallback;
        return typeof possibleCallback === "function" ? possibleCallback.apply(void 0, (0, $2b6Uo._)(args)) : defaultValue;
    };
    var executeAfterTransition = function(callback, transitionElement) {
        var waitForTransition = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
        if (!waitForTransition) {
            execute(callback);
            return;
        }
        var durationPadding = 5;
        var emulatedDuration = getTransitionDurationFromElement(transitionElement) + durationPadding;
        var called = false;
        var handler = function(param) {
            var target = param.target;
            if (target !== transitionElement) return;
            called = true;
            transitionElement.removeEventListener(TRANSITION_END, handler);
            execute(callback);
        };
        transitionElement.addEventListener(TRANSITION_END, handler);
        setTimeout(function() {
            if (!called) triggerTransitionEnd(transitionElement);
        }, emulatedDuration);
    };
    /**
   * Return the previous/next element of a list.
   *
   * @param {array} list    The list of elements
   * @param activeElement   The active element
   * @param shouldGetNext   Choose to get next or previous element
   * @param isCycleAllowed
   * @return {Element|elem} The proper element
   */ var getNextActiveElement = function(list, activeElement, shouldGetNext, isCycleAllowed) {
        var listLength = list.length;
        var index = list.indexOf(activeElement);
        // if the element does not exist in the list return an element
        // depending on the direction and if cycle is allowed
        if (index === -1) return !shouldGetNext && isCycleAllowed ? list[listLength - 1] : list[0];
        index += shouldGetNext ? 1 : -1;
        if (isCycleAllowed) index = (index + listLength) % listLength;
        return list[Math.max(0, Math.min(index, listLength - 1))];
    };
    exports1.defineJQueryPlugin = defineJQueryPlugin;
    exports1.execute = execute;
    exports1.executeAfterTransition = executeAfterTransition;
    exports1.findShadowRoot = findShadowRoot;
    exports1.getElement = getElement;
    exports1.getNextActiveElement = getNextActiveElement;
    exports1.getTransitionDurationFromElement = getTransitionDurationFromElement;
    exports1.getUID = getUID;
    exports1.getjQuery = getjQuery;
    exports1.isDisabled = isDisabled;
    exports1.isElement = isElement;
    exports1.isRTL = isRTL;
    exports1.isVisible = isVisible;
    exports1.noop = noop;
    exports1.onDOMContentLoaded = onDOMContentLoaded;
    exports1.parseSelector = parseSelector;
    exports1.reflow = reflow;
    exports1.toType = toType;
    exports1.triggerTransitionEnd = triggerTransitionEnd;
    Object.defineProperty(exports1, Symbol.toStringTag, {
        value: "Module"
    });
});

});
parcelRequire.register("2b6Uo", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1961f7bca441a4c6$export$1b5e630bc3aea29f; });

var $jWe67 = parcelRequire("jWe67");

var $f2mBX = parcelRequire("f2mBX");

var $2g5td = parcelRequire("2g5td");

var $ghR52 = parcelRequire("ghR52");
function $1961f7bca441a4c6$export$1b5e630bc3aea29f(arr) {
    return (0, $jWe67._array_without_holes)(arr) || (0, $f2mBX._iterable_to_array)(arr) || (0, $ghR52._unsupported_iterable_to_array)(arr) || (0, $2g5td._non_iterable_spread)();
}

});
parcelRequire.register("jWe67", function(module, exports) {

$parcel$export(module.exports, "_array_without_holes", function () { return $e83e5e97102e2c54$export$7e0947b5ad3404e2; });

var $2bDqK = parcelRequire("2bDqK");
function $e83e5e97102e2c54$export$7e0947b5ad3404e2(arr) {
    if (Array.isArray(arr)) return (0, $2bDqK._array_like_to_array)(arr);
}

});

parcelRequire.register("f2mBX", function(module, exports) {

$parcel$export(module.exports, "_iterable_to_array", function () { return $af28950850a78917$export$1eb58a6e75231000; });
function $af28950850a78917$export$1eb58a6e75231000(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});

parcelRequire.register("2g5td", function(module, exports) {

$parcel$export(module.exports, "_non_iterable_spread", function () { return $1a5151a9158d4e3a$export$e6f3c4780d19eb2b; });
function $1a5151a9158d4e3a$export$e6f3c4780d19eb2b() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});




parcelRequire.register("2LdBZ", function(module, exports) {

var $eCXNS = parcelRequire("eCXNS");

var $7M9bt = parcelRequire("7M9bt");

var $4udDG = parcelRequire("4udDG");

var $iFZdg = parcelRequire("iFZdg");


/*!
  * Bootstrap config.js v5.3.2 (https://getbootstrap.com/)
  * Copyright 2011-2023 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory((parcelRequire("jIYj0")), (parcelRequire("c0GPz")));
})(undefined, function(Manipulator, index_js) {
    "use strict";
    /**
   * --------------------------------------------------------------------------
   * Bootstrap util/config.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Class definition
   */ var Config = /*#__PURE__*/ function() {
        function Config() {
            (0, $eCXNS._)(this, Config);
        }
        (0, $7M9bt._)(Config, [
            {
                key: "_getConfig",
                value: function _getConfig(config) {
                    config = this._mergeConfigObj(config);
                    config = this._configAfterMerge(config);
                    this._typeCheckConfig(config);
                    return config;
                }
            },
            {
                key: "_configAfterMerge",
                value: function _configAfterMerge(config) {
                    return config;
                }
            },
            {
                key: "_mergeConfigObj",
                value: function _mergeConfigObj(config, element) {
                    var jsonConfig = index_js.isElement(element) ? Manipulator.getDataAttribute(element, "config") : {}; // try to parse
                    return (0, $4udDG._)({}, this.constructor.Default, typeof jsonConfig === "object" ? jsonConfig : {}, index_js.isElement(element) ? Manipulator.getDataAttributes(element) : {}, typeof config === "object" ? config : {});
                }
            },
            {
                key: "_typeCheckConfig",
                value: function _typeCheckConfig(config) {
                    var configTypes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.constructor.DefaultType;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.entries(configTypes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = (0, $iFZdg._)(_step.value, 2), property = _step_value[0], expectedTypes = _step_value[1];
                            var value = config[property];
                            var valueType = index_js.isElement(value) ? "element" : index_js.toType(value);
                            if (!new RegExp(expectedTypes).test(valueType)) throw new TypeError("".concat(this.constructor.NAME.toUpperCase(), ': Option "').concat(property, '" provided type "').concat(valueType, '" but expected type "').concat(expectedTypes, '".'));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            }
        ], [
            {
                key: "Default",
                get: // Getters
                function get() {
                    return {};
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return {};
                }
            },
            {
                key: "NAME",
                get: function get() {
                    throw new Error('You have to implement the static method "NAME", for each component!');
                }
            }
        ]);
        return Config;
    }();
    return Config;
});

});
parcelRequire.register("4udDG", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $34448b2f636abc71$export$581ff339ea0ba762; });

var $9HFeY = parcelRequire("9HFeY");
function $34448b2f636abc71$export$581ff339ea0ba762(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $9HFeY._define_property)(target, key, source[key]);
        });
    }
    return target;
}

});
parcelRequire.register("9HFeY", function(module, exports) {

$parcel$export(module.exports, "_define_property", function () { return $71081ebd7d211bed$export$1e71eb4bef00f6b0; });
$parcel$export(module.exports, "_", function () { return $71081ebd7d211bed$export$1e71eb4bef00f6b0; });
function $71081ebd7d211bed$export$1e71eb4bef00f6b0(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});


parcelRequire.register("jIYj0", function(module, exports) {
/*!
  * Bootstrap manipulator.js v5.3.2 (https://getbootstrap.com/)
  * Copyright 2011-2023 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory();
})(module.exports, function() {
    "use strict";
    var normalizeData = /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/manipulator.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ function normalizeData(value) {
        if (value === "true") return true;
        if (value === "false") return false;
        if (value === Number(value).toString()) return Number(value);
        if (value === "" || value === "null") return null;
        if (typeof value !== "string") return value;
        try {
            return JSON.parse(decodeURIComponent(value));
        } catch (_unused) {
            return value;
        }
    };
    var normalizeDataKey = function normalizeDataKey(key) {
        return key.replace(/[A-Z]/g, function(chr) {
            return "-".concat(chr.toLowerCase());
        });
    };
    var Manipulator = {
        setDataAttribute: function(element, key, value) {
            element.setAttribute("data-bs-".concat(normalizeDataKey(key)), value);
        },
        removeDataAttribute: function(element, key) {
            element.removeAttribute("data-bs-".concat(normalizeDataKey(key)));
        },
        getDataAttributes: function(element) {
            if (!element) return {};
            var attributes = {};
            var bsKeys = Object.keys(element.dataset).filter(function(key) {
                return key.startsWith("bs") && !key.startsWith("bsConfig");
            });
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = bsKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var key = _step.value;
                    var pureKey = key.replace(/^bs/, "");
                    pureKey = pureKey.charAt(0).toLowerCase() + pureKey.slice(1, pureKey.length);
                    attributes[pureKey] = normalizeData(element.dataset[key]);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return attributes;
        },
        getDataAttribute: function(element, key) {
            return normalizeData(element.getAttribute("data-bs-".concat(normalizeDataKey(key))));
        }
    };
    return Manipulator;
});

});



parcelRequire.register("4JvcO", function(module, exports) {

var $2b6Uo = parcelRequire("2b6Uo");

/*!
  * Bootstrap selector-engine.js v5.3.2 (https://getbootstrap.com/)
  * Copyright 2011-2023 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    module.exports = factory((parcelRequire("c0GPz")));
})(undefined, function(index_js) {
    "use strict";
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dom/selector-engine.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ var getSelector = function(element) {
        var selector = element.getAttribute("data-bs-target");
        if (!selector || selector === "#") {
            var hrefAttribute = element.getAttribute("href");
            // The only valid content that could double as a selector are IDs or classes,
            // so everything starting with `#` or `.`. If a "real" URL is used as the selector,
            // `document.querySelector` will rightfully complain it is invalid.
            // See https://github.com/twbs/bootstrap/issues/32273
            if (!hrefAttribute || !hrefAttribute.includes("#") && !hrefAttribute.startsWith(".")) return null;
            // Just in case some CMS puts out a full URL with the anchor appended
            if (hrefAttribute.includes("#") && !hrefAttribute.startsWith("#")) hrefAttribute = "#".concat(hrefAttribute.split("#")[1]);
            selector = hrefAttribute && hrefAttribute !== "#" ? index_js.parseSelector(hrefAttribute.trim()) : null;
        }
        return selector;
    };
    var SelectorEngine = {
        find: function(selector) {
            var element = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document.documentElement;
            var _instance;
            return (_instance = []).concat.apply(_instance, (0, $2b6Uo._)(Element.prototype.querySelectorAll.call(element, selector)));
        },
        findOne: function(selector) {
            var element = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : document.documentElement;
            return Element.prototype.querySelector.call(element, selector);
        },
        children: function(element, selector) {
            var _instance;
            return (_instance = []).concat.apply(_instance, (0, $2b6Uo._)(element.children)).filter(function(child) {
                return child.matches(selector);
            });
        },
        parents: function(element, selector) {
            var parents = [];
            var ancestor = element.parentNode.closest(selector);
            while(ancestor){
                parents.push(ancestor);
                ancestor = ancestor.parentNode.closest(selector);
            }
            return parents;
        },
        prev: function(element, selector) {
            var previous = element.previousElementSibling;
            while(previous){
                if (previous.matches(selector)) return [
                    previous
                ];
                previous = previous.previousElementSibling;
            }
            return [];
        },
        // TODO: this is now unused; remove later along with prev()
        next: function(element, selector) {
            var next = element.nextElementSibling;
            while(next){
                if (next.matches(selector)) return [
                    next
                ];
                next = next.nextElementSibling;
            }
            return [];
        },
        focusableChildren: function(element) {
            var focusables = [
                "a",
                "button",
                "input",
                "textarea",
                "select",
                "details",
                "[tabindex]",
                '[contenteditable="true"]'
            ].map(function(selector) {
                return "".concat(selector, ':not([tabindex^="-"])');
            }).join(",");
            return this.find(focusables, element).filter(function(el) {
                return !index_js.isDisabled(el) && index_js.isVisible(el);
            });
        },
        getSelectorFromElement: function(element) {
            var selector = getSelector(element);
            if (selector) return SelectorEngine.findOne(selector) ? selector : null;
            return null;
        },
        getElementFromSelector: function(element) {
            var selector = getSelector(element);
            return selector ? SelectorEngine.findOne(selector) : null;
        },
        getMultipleElementsFromSelector: function(element) {
            var selector = getSelector(element);
            return selector ? SelectorEngine.find(selector) : [];
        }
    };
    return SelectorEngine;
});

});

parcelRequire.register("2VHbc", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return (parcelRequire("eUhUr")).popperGenerator; });
$parcel$export(module.exports, "detectOverflow", function () { return (parcelRequire("7W9OQ")).default; });
$parcel$export(module.exports, "createPopperBase", function () { return (parcelRequire("eUhUr")).createPopper; });
$parcel$export(module.exports, "createPopper", function () { return (parcelRequire("gj0kA")).createPopper; });
$parcel$export(module.exports, "createPopperLite", function () { return (parcelRequire("cvLMA")).createPopper; });

var $hLNOA = parcelRequire("hLNOA");

var $4cJjP = parcelRequire("4cJjP");

var $eUhUr = parcelRequire("eUhUr");
var $7W9OQ = parcelRequire("7W9OQ");

var $gj0kA = parcelRequire("gj0kA");

var $cvLMA = parcelRequire("cvLMA");
$parcel$exportWildcard(module.exports, $hLNOA);
$parcel$exportWildcard(module.exports, $4cJjP);

});
parcelRequire.register("hLNOA", function(module, exports) {

$parcel$export(module.exports, "top", function () { return $cefd77a409472d8d$export$1e95b668f3b82d; });
$parcel$export(module.exports, "bottom", function () { return $cefd77a409472d8d$export$40e543e69a8b3fbb; });
$parcel$export(module.exports, "right", function () { return $cefd77a409472d8d$export$79ffe56a765070d2; });
$parcel$export(module.exports, "left", function () { return $cefd77a409472d8d$export$eabcd2c8791e7bf4; });
$parcel$export(module.exports, "auto", function () { return $cefd77a409472d8d$export$dfb5619354ba860; });
$parcel$export(module.exports, "basePlacements", function () { return $cefd77a409472d8d$export$aec2ce47c367b8c3; });
$parcel$export(module.exports, "start", function () { return $cefd77a409472d8d$export$b3571188c770cc5a; });
$parcel$export(module.exports, "end", function () { return $cefd77a409472d8d$export$bd5df0f255a350f8; });
$parcel$export(module.exports, "clippingParents", function () { return $cefd77a409472d8d$export$390fd549c5303b4d; });
$parcel$export(module.exports, "viewport", function () { return $cefd77a409472d8d$export$d7b7311ec04a3e8f; });
$parcel$export(module.exports, "popper", function () { return $cefd77a409472d8d$export$ae5ab1c730825774; });
$parcel$export(module.exports, "reference", function () { return $cefd77a409472d8d$export$ca50aac9f3ba507f; });
$parcel$export(module.exports, "variationPlacements", function () { return $cefd77a409472d8d$export$368f9a87e87fa4e1; });
$parcel$export(module.exports, "placements", function () { return $cefd77a409472d8d$export$803cd8101b6c182b; });
$parcel$export(module.exports, "beforeRead", function () { return $cefd77a409472d8d$export$421679a7c3d56e; });
$parcel$export(module.exports, "read", function () { return $cefd77a409472d8d$export$aafa59e2e03f2942; });
$parcel$export(module.exports, "afterRead", function () { return $cefd77a409472d8d$export$6964f6c886723980; });
$parcel$export(module.exports, "beforeMain", function () { return $cefd77a409472d8d$export$c65e99957a05207c; });
$parcel$export(module.exports, "main", function () { return $cefd77a409472d8d$export$f22da7240b7add18; });
$parcel$export(module.exports, "afterMain", function () { return $cefd77a409472d8d$export$bab79516f2d662fe; });
$parcel$export(module.exports, "beforeWrite", function () { return $cefd77a409472d8d$export$8d4d2d70e7d46032; });
$parcel$export(module.exports, "write", function () { return $cefd77a409472d8d$export$68d8715fc104d294; });
$parcel$export(module.exports, "afterWrite", function () { return $cefd77a409472d8d$export$70a6e5159acce2e6; });
$parcel$export(module.exports, "modifierPhases", function () { return $cefd77a409472d8d$export$d087d3878fdf71d5; });
var $cefd77a409472d8d$export$1e95b668f3b82d = "top";
var $cefd77a409472d8d$export$40e543e69a8b3fbb = "bottom";
var $cefd77a409472d8d$export$79ffe56a765070d2 = "right";
var $cefd77a409472d8d$export$eabcd2c8791e7bf4 = "left";
var $cefd77a409472d8d$export$dfb5619354ba860 = "auto";
var $cefd77a409472d8d$export$aec2ce47c367b8c3 = [
    $cefd77a409472d8d$export$1e95b668f3b82d,
    $cefd77a409472d8d$export$40e543e69a8b3fbb,
    $cefd77a409472d8d$export$79ffe56a765070d2,
    $cefd77a409472d8d$export$eabcd2c8791e7bf4
];
var $cefd77a409472d8d$export$b3571188c770cc5a = "start";
var $cefd77a409472d8d$export$bd5df0f255a350f8 = "end";
var $cefd77a409472d8d$export$390fd549c5303b4d = "clippingParents";
var $cefd77a409472d8d$export$d7b7311ec04a3e8f = "viewport";
var $cefd77a409472d8d$export$ae5ab1c730825774 = "popper";
var $cefd77a409472d8d$export$ca50aac9f3ba507f = "reference";
var $cefd77a409472d8d$export$368f9a87e87fa4e1 = /*#__PURE__*/ $cefd77a409472d8d$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $cefd77a409472d8d$export$b3571188c770cc5a,
        placement + "-" + $cefd77a409472d8d$export$bd5df0f255a350f8
    ]);
}, []);
var $cefd77a409472d8d$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($cefd77a409472d8d$export$aec2ce47c367b8c3, [
    $cefd77a409472d8d$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $cefd77a409472d8d$export$b3571188c770cc5a,
        placement + "-" + $cefd77a409472d8d$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $cefd77a409472d8d$export$421679a7c3d56e = "beforeRead";
var $cefd77a409472d8d$export$aafa59e2e03f2942 = "read";
var $cefd77a409472d8d$export$6964f6c886723980 = "afterRead"; // pure-logic modifiers
var $cefd77a409472d8d$export$c65e99957a05207c = "beforeMain";
var $cefd77a409472d8d$export$f22da7240b7add18 = "main";
var $cefd77a409472d8d$export$bab79516f2d662fe = "afterMain"; // modifier with the purpose to write to the DOM (or write into a framework state)
var $cefd77a409472d8d$export$8d4d2d70e7d46032 = "beforeWrite";
var $cefd77a409472d8d$export$68d8715fc104d294 = "write";
var $cefd77a409472d8d$export$70a6e5159acce2e6 = "afterWrite";
var $cefd77a409472d8d$export$d087d3878fdf71d5 = [
    $cefd77a409472d8d$export$421679a7c3d56e,
    $cefd77a409472d8d$export$aafa59e2e03f2942,
    $cefd77a409472d8d$export$6964f6c886723980,
    $cefd77a409472d8d$export$c65e99957a05207c,
    $cefd77a409472d8d$export$f22da7240b7add18,
    $cefd77a409472d8d$export$bab79516f2d662fe,
    $cefd77a409472d8d$export$8d4d2d70e7d46032,
    $cefd77a409472d8d$export$68d8715fc104d294,
    $cefd77a409472d8d$export$70a6e5159acce2e6
];

});

parcelRequire.register("4cJjP", function(module, exports) {

$parcel$export(module.exports, "applyStyles", function () { return (parcelRequire("9XzE9")).default; });
$parcel$export(module.exports, "arrow", function () { return (parcelRequire("bjTvB")).default; });
$parcel$export(module.exports, "computeStyles", function () { return (parcelRequire("5t115")).default; });
$parcel$export(module.exports, "eventListeners", function () { return (parcelRequire("jB2gV")).default; });
$parcel$export(module.exports, "flip", function () { return (parcelRequire("gnTEb")).default; });
$parcel$export(module.exports, "hide", function () { return (parcelRequire("2VS1U")).default; });
$parcel$export(module.exports, "offset", function () { return (parcelRequire("BJXkZ")).default; });
$parcel$export(module.exports, "popperOffsets", function () { return (parcelRequire("lgEf5")).default; });
$parcel$export(module.exports, "preventOverflow", function () { return (parcelRequire("2bNRN")).default; });

var $9XzE9 = parcelRequire("9XzE9");

var $bjTvB = parcelRequire("bjTvB");

var $5t115 = parcelRequire("5t115");

var $jB2gV = parcelRequire("jB2gV");

var $gnTEb = parcelRequire("gnTEb");

var $2VS1U = parcelRequire("2VS1U");

var $BJXkZ = parcelRequire("BJXkZ");

var $lgEf5 = parcelRequire("lgEf5");

var $2bNRN = parcelRequire("2bNRN");

});
parcelRequire.register("9XzE9", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $74054666164da556$export$2e2bcd8739ae039; });

var $4po09 = parcelRequire("4po09");

var $fnwZW = parcelRequire("fnwZW");
// and applies them to the HTMLElements such as popper and arrow
function $74054666164da556$var$applyStyles(_ref) {
    var state = _ref.state;
    Object.keys(state.elements).forEach(function(name) {
        var style = state.styles[name] || {};
        var attributes = state.attributes[name] || {};
        var element = state.elements[name]; // arrow is optional + virtual elements
        if (!(0, $fnwZW.isHTMLElement)(element) || !(0, $4po09.default)(element)) return;
         // Flow doesn't support to extend this property, but it's the most
        // effective way to apply styles to an HTMLElement
        // $FlowFixMe[cannot-write]
        Object.assign(element.style, style);
        Object.keys(attributes).forEach(function(name) {
            var value = attributes[name];
            if (value === false) element.removeAttribute(name);
            else element.setAttribute(name, value === true ? "" : value);
        });
    });
}
function $74054666164da556$var$effect(_ref2) {
    var state = _ref2.state;
    var initialStyles = {
        popper: {
            position: state.options.strategy,
            left: "0",
            top: "0",
            margin: "0"
        },
        arrow: {
            position: "absolute"
        },
        reference: {}
    };
    Object.assign(state.elements.popper.style, initialStyles.popper);
    state.styles = initialStyles;
    if (state.elements.arrow) Object.assign(state.elements.arrow.style, initialStyles.arrow);
    return function() {
        Object.keys(state.elements).forEach(function(name) {
            var element = state.elements[name];
            var attributes = state.attributes[name] || {};
            var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them
            var style = styleProperties.reduce(function(style, property) {
                style[property] = "";
                return style;
            }, {}); // arrow is optional + virtual elements
            if (!(0, $fnwZW.isHTMLElement)(element) || !(0, $4po09.default)(element)) return;
            Object.assign(element.style, style);
            Object.keys(attributes).forEach(function(attribute) {
                element.removeAttribute(attribute);
            });
        });
    };
} // eslint-disable-next-line import/no-unused-modules
var $74054666164da556$export$2e2bcd8739ae039 = {
    name: "applyStyles",
    enabled: true,
    phase: "write",
    fn: $74054666164da556$var$applyStyles,
    effect: $74054666164da556$var$effect,
    requires: [
        "computeStyles"
    ]
};

});
parcelRequire.register("4po09", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $335c1d630991db9d$export$2e2bcd8739ae039; });
function $335c1d630991db9d$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || "").toLowerCase() : null;
}

});

parcelRequire.register("fnwZW", function(module, exports) {

$parcel$export(module.exports, "isElement", function () { return $02e3a7a40389e518$export$45a5e7f76e0caa8d; });
$parcel$export(module.exports, "isHTMLElement", function () { return $02e3a7a40389e518$export$1b3bfaa9684536aa; });
$parcel$export(module.exports, "isShadowRoot", function () { return $02e3a7a40389e518$export$af51f0f06c0f328a; });

var $75WJ3 = parcelRequire("75WJ3");
function $02e3a7a40389e518$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $75WJ3.default)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $02e3a7a40389e518$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $75WJ3.default)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $02e3a7a40389e518$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === "undefined") return false;
    var OwnElement = (0, $75WJ3.default)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}

});
parcelRequire.register("75WJ3", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52a68dbbf79b0696$export$2e2bcd8739ae039; });
function $52a68dbbf79b0696$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== "[object Window]") {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}

});



parcelRequire.register("bjTvB", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $83dc86f42fc279ac$export$2e2bcd8739ae039; });

var $5DN8C = parcelRequire("5DN8C");

var $WjiIh = parcelRequire("WjiIh");

var $amSOG = parcelRequire("amSOG");

var $5Ulvj = parcelRequire("5Ulvj");

var $4G5YW = parcelRequire("4G5YW");

var $f3VaM = parcelRequire("f3VaM");

var $cU8tF = parcelRequire("cU8tF");

var $4c890 = parcelRequire("4c890");

var $hLNOA = parcelRequire("hLNOA");
var $83dc86f42fc279ac$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === "function" ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $cU8tF.default)(typeof padding !== "number" ? padding : (0, $4c890.default)(padding, (0, $hLNOA.basePlacements)));
};
function $83dc86f42fc279ac$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $5DN8C.default)(state.placement);
    var axis = (0, $4G5YW.default)(basePlacement);
    var isVertical = [
        (0, $hLNOA.left),
        (0, $hLNOA.right)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? "height" : "width";
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $83dc86f42fc279ac$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $WjiIh.default)(arrowElement);
    var minProp = axis === "y" ? (0, $hLNOA.top) : (0, $hLNOA.left);
    var maxProp = axis === "y" ? (0, $hLNOA.bottom) : (0, $hLNOA.right);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $5Ulvj.default)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === "y" ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $f3VaM.within)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $83dc86f42fc279ac$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? "[data-popper-arrow]" : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === "string") {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $amSOG.default)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $83dc86f42fc279ac$export$2e2bcd8739ae039 = {
    name: "arrow",
    enabled: true,
    phase: "main",
    fn: $83dc86f42fc279ac$var$arrow,
    effect: $83dc86f42fc279ac$var$effect,
    requires: [
        "popperOffsets"
    ],
    requiresIfExists: [
        "preventOverflow"
    ]
};

});
parcelRequire.register("5DN8C", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $41b6b608ffa08ca1$export$2e2bcd8739ae039; });

function $41b6b608ffa08ca1$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[0];
}

});

parcelRequire.register("WjiIh", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0af463a2f2f36779$export$2e2bcd8739ae039; });

var $ce6re = parcelRequire("ce6re");
function $0af463a2f2f36779$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $ce6re.default)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}

});
parcelRequire.register("ce6re", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $8e6bc95b10844cc4$export$2e2bcd8739ae039; });

var $fnwZW = parcelRequire("fnwZW");

var $hPrig = parcelRequire("hPrig");

var $75WJ3 = parcelRequire("75WJ3");

var $fvgXO = parcelRequire("fvgXO");
function $8e6bc95b10844cc4$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $fnwZW.isHTMLElement)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $hPrig.round)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $hPrig.round)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $fnwZW.isElement)(element) ? (0, $75WJ3.default)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $fvgXO.default)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}

});
parcelRequire.register("hPrig", function(module, exports) {

$parcel$export(module.exports, "max", function () { return $cfac5f0503fa0c0c$export$8960430cfd85939f; });
$parcel$export(module.exports, "min", function () { return $cfac5f0503fa0c0c$export$96ec731ed4dcb222; });
$parcel$export(module.exports, "round", function () { return $cfac5f0503fa0c0c$export$2077e0241d6afd3c; });
var $cfac5f0503fa0c0c$export$8960430cfd85939f = Math.max;
var $cfac5f0503fa0c0c$export$96ec731ed4dcb222 = Math.min;
var $cfac5f0503fa0c0c$export$2077e0241d6afd3c = Math.round;

});

parcelRequire.register("fvgXO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $b496e8e32f6ce209$export$2e2bcd8739ae039; });

var $oqoG4 = parcelRequire("oqoG4");
function $b496e8e32f6ce209$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $oqoG4.default)());
}

});
parcelRequire.register("oqoG4", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $0496b7e7c66765a6$export$2e2bcd8739ae039; });
function $0496b7e7c66765a6$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(" ");
    return navigator.userAgent;
}

});




parcelRequire.register("amSOG", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $78c67adc35462806$export$2e2bcd8739ae039; });

var $fnwZW = parcelRequire("fnwZW");
function $78c67adc35462806$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $fnwZW.isShadowRoot)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}

});

parcelRequire.register("5Ulvj", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $44d2dcfa9b6528d5$export$2e2bcd8739ae039; });

var $75WJ3 = parcelRequire("75WJ3");

var $4po09 = parcelRequire("4po09");

var $eCVvO = parcelRequire("eCVvO");

var $fnwZW = parcelRequire("fnwZW");

var $wxfkv = parcelRequire("wxfkv");

var $dQ5A6 = parcelRequire("dQ5A6");

var $oqoG4 = parcelRequire("oqoG4");
function $44d2dcfa9b6528d5$var$getTrueOffsetParent(element) {
    if (!(0, $fnwZW.isHTMLElement)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $eCVvO.default)(element).position === "fixed") return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $44d2dcfa9b6528d5$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $oqoG4.default)());
    var isIE = /Trident/i.test((0, $oqoG4.default)());
    if (isIE && (0, $fnwZW.isHTMLElement)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $eCVvO.default)(element);
        if (elementCss.position === "fixed") return null;
    }
    var currentNode = (0, $dQ5A6.default)(element);
    if ((0, $fnwZW.isShadowRoot)(currentNode)) currentNode = currentNode.host;
    while((0, $fnwZW.isHTMLElement)(currentNode) && [
        "html",
        "body"
    ].indexOf((0, $4po09.default)(currentNode)) < 0){
        var css = (0, $eCVvO.default)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== "none" || css.perspective !== "none" || css.contain === "paint" || [
            "transform",
            "perspective"
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === "filter" || isFirefox && css.filter && css.filter !== "none") return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $44d2dcfa9b6528d5$export$2e2bcd8739ae039(element) {
    var window = (0, $75WJ3.default)(element);
    var offsetParent = $44d2dcfa9b6528d5$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $wxfkv.default)(offsetParent) && (0, $eCVvO.default)(offsetParent).position === "static")offsetParent = $44d2dcfa9b6528d5$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $4po09.default)(offsetParent) === "html" || (0, $4po09.default)(offsetParent) === "body" && (0, $eCVvO.default)(offsetParent).position === "static")) return window;
    return offsetParent || $44d2dcfa9b6528d5$var$getContainingBlock(element) || window;
}

});
parcelRequire.register("eCVvO", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $aa613a05ba685ccb$export$2e2bcd8739ae039; });

var $75WJ3 = parcelRequire("75WJ3");
function $aa613a05ba685ccb$export$2e2bcd8739ae039(element) {
    return (0, $75WJ3.default)(element).getComputedStyle(element);
}

});

parcelRequire.register("wxfkv", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $061cc7497f9f99cf$export$2e2bcd8739ae039; });

var $4po09 = parcelRequire("4po09");
function $061cc7497f9f99cf$export$2e2bcd8739ae039(element) {
    return [
        "table",
        "td",
        "th"
    ].indexOf((0, $4po09.default)(element)) >= 0;
}

});

parcelRequire.register("dQ5A6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a13476024d635e41$export$2e2bcd8739ae039; });

var $4po09 = parcelRequire("4po09");

var $7oLJz = parcelRequire("7oLJz");

var $fnwZW = parcelRequire("fnwZW");
function $a13476024d635e41$export$2e2bcd8739ae039(element) {
    if ((0, $4po09.default)(element) === "html") return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $fnwZW.isShadowRoot)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $7oLJz.default)(element) // fallback
    );
}

});
parcelRequire.register("7oLJz", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $562fcd476b3355d2$export$2e2bcd8739ae039; });

var $fnwZW = parcelRequire("fnwZW");
function $562fcd476b3355d2$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $fnwZW.isElement)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}

});



parcelRequire.register("4G5YW", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $367fb99255482738$export$2e2bcd8739ae039; });
function $367fb99255482738$export$2e2bcd8739ae039(placement) {
    return [
        "top",
        "bottom"
    ].indexOf(placement) >= 0 ? "x" : "y";
}

});

parcelRequire.register("f3VaM", function(module, exports) {

$parcel$export(module.exports, "within", function () { return $af737c27d799169c$export$f28d906d67a997f3; });
$parcel$export(module.exports, "withinMaxClamp", function () { return $af737c27d799169c$export$86c8af6d3ef0b4a; });

var $hPrig = parcelRequire("hPrig");
function $af737c27d799169c$export$f28d906d67a997f3(min, value, max) {
    return (0, $hPrig.max)(min, (0, $hPrig.min)(value, max));
}
function $af737c27d799169c$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $af737c27d799169c$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}

});

parcelRequire.register("cU8tF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $96514a6e68cf3ac6$export$2e2bcd8739ae039; });

var $effgS = parcelRequire("effgS");
function $96514a6e68cf3ac6$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $effgS.default)(), paddingObject);
}

});
parcelRequire.register("effgS", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $a5ee4ff71e95e5f9$export$2e2bcd8739ae039; });
function $a5ee4ff71e95e5f9$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}

});


parcelRequire.register("4c890", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30de99b1366d30c9$export$2e2bcd8739ae039; });
function $30de99b1366d30c9$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}

});


parcelRequire.register("5t115", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $3fb07310bceb7864$export$2e2bcd8739ae039; });

var $hLNOA = parcelRequire("hLNOA");

var $5Ulvj = parcelRequire("5Ulvj");

var $75WJ3 = parcelRequire("75WJ3");

var $7oLJz = parcelRequire("7oLJz");

var $eCVvO = parcelRequire("eCVvO");

var $5DN8C = parcelRequire("5DN8C");

var $cTtdJ = parcelRequire("cTtdJ");

var $hPrig = parcelRequire("hPrig");
var $3fb07310bceb7864$var$unsetSides = {
    top: "auto",
    right: "auto",
    bottom: "auto",
    left: "auto"
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $3fb07310bceb7864$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $hPrig.round)(x * dpr) / dpr || 0,
        y: (0, $hPrig.round)(y * dpr) / dpr || 0
    };
}
function $3fb07310bceb7864$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === "function" ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty("x");
    var hasY = offsets.hasOwnProperty("y");
    var sideX = (0, $hLNOA.left);
    var sideY = (0, $hLNOA.top);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $5Ulvj.default)(popper);
        var heightProp = "clientHeight";
        var widthProp = "clientWidth";
        if (offsetParent === (0, $75WJ3.default)(popper)) {
            offsetParent = (0, $7oLJz.default)(popper);
            if ((0, $eCVvO.default)(offsetParent).position !== "static" && position === "absolute") {
                heightProp = "scrollHeight";
                widthProp = "scrollWidth";
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $hLNOA.top) || (placement === (0, $hLNOA.left) || placement === (0, $hLNOA.right)) && variation === (0, $hLNOA.end)) {
            sideY = (0, $hLNOA.bottom);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $hLNOA.left) || (placement === (0, $hLNOA.top) || placement === (0, $hLNOA.bottom)) && variation === (0, $hLNOA.end)) {
            sideX = (0, $hLNOA.right);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $3fb07310bceb7864$var$unsetSides);
    var _ref4 = roundOffsets === true ? $3fb07310bceb7864$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $75WJ3.default)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? "0" : "", _Object$assign[sideX] = hasX ? "0" : "", _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : "", _Object$assign2[sideX] = hasX ? x + "px" : "", _Object$assign2.transform = "", _Object$assign2));
}
function $3fb07310bceb7864$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $5DN8C.default)(state.placement),
        variation: (0, $cTtdJ.default)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === "fixed"
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $3fb07310bceb7864$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $3fb07310bceb7864$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: "absolute",
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-placement": state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $3fb07310bceb7864$export$2e2bcd8739ae039 = {
    name: "computeStyles",
    enabled: true,
    phase: "beforeWrite",
    fn: $3fb07310bceb7864$var$computeStyles,
    data: {}
};

});
parcelRequire.register("cTtdJ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $963149affb10e1b3$export$2e2bcd8739ae039; });
function $963149affb10e1b3$export$2e2bcd8739ae039(placement) {
    return placement.split("-")[1];
}

});


parcelRequire.register("jB2gV", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $e4433c3268ceda30$export$2e2bcd8739ae039; });

var $75WJ3 = parcelRequire("75WJ3");
var $e4433c3268ceda30$var$passive = {
    passive: true
};
function $e4433c3268ceda30$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $75WJ3.default)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener("scroll", instance.update, $e4433c3268ceda30$var$passive);
    });
    if (resize) window.addEventListener("resize", instance.update, $e4433c3268ceda30$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener("scroll", instance.update, $e4433c3268ceda30$var$passive);
        });
        if (resize) window.removeEventListener("resize", instance.update, $e4433c3268ceda30$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $e4433c3268ceda30$export$2e2bcd8739ae039 = {
    name: "eventListeners",
    enabled: true,
    phase: "write",
    fn: function fn() {},
    effect: $e4433c3268ceda30$var$effect,
    data: {}
};

});

parcelRequire.register("gnTEb", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $bed9f5a8c2893a90$export$2e2bcd8739ae039; });

var $kJAhT = parcelRequire("kJAhT");

var $5DN8C = parcelRequire("5DN8C");

var $73k3R = parcelRequire("73k3R");

var $7W9OQ = parcelRequire("7W9OQ");

var $dbB6I = parcelRequire("dbB6I");

var $hLNOA = parcelRequire("hLNOA");

var $cTtdJ = parcelRequire("cTtdJ");
function $bed9f5a8c2893a90$var$getExpandedFallbackPlacements(placement) {
    if ((0, $5DN8C.default)(placement) === (0, $hLNOA.auto)) return [];
    var oppositePlacement = (0, $kJAhT.default)(placement);
    return [
        (0, $73k3R.default)(placement),
        oppositePlacement,
        (0, $73k3R.default)(oppositePlacement)
    ];
}
function $bed9f5a8c2893a90$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $5DN8C.default)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $kJAhT.default)(preferredPlacement)
    ] : $bed9f5a8c2893a90$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $5DN8C.default)(placement) === (0, $hLNOA.auto) ? (0, $dbB6I.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $5DN8C.default)(placement);
        var isStartVariation = (0, $cTtdJ.default)(placement) === (0, $hLNOA.start);
        var isVertical = [
            (0, $hLNOA.top),
            (0, $hLNOA.bottom)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? "width" : "height";
        var overflow = (0, $7W9OQ.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $hLNOA.right) : (0, $hLNOA.left) : isStartVariation ? (0, $hLNOA.bottom) : (0, $hLNOA.top);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $kJAhT.default)(mainVariationSide);
        var altVariationSide = (0, $kJAhT.default)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $bed9f5a8c2893a90$export$2e2bcd8739ae039 = {
    name: "flip",
    enabled: true,
    phase: "main",
    fn: $bed9f5a8c2893a90$var$flip,
    requiresIfExists: [
        "offset"
    ],
    data: {
        _skip: false
    }
};

});
parcelRequire.register("kJAhT", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f1842893058158ff$export$2e2bcd8739ae039; });
var $f1842893058158ff$var$hash = {
    left: "right",
    right: "left",
    bottom: "top",
    top: "bottom"
};
function $f1842893058158ff$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $f1842893058158ff$var$hash[matched];
    });
}

});

parcelRequire.register("73k3R", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $52285ff45efd9816$export$2e2bcd8739ae039; });
var $52285ff45efd9816$var$hash = {
    start: "end",
    end: "start"
};
function $52285ff45efd9816$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $52285ff45efd9816$var$hash[matched];
    });
}

});

parcelRequire.register("7W9OQ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $5c75910e995426af$export$2e2bcd8739ae039; });

var $4rmEP = parcelRequire("4rmEP");

var $7oLJz = parcelRequire("7oLJz");

var $ce6re = parcelRequire("ce6re");

var $kx3pR = parcelRequire("kx3pR");

var $7C1zp = parcelRequire("7C1zp");

var $hLNOA = parcelRequire("hLNOA");

var $fnwZW = parcelRequire("fnwZW");

var $cU8tF = parcelRequire("cU8tF");

var $4c890 = parcelRequire("4c890");
function $5c75910e995426af$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $hLNOA.clippingParents) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $hLNOA.viewport) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $hLNOA.popper) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $cU8tF.default)(typeof padding !== "number" ? padding : (0, $4c890.default)(padding, (0, $hLNOA.basePlacements)));
    var altContext = elementContext === (0, $hLNOA.popper) ? (0, $hLNOA.reference) : (0, $hLNOA.popper);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $4rmEP.default)((0, $fnwZW.isElement)(element) ? element : element.contextElement || (0, $7oLJz.default)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $ce6re.default)(state.elements.reference);
    var popperOffsets = (0, $kx3pR.default)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: "absolute",
        placement: placement
    });
    var popperClientRect = (0, $7C1zp.default)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $hLNOA.popper) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $hLNOA.popper) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $hLNOA.right),
                (0, $hLNOA.bottom)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $hLNOA.top),
                (0, $hLNOA.bottom)
            ].indexOf(key) >= 0 ? "y" : "x";
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}

});
parcelRequire.register("4rmEP", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $33bb425c939e76c7$export$2e2bcd8739ae039; });

var $hLNOA = parcelRequire("hLNOA");

var $8mpYc = parcelRequire("8mpYc");

var $hjPFZ = parcelRequire("hjPFZ");

var $45J2h = parcelRequire("45J2h");

var $5Ulvj = parcelRequire("5Ulvj");

var $7oLJz = parcelRequire("7oLJz");

var $eCVvO = parcelRequire("eCVvO");

var $fnwZW = parcelRequire("fnwZW");

var $ce6re = parcelRequire("ce6re");

var $dQ5A6 = parcelRequire("dQ5A6");

var $amSOG = parcelRequire("amSOG");

var $4po09 = parcelRequire("4po09");

var $7C1zp = parcelRequire("7C1zp");

var $hPrig = parcelRequire("hPrig");
function $33bb425c939e76c7$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $ce6re.default)(element, false, strategy === "fixed");
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $33bb425c939e76c7$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $hLNOA.viewport) ? (0, $7C1zp.default)((0, $8mpYc.default)(element, strategy)) : (0, $fnwZW.isElement)(clippingParent) ? $33bb425c939e76c7$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $7C1zp.default)((0, $hjPFZ.default)((0, $7oLJz.default)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $33bb425c939e76c7$var$getClippingParents(element) {
    var clippingParents = (0, $45J2h.default)((0, $dQ5A6.default)(element));
    var canEscapeClipping = [
        "absolute",
        "fixed"
    ].indexOf((0, $eCVvO.default)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $fnwZW.isHTMLElement)(element) ? (0, $5Ulvj.default)(element) : element;
    if (!(0, $fnwZW.isElement)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $fnwZW.isElement)(clippingParent) && (0, $amSOG.default)(clippingParent, clipperElement) && (0, $4po09.default)(clippingParent) !== "body";
    });
} // Gets the maximum area that the element is visible in due to any number of
function $33bb425c939e76c7$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === "clippingParents" ? $33bb425c939e76c7$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $33bb425c939e76c7$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $hPrig.max)(rect.top, accRect.top);
        accRect.right = (0, $hPrig.min)(rect.right, accRect.right);
        accRect.bottom = (0, $hPrig.min)(rect.bottom, accRect.bottom);
        accRect.left = (0, $hPrig.max)(rect.left, accRect.left);
        return accRect;
    }, $33bb425c939e76c7$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}

});
parcelRequire.register("8mpYc", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $616485e4a91e3db8$export$2e2bcd8739ae039; });

var $75WJ3 = parcelRequire("75WJ3");

var $7oLJz = parcelRequire("7oLJz");

var $4bBtm = parcelRequire("4bBtm");

var $fvgXO = parcelRequire("fvgXO");
function $616485e4a91e3db8$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $75WJ3.default)(element);
    var html = (0, $7oLJz.default)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $fvgXO.default)();
        if (layoutViewport || !layoutViewport && strategy === "fixed") {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $4bBtm.default)(element),
        y: y
    };
}

});
parcelRequire.register("4bBtm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $30c541c7d797b61f$export$2e2bcd8739ae039; });

var $ce6re = parcelRequire("ce6re");

var $7oLJz = parcelRequire("7oLJz");

var $gTYCU = parcelRequire("gTYCU");
function $30c541c7d797b61f$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $ce6re.default)((0, $7oLJz.default)(element)).left + (0, $gTYCU.default)(element).scrollLeft;
}

});
parcelRequire.register("gTYCU", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c4e0cf975615cf4c$export$2e2bcd8739ae039; });

var $75WJ3 = parcelRequire("75WJ3");
function $c4e0cf975615cf4c$export$2e2bcd8739ae039(node) {
    var win = (0, $75WJ3.default)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}

});



parcelRequire.register("hjPFZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $c9bc4bd93d03c0dd$export$2e2bcd8739ae039; });

var $7oLJz = parcelRequire("7oLJz");

var $eCVvO = parcelRequire("eCVvO");

var $4bBtm = parcelRequire("4bBtm");

var $gTYCU = parcelRequire("gTYCU");

var $hPrig = parcelRequire("hPrig");
function $c9bc4bd93d03c0dd$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $7oLJz.default)(element);
    var winScroll = (0, $gTYCU.default)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $hPrig.max)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $hPrig.max)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $4bBtm.default)(element);
    var y = -winScroll.scrollTop;
    if ((0, $eCVvO.default)(body || html).direction === "rtl") x += (0, $hPrig.max)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}

});

parcelRequire.register("45J2h", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $2faa903c271e9c84$export$2e2bcd8739ae039; });

var $6AhnN = parcelRequire("6AhnN");

var $dQ5A6 = parcelRequire("dQ5A6");

var $75WJ3 = parcelRequire("75WJ3");

var $7kmIM = parcelRequire("7kmIM");
function $2faa903c271e9c84$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $6AhnN.default)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $75WJ3.default)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $7kmIM.default)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($2faa903c271e9c84$export$2e2bcd8739ae039((0, $dQ5A6.default)(target)));
}

});
parcelRequire.register("6AhnN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $4cb396b5b9e812c5$export$2e2bcd8739ae039; });

var $dQ5A6 = parcelRequire("dQ5A6");

var $7kmIM = parcelRequire("7kmIM");

var $4po09 = parcelRequire("4po09");

var $fnwZW = parcelRequire("fnwZW");
function $4cb396b5b9e812c5$export$2e2bcd8739ae039(node) {
    if ([
        "html",
        "body",
        "#document"
    ].indexOf((0, $4po09.default)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $fnwZW.isHTMLElement)(node) && (0, $7kmIM.default)(node)) return node;
    return $4cb396b5b9e812c5$export$2e2bcd8739ae039((0, $dQ5A6.default)(node));
}

});
parcelRequire.register("7kmIM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $555c06a00f1841ba$export$2e2bcd8739ae039; });

var $eCVvO = parcelRequire("eCVvO");
function $555c06a00f1841ba$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $eCVvO.default)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

});



parcelRequire.register("7C1zp", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $58ad4cd3a98c7161$export$2e2bcd8739ae039; });
function $58ad4cd3a98c7161$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}

});


parcelRequire.register("kx3pR", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ef298a14a6d7c348$export$2e2bcd8739ae039; });

var $5DN8C = parcelRequire("5DN8C");

var $cTtdJ = parcelRequire("cTtdJ");

var $4G5YW = parcelRequire("4G5YW");

var $hLNOA = parcelRequire("hLNOA");
function $ef298a14a6d7c348$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $5DN8C.default)(placement) : null;
    var variation = placement ? (0, $cTtdJ.default)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $hLNOA.top:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $hLNOA.bottom:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $hLNOA.right:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $hLNOA.left:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $4G5YW.default)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === "y" ? "height" : "width";
        switch(variation){
            case 0, $hLNOA.start:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $hLNOA.end:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}

});


parcelRequire.register("dbB6I", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $99991629c512342a$export$2e2bcd8739ae039; });

var $cTtdJ = parcelRequire("cTtdJ");

var $hLNOA = parcelRequire("hLNOA");

var $7W9OQ = parcelRequire("7W9OQ");

var $5DN8C = parcelRequire("5DN8C");
function $99991629c512342a$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $hLNOA.placements) : _options$allowedAutoP;
    var variation = (0, $cTtdJ.default)(placement);
    var placements = variation ? flipVariations ? (0, $hLNOA.variationPlacements) : (0, $hLNOA.variationPlacements).filter(function(placement) {
        return (0, $cTtdJ.default)(placement) === variation;
    }) : (0, $hLNOA.basePlacements);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $7W9OQ.default)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $5DN8C.default)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}

});


parcelRequire.register("2VS1U", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $222ad0d139efc5fd$export$2e2bcd8739ae039; });

var $hLNOA = parcelRequire("hLNOA");

var $7W9OQ = parcelRequire("7W9OQ");
function $222ad0d139efc5fd$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $222ad0d139efc5fd$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $hLNOA.top),
        (0, $hLNOA.right),
        (0, $hLNOA.bottom),
        (0, $hLNOA.left)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $222ad0d139efc5fd$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $7W9OQ.default)(state, {
        elementContext: "reference"
    });
    var popperAltOverflow = (0, $7W9OQ.default)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $222ad0d139efc5fd$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $222ad0d139efc5fd$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $222ad0d139efc5fd$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $222ad0d139efc5fd$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        "data-popper-reference-hidden": isReferenceHidden,
        "data-popper-escaped": hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $222ad0d139efc5fd$export$2e2bcd8739ae039 = {
    name: "hide",
    enabled: true,
    phase: "main",
    requiresIfExists: [
        "preventOverflow"
    ],
    fn: $222ad0d139efc5fd$var$hide
};

});

parcelRequire.register("BJXkZ", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $07171abb3b970e38$export$2e2bcd8739ae039; });

var $5DN8C = parcelRequire("5DN8C");

var $hLNOA = parcelRequire("hLNOA");
function $07171abb3b970e38$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $5DN8C.default)(placement);
    var invertDistance = [
        (0, $hLNOA.left),
        (0, $hLNOA.top)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === "function" ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $hLNOA.left),
        (0, $hLNOA.right)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $07171abb3b970e38$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, _$offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $hLNOA.placements).reduce(function(acc, placement) {
        acc[placement] = $07171abb3b970e38$export$7fa02d8595b015ed(placement, state.rects, _$offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $07171abb3b970e38$export$2e2bcd8739ae039 = {
    name: "offset",
    enabled: true,
    phase: "main",
    requires: [
        "popperOffsets"
    ],
    fn: $07171abb3b970e38$var$offset
};

});

parcelRequire.register("lgEf5", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $f7ba4eded364f4f7$export$2e2bcd8739ae039; });

var $kx3pR = parcelRequire("kx3pR");
function $f7ba4eded364f4f7$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $kx3pR.default)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: "absolute",
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $f7ba4eded364f4f7$export$2e2bcd8739ae039 = {
    name: "popperOffsets",
    enabled: true,
    phase: "read",
    fn: $f7ba4eded364f4f7$var$popperOffsets,
    data: {}
};

});

parcelRequire.register("2bNRN", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $19834a509ede1e0f$export$2e2bcd8739ae039; });

var $hLNOA = parcelRequire("hLNOA");

var $5DN8C = parcelRequire("5DN8C");

var $4G5YW = parcelRequire("4G5YW");

var $3pWci = parcelRequire("3pWci");

var $f3VaM = parcelRequire("f3VaM");

var $WjiIh = parcelRequire("WjiIh");

var $5Ulvj = parcelRequire("5Ulvj");

var $7W9OQ = parcelRequire("7W9OQ");

var $cTtdJ = parcelRequire("cTtdJ");

var $effgS = parcelRequire("effgS");

var $hPrig = parcelRequire("hPrig");
function $19834a509ede1e0f$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $7W9OQ.default)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $5DN8C.default)(state.placement);
    var variation = (0, $cTtdJ.default)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $4G5YW.default)(basePlacement);
    var altAxis = (0, $3pWci.default)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === "function" ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === "number" ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === "y" ? (0, $hLNOA.top) : (0, $hLNOA.left);
        var altSide = mainAxis === "y" ? (0, $hLNOA.bottom) : (0, $hLNOA.right);
        var len = mainAxis === "y" ? "height" : "width";
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $hLNOA.start) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $hLNOA.start) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $WjiIh.default)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData["arrow#persistent"] ? state.modifiersData["arrow#persistent"].padding : (0, $effgS.default)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $f3VaM.within)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $5Ulvj.default)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === "y" ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $f3VaM.within)(tether ? (0, $hPrig.min)(min, tetherMin) : min, offset, tether ? (0, $hPrig.max)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === "x" ? (0, $hLNOA.top) : (0, $hLNOA.left);
        var _altSide = mainAxis === "x" ? (0, $hLNOA.bottom) : (0, $hLNOA.right);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === "y" ? "height" : "width";
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $hLNOA.top),
            (0, $hLNOA.left)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $f3VaM.withinMaxClamp)(_tetherMin, _offset, _tetherMax) : (0, $f3VaM.within)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $19834a509ede1e0f$export$2e2bcd8739ae039 = {
    name: "preventOverflow",
    enabled: true,
    phase: "main",
    fn: $19834a509ede1e0f$var$preventOverflow,
    requiresIfExists: [
        "offset"
    ]
};

});
parcelRequire.register("3pWci", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $27d0d9b036ab2393$export$2e2bcd8739ae039; });
function $27d0d9b036ab2393$export$2e2bcd8739ae039(axis) {
    return axis === "x" ? "y" : "x";
}

});



parcelRequire.register("eUhUr", function(module, exports) {

$parcel$export(module.exports, "popperGenerator", function () { return $ada4301381eadd7f$export$ed5e13716264f202; });
$parcel$export(module.exports, "createPopper", function () { return $ada4301381eadd7f$export$8f7491d57c8f97a9; });

var $fZBdm = parcelRequire("fZBdm");

var $WjiIh = parcelRequire("WjiIh");

var $45J2h = parcelRequire("45J2h");

var $5Ulvj = parcelRequire("5Ulvj");

var $7jBcF = parcelRequire("7jBcF");

var $bMPJL = parcelRequire("bMPJL");

var $v25V6 = parcelRequire("v25V6");

var $7W9OQ = parcelRequire("7W9OQ");

var $fnwZW = parcelRequire("fnwZW");
var $ada4301381eadd7f$var$DEFAULT_OPTIONS = {
    placement: "bottom",
    modifiers: [],
    strategy: "absolute"
};
function $ada4301381eadd7f$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === "function");
    });
}
function $ada4301381eadd7f$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $ada4301381eadd7f$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        var runModifierEffects = // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, _$options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === "function") {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: _$options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        };
        var cleanupModifierEffects = function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        };
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: "bottom",
            orderedModifiers: [],
            options: Object.assign({}, $ada4301381eadd7f$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var _$options = typeof setOptionsAction === "function" ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, _$options);
                state.scrollParents = {
                    reference: (0, $fnwZW.isElement)(reference) ? (0, $45J2h.default)(reference) : reference.contextElement ? (0, $45J2h.default)(reference.contextElement) : [],
                    popper: (0, $45J2h.default)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $7jBcF.default)((0, $v25V6.default)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, _$reference = _state$elements.reference, _$popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$ada4301381eadd7f$var$areValidElements(_$reference, _$popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $fZBdm.default)(_$reference, (0, $5Ulvj.default)(_$popper), state.options.strategy === "fixed"),
                    popper: (0, $WjiIh.default)(_$popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === "function") state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $bMPJL.default)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$ada4301381eadd7f$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        return instance;
    };
}
var $ada4301381eadd7f$export$8f7491d57c8f97a9 = /*#__PURE__*/ $ada4301381eadd7f$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules

});
parcelRequire.register("fZBdm", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $ba496b91dbb50203$export$2e2bcd8739ae039; });

var $ce6re = parcelRequire("ce6re");

var $92KCM = parcelRequire("92KCM");

var $4po09 = parcelRequire("4po09");

var $fnwZW = parcelRequire("fnwZW");

var $4bBtm = parcelRequire("4bBtm");

var $7oLJz = parcelRequire("7oLJz");

var $7kmIM = parcelRequire("7kmIM");

var $hPrig = parcelRequire("hPrig");
function $ba496b91dbb50203$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $hPrig.round)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $hPrig.round)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $ba496b91dbb50203$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $fnwZW.isHTMLElement)(offsetParent);
    var offsetParentIsScaled = (0, $fnwZW.isHTMLElement)(offsetParent) && $ba496b91dbb50203$var$isElementScaled(offsetParent);
    var documentElement = (0, $7oLJz.default)(offsetParent);
    var rect = (0, $ce6re.default)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $4po09.default)(offsetParent) !== "body" || // https://github.com/popperjs/popper-core/issues/1078
        (0, $7kmIM.default)(documentElement)) scroll = (0, $92KCM.default)(offsetParent);
        if ((0, $fnwZW.isHTMLElement)(offsetParent)) {
            offsets = (0, $ce6re.default)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $4bBtm.default)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}

});
parcelRequire.register("92KCM", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $6958779f792d73b3$export$2e2bcd8739ae039; });

var $gTYCU = parcelRequire("gTYCU");

var $75WJ3 = parcelRequire("75WJ3");

var $fnwZW = parcelRequire("fnwZW");

var $1Ovpk = parcelRequire("1Ovpk");
function $6958779f792d73b3$export$2e2bcd8739ae039(node) {
    if (node === (0, $75WJ3.default)(node) || !(0, $fnwZW.isHTMLElement)(node)) return (0, $gTYCU.default)(node);
    else return (0, $1Ovpk.default)(node);
}

});
parcelRequire.register("1Ovpk", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $1522d2d0b08b8e74$export$2e2bcd8739ae039; });
function $1522d2d0b08b8e74$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}

});



parcelRequire.register("7jBcF", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $55372a8a1c1b1368$export$2e2bcd8739ae039; });

var $hLNOA = parcelRequire("hLNOA");
function $55372a8a1c1b1368$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $55372a8a1c1b1368$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $55372a8a1c1b1368$var$order(modifiers); // order based on phase
    return (0, $hLNOA.modifierPhases).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}

});

parcelRequire.register("bMPJL", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $894c4f4cf7ffd620$export$2e2bcd8739ae039; });
function $894c4f4cf7ffd620$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}

});

parcelRequire.register("v25V6", function(module, exports) {

$parcel$export(module.exports, "default", function () { return $05d485493b85a587$export$2e2bcd8739ae039; });
function $05d485493b85a587$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}

});


parcelRequire.register("gj0kA", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $bdeead69b159d288$export$8f7491d57c8f97a9; });

var $eUhUr = parcelRequire("eUhUr");

var $jB2gV = parcelRequire("jB2gV");

var $lgEf5 = parcelRequire("lgEf5");

var $5t115 = parcelRequire("5t115");

var $9XzE9 = parcelRequire("9XzE9");

var $BJXkZ = parcelRequire("BJXkZ");

var $gnTEb = parcelRequire("gnTEb");

var $2bNRN = parcelRequire("2bNRN");

var $bjTvB = parcelRequire("bjTvB");

var $2VS1U = parcelRequire("2VS1U");


var $bdeead69b159d288$export$d34966752335dd47 = [
    (0, $jB2gV.default),
    (0, $lgEf5.default),
    (0, $5t115.default),
    (0, $9XzE9.default),
    (0, $BJXkZ.default),
    (0, $gnTEb.default),
    (0, $2bNRN.default),
    (0, $bjTvB.default),
    (0, $2VS1U.default)
];
var $bdeead69b159d288$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $eUhUr.popperGenerator)({
    defaultModifiers: $bdeead69b159d288$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});

parcelRequire.register("cvLMA", function(module, exports) {

$parcel$export(module.exports, "createPopper", function () { return $91bd71f001b9e709$export$8f7491d57c8f97a9; });

var $eUhUr = parcelRequire("eUhUr");

var $jB2gV = parcelRequire("jB2gV");

var $lgEf5 = parcelRequire("lgEf5");

var $5t115 = parcelRequire("5t115");

var $9XzE9 = parcelRequire("9XzE9");
var $91bd71f001b9e709$export$d34966752335dd47 = [
    (0, $jB2gV.default),
    (0, $lgEf5.default),
    (0, $5t115.default),
    (0, $9XzE9.default)
];
var $91bd71f001b9e709$export$8f7491d57c8f97a9 = /*#__PURE__*/ (0, $eUhUr.popperGenerator)({
    defaultModifiers: $91bd71f001b9e709$export$d34966752335dd47
}); // eslint-disable-next-line import/no-unused-modules

});


/* import "./jquery-global.js";
import $ from "jquery"; */ // import { Collapse} from 'bootstrap'; /* not reliable */
// import "/node_modules/bootstrap/js/src/collapse.js"; /* reliable */
var $b4a24ef9143f11e5$exports = {};

var $eCXNS = parcelRequire("eCXNS");

var $7M9bt = parcelRequire("7M9bt");

var $5IDCd = parcelRequire("5IDCd");

var $1YTSz = parcelRequire("1YTSz");




/*!
  * Bootstrap collapse.js v5.3.2 (https://getbootstrap.com/)
  * Copyright 2011-2023 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    $b4a24ef9143f11e5$exports = factory((parcelRequire("31kbN")), (parcelRequire("jYOfh")), (parcelRequire("4JvcO")), (parcelRequire("c0GPz")));
})(undefined, function(BaseComponent, EventHandler, SelectorEngine, index_js) {
    "use strict";
    /**
   * --------------------------------------------------------------------------
   * Bootstrap collapse.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ var NAME = "collapse";
    var DATA_KEY = "bs.collapse";
    var EVENT_KEY = ".".concat(DATA_KEY);
    var DATA_API_KEY = ".data-api";
    var EVENT_SHOW = "show".concat(EVENT_KEY);
    var EVENT_SHOWN = "shown".concat(EVENT_KEY);
    var EVENT_HIDE = "hide".concat(EVENT_KEY);
    var EVENT_HIDDEN = "hidden".concat(EVENT_KEY);
    var EVENT_CLICK_DATA_API = "click".concat(EVENT_KEY).concat(DATA_API_KEY);
    var CLASS_NAME_SHOW = "show";
    var CLASS_NAME_COLLAPSE = "collapse";
    var CLASS_NAME_COLLAPSING = "collapsing";
    var CLASS_NAME_COLLAPSED = "collapsed";
    var CLASS_NAME_DEEPER_CHILDREN = ":scope .".concat(CLASS_NAME_COLLAPSE, " .").concat(CLASS_NAME_COLLAPSE);
    var CLASS_NAME_HORIZONTAL = "collapse-horizontal";
    var WIDTH = "width";
    var HEIGHT = "height";
    var SELECTOR_ACTIVES = ".collapse.show, .collapse.collapsing";
    var SELECTOR_DATA_TOGGLE = '[data-bs-toggle="collapse"]';
    var Default = {
        parent: null,
        toggle: true
    };
    var DefaultType = {
        parent: "(null|element)",
        toggle: "boolean"
    };
    /**
   * Class definition
   */ var Collapse = /*#__PURE__*/ function(BaseComponent) {
        (0, $5IDCd._)(Collapse, BaseComponent);
        var _super = (0, $1YTSz._)(Collapse);
        function Collapse(element, config) {
            (0, $eCXNS._)(this, Collapse);
            var _this;
            _this = _super.call(this, element, config);
            _this._isTransitioning = false;
            _this._triggerArray = [];
            var toggleList = SelectorEngine.find(SELECTOR_DATA_TOGGLE);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = toggleList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var elem = _step.value;
                    var selector = SelectorEngine.getSelectorFromElement(elem);
                    var filterElement = SelectorEngine.find(selector).filter(function(foundElement) {
                        return foundElement === _this._element;
                    });
                    if (selector !== null && filterElement.length) _this._triggerArray.push(elem);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            _this._initializeChildren();
            if (!_this._config.parent) _this._addAriaAndCollapsedClass(_this._triggerArray, _this._isShown());
            if (_this._config.toggle) _this.toggle();
            return _this;
        }
        (0, $7M9bt._)(Collapse, [
            {
                // Public
                key: "toggle",
                value: function toggle() {
                    if (this._isShown()) this.hide();
                    else this.show();
                }
            },
            {
                key: "show",
                value: function show() {
                    var _this = this;
                    if (this._isTransitioning || this._isShown()) return;
                    var activeChildren = [];
                    // find active children
                    if (this._config.parent) activeChildren = this._getFirstLevelChildren(SELECTOR_ACTIVES).filter(function(element) {
                        return element !== _this._element;
                    }).map(function(element) {
                        return Collapse.getOrCreateInstance(element, {
                            toggle: false
                        });
                    });
                    if (activeChildren.length && activeChildren[0]._isTransitioning) return;
                    var startEvent = EventHandler.trigger(this._element, EVENT_SHOW);
                    if (startEvent.defaultPrevented) return;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = activeChildren[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var activeInstance = _step.value;
                            activeInstance.hide();
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    var dimension = this._getDimension();
                    this._element.classList.remove(CLASS_NAME_COLLAPSE);
                    this._element.classList.add(CLASS_NAME_COLLAPSING);
                    this._element.style[dimension] = 0;
                    this._addAriaAndCollapsedClass(this._triggerArray, true);
                    this._isTransitioning = true;
                    var complete = function() {
                        _this._isTransitioning = false;
                        _this._element.classList.remove(CLASS_NAME_COLLAPSING);
                        _this._element.classList.add(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW);
                        _this._element.style[dimension] = "";
                        EventHandler.trigger(_this._element, EVENT_SHOWN);
                    };
                    var capitalizedDimension = dimension[0].toUpperCase() + dimension.slice(1);
                    var scrollSize = "scroll".concat(capitalizedDimension);
                    this._queueCallback(complete, this._element, true);
                    this._element.style[dimension] = "".concat(this._element[scrollSize], "px");
                }
            },
            {
                key: "hide",
                value: function hide() {
                    var _this = this;
                    if (this._isTransitioning || !this._isShown()) return;
                    var startEvent = EventHandler.trigger(this._element, EVENT_HIDE);
                    if (startEvent.defaultPrevented) return;
                    var dimension = this._getDimension();
                    this._element.style[dimension] = "".concat(this._element.getBoundingClientRect()[dimension], "px");
                    index_js.reflow(this._element);
                    this._element.classList.add(CLASS_NAME_COLLAPSING);
                    this._element.classList.remove(CLASS_NAME_COLLAPSE, CLASS_NAME_SHOW);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = this._triggerArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var trigger = _step.value;
                            var element = SelectorEngine.getElementFromSelector(trigger);
                            if (element && !this._isShown(element)) this._addAriaAndCollapsedClass([
                                trigger
                            ], false);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    this._isTransitioning = true;
                    var complete = function() {
                        _this._isTransitioning = false;
                        _this._element.classList.remove(CLASS_NAME_COLLAPSING);
                        _this._element.classList.add(CLASS_NAME_COLLAPSE);
                        EventHandler.trigger(_this._element, EVENT_HIDDEN);
                    };
                    this._element.style[dimension] = "";
                    this._queueCallback(complete, this._element, true);
                }
            },
            {
                key: "_isShown",
                value: function _isShown() {
                    var element = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this._element;
                    return element.classList.contains(CLASS_NAME_SHOW);
                }
            },
            {
                // Private
                key: "_configAfterMerge",
                value: function _configAfterMerge(config) {
                    config.toggle = Boolean(config.toggle); // Coerce string values
                    config.parent = index_js.getElement(config.parent);
                    return config;
                }
            },
            {
                key: "_getDimension",
                value: function _getDimension() {
                    return this._element.classList.contains(CLASS_NAME_HORIZONTAL) ? WIDTH : HEIGHT;
                }
            },
            {
                key: "_initializeChildren",
                value: function _initializeChildren() {
                    if (!this._config.parent) return;
                    var children = this._getFirstLevelChildren(SELECTOR_DATA_TOGGLE);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var element = _step.value;
                            var selected = SelectorEngine.getElementFromSelector(element);
                            if (selected) this._addAriaAndCollapsedClass([
                                element
                            ], this._isShown(selected));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            },
            {
                key: "_getFirstLevelChildren",
                value: function _getFirstLevelChildren(selector) {
                    var children = SelectorEngine.find(CLASS_NAME_DEEPER_CHILDREN, this._config.parent);
                    // remove children if greater depth
                    return SelectorEngine.find(selector, this._config.parent).filter(function(element) {
                        return !children.includes(element);
                    });
                }
            },
            {
                key: "_addAriaAndCollapsedClass",
                value: function _addAriaAndCollapsedClass(triggerArray, isOpen) {
                    if (!triggerArray.length) return;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = triggerArray[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var element = _step.value;
                            element.classList.toggle(CLASS_NAME_COLLAPSED, !isOpen);
                            element.setAttribute("aria-expanded", isOpen);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            }
        ], [
            {
                key: "Default",
                get: // Getters
                function get() {
                    return Default;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return NAME;
                }
            },
            {
                key: "jQueryInterface",
                value: // Static
                function jQueryInterface(config) {
                    var _config = {};
                    if (typeof config === "string" && /show|hide/.test(config)) _config.toggle = false;
                    return this.each(function() {
                        var data = Collapse.getOrCreateInstance(this, _config);
                        if (typeof config === "string") {
                            if (typeof data[config] === "undefined") throw new TypeError('No method named "'.concat(config, '"'));
                            data[config]();
                        }
                    });
                }
            }
        ]);
        return Collapse;
    }(BaseComponent);
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API, SELECTOR_DATA_TOGGLE, function(event) {
        // preventDefault only for <a> elements (which change the URL) not inside the collapsible element
        if (event.target.tagName === "A" || event.delegateTarget && event.delegateTarget.tagName === "A") event.preventDefault();
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = SelectorEngine.getMultipleElementsFromSelector(this)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var element = _step.value;
                Collapse.getOrCreateInstance(element, {
                    toggle: false
                }).toggle();
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    /**
   * jQuery
   */ index_js.defineJQueryPlugin(Collapse);
    return Collapse;
});


var $7a101154e6cf9c06$exports = {};

var $eCXNS = parcelRequire("eCXNS");

var $7M9bt = parcelRequire("7M9bt");

var $5IDCd = parcelRequire("5IDCd");

var $8cFxo = parcelRequire("8cFxo");

var $1YTSz = parcelRequire("1YTSz");




/*!
  * Bootstrap tab.js v5.3.2 (https://getbootstrap.com/)
  * Copyright 2011-2023 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    $7a101154e6cf9c06$exports = factory((parcelRequire("31kbN")), (parcelRequire("jYOfh")), (parcelRequire("4JvcO")), (parcelRequire("c0GPz")));
})(undefined, function(BaseComponent, EventHandler, SelectorEngine, index_js) {
    "use strict";
    /**
   * --------------------------------------------------------------------------
   * Bootstrap tab.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ var NAME = "tab";
    var DATA_KEY = "bs.tab";
    var EVENT_KEY = ".".concat(DATA_KEY);
    var EVENT_HIDE = "hide".concat(EVENT_KEY);
    var EVENT_HIDDEN = "hidden".concat(EVENT_KEY);
    var EVENT_SHOW = "show".concat(EVENT_KEY);
    var EVENT_SHOWN = "shown".concat(EVENT_KEY);
    var EVENT_CLICK_DATA_API = "click".concat(EVENT_KEY);
    var EVENT_KEYDOWN = "keydown".concat(EVENT_KEY);
    var EVENT_LOAD_DATA_API = "load".concat(EVENT_KEY);
    var ARROW_LEFT_KEY = "ArrowLeft";
    var ARROW_RIGHT_KEY = "ArrowRight";
    var ARROW_UP_KEY = "ArrowUp";
    var ARROW_DOWN_KEY = "ArrowDown";
    var HOME_KEY = "Home";
    var END_KEY = "End";
    var CLASS_NAME_ACTIVE = "active";
    var CLASS_NAME_FADE = "fade";
    var CLASS_NAME_SHOW = "show";
    var CLASS_DROPDOWN = "dropdown";
    var SELECTOR_DROPDOWN_TOGGLE = ".dropdown-toggle";
    var SELECTOR_DROPDOWN_MENU = ".dropdown-menu";
    var NOT_SELECTOR_DROPDOWN_TOGGLE = ":not(".concat(SELECTOR_DROPDOWN_TOGGLE, ")");
    var SELECTOR_TAB_PANEL = '.list-group, .nav, [role="tablist"]';
    var SELECTOR_OUTER = ".nav-item, .list-group-item";
    var SELECTOR_INNER = ".nav-link".concat(NOT_SELECTOR_DROPDOWN_TOGGLE, ", .list-group-item").concat(NOT_SELECTOR_DROPDOWN_TOGGLE, ', [role="tab"]').concat(NOT_SELECTOR_DROPDOWN_TOGGLE);
    var SELECTOR_DATA_TOGGLE = '[data-bs-toggle="tab"], [data-bs-toggle="pill"], [data-bs-toggle="list"]'; // TODO: could only be `tab` in v6
    var SELECTOR_INNER_ELEM = "".concat(SELECTOR_INNER, ", ").concat(SELECTOR_DATA_TOGGLE);
    var SELECTOR_DATA_TOGGLE_ACTIVE = ".".concat(CLASS_NAME_ACTIVE, '[data-bs-toggle="tab"], .').concat(CLASS_NAME_ACTIVE, '[data-bs-toggle="pill"], .').concat(CLASS_NAME_ACTIVE, '[data-bs-toggle="list"]');
    /**
   * Class definition
   */ var Tab = /*#__PURE__*/ function(BaseComponent) {
        (0, $5IDCd._)(Tab, BaseComponent);
        var _super = (0, $1YTSz._)(Tab);
        function Tab(element) {
            (0, $eCXNS._)(this, Tab);
            var _this;
            _this = _super.call(this, element);
            _this._parent = _this._element.closest(SELECTOR_TAB_PANEL);
            if (!_this._parent) return (0, $8cFxo._)(_this);
            // Set up initial aria attributes
            _this._setInitialAttributes(_this._parent, _this._getChildren());
            EventHandler.on(_this._element, EVENT_KEYDOWN, function(event) {
                return _this._keydown(event);
            });
            return _this;
        }
        (0, $7M9bt._)(Tab, [
            {
                // Public
                key: "show",
                value: function show() {
                    // Shows this elem and deactivate the active sibling if exists
                    var innerElem = this._element;
                    if (this._elemIsActive(innerElem)) return;
                    // Search for active tab on same parent to deactivate it
                    var active = this._getActiveElem();
                    var hideEvent = active ? EventHandler.trigger(active, EVENT_HIDE, {
                        relatedTarget: innerElem
                    }) : null;
                    var showEvent = EventHandler.trigger(innerElem, EVENT_SHOW, {
                        relatedTarget: active
                    });
                    if (showEvent.defaultPrevented || hideEvent && hideEvent.defaultPrevented) return;
                    this._deactivate(active, innerElem);
                    this._activate(innerElem, active);
                }
            },
            {
                // Private
                key: "_activate",
                value: function _activate(element, relatedElem) {
                    var _this = this;
                    if (!element) return;
                    element.classList.add(CLASS_NAME_ACTIVE);
                    this._activate(SelectorEngine.getElementFromSelector(element)); // Search and activate/show the proper section
                    var complete = function() {
                        if (element.getAttribute("role") !== "tab") {
                            element.classList.add(CLASS_NAME_SHOW);
                            return;
                        }
                        element.removeAttribute("tabindex");
                        element.setAttribute("aria-selected", true);
                        _this._toggleDropDown(element, true);
                        EventHandler.trigger(element, EVENT_SHOWN, {
                            relatedTarget: relatedElem
                        });
                    };
                    this._queueCallback(complete, element, element.classList.contains(CLASS_NAME_FADE));
                }
            },
            {
                key: "_deactivate",
                value: function _deactivate(element, relatedElem) {
                    var _this = this;
                    if (!element) return;
                    element.classList.remove(CLASS_NAME_ACTIVE);
                    element.blur();
                    this._deactivate(SelectorEngine.getElementFromSelector(element)); // Search and deactivate the shown section too
                    var complete = function() {
                        if (element.getAttribute("role") !== "tab") {
                            element.classList.remove(CLASS_NAME_SHOW);
                            return;
                        }
                        element.setAttribute("aria-selected", false);
                        element.setAttribute("tabindex", "-1");
                        _this._toggleDropDown(element, false);
                        EventHandler.trigger(element, EVENT_HIDDEN, {
                            relatedTarget: relatedElem
                        });
                    };
                    this._queueCallback(complete, element, element.classList.contains(CLASS_NAME_FADE));
                }
            },
            {
                key: "_keydown",
                value: function _keydown(event) {
                    if (![
                        ARROW_LEFT_KEY,
                        ARROW_RIGHT_KEY,
                        ARROW_UP_KEY,
                        ARROW_DOWN_KEY,
                        HOME_KEY,
                        END_KEY
                    ].includes(event.key)) return;
                    event.stopPropagation(); // stopPropagation/preventDefault both added to support up/down keys without scrolling the page
                    event.preventDefault();
                    var children = this._getChildren().filter(function(element) {
                        return !index_js.isDisabled(element);
                    });
                    var nextActiveElement;
                    if ([
                        HOME_KEY,
                        END_KEY
                    ].includes(event.key)) nextActiveElement = children[event.key === HOME_KEY ? 0 : children.length - 1];
                    else {
                        var isNext = [
                            ARROW_RIGHT_KEY,
                            ARROW_DOWN_KEY
                        ].includes(event.key);
                        nextActiveElement = index_js.getNextActiveElement(children, event.target, isNext, true);
                    }
                    if (nextActiveElement) {
                        nextActiveElement.focus({
                            preventScroll: true
                        });
                        Tab.getOrCreateInstance(nextActiveElement).show();
                    }
                }
            },
            {
                key: "_getChildren",
                value: function _getChildren() {
                    // collection of inner elements
                    return SelectorEngine.find(SELECTOR_INNER_ELEM, this._parent);
                }
            },
            {
                key: "_getActiveElem",
                value: function _getActiveElem() {
                    var _this = this;
                    return this._getChildren().find(function(child) {
                        return _this._elemIsActive(child);
                    }) || null;
                }
            },
            {
                key: "_setInitialAttributes",
                value: function _setInitialAttributes(parent, children) {
                    this._setAttributeIfNotExists(parent, "role", "tablist");
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = children[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var child = _step.value;
                            this._setInitialAttributesOnChild(child);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            },
            {
                key: "_setInitialAttributesOnChild",
                value: function _setInitialAttributesOnChild(child) {
                    child = this._getInnerElement(child);
                    var isActive = this._elemIsActive(child);
                    var outerElem = this._getOuterElement(child);
                    child.setAttribute("aria-selected", isActive);
                    if (outerElem !== child) this._setAttributeIfNotExists(outerElem, "role", "presentation");
                    if (!isActive) child.setAttribute("tabindex", "-1");
                    this._setAttributeIfNotExists(child, "role", "tab");
                    // set attributes to the related panel too
                    this._setInitialAttributesOnTargetPanel(child);
                }
            },
            {
                key: "_setInitialAttributesOnTargetPanel",
                value: function _setInitialAttributesOnTargetPanel(child) {
                    var target = SelectorEngine.getElementFromSelector(child);
                    if (!target) return;
                    this._setAttributeIfNotExists(target, "role", "tabpanel");
                    if (child.id) this._setAttributeIfNotExists(target, "aria-labelledby", "".concat(child.id));
                }
            },
            {
                key: "_toggleDropDown",
                value: function _toggleDropDown(element, open) {
                    var outerElem = this._getOuterElement(element);
                    if (!outerElem.classList.contains(CLASS_DROPDOWN)) return;
                    var toggle = function(selector, className) {
                        var _$element = SelectorEngine.findOne(selector, outerElem);
                        if (_$element) _$element.classList.toggle(className, open);
                    };
                    toggle(SELECTOR_DROPDOWN_TOGGLE, CLASS_NAME_ACTIVE);
                    toggle(SELECTOR_DROPDOWN_MENU, CLASS_NAME_SHOW);
                    outerElem.setAttribute("aria-expanded", open);
                }
            },
            {
                key: "_setAttributeIfNotExists",
                value: function _setAttributeIfNotExists(element, attribute, value) {
                    if (!element.hasAttribute(attribute)) element.setAttribute(attribute, value);
                }
            },
            {
                key: "_elemIsActive",
                value: function _elemIsActive(elem) {
                    return elem.classList.contains(CLASS_NAME_ACTIVE);
                }
            },
            {
                // Try to get the inner element (usually the .nav-link)
                key: "_getInnerElement",
                value: function _getInnerElement(elem) {
                    return elem.matches(SELECTOR_INNER_ELEM) ? elem : SelectorEngine.findOne(SELECTOR_INNER_ELEM, elem);
                }
            },
            {
                // Try to get the outer element (usually the .nav-item)
                key: "_getOuterElement",
                value: function _getOuterElement(elem) {
                    return elem.closest(SELECTOR_OUTER) || elem;
                }
            }
        ], [
            {
                key: "NAME",
                get: // Getters
                function get() {
                    return NAME;
                }
            },
            {
                key: "jQueryInterface",
                value: // Static
                function jQueryInterface(config) {
                    return this.each(function() {
                        var data = Tab.getOrCreateInstance(this);
                        if (typeof config !== "string") return;
                        if (data[config] === undefined || config.startsWith("_") || config === "constructor") throw new TypeError('No method named "'.concat(config, '"'));
                        data[config]();
                    });
                }
            }
        ]);
        return Tab;
    }(BaseComponent);
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_CLICK_DATA_API, SELECTOR_DATA_TOGGLE, function(event) {
        if ([
            "A",
            "AREA"
        ].includes(this.tagName)) event.preventDefault();
        if (index_js.isDisabled(this)) return;
        Tab.getOrCreateInstance(this).show();
    });
    /**
   * Initialize on focus
   */ EventHandler.on(window, EVENT_LOAD_DATA_API, function() {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = SelectorEngine.find(SELECTOR_DATA_TOGGLE_ACTIVE)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var element = _step.value;
                Tab.getOrCreateInstance(element);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    /**
   * jQuery
   */ index_js.defineJQueryPlugin(Tab);
    return Tab;
});


var $c5896a5561e49d24$exports = {};

var $eCXNS = parcelRequire("eCXNS");

var $7M9bt = parcelRequire("7M9bt");

var $9HFeY = parcelRequire("9HFeY");

var $hzVoy = parcelRequire("hzVoy");
function $1a31f82b87f62ce4$export$e4187255aefbc259(object, property) {
    while(!Object.prototype.hasOwnProperty.call(object, property)){
        object = (0, $hzVoy._get_prototype_of)(object);
        if (object === null) break;
    }
    return object;
}


function $3eca773514dd6a70$export$afb3516d9d608401(target, property, receiver) {
    if (typeof Reflect !== "undefined" && Reflect.get) $3eca773514dd6a70$export$afb3516d9d608401 = Reflect.get;
    else $3eca773514dd6a70$export$afb3516d9d608401 = function get(target, property, receiver) {
        var base = (0, $1a31f82b87f62ce4$export$e4187255aefbc259)(target, property);
        if (!base) return;
        var desc = Object.getOwnPropertyDescriptor(base, property);
        if (desc.get) return desc.get.call(receiver || target);
        return desc.value;
    };
    return $3eca773514dd6a70$export$afb3516d9d608401(target, property, receiver || target);
}



var $hzVoy = parcelRequire("hzVoy");

var $5IDCd = parcelRequire("5IDCd");

var $4udDG = parcelRequire("4udDG");

var $2b6Uo = parcelRequire("2b6Uo");

var $1YTSz = parcelRequire("1YTSz");






/*!
  * Bootstrap dropdown.js v5.3.2 (https://getbootstrap.com/)
  * Copyright 2011-2023 The Bootstrap Authors (https://github.com/twbs/bootstrap/graphs/contributors)
  * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
  */ (function(global, factory) {
    $c5896a5561e49d24$exports = factory((parcelRequire("2VHbc")), (parcelRequire("31kbN")), (parcelRequire("jYOfh")), (parcelRequire("jIYj0")), (parcelRequire("4JvcO")), (parcelRequire("c0GPz")));
})(undefined, function(Popper, BaseComponent, EventHandler, Manipulator, SelectorEngine, index_js) {
    "use strict";
    var _interopNamespaceDefault = function _interopNamespaceDefault(e) {
        var n = Object.create(null, (0, $9HFeY._)({}, Symbol.toStringTag, {
            value: "Module"
        }));
        if (e) {
            var _loop = function(k) {
                if (k !== "default") {
                    var d = Object.getOwnPropertyDescriptor(e, k);
                    Object.defineProperty(n, k, d.get ? d : {
                        enumerable: true,
                        get: function() {
                            return e[k];
                        }
                    });
                }
            };
            for(var k in e)_loop(k);
        }
        n.default = e;
        return Object.freeze(n);
    };
    var Popper__namespace = /*#__PURE__*/ _interopNamespaceDefault(Popper);
    /**
   * --------------------------------------------------------------------------
   * Bootstrap dropdown.js
   * Licensed under MIT (https://github.com/twbs/bootstrap/blob/main/LICENSE)
   * --------------------------------------------------------------------------
   */ /**
   * Constants
   */ var NAME = "dropdown";
    var DATA_KEY = "bs.dropdown";
    var EVENT_KEY = ".".concat(DATA_KEY);
    var DATA_API_KEY = ".data-api";
    var ESCAPE_KEY = "Escape";
    var TAB_KEY = "Tab";
    var ARROW_UP_KEY = "ArrowUp";
    var ARROW_DOWN_KEY = "ArrowDown";
    var RIGHT_MOUSE_BUTTON = 2; // MouseEvent.button value for the secondary button, usually the right button
    var EVENT_HIDE = "hide".concat(EVENT_KEY);
    var EVENT_HIDDEN = "hidden".concat(EVENT_KEY);
    var EVENT_SHOW = "show".concat(EVENT_KEY);
    var EVENT_SHOWN = "shown".concat(EVENT_KEY);
    var EVENT_CLICK_DATA_API = "click".concat(EVENT_KEY).concat(DATA_API_KEY);
    var EVENT_KEYDOWN_DATA_API = "keydown".concat(EVENT_KEY).concat(DATA_API_KEY);
    var EVENT_KEYUP_DATA_API = "keyup".concat(EVENT_KEY).concat(DATA_API_KEY);
    var CLASS_NAME_SHOW = "show";
    var CLASS_NAME_DROPUP = "dropup";
    var CLASS_NAME_DROPEND = "dropend";
    var CLASS_NAME_DROPSTART = "dropstart";
    var CLASS_NAME_DROPUP_CENTER = "dropup-center";
    var CLASS_NAME_DROPDOWN_CENTER = "dropdown-center";
    var SELECTOR_DATA_TOGGLE = '[data-bs-toggle="dropdown"]:not(.disabled):not(:disabled)';
    var SELECTOR_DATA_TOGGLE_SHOWN = "".concat(SELECTOR_DATA_TOGGLE, ".").concat(CLASS_NAME_SHOW);
    var SELECTOR_MENU = ".dropdown-menu";
    var SELECTOR_NAVBAR = ".navbar";
    var SELECTOR_NAVBAR_NAV = ".navbar-nav";
    var SELECTOR_VISIBLE_ITEMS = ".dropdown-menu .dropdown-item:not(.disabled):not(:disabled)";
    var PLACEMENT_TOP = index_js.isRTL() ? "top-end" : "top-start";
    var PLACEMENT_TOPEND = index_js.isRTL() ? "top-start" : "top-end";
    var PLACEMENT_BOTTOM = index_js.isRTL() ? "bottom-end" : "bottom-start";
    var PLACEMENT_BOTTOMEND = index_js.isRTL() ? "bottom-start" : "bottom-end";
    var PLACEMENT_RIGHT = index_js.isRTL() ? "left-start" : "right-start";
    var PLACEMENT_LEFT = index_js.isRTL() ? "right-start" : "left-start";
    var PLACEMENT_TOPCENTER = "top";
    var PLACEMENT_BOTTOMCENTER = "bottom";
    var Default = {
        autoClose: true,
        boundary: "clippingParents",
        display: "dynamic",
        offset: [
            0,
            2
        ],
        popperConfig: null,
        reference: "toggle"
    };
    var DefaultType = {
        autoClose: "(boolean|string)",
        boundary: "(string|element)",
        display: "string",
        offset: "(array|string|function)",
        popperConfig: "(null|object|function)",
        reference: "(string|element|object)"
    };
    /**
   * Class definition
   */ var Dropdown = /*#__PURE__*/ function(BaseComponent) {
        (0, $5IDCd._)(Dropdown, BaseComponent);
        var _super = (0, $1YTSz._)(Dropdown);
        function Dropdown(element, config) {
            (0, $eCXNS._)(this, Dropdown);
            var _this;
            _this = _super.call(this, element, config);
            _this._popper = null;
            _this._parent = _this._element.parentNode; // dropdown wrapper
            // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
            _this._menu = SelectorEngine.next(_this._element, SELECTOR_MENU)[0] || SelectorEngine.prev(_this._element, SELECTOR_MENU)[0] || SelectorEngine.findOne(SELECTOR_MENU, _this._parent);
            _this._inNavbar = _this._detectNavbar();
            return _this;
        }
        (0, $7M9bt._)(Dropdown, [
            {
                // Public
                key: "toggle",
                value: function toggle() {
                    return this._isShown() ? this.hide() : this.show();
                }
            },
            {
                key: "show",
                value: function show() {
                    var _instance;
                    if (index_js.isDisabled(this._element) || this._isShown()) return;
                    var relatedTarget = {
                        relatedTarget: this._element
                    };
                    var showEvent = EventHandler.trigger(this._element, EVENT_SHOW, relatedTarget);
                    if (showEvent.defaultPrevented) return;
                    this._createPopper();
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    // If this is a touch-enabled device we add extra
                    // empty mouseover listeners to the body's immediate children;
                    // only needed because of broken event delegation on iOS
                    // https://www.quirksmode.org/blog/archives/2014/02/mouse_event_bub.html
                    if ("ontouchstart" in document.documentElement && !this._parent.closest(SELECTOR_NAVBAR_NAV)) try {
                        for(var _iterator = (_instance = []).concat.apply(_instance, (0, $2b6Uo._)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var element = _step.value;
                            EventHandler.on(element, "mouseover", index_js.noop);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    this._element.focus();
                    this._element.setAttribute("aria-expanded", true);
                    this._menu.classList.add(CLASS_NAME_SHOW);
                    this._element.classList.add(CLASS_NAME_SHOW);
                    EventHandler.trigger(this._element, EVENT_SHOWN, relatedTarget);
                }
            },
            {
                key: "hide",
                value: function hide() {
                    if (index_js.isDisabled(this._element) || !this._isShown()) return;
                    var relatedTarget = {
                        relatedTarget: this._element
                    };
                    this._completeHide(relatedTarget);
                }
            },
            {
                key: "dispose",
                value: function dispose() {
                    if (this._popper) this._popper.destroy();
                    (0, $3eca773514dd6a70$export$afb3516d9d608401)((0, $hzVoy._)(Dropdown.prototype), "dispose", this).call(this);
                }
            },
            {
                key: "update",
                value: function update() {
                    this._inNavbar = this._detectNavbar();
                    if (this._popper) this._popper.update();
                }
            },
            {
                // Private
                key: "_completeHide",
                value: function _completeHide(relatedTarget) {
                    var _instance;
                    var hideEvent = EventHandler.trigger(this._element, EVENT_HIDE, relatedTarget);
                    if (hideEvent.defaultPrevented) return;
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    // If this is a touch-enabled device we remove the extra
                    // empty mouseover listeners we added for iOS support
                    if ("ontouchstart" in document.documentElement) try {
                        for(var _iterator = (_instance = []).concat.apply(_instance, (0, $2b6Uo._)(document.body.children))[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var element = _step.value;
                            EventHandler.off(element, "mouseover", index_js.noop);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    if (this._popper) this._popper.destroy();
                    this._menu.classList.remove(CLASS_NAME_SHOW);
                    this._element.classList.remove(CLASS_NAME_SHOW);
                    this._element.setAttribute("aria-expanded", "false");
                    Manipulator.removeDataAttribute(this._menu, "popper");
                    EventHandler.trigger(this._element, EVENT_HIDDEN, relatedTarget);
                }
            },
            {
                key: "_getConfig",
                value: function _getConfig(config) {
                    config = (0, $3eca773514dd6a70$export$afb3516d9d608401)((0, $hzVoy._)(Dropdown.prototype), "_getConfig", this).call(this, config);
                    if (typeof config.reference === "object" && !index_js.isElement(config.reference) && typeof config.reference.getBoundingClientRect !== "function") // Popper virtual elements require a getBoundingClientRect method
                    throw new TypeError("".concat(NAME.toUpperCase(), ': Option "reference" provided type "object" without a required "getBoundingClientRect" method.'));
                    return config;
                }
            },
            {
                key: "_createPopper",
                value: function _createPopper() {
                    if (typeof Popper__namespace === "undefined") throw new TypeError("Bootstrap's dropdowns require Popper (https://popper.js.org)");
                    var referenceElement = this._element;
                    if (this._config.reference === "parent") referenceElement = this._parent;
                    else if (index_js.isElement(this._config.reference)) referenceElement = index_js.getElement(this._config.reference);
                    else if (typeof this._config.reference === "object") referenceElement = this._config.reference;
                    var popperConfig = this._getPopperConfig();
                    this._popper = Popper__namespace.createPopper(referenceElement, this._menu, popperConfig);
                }
            },
            {
                key: "_isShown",
                value: function _isShown() {
                    return this._menu.classList.contains(CLASS_NAME_SHOW);
                }
            },
            {
                key: "_getPlacement",
                value: function _getPlacement() {
                    var parentDropdown = this._parent;
                    if (parentDropdown.classList.contains(CLASS_NAME_DROPEND)) return PLACEMENT_RIGHT;
                    if (parentDropdown.classList.contains(CLASS_NAME_DROPSTART)) return PLACEMENT_LEFT;
                    if (parentDropdown.classList.contains(CLASS_NAME_DROPUP_CENTER)) return PLACEMENT_TOPCENTER;
                    if (parentDropdown.classList.contains(CLASS_NAME_DROPDOWN_CENTER)) return PLACEMENT_BOTTOMCENTER;
                    // We need to trim the value because custom properties can also include spaces
                    var isEnd = getComputedStyle(this._menu).getPropertyValue("--bs-position").trim() === "end";
                    if (parentDropdown.classList.contains(CLASS_NAME_DROPUP)) return isEnd ? PLACEMENT_TOPEND : PLACEMENT_TOP;
                    return isEnd ? PLACEMENT_BOTTOMEND : PLACEMENT_BOTTOM;
                }
            },
            {
                key: "_detectNavbar",
                value: function _detectNavbar() {
                    return this._element.closest(SELECTOR_NAVBAR) !== null;
                }
            },
            {
                key: "_getOffset",
                value: function _getOffset() {
                    var _this = this;
                    var offset = this._config.offset;
                    if (typeof offset === "string") return offset.split(",").map(function(value) {
                        return Number.parseInt(value, 10);
                    });
                    if (typeof offset === "function") return function(popperData) {
                        return offset(popperData, _this._element);
                    };
                    return offset;
                }
            },
            {
                key: "_getPopperConfig",
                value: function _getPopperConfig() {
                    var defaultBsPopperConfig = {
                        placement: this._getPlacement(),
                        modifiers: [
                            {
                                name: "preventOverflow",
                                options: {
                                    boundary: this._config.boundary
                                }
                            },
                            {
                                name: "offset",
                                options: {
                                    offset: this._getOffset()
                                }
                            }
                        ]
                    };
                    // Disable Popper if we have a static display or Dropdown is in Navbar
                    if (this._inNavbar || this._config.display === "static") {
                        Manipulator.setDataAttribute(this._menu, "popper", "static"); // TODO: v6 remove
                        defaultBsPopperConfig.modifiers = [
                            {
                                name: "applyStyles",
                                enabled: false
                            }
                        ];
                    }
                    return (0, $4udDG._)({}, defaultBsPopperConfig, index_js.execute(this._config.popperConfig, [
                        defaultBsPopperConfig
                    ]));
                }
            },
            {
                key: "_selectMenuItem",
                value: function _selectMenuItem(param) {
                    var key = param.key, target = param.target;
                    var items = SelectorEngine.find(SELECTOR_VISIBLE_ITEMS, this._menu).filter(function(element) {
                        return index_js.isVisible(element);
                    });
                    if (!items.length) return;
                    // if target isn't included in items (e.g. when expanding the dropdown)
                    // allow cycling to get the last item in case key equals ARROW_UP_KEY
                    index_js.getNextActiveElement(items, target, key === ARROW_DOWN_KEY, !items.includes(target)).focus();
                }
            }
        ], [
            {
                key: "Default",
                get: // Getters
                function get() {
                    return Default;
                }
            },
            {
                key: "DefaultType",
                get: function get() {
                    return DefaultType;
                }
            },
            {
                key: "NAME",
                get: function get() {
                    return NAME;
                }
            },
            {
                key: "jQueryInterface",
                value: // Static
                function jQueryInterface(config) {
                    return this.each(function() {
                        var data = Dropdown.getOrCreateInstance(this, config);
                        if (typeof config !== "string") return;
                        if (typeof data[config] === "undefined") throw new TypeError('No method named "'.concat(config, '"'));
                        data[config]();
                    });
                }
            },
            {
                key: "clearMenus",
                value: function clearMenus(event) {
                    if (event.button === RIGHT_MOUSE_BUTTON || event.type === "keyup" && event.key !== TAB_KEY) return;
                    var openToggles = SelectorEngine.find(SELECTOR_DATA_TOGGLE_SHOWN);
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = openToggles[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var toggle = _step.value;
                            var context = Dropdown.getInstance(toggle);
                            if (!context || context._config.autoClose === false) continue;
                            var composedPath = event.composedPath();
                            var isMenuTarget = composedPath.includes(context._menu);
                            if (composedPath.includes(context._element) || context._config.autoClose === "inside" && !isMenuTarget || context._config.autoClose === "outside" && isMenuTarget) continue;
                            // Tab navigation through the dropdown menu or events from contained inputs shouldn't close the menu
                            if (context._menu.contains(event.target) && (event.type === "keyup" && event.key === TAB_KEY || /input|select|option|textarea|form/i.test(event.target.tagName))) continue;
                            var relatedTarget = {
                                relatedTarget: context._element
                            };
                            if (event.type === "click") relatedTarget.clickEvent = event;
                            context._completeHide(relatedTarget);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }
            },
            {
                key: "dataApiKeydownHandler",
                value: function dataApiKeydownHandler(event) {
                    // If not an UP | DOWN | ESCAPE key => not a dropdown command
                    // If input/textarea && if key is other than ESCAPE => not a dropdown command
                    var isInput = /input|textarea/i.test(event.target.tagName);
                    var isEscapeEvent = event.key === ESCAPE_KEY;
                    var isUpOrDownEvent = [
                        ARROW_UP_KEY,
                        ARROW_DOWN_KEY
                    ].includes(event.key);
                    if (!isUpOrDownEvent && !isEscapeEvent) return;
                    if (isInput && !isEscapeEvent) return;
                    event.preventDefault();
                    // TODO: v6 revert #37011 & change markup https://getbootstrap.com/docs/5.3/forms/input-group/
                    var getToggleButton = this.matches(SELECTOR_DATA_TOGGLE) ? this : SelectorEngine.prev(this, SELECTOR_DATA_TOGGLE)[0] || SelectorEngine.next(this, SELECTOR_DATA_TOGGLE)[0] || SelectorEngine.findOne(SELECTOR_DATA_TOGGLE, event.delegateTarget.parentNode);
                    var instance = Dropdown.getOrCreateInstance(getToggleButton);
                    if (isUpOrDownEvent) {
                        event.stopPropagation();
                        instance.show();
                        instance._selectMenuItem(event);
                        return;
                    }
                    if (instance._isShown()) {
                        // else is escape and we check if it is shown
                        event.stopPropagation();
                        instance.hide();
                        getToggleButton.focus();
                    }
                }
            }
        ]);
        return Dropdown;
    }(BaseComponent);
    /**
   * Data API implementation
   */ EventHandler.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_DATA_TOGGLE, Dropdown.dataApiKeydownHandler);
    EventHandler.on(document, EVENT_KEYDOWN_DATA_API, SELECTOR_MENU, Dropdown.dataApiKeydownHandler);
    EventHandler.on(document, EVENT_CLICK_DATA_API, Dropdown.clearMenus);
    EventHandler.on(document, EVENT_KEYUP_DATA_API, Dropdown.clearMenus);
    EventHandler.on(document, EVENT_CLICK_DATA_API, SELECTOR_DATA_TOGGLE, function(event) {
        event.preventDefault();
        Dropdown.getOrCreateInstance(this).toggle();
    });
    /**
   * jQuery
   */ index_js.defineJQueryPlugin(Dropdown);
    return Dropdown;
});


/* import $ from "jquery"; */ // Sticky header
document.addEventListener("DOMContentLoaded", function() {
    window.addEventListener("scroll", function() {
        if (document.querySelector("body")) {
            var body = document.querySelector("body");
            if (window.scrollY > 50) body.classList.add("fixed");
            else body.classList.remove("fixed");
        }
    });
});
// back-to-top
(function() {
    var trackScroll = function trackScroll() {
        var scrolled = window.scrollY;
        var coords = document.documentElement.clientHeight;
        if (scrolled > coords) goTopBtn.classList.add("back_to_top-show");
        if (scrolled < coords) goTopBtn.classList.remove("back_to_top-show");
    };
    var backToTop = function backToTop() {
        window.scrollTo(0, 0);
    };
    var back_to_top_button = document.createElement("a");
    back_to_top_button.className = "back_to_top";
    back_to_top_button.title = "Zur\xfcck nach oben";
    back_to_top_button.innerHTML = "&uarr;";
    document.querySelector("body").append(back_to_top_button);
    var goTopBtn = document.querySelector(".back_to_top");
    window.addEventListener("scroll", trackScroll);
    goTopBtn.addEventListener("click", backToTop);
})();
// call button toggle
if (document.getElementById("call-button")) {
    var $e77e57f2abfd97c1$var$togglePopClass = function togglePopClass() {
        if (-1 !== $e77e57f2abfd97c1$var$callPop.className.indexOf("open")) $e77e57f2abfd97c1$var$callPop.className = $e77e57f2abfd97c1$var$callPop.className.replace(" open", "");
        else $e77e57f2abfd97c1$var$callPop.className += " open";
    };
    var $e77e57f2abfd97c1$var$callBtn = document.getElementById("call-button"), $e77e57f2abfd97c1$var$callPop = document.getElementById("call-popup");
    $e77e57f2abfd97c1$var$callBtn.onclick = $e77e57f2abfd97c1$var$togglePopClass;
}
// search overlay
if (document.getElementById("search-button")) {
    var $e77e57f2abfd97c1$var$toggleOvrlClass = function toggleOvrlClass() {
        if (-1 !== $e77e57f2abfd97c1$var$searchOvrl.className.indexOf("open")) {
            $e77e57f2abfd97c1$var$searchOvrl.className = $e77e57f2abfd97c1$var$searchOvrl.className.replace(" open", "");
            document.body.style.overflow = "";
        } else {
            $e77e57f2abfd97c1$var$searchOvrl.className += " open";
            document.body.style.overflow = "hidden";
        }
    };
    var $e77e57f2abfd97c1$var$searchBtn = document.getElementById("search-button"), $e77e57f2abfd97c1$var$searchOvrl = document.getElementById("search-overlay"), $e77e57f2abfd97c1$var$closehOvrl = document.getElementById("close-search-overlay");
    $e77e57f2abfd97c1$var$searchBtn.onclick = $e77e57f2abfd97c1$var$toggleOvrlClass;
    $e77e57f2abfd97c1$var$closehOvrl.onclick = $e77e57f2abfd97c1$var$toggleOvrlClass;
}
// mobile menu
if (document.getElementById("menu-btn")) {
    var $e77e57f2abfd97c1$var$_loop = function(i) {
        $e77e57f2abfd97c1$var$menuLinkLevel1[i].addEventListener("click", function(event) {
            $e77e57f2abfd97c1$var$menuLinkLevel1[i].className += " is-active";
        });
    }, $e77e57f2abfd97c1$var$_loop1 = function(i1) {
        $e77e57f2abfd97c1$var$menuBackButton[i1].addEventListener("click", function(event) {
            var parent = $e77e57f2abfd97c1$var$menuBackButton[i1].parentElement.parentElement.previousElementSibling;
            parent.className = parent.className.replace(" is-active", "");
        });
    };
    var $e77e57f2abfd97c1$var$toggleMenuClass = function toggleMenuClass() {
        if (-1 !== $e77e57f2abfd97c1$var$mainnavArea.className.indexOf("is-active")) {
            $e77e57f2abfd97c1$var$mainnavArea.className = $e77e57f2abfd97c1$var$mainnavArea.className.replace(" is-active", "");
            document.body.style.overflow = "";
        } else {
            $e77e57f2abfd97c1$var$mainnavArea.className += " is-active";
            document.body.style.overflow = "hidden";
        }
        if (-1 !== $e77e57f2abfd97c1$var$menuOverlay.className.indexOf("is-active")) $e77e57f2abfd97c1$var$menuOverlay.className = $e77e57f2abfd97c1$var$menuOverlay.className.replace(" is-active", "");
        else $e77e57f2abfd97c1$var$menuOverlay.className += " is-active";
    };
    var $e77e57f2abfd97c1$var$menuOpen = document.getElementById("menu-btn"), $e77e57f2abfd97c1$var$mainnavArea = document.getElementById("mainnav-area"), $e77e57f2abfd97c1$var$menuClose = document.getElementById("menu-btn-close"), $e77e57f2abfd97c1$var$menuOverlay = document.getElementById("menu-overlay");
    $e77e57f2abfd97c1$var$menuOpen.onclick = $e77e57f2abfd97c1$var$toggleMenuClass;
    $e77e57f2abfd97c1$var$menuClose.onclick = $e77e57f2abfd97c1$var$toggleMenuClass;
    var $e77e57f2abfd97c1$var$menuLinkLevel1 = document.querySelectorAll(".menu-link-level-1");
    for(var $e77e57f2abfd97c1$var$i = 0; $e77e57f2abfd97c1$var$i < $e77e57f2abfd97c1$var$menuLinkLevel1.length; $e77e57f2abfd97c1$var$i++)$e77e57f2abfd97c1$var$_loop($e77e57f2abfd97c1$var$i);
    var $e77e57f2abfd97c1$var$menuBackButton = document.querySelectorAll(".menu-backbtn");
    for(var $e77e57f2abfd97c1$var$i1 = 0; $e77e57f2abfd97c1$var$i1 < $e77e57f2abfd97c1$var$menuBackButton.length; $e77e57f2abfd97c1$var$i1++)$e77e57f2abfd97c1$var$_loop1($e77e57f2abfd97c1$var$i1);
}
// move mainnav out of header into body on mobile
if (document.querySelector("#mainnav-area") != null) {
    var $e77e57f2abfd97c1$var$moveMainNav = function moveMainNav() {
        var a = document.querySelector("header");
        var b = document.querySelector("body");
        var c = document.querySelector("#mainnav-area");
        if (1200 >= window.innerWidth && "a" === c.dataset.location) {
            b.appendChild(c);
            c.dataset.location = "b";
        } else if (1200 < window.innerWidth && "b" === c.dataset.location) {
            a.appendChild(c);
            c.dataset.location = "a";
        }
    };
    window.addEventListener("load", function() {
        $e77e57f2abfd97c1$var$moveMainNav();
        window.addEventListener("resize", function(event) {
            $e77e57f2abfd97c1$var$moveMainNav();
        });
    }, {
        once: true
    });
}


/* import jQuery from "jquery";
window.$ = window.jQuery = jQuery; */ /**
 * Swiper 9.4.1
 * Most modern mobile touch slider and framework with hardware accelerated transitions
 * https://swiperjs.com
 *
 * Copyright 2014-2023 Vladimir Kharlampidi
 *
 * Released under the MIT License
 *
 * Released on: June 13, 2023
 */ /* eslint no-param-reassign: "off" */ 
var $eCXNS = parcelRequire("eCXNS");

var $7M9bt = parcelRequire("7M9bt");

var $iFZdg = parcelRequire("iFZdg");

var $2b6Uo = parcelRequire("2b6Uo");
/**
 * SSR Window 4.0.2
 * Better handling for window object in SSR environment
 * https://github.com/nolimits4web/ssr-window
 *
 * Copyright 2021, Vladimir Kharlampidi
 *
 * Licensed under MIT
 *
 * Released on: December 13, 2021
 */ /* eslint-disable no-param-reassign */ function $e7beec05cc3d4f7e$var$isObject(obj) {
    return obj !== null && typeof obj === "object" && "constructor" in obj && obj.constructor === Object;
}
function $e7beec05cc3d4f7e$export$8b58be045bf06082() {
    var target = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, src = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    Object.keys(src).forEach(function(key) {
        if (typeof target[key] === "undefined") target[key] = src[key];
        else if ($e7beec05cc3d4f7e$var$isObject(src[key]) && $e7beec05cc3d4f7e$var$isObject(target[key]) && Object.keys(src[key]).length > 0) $e7beec05cc3d4f7e$export$8b58be045bf06082(target[key], src[key]);
    });
}
var $e7beec05cc3d4f7e$export$3fdcb9b4d81368d8 = {
    body: {},
    addEventListener: function() {},
    removeEventListener: function() {},
    activeElement: {
        blur: function() {},
        nodeName: ""
    },
    querySelector: function() {
        return null;
    },
    querySelectorAll: function() {
        return [];
    },
    getElementById: function() {
        return null;
    },
    createEvent: function() {
        return {
            initEvent: function() {}
        };
    },
    createElement: function() {
        return {
            children: [],
            childNodes: [],
            style: {},
            setAttribute: function() {},
            getElementsByTagName: function() {
                return [];
            }
        };
    },
    createElementNS: function() {
        return {};
    },
    importNode: function() {
        return null;
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    }
};
function $e7beec05cc3d4f7e$export$f65ca476c09acec0() {
    var doc = typeof document !== "undefined" ? document : {};
    $e7beec05cc3d4f7e$export$8b58be045bf06082(doc, $e7beec05cc3d4f7e$export$3fdcb9b4d81368d8);
    return doc;
}
var $e7beec05cc3d4f7e$export$8582633f185c62bb = {
    document: $e7beec05cc3d4f7e$export$3fdcb9b4d81368d8,
    navigator: {
        userAgent: ""
    },
    location: {
        hash: "",
        host: "",
        hostname: "",
        href: "",
        origin: "",
        pathname: "",
        protocol: "",
        search: ""
    },
    history: {
        replaceState: function() {},
        pushState: function() {},
        go: function() {},
        back: function() {}
    },
    CustomEvent: function CustomEvent() {
        return this;
    },
    addEventListener: function() {},
    removeEventListener: function() {},
    getComputedStyle: function() {
        return {
            getPropertyValue: function() {
                return "";
            }
        };
    },
    Image: function() {},
    Date: function() {},
    screen: {},
    setTimeout: function() {},
    clearTimeout: function() {},
    matchMedia: function() {
        return {};
    },
    requestAnimationFrame: function(callback) {
        if (typeof setTimeout === "undefined") {
            callback();
            return null;
        }
        return setTimeout(callback, 0);
    },
    cancelAnimationFrame: function(id) {
        if (typeof setTimeout === "undefined") return;
        clearTimeout(id);
    }
};
function $e7beec05cc3d4f7e$export$38b2d434cce3ea22() {
    var win = typeof window !== "undefined" ? window : {};
    $e7beec05cc3d4f7e$export$8b58be045bf06082(win, $e7beec05cc3d4f7e$export$8582633f185c62bb);
    return win;
}



var $9HFeY = parcelRequire("9HFeY");

var $2b6Uo = parcelRequire("2b6Uo");

function $2530e0d256bb8028$export$8694e5c03a4df8e6(obj) {
    var object = obj;
    Object.keys(object).forEach(function(key) {
        try {
            object[key] = null;
        } catch (e) {
        // no getter for object
        }
        try {
            delete object[key];
        } catch (e) {
        // something got wrong
        }
    });
}
function $2530e0d256bb8028$export$bdd553fddd433dcb(callback) {
    var delay = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    return setTimeout(callback, delay);
}
function $2530e0d256bb8028$export$461939dd4422153() {
    return Date.now();
}
function $2530e0d256bb8028$export$3735103072e4a80(el) {
    var window1 = (0, $e7beec05cc3d4f7e$export$38b2d434cce3ea22)();
    var style;
    if (window1.getComputedStyle) style = window1.getComputedStyle(el, null);
    if (!style && el.currentStyle) style = el.currentStyle;
    if (!style) style = el.style;
    return style;
}
function $2530e0d256bb8028$export$5ec402b7fcf74398(el) {
    var axis = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "x";
    var window1 = (0, $e7beec05cc3d4f7e$export$38b2d434cce3ea22)();
    var matrix;
    var curTransform;
    var transformMatrix;
    var curStyle = $2530e0d256bb8028$export$3735103072e4a80(el, null);
    if (window1.WebKitCSSMatrix) {
        curTransform = curStyle.transform || curStyle.webkitTransform;
        if (curTransform.split(",").length > 6) curTransform = curTransform.split(", ").map(function(a) {
            return a.replace(",", ".");
        }).join(", ");
        // Some old versions of Webkit choke when 'none' is passed; pass
        // empty string instead in this case
        transformMatrix = new window1.WebKitCSSMatrix(curTransform === "none" ? "" : curTransform);
    } else {
        transformMatrix = curStyle.MozTransform || curStyle.OTransform || curStyle.MsTransform || curStyle.msTransform || curStyle.transform || curStyle.getPropertyValue("transform").replace("translate(", "matrix(1, 0, 0, 1,");
        matrix = transformMatrix.toString().split(",");
    }
    if (axis === "x") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m41;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[12]);
        else curTransform = parseFloat(matrix[4]);
    }
    if (axis === "y") {
        // Latest Chrome and webkits Fix
        if (window1.WebKitCSSMatrix) curTransform = transformMatrix.m42;
        else if (matrix.length === 16) curTransform = parseFloat(matrix[13]);
        else curTransform = parseFloat(matrix[5]);
    }
    return curTransform || 0;
}
function $2530e0d256bb8028$export$a6cdc56e425d0d0a(o) {
    return typeof o === "object" && o !== null && o.constructor && Object.prototype.toString.call(o).slice(8, -1) === "Object";
}
function $2530e0d256bb8028$var$isNode(node) {
    // eslint-disable-next-line
    if (typeof window !== "undefined" && typeof window.HTMLElement !== "undefined") return node instanceof HTMLElement;
    return node && (node.nodeType === 1 || node.nodeType === 11);
}
function $2530e0d256bb8028$export$8b58be045bf06082() {
    var _loop = function(i) {
        var nextSource = args[i];
        if (nextSource !== undefined && nextSource !== null && !$2530e0d256bb8028$var$isNode(nextSource)) {
            var keysArray = Object.keys(Object(nextSource)).filter(function(key) {
                return noExtend.indexOf(key) < 0;
            });
            for(var nextIndex = 0, len = keysArray.length; nextIndex < len; nextIndex += 1){
                var nextKey = keysArray[nextIndex];
                var desc = Object.getOwnPropertyDescriptor(nextSource, nextKey);
                if (desc !== undefined && desc.enumerable) {
                    if ($2530e0d256bb8028$export$a6cdc56e425d0d0a(to[nextKey]) && $2530e0d256bb8028$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $2530e0d256bb8028$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else if (!$2530e0d256bb8028$export$a6cdc56e425d0d0a(to[nextKey]) && $2530e0d256bb8028$export$a6cdc56e425d0d0a(nextSource[nextKey])) {
                        to[nextKey] = {};
                        if (nextSource[nextKey].__swiper__) to[nextKey] = nextSource[nextKey];
                        else $2530e0d256bb8028$export$8b58be045bf06082(to[nextKey], nextSource[nextKey]);
                    } else to[nextKey] = nextSource[nextKey];
                }
            }
        }
    };
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var to = Object(args[0]);
    var noExtend = [
        "__proto__",
        "constructor",
        "prototype"
    ];
    for(var i = 1; i < args.length; i += 1)_loop(i);
    return to;
}
function $2530e0d256bb8028$export$a607267f322101fd(el, varName, varValue) {
    el.style.setProperty(varName, varValue);
}
function $2530e0d256bb8028$export$a5dd2b4b1a116d6d(param) {
    var swiper = param.swiper, targetPosition = param.targetPosition, side = param.side;
    var window1 = (0, $e7beec05cc3d4f7e$export$38b2d434cce3ea22)();
    var startPosition = -swiper.translate;
    var startTime = null;
    var time;
    var duration = swiper.params.speed;
    swiper.wrapperEl.style.scrollSnapType = "none";
    window1.cancelAnimationFrame(swiper.cssModeFrameID);
    var dir = targetPosition > startPosition ? "next" : "prev";
    var isOutOfBound = function(current, target) {
        return dir === "next" && current >= target || dir === "prev" && current <= target;
    };
    var animate = function() {
        time = new Date().getTime();
        if (startTime === null) startTime = time;
        var progress = Math.max(Math.min((time - startTime) / duration, 1), 0);
        var easeProgress = 0.5 - Math.cos(progress * Math.PI) / 2;
        var currentPosition = startPosition + easeProgress * (targetPosition - startPosition);
        if (isOutOfBound(currentPosition, targetPosition)) currentPosition = targetPosition;
        swiper.wrapperEl.scrollTo((0, $9HFeY._)({}, side, currentPosition));
        if (isOutOfBound(currentPosition, targetPosition)) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.scrollSnapType = "";
            setTimeout(function() {
                swiper.wrapperEl.style.overflow = "";
                swiper.wrapperEl.scrollTo((0, $9HFeY._)({}, side, currentPosition));
            });
            window1.cancelAnimationFrame(swiper.cssModeFrameID);
            return;
        }
        swiper.cssModeFrameID = window1.requestAnimationFrame(animate);
    };
    animate();
}
function $2530e0d256bb8028$export$616841b86f802685(slideEl) {
    return slideEl.querySelector(".swiper-slide-transform") || slideEl.shadowEl && slideEl.shadowEl.querySelector(".swiper-slide-transform") || slideEl;
}
function $2530e0d256bb8028$export$dc9b7e8989189d9f() {
    var elements = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], selector = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    var found = [];
    elements.forEach(function(el) {
        var _found;
        (_found = found).push.apply(_found, (0, $2b6Uo._)(el.querySelectorAll(selector)));
    });
    return found;
}
function $2530e0d256bb8028$export$eb846d859f2895e6(element) {
    var selector = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "";
    return (0, $2b6Uo._)(element.children).filter(function(el) {
        return el.matches(selector);
    });
}
function $2530e0d256bb8028$export$c8a8987d4410bf2d(tag) {
    var classes = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var _el_classList;
    var el = document.createElement(tag);
    (_el_classList = el.classList).add.apply(_el_classList, (0, $2b6Uo._)(Array.isArray(classes) ? classes : [
        classes
    ]));
    return el;
}
function $2530e0d256bb8028$export$d7820ec56f35bbaa(el) {
    var window1 = (0, $e7beec05cc3d4f7e$export$38b2d434cce3ea22)();
    var document1 = (0, $e7beec05cc3d4f7e$export$f65ca476c09acec0)();
    var box = el.getBoundingClientRect();
    var body = document1.body;
    var clientTop = el.clientTop || body.clientTop || 0;
    var clientLeft = el.clientLeft || body.clientLeft || 0;
    var scrollTop = el === window1 ? window1.scrollY : el.scrollTop;
    var scrollLeft = el === window1 ? window1.scrollX : el.scrollLeft;
    return {
        top: box.top + scrollTop - clientTop,
        left: box.left + scrollLeft - clientLeft
    };
}
function $2530e0d256bb8028$export$392b9fa9626e91e0(el, selector) {
    var prevEls = [];
    while(el.previousElementSibling){
        var prev = el.previousElementSibling; // eslint-disable-line
        if (selector) {
            if (prev.matches(selector)) prevEls.push(prev);
        } else prevEls.push(prev);
        el = prev;
    }
    return prevEls;
}
function $2530e0d256bb8028$export$b245807c30cf5df8(el, selector) {
    var nextEls = [];
    while(el.nextElementSibling){
        var next = el.nextElementSibling; // eslint-disable-line
        if (selector) {
            if (next.matches(selector)) nextEls.push(next);
        } else nextEls.push(next);
        el = next;
    }
    return nextEls;
}
function $2530e0d256bb8028$export$4184470d4bd0f986(el, prop) {
    var window1 = (0, $e7beec05cc3d4f7e$export$38b2d434cce3ea22)();
    return window1.getComputedStyle(el, null).getPropertyValue(prop);
}
function $2530e0d256bb8028$export$371885c503a01623(el) {
    var child = el;
    var i;
    if (child) {
        i = 0;
        // eslint-disable-next-line
        while((child = child.previousSibling) !== null)if (child.nodeType === 1) i += 1;
        return i;
    }
    return undefined;
}
function $2530e0d256bb8028$export$aedc7b608ca8e855(el, selector) {
    var parents = []; // eslint-disable-line
    var parent = el.parentElement; // eslint-disable-line
    while(parent){
        if (selector) {
            if (parent.matches(selector)) parents.push(parent);
        } else parents.push(parent);
        parent = parent.parentElement;
    }
    return parents;
}
function $2530e0d256bb8028$export$6b974c5889da0bb5(el, callback) {
    function fireCallBack(e) {
        if (e.target !== el) return;
        callback.call(el, e);
        el.removeEventListener("transitionend", fireCallBack);
    }
    if (callback) el.addEventListener("transitionend", fireCallBack);
}
function $2530e0d256bb8028$export$863f37913038cf77(el, size, includeMargins) {
    var window1 = (0, $e7beec05cc3d4f7e$export$38b2d434cce3ea22)();
    if (includeMargins) return el[size === "width" ? "offsetWidth" : "offsetHeight"] + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-right" : "margin-top")) + parseFloat(window1.getComputedStyle(el, null).getPropertyValue(size === "width" ? "margin-left" : "margin-bottom"));
    return el.offsetWidth;
}



var $650ff7d2717c3f6c$var$support;
function $650ff7d2717c3f6c$var$calcSupport() {
    var window = (0, $e7beec05cc3d4f7e$export$38b2d434cce3ea22)();
    var document = (0, $e7beec05cc3d4f7e$export$f65ca476c09acec0)();
    return {
        smoothScroll: document.documentElement && document.documentElement.style && "scrollBehavior" in document.documentElement.style,
        touch: !!("ontouchstart" in window || window.DocumentTouch && document instanceof window.DocumentTouch)
    };
}
function $650ff7d2717c3f6c$export$d61c7b85ff180578() {
    if (!$650ff7d2717c3f6c$var$support) $650ff7d2717c3f6c$var$support = $650ff7d2717c3f6c$var$calcSupport();
    return $650ff7d2717c3f6c$var$support;
}




var $1825746e4b4aecad$var$deviceCached;
function $1825746e4b4aecad$var$calcDevice() {
    var userAgent = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).userAgent;
    var support = (0, $650ff7d2717c3f6c$export$d61c7b85ff180578)();
    var window = (0, $e7beec05cc3d4f7e$export$38b2d434cce3ea22)();
    var platform = window.navigator.platform;
    var ua = userAgent || window.navigator.userAgent;
    var device = {
        ios: false,
        android: false
    };
    var screenWidth = window.screen.width;
    var screenHeight = window.screen.height;
    var android = ua.match(/(Android);?[\s\/]+([\d.]+)?/); // eslint-disable-line
    var ipad = ua.match(/(iPad).*OS\s([\d_]+)/);
    var ipod = ua.match(/(iPod)(.*OS\s([\d_]+))?/);
    var iphone = !ipad && ua.match(/(iPhone\sOS|iOS)\s([\d_]+)/);
    var windows = platform === "Win32";
    var macos = platform === "MacIntel";
    // iPadOs 13 fix
    var iPadScreens = [
        "1024x1366",
        "1366x1024",
        "834x1194",
        "1194x834",
        "834x1112",
        "1112x834",
        "768x1024",
        "1024x768",
        "820x1180",
        "1180x820",
        "810x1080",
        "1080x810"
    ];
    if (!ipad && macos && support.touch && iPadScreens.indexOf("".concat(screenWidth, "x").concat(screenHeight)) >= 0) {
        ipad = ua.match(/(Version)\/([\d.]+)/);
        if (!ipad) ipad = [
            0,
            1,
            "13_0_0"
        ];
        macos = false;
    }
    // Android
    if (android && !windows) {
        device.os = "android";
        device.android = true;
    }
    if (ipad || iphone || ipod) {
        device.os = "ios";
        device.ios = true;
    }
    // Export object
    return device;
}
function $1825746e4b4aecad$export$30c823bc834d6ab4() {
    var overrides = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!$1825746e4b4aecad$var$deviceCached) $1825746e4b4aecad$var$deviceCached = $1825746e4b4aecad$var$calcDevice(overrides);
    return $1825746e4b4aecad$var$deviceCached;
}



var $iFZdg = parcelRequire("iFZdg");

var $11ad6cf6563a68be$var$browser;
function $11ad6cf6563a68be$var$calcBrowser() {
    var isSafari = function isSafari() {
        var ua = window.navigator.userAgent.toLowerCase();
        return ua.indexOf("safari") >= 0 && ua.indexOf("chrome") < 0 && ua.indexOf("android") < 0;
    };
    var window = (0, $e7beec05cc3d4f7e$export$38b2d434cce3ea22)();
    var needPerspectiveFix = false;
    if (isSafari()) {
        var ua = String(window.navigator.userAgent);
        if (ua.includes("Version/")) {
            var _ua_split__split__split_map = (0, $iFZdg._)(ua.split("Version/")[1].split(" ")[0].split(".").map(function(num) {
                return Number(num);
            }), 2), major = _ua_split__split__split_map[0], minor = _ua_split__split__split_map[1];
            needPerspectiveFix = major < 16 || major === 16 && minor < 2;
        }
    }
    return {
        isSafari: needPerspectiveFix || isSafari(),
        needPerspectiveFix: needPerspectiveFix,
        isWebView: /(iPhone|iPod|iPad).*AppleWebKit(?!.*Safari)/i.test(window.navigator.userAgent)
    };
}
function $11ad6cf6563a68be$export$89e15fc796a4a429() {
    if (!$11ad6cf6563a68be$var$browser) $11ad6cf6563a68be$var$browser = $11ad6cf6563a68be$var$calcBrowser();
    return $11ad6cf6563a68be$var$browser;
}



function $6d20db31b0c0bc88$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, on = param.on, emit = param.emit;
    var window = (0, $e7beec05cc3d4f7e$export$38b2d434cce3ea22)();
    var observer = null;
    var animationFrame = null;
    var resizeHandler = function() {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("beforeResize");
        emit("resize");
    };
    var createObserver = function() {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        observer = new ResizeObserver(function(entries) {
            animationFrame = window.requestAnimationFrame(function() {
                var width = swiper.width, height = swiper.height;
                var newWidth = width;
                var newHeight = height;
                entries.forEach(function(param) {
                    var contentBoxSize = param.contentBoxSize, contentRect = param.contentRect, target = param.target;
                    if (target && target !== swiper.el) return;
                    newWidth = contentRect ? contentRect.width : (contentBoxSize[0] || contentBoxSize).inlineSize;
                    newHeight = contentRect ? contentRect.height : (contentBoxSize[0] || contentBoxSize).blockSize;
                });
                if (newWidth !== width || newHeight !== height) resizeHandler();
            });
        });
        observer.observe(swiper.el);
    };
    var removeObserver = function() {
        if (animationFrame) window.cancelAnimationFrame(animationFrame);
        if (observer && observer.unobserve && swiper.el) {
            observer.unobserve(swiper.el);
            observer = null;
        }
    };
    var orientationChangeHandler = function() {
        if (!swiper || swiper.destroyed || !swiper.initialized) return;
        emit("orientationchange");
    };
    on("init", function() {
        if (swiper.params.resizeObserver && typeof window.ResizeObserver !== "undefined") {
            createObserver();
            return;
        }
        window.addEventListener("resize", resizeHandler);
        window.addEventListener("orientationchange", orientationChangeHandler);
    });
    on("destroy", function() {
        removeObserver();
        window.removeEventListener("resize", resizeHandler);
        window.removeEventListener("orientationchange", orientationChangeHandler);
    });
}




function $261aaf38d343d095$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    var observers = [];
    var window = (0, $e7beec05cc3d4f7e$export$38b2d434cce3ea22)();
    var attach = function(target) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var ObserverFunc = window.MutationObserver || window.WebkitMutationObserver;
        var observer = new ObserverFunc(function(mutations) {
            // The observerUpdate event should only be triggered
            // once despite the number of mutations.  Additional
            // triggers are redundant and are very costly
            if (swiper.__preventObserver__) return;
            if (mutations.length === 1) {
                emit("observerUpdate", mutations[0]);
                return;
            }
            var observerUpdate = function observerUpdate() {
                emit("observerUpdate", mutations[0]);
            };
            if (window.requestAnimationFrame) window.requestAnimationFrame(observerUpdate);
            else window.setTimeout(observerUpdate, 0);
        });
        observer.observe(target, {
            attributes: typeof options.attributes === "undefined" ? true : options.attributes,
            childList: typeof options.childList === "undefined" ? true : options.childList,
            characterData: typeof options.characterData === "undefined" ? true : options.characterData
        });
        observers.push(observer);
    };
    var init = function() {
        if (!swiper.params.observer) return;
        if (swiper.params.observeParents) {
            var containerParents = (0, $2530e0d256bb8028$export$aedc7b608ca8e855)(swiper.el);
            for(var i = 0; i < containerParents.length; i += 1)attach(containerParents[i]);
        }
        // Observe container
        attach(swiper.el, {
            childList: swiper.params.observeSlideChildren
        });
        // Observe wrapper
        attach(swiper.wrapperEl, {
            attributes: false
        });
    };
    var destroy = function() {
        observers.forEach(function(observer) {
            observer.disconnect();
        });
        observers.splice(0, observers.length);
    };
    extendParams({
        observer: false,
        observeParents: false,
        observeSlideChildren: false
    });
    on("init", init);
    on("destroy", destroy);
}


/* eslint-disable no-underscore-dangle */ 
var $2b6Uo = parcelRequire("2b6Uo");
var $a2c920a5b0d5576c$export$2e2bcd8739ae039 = {
    on: function(events, handler, priority) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        var method = priority ? "unshift" : "push";
        events.split(" ").forEach(function(event) {
            if (!self.eventsListeners[event]) self.eventsListeners[event] = [];
            self.eventsListeners[event][method](handler);
        });
        return self;
    },
    once: function(events, handler, priority) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        function onceHandler() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            self.off(events, onceHandler);
            if (onceHandler.__emitterProxy) delete onceHandler.__emitterProxy;
            handler.apply(self, args);
        }
        onceHandler.__emitterProxy = handler;
        return self.on(events, onceHandler, priority);
    },
    onAny: function(handler, priority) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (typeof handler !== "function") return self;
        var method = priority ? "unshift" : "push";
        if (self.eventsAnyListeners.indexOf(handler) < 0) self.eventsAnyListeners[method](handler);
        return self;
    },
    offAny: function(handler) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsAnyListeners) return self;
        var index = self.eventsAnyListeners.indexOf(handler);
        if (index >= 0) self.eventsAnyListeners.splice(index, 1);
        return self;
    },
    off: function(events, handler) {
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        events.split(" ").forEach(function(event) {
            if (typeof handler === "undefined") self.eventsListeners[event] = [];
            else if (self.eventsListeners[event]) self.eventsListeners[event].forEach(function(eventHandler, index) {
                if (eventHandler === handler || eventHandler.__emitterProxy && eventHandler.__emitterProxy === handler) self.eventsListeners[event].splice(index, 1);
            });
        });
        return self;
    },
    emit: function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var self = this;
        if (!self.eventsListeners || self.destroyed) return self;
        if (!self.eventsListeners) return self;
        var events;
        var data;
        var context;
        if (typeof args[0] === "string" || Array.isArray(args[0])) {
            events = args[0];
            data = args.slice(1, args.length);
            context = self;
        } else {
            events = args[0].events;
            data = args[0].data;
            context = args[0].context || self;
        }
        data.unshift(context);
        var eventsArray = Array.isArray(events) ? events : events.split(" ");
        eventsArray.forEach(function(event) {
            if (self.eventsAnyListeners && self.eventsAnyListeners.length) self.eventsAnyListeners.forEach(function(eventHandler) {
                eventHandler.apply(context, [
                    event
                ].concat((0, $2b6Uo._)(data)));
            });
            if (self.eventsListeners && self.eventsListeners[event]) self.eventsListeners[event].forEach(function(eventHandler) {
                eventHandler.apply(context, data);
            });
        });
        return self;
    }
};



function $bc969395b68fcc55$export$2e2bcd8739ae039() {
    var swiper = this;
    var width;
    var height;
    var el = swiper.el;
    if (typeof swiper.params.width !== "undefined" && swiper.params.width !== null) width = swiper.params.width;
    else width = el.clientWidth;
    if (typeof swiper.params.height !== "undefined" && swiper.params.height !== null) height = swiper.params.height;
    else height = el.clientHeight;
    if (width === 0 && swiper.isHorizontal() || height === 0 && swiper.isVertical()) return;
    // Subtract paddings
    width = width - parseInt((0, $2530e0d256bb8028$export$4184470d4bd0f986)(el, "padding-left") || 0, 10) - parseInt((0, $2530e0d256bb8028$export$4184470d4bd0f986)(el, "padding-right") || 0, 10);
    height = height - parseInt((0, $2530e0d256bb8028$export$4184470d4bd0f986)(el, "padding-top") || 0, 10) - parseInt((0, $2530e0d256bb8028$export$4184470d4bd0f986)(el, "padding-bottom") || 0, 10);
    if (Number.isNaN(width)) width = 0;
    if (Number.isNaN(height)) height = 0;
    Object.assign(swiper, {
        width: width,
        height: height,
        size: swiper.isHorizontal() ? width : height
    });
}



function $f58a94fb8155f41d$export$2e2bcd8739ae039() {
    var getDirectionLabel = function getDirectionLabel(property) {
        if (swiper.isHorizontal()) return property;
        // prettier-ignore
        return ({
            "width": "height",
            "margin-top": "margin-left",
            "margin-bottom ": "margin-right",
            "margin-left": "margin-top",
            "margin-right": "margin-bottom",
            "padding-left": "padding-top",
            "padding-right": "padding-bottom",
            "marginRight": "marginBottom"
        })[property];
    };
    var getDirectionPropertyValue = function getDirectionPropertyValue(node, label) {
        return parseFloat(node.getPropertyValue(getDirectionLabel(label)) || 0);
    };
    var swiper = this;
    var params = swiper.params;
    var wrapperEl = swiper.wrapperEl, slidesEl = swiper.slidesEl, swiperSize = swiper.size, rtl = swiper.rtlTranslate, wrongRTL = swiper.wrongRTL;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    var previousSlidesLength = isVirtual ? swiper.virtual.slides.length : swiper.slides.length;
    var slides = (0, $2530e0d256bb8028$export$eb846d859f2895e6)(slidesEl, ".".concat(swiper.params.slideClass, ", swiper-slide"));
    var slidesLength = isVirtual ? swiper.virtual.slides.length : slides.length;
    var snapGrid = [];
    var slidesGrid = [];
    var slidesSizesGrid = [];
    var offsetBefore = params.slidesOffsetBefore;
    if (typeof offsetBefore === "function") offsetBefore = params.slidesOffsetBefore.call(swiper);
    var offsetAfter = params.slidesOffsetAfter;
    if (typeof offsetAfter === "function") offsetAfter = params.slidesOffsetAfter.call(swiper);
    var previousSnapGridLength = swiper.snapGrid.length;
    var previousSlidesGridLength = swiper.slidesGrid.length;
    var spaceBetween = params.spaceBetween;
    var slidePosition = -offsetBefore;
    var prevSlideSize = 0;
    var index = 0;
    if (typeof swiperSize === "undefined") return;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiperSize;
    else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
    swiper.virtualSize = -spaceBetween;
    // reset margins
    slides.forEach(function(slideEl) {
        if (rtl) slideEl.style.marginLeft = "";
        else slideEl.style.marginRight = "";
        slideEl.style.marginBottom = "";
        slideEl.style.marginTop = "";
    });
    // reset cssMode offsets
    if (params.centeredSlides && params.cssMode) {
        (0, $2530e0d256bb8028$export$a607267f322101fd)(wrapperEl, "--swiper-centered-offset-before", "");
        (0, $2530e0d256bb8028$export$a607267f322101fd)(wrapperEl, "--swiper-centered-offset-after", "");
    }
    var gridEnabled = params.grid && params.grid.rows > 1 && swiper.grid;
    if (gridEnabled) swiper.grid.initSlides(slidesLength);
    // Calc slides
    var slideSize;
    var shouldResetSlideSize = params.slidesPerView === "auto" && params.breakpoints && Object.keys(params.breakpoints).filter(function(key) {
        return typeof params.breakpoints[key].slidesPerView !== "undefined";
    }).length > 0;
    for(var i = 0; i < slidesLength; i += 1){
        slideSize = 0;
        var slide = void 0;
        if (slides[i]) slide = slides[i];
        if (gridEnabled) swiper.grid.updateSlide(i, slide, slidesLength, getDirectionLabel);
        if (slides[i] && (0, $2530e0d256bb8028$export$4184470d4bd0f986)(slide, "display") === "none") continue; // eslint-disable-line
        if (params.slidesPerView === "auto") {
            if (shouldResetSlideSize) slides[i].style[getDirectionLabel("width")] = "";
            var slideStyles = getComputedStyle(slide);
            var currentTransform = slide.style.transform;
            var currentWebKitTransform = slide.style.webkitTransform;
            if (currentTransform) slide.style.transform = "none";
            if (currentWebKitTransform) slide.style.webkitTransform = "none";
            if (params.roundLengths) slideSize = swiper.isHorizontal() ? (0, $2530e0d256bb8028$export$863f37913038cf77)(slide, "width", true) : (0, $2530e0d256bb8028$export$863f37913038cf77)(slide, "height", true);
            else {
                // eslint-disable-next-line
                var width = getDirectionPropertyValue(slideStyles, "width");
                var paddingLeft = getDirectionPropertyValue(slideStyles, "padding-left");
                var paddingRight = getDirectionPropertyValue(slideStyles, "padding-right");
                var marginLeft = getDirectionPropertyValue(slideStyles, "margin-left");
                var marginRight = getDirectionPropertyValue(slideStyles, "margin-right");
                var boxSizing = slideStyles.getPropertyValue("box-sizing");
                if (boxSizing && boxSizing === "border-box") slideSize = width + marginLeft + marginRight;
                else {
                    var clientWidth = slide.clientWidth, offsetWidth = slide.offsetWidth;
                    slideSize = width + paddingLeft + paddingRight + marginLeft + marginRight + (offsetWidth - clientWidth);
                }
            }
            if (currentTransform) slide.style.transform = currentTransform;
            if (currentWebKitTransform) slide.style.webkitTransform = currentWebKitTransform;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
        } else {
            slideSize = (swiperSize - (params.slidesPerView - 1) * spaceBetween) / params.slidesPerView;
            if (params.roundLengths) slideSize = Math.floor(slideSize);
            if (slides[i]) slides[i].style[getDirectionLabel("width")] = "".concat(slideSize, "px");
        }
        if (slides[i]) slides[i].swiperSlideSize = slideSize;
        slidesSizesGrid.push(slideSize);
        if (params.centeredSlides) {
            slidePosition = slidePosition + slideSize / 2 + prevSlideSize / 2 + spaceBetween;
            if (prevSlideSize === 0 && i !== 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (i === 0) slidePosition = slidePosition - swiperSize / 2 - spaceBetween;
            if (Math.abs(slidePosition) < 0.001) slidePosition = 0;
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if (index % params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
        } else {
            if (params.roundLengths) slidePosition = Math.floor(slidePosition);
            if ((index - Math.min(swiper.params.slidesPerGroupSkip, index)) % swiper.params.slidesPerGroup === 0) snapGrid.push(slidePosition);
            slidesGrid.push(slidePosition);
            slidePosition = slidePosition + slideSize + spaceBetween;
        }
        swiper.virtualSize += slideSize + spaceBetween;
        prevSlideSize = slideSize;
        index += 1;
    }
    swiper.virtualSize = Math.max(swiper.virtualSize, swiperSize) + offsetAfter;
    if (rtl && wrongRTL && (params.effect === "slide" || params.effect === "coverflow")) wrapperEl.style.width = "".concat(swiper.virtualSize + spaceBetween, "px");
    if (params.setWrapperSize) wrapperEl.style[getDirectionLabel("width")] = "".concat(swiper.virtualSize + spaceBetween, "px");
    if (gridEnabled) swiper.grid.updateWrapperSize(slideSize, snapGrid, getDirectionLabel);
    // Remove last grid elements depending on width
    if (!params.centeredSlides) {
        var newSlidesGrid = [];
        for(var i1 = 0; i1 < snapGrid.length; i1 += 1){
            var slidesGridItem = snapGrid[i1];
            if (params.roundLengths) slidesGridItem = Math.floor(slidesGridItem);
            if (snapGrid[i1] <= swiper.virtualSize - swiperSize) newSlidesGrid.push(slidesGridItem);
        }
        snapGrid = newSlidesGrid;
        if (Math.floor(swiper.virtualSize - swiperSize) - Math.floor(snapGrid[snapGrid.length - 1]) > 1) snapGrid.push(swiper.virtualSize - swiperSize);
    }
    if (isVirtual && params.loop) {
        var size = slidesSizesGrid[0] + spaceBetween;
        if (params.slidesPerGroup > 1) {
            var groups = Math.ceil((swiper.virtual.slidesBefore + swiper.virtual.slidesAfter) / params.slidesPerGroup);
            var groupSize = size * params.slidesPerGroup;
            for(var i2 = 0; i2 < groups; i2 += 1)snapGrid.push(snapGrid[snapGrid.length - 1] + groupSize);
        }
        for(var i3 = 0; i3 < swiper.virtual.slidesBefore + swiper.virtual.slidesAfter; i3 += 1){
            if (params.slidesPerGroup === 1) snapGrid.push(snapGrid[snapGrid.length - 1] + size);
            slidesGrid.push(slidesGrid[slidesGrid.length - 1] + size);
            swiper.virtualSize += size;
        }
    }
    if (snapGrid.length === 0) snapGrid = [
        0
    ];
    if (spaceBetween !== 0) {
        var key = swiper.isHorizontal() && rtl ? "marginLeft" : getDirectionLabel("marginRight");
        slides.filter(function(_, slideIndex) {
            if (!params.cssMode || params.loop) return true;
            if (slideIndex === slides.length - 1) return false;
            return true;
        }).forEach(function(slideEl) {
            slideEl.style[key] = "".concat(spaceBetween, "px");
        });
    }
    if (params.centeredSlides && params.centeredSlidesBounds) {
        var allSlidesSize = 0;
        slidesSizesGrid.forEach(function(slideSizeValue) {
            allSlidesSize += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize -= spaceBetween;
        var maxSnap = allSlidesSize - swiperSize;
        snapGrid = snapGrid.map(function(snap) {
            if (snap <= 0) return -offsetBefore;
            if (snap > maxSnap) return maxSnap + offsetAfter;
            return snap;
        });
    }
    if (params.centerInsufficientSlides) {
        var allSlidesSize1 = 0;
        slidesSizesGrid.forEach(function(slideSizeValue) {
            allSlidesSize1 += slideSizeValue + (spaceBetween || 0);
        });
        allSlidesSize1 -= spaceBetween;
        if (allSlidesSize1 < swiperSize) {
            var allSlidesOffset = (swiperSize - allSlidesSize1) / 2;
            snapGrid.forEach(function(snap, snapIndex) {
                snapGrid[snapIndex] = snap - allSlidesOffset;
            });
            slidesGrid.forEach(function(snap, snapIndex) {
                slidesGrid[snapIndex] = snap + allSlidesOffset;
            });
        }
    }
    Object.assign(swiper, {
        slides: slides,
        snapGrid: snapGrid,
        slidesGrid: slidesGrid,
        slidesSizesGrid: slidesSizesGrid
    });
    if (params.centeredSlides && params.cssMode && !params.centeredSlidesBounds) {
        (0, $2530e0d256bb8028$export$a607267f322101fd)(wrapperEl, "--swiper-centered-offset-before", "".concat(-snapGrid[0], "px"));
        (0, $2530e0d256bb8028$export$a607267f322101fd)(wrapperEl, "--swiper-centered-offset-after", "".concat(swiper.size / 2 - slidesSizesGrid[slidesSizesGrid.length - 1] / 2, "px"));
        var addToSnapGrid = -swiper.snapGrid[0];
        var addToSlidesGrid = -swiper.slidesGrid[0];
        swiper.snapGrid = swiper.snapGrid.map(function(v) {
            return v + addToSnapGrid;
        });
        swiper.slidesGrid = swiper.slidesGrid.map(function(v) {
            return v + addToSlidesGrid;
        });
    }
    if (slidesLength !== previousSlidesLength) swiper.emit("slidesLengthChange");
    if (snapGrid.length !== previousSnapGridLength) {
        if (swiper.params.watchOverflow) swiper.checkOverflow();
        swiper.emit("snapGridLengthChange");
    }
    if (slidesGrid.length !== previousSlidesGridLength) swiper.emit("slidesGridLengthChange");
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (!isVirtual && !params.cssMode && (params.effect === "slide" || params.effect === "fade")) {
        var backFaceHiddenClass = "".concat(params.containerModifierClass, "backface-hidden");
        var hasClassBackfaceClassAdded = swiper.el.classList.contains(backFaceHiddenClass);
        if (slidesLength <= params.maxBackfaceHiddenSlides) {
            if (!hasClassBackfaceClassAdded) swiper.el.classList.add(backFaceHiddenClass);
        } else if (hasClassBackfaceClassAdded) swiper.el.classList.remove(backFaceHiddenClass);
    }
}


function $5eb1dea23abdb26d$export$2e2bcd8739ae039(speed) {
    var swiper = this;
    var activeSlides = [];
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    var newHeight = 0;
    var i;
    if (typeof speed === "number") swiper.setTransition(speed);
    else if (speed === true) swiper.setTransition(swiper.params.speed);
    var getSlideByIndex = function(index) {
        if (isVirtual) return swiper.slides[swiper.getSlideIndexByData(index)];
        return swiper.slides[index];
    };
    // Find slides currently in view
    if (swiper.params.slidesPerView !== "auto" && swiper.params.slidesPerView > 1) {
        if (swiper.params.centeredSlides) (swiper.visibleSlides || []).forEach(function(slide) {
            activeSlides.push(slide);
        });
        else for(i = 0; i < Math.ceil(swiper.params.slidesPerView); i += 1){
            var index = swiper.activeIndex + i;
            if (index > swiper.slides.length && !isVirtual) break;
            activeSlides.push(getSlideByIndex(index));
        }
    } else activeSlides.push(getSlideByIndex(swiper.activeIndex));
    // Find new height from highest slide in view
    for(i = 0; i < activeSlides.length; i += 1)if (typeof activeSlides[i] !== "undefined") {
        var height = activeSlides[i].offsetHeight;
        newHeight = height > newHeight ? height : newHeight;
    }
    // Update Height
    if (newHeight || newHeight === 0) swiper.wrapperEl.style.height = "".concat(newHeight, "px");
}


function $6033261e6e8860db$export$2e2bcd8739ae039() {
    var swiper = this;
    var slides = swiper.slides;
    // eslint-disable-next-line
    var minusOffset = swiper.isElement ? swiper.isHorizontal() ? swiper.wrapperEl.offsetLeft : swiper.wrapperEl.offsetTop : 0;
    for(var i = 0; i < slides.length; i += 1)slides[i].swiperSlideOffset = (swiper.isHorizontal() ? slides[i].offsetLeft : slides[i].offsetTop) - minusOffset - swiper.cssOverflowAdjustment();
}


function $f6ad7011e9b0c675$export$2e2bcd8739ae039() {
    var translate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this && this.translate || 0;
    var swiper = this;
    var params = swiper.params;
    var slides = swiper.slides, rtl = swiper.rtlTranslate, snapGrid = swiper.snapGrid;
    if (slides.length === 0) return;
    if (typeof slides[0].swiperSlideOffset === "undefined") swiper.updateSlidesOffset();
    var offsetCenter = -translate;
    if (rtl) offsetCenter = translate;
    // Visible Slides
    slides.forEach(function(slideEl) {
        slideEl.classList.remove(params.slideVisibleClass);
    });
    swiper.visibleSlidesIndexes = [];
    swiper.visibleSlides = [];
    var spaceBetween = params.spaceBetween;
    if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
    else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
    for(var i = 0; i < slides.length; i += 1){
        var slide = slides[i];
        var slideOffset = slide.swiperSlideOffset;
        if (params.cssMode && params.centeredSlides) slideOffset -= slides[0].swiperSlideOffset;
        var slideProgress = (offsetCenter + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        var originalSlideProgress = (offsetCenter - snapGrid[0] + (params.centeredSlides ? swiper.minTranslate() : 0) - slideOffset) / (slide.swiperSlideSize + spaceBetween);
        var slideBefore = -(offsetCenter - slideOffset);
        var slideAfter = slideBefore + swiper.slidesSizesGrid[i];
        var isVisible = slideBefore >= 0 && slideBefore < swiper.size - 1 || slideAfter > 1 && slideAfter <= swiper.size || slideBefore <= 0 && slideAfter >= swiper.size;
        if (isVisible) {
            swiper.visibleSlides.push(slide);
            swiper.visibleSlidesIndexes.push(i);
            slides[i].classList.add(params.slideVisibleClass);
        }
        slide.progress = rtl ? -slideProgress : slideProgress;
        slide.originalProgress = rtl ? -originalSlideProgress : originalSlideProgress;
    }
}


function $9b6fb767b08e4754$export$2e2bcd8739ae039(translate) {
    var swiper = this;
    if (typeof translate === "undefined") {
        var multiplier = swiper.rtlTranslate ? -1 : 1;
        // eslint-disable-next-line
        translate = swiper && swiper.translate && swiper.translate * multiplier || 0;
    }
    var params = swiper.params;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    var progress = swiper.progress, isBeginning = swiper.isBeginning, isEnd = swiper.isEnd, progressLoop = swiper.progressLoop;
    var wasBeginning = isBeginning;
    var wasEnd = isEnd;
    if (translatesDiff === 0) {
        progress = 0;
        isBeginning = true;
        isEnd = true;
    } else {
        progress = (translate - swiper.minTranslate()) / translatesDiff;
        var isBeginningRounded = Math.abs(translate - swiper.minTranslate()) < 1;
        var isEndRounded = Math.abs(translate - swiper.maxTranslate()) < 1;
        isBeginning = isBeginningRounded || progress <= 0;
        isEnd = isEndRounded || progress >= 1;
        if (isBeginningRounded) progress = 0;
        if (isEndRounded) progress = 1;
    }
    if (params.loop) {
        var firstSlideIndex = swiper.getSlideIndexByData(0);
        var lastSlideIndex = swiper.getSlideIndexByData(swiper.slides.length - 1);
        var firstSlideTranslate = swiper.slidesGrid[firstSlideIndex];
        var lastSlideTranslate = swiper.slidesGrid[lastSlideIndex];
        var translateMax = swiper.slidesGrid[swiper.slidesGrid.length - 1];
        var translateAbs = Math.abs(translate);
        if (translateAbs >= firstSlideTranslate) progressLoop = (translateAbs - firstSlideTranslate) / translateMax;
        else progressLoop = (translateAbs + translateMax - lastSlideTranslate) / translateMax;
        if (progressLoop > 1) progressLoop -= 1;
    }
    Object.assign(swiper, {
        progress: progress,
        progressLoop: progressLoop,
        isBeginning: isBeginning,
        isEnd: isEnd
    });
    if (params.watchSlidesProgress || params.centeredSlides && params.autoHeight) swiper.updateSlidesProgress(translate);
    if (isBeginning && !wasBeginning) swiper.emit("reachBeginning toEdge");
    if (isEnd && !wasEnd) swiper.emit("reachEnd toEdge");
    if (wasBeginning && !isBeginning || wasEnd && !isEnd) swiper.emit("fromEdge");
    swiper.emit("progress", progress);
}



function $923501e3653b8edb$export$2e2bcd8739ae039() {
    var swiper = this;
    var slides = swiper.slides, params = swiper.params, slidesEl = swiper.slidesEl, activeIndex = swiper.activeIndex;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    var getFilteredSlide = function(selector) {
        return (0, $2530e0d256bb8028$export$eb846d859f2895e6)(slidesEl, ".".concat(params.slideClass).concat(selector, ", swiper-slide").concat(selector))[0];
    };
    slides.forEach(function(slideEl) {
        slideEl.classList.remove(params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
    });
    var activeSlide;
    if (isVirtual) {
        if (params.loop) {
            var slideIndex = activeIndex - swiper.virtual.slidesBefore;
            if (slideIndex < 0) slideIndex = swiper.virtual.slides.length + slideIndex;
            if (slideIndex >= swiper.virtual.slides.length) slideIndex -= swiper.virtual.slides.length;
            activeSlide = getFilteredSlide('[data-swiper-slide-index="'.concat(slideIndex, '"]'));
        } else activeSlide = getFilteredSlide('[data-swiper-slide-index="'.concat(activeIndex, '"]'));
    } else activeSlide = slides[activeIndex];
    if (activeSlide) {
        // Active classes
        activeSlide.classList.add(params.slideActiveClass);
        // Next Slide
        var nextSlide = (0, $2530e0d256bb8028$export$b245807c30cf5df8)(activeSlide, ".".concat(params.slideClass, ", swiper-slide"))[0];
        if (params.loop && !nextSlide) nextSlide = slides[0];
        if (nextSlide) nextSlide.classList.add(params.slideNextClass);
        // Prev Slide
        var prevSlide = (0, $2530e0d256bb8028$export$392b9fa9626e91e0)(activeSlide, ".".concat(params.slideClass, ", swiper-slide"))[0];
        params.loop;
        if (prevSlide) prevSlide.classList.add(params.slidePrevClass);
    }
    swiper.emitSlidesClasses();
}



var $2b6Uo = parcelRequire("2b6Uo");
var $cb0e9c9aa16a7aa5$export$54749c0631f34ffc = function(swiper, imageEl) {
    if (!swiper || swiper.destroyed || !swiper.params) return;
    var slideSelector = function() {
        return swiper.isElement ? "swiper-slide" : ".".concat(swiper.params.slideClass);
    };
    var slideEl = imageEl.closest(slideSelector());
    if (slideEl) {
        var lazyEl = slideEl.querySelector(".".concat(swiper.params.lazyPreloaderClass));
        if (lazyEl) lazyEl.remove();
    }
};
var $cb0e9c9aa16a7aa5$var$unlazy = function(swiper, index) {
    if (!swiper.slides[index]) return;
    var imageEl = swiper.slides[index].querySelector('[loading="lazy"]');
    if (imageEl) imageEl.removeAttribute("loading");
};
var $cb0e9c9aa16a7aa5$export$513ccb98c53b8039 = function(swiper) {
    if (!swiper || swiper.destroyed || !swiper.params) return;
    var amount = swiper.params.lazyPreloadPrevNext;
    var len = swiper.slides.length;
    if (!len || !amount || amount < 0) return;
    amount = Math.min(amount, len);
    var slidesPerView = swiper.params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(swiper.params.slidesPerView);
    var activeIndex = swiper.activeIndex;
    if (swiper.params.grid && swiper.params.grid.rows > 1) {
        var _preloadColumns;
        var activeColumn = activeIndex;
        var preloadColumns = [
            activeColumn - amount
        ];
        (_preloadColumns = preloadColumns).push.apply(_preloadColumns, (0, $2b6Uo._)(Array.from({
            length: amount
        }).map(function(_, i) {
            return activeColumn + slidesPerView + i;
        })));
        swiper.slides.forEach(function(slideEl, i) {
            if (preloadColumns.includes(slideEl.column)) $cb0e9c9aa16a7aa5$var$unlazy(swiper, i);
        });
        return;
    }
    var slideIndexLastInView = activeIndex + slidesPerView - 1;
    if (swiper.params.rewind || swiper.params.loop) for(var i = activeIndex - amount; i <= slideIndexLastInView + amount; i += 1){
        var realIndex = (i % len + len) % len;
        if (realIndex < activeIndex || realIndex > slideIndexLastInView) $cb0e9c9aa16a7aa5$var$unlazy(swiper, realIndex);
    }
    else {
        for(var i1 = Math.max(activeIndex - amount, 0); i1 <= Math.min(slideIndexLastInView + amount, len - 1); i1 += 1)if (i1 !== activeIndex && (i1 > slideIndexLastInView || i1 < activeIndex)) $cb0e9c9aa16a7aa5$var$unlazy(swiper, i1);
    }
};


function $815f8a6d5d7f1a3d$export$81ecffcda7ad6ebb(swiper) {
    var slidesGrid = swiper.slidesGrid, params = swiper.params;
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    var activeIndex;
    for(var i = 0; i < slidesGrid.length; i += 1){
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1] - (slidesGrid[i + 1] - slidesGrid[i]) / 2) activeIndex = i;
            else if (translate >= slidesGrid[i] && translate < slidesGrid[i + 1]) activeIndex = i + 1;
        } else if (translate >= slidesGrid[i]) activeIndex = i;
    }
    // Normalize slideIndex
    if (params.normalizeSlideIndex) {
        if (activeIndex < 0 || typeof activeIndex === "undefined") activeIndex = 0;
    }
    return activeIndex;
}
function $815f8a6d5d7f1a3d$export$2e2bcd8739ae039(newActiveIndex) {
    var swiper = this;
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    var snapGrid = swiper.snapGrid, params = swiper.params, previousIndex = swiper.activeIndex, previousRealIndex = swiper.realIndex, previousSnapIndex = swiper.snapIndex;
    var activeIndex = newActiveIndex;
    var snapIndex;
    var getVirtualRealIndex = function(aIndex) {
        var realIndex = aIndex - swiper.virtual.slidesBefore;
        if (realIndex < 0) realIndex = swiper.virtual.slides.length + realIndex;
        if (realIndex >= swiper.virtual.slides.length) realIndex -= swiper.virtual.slides.length;
        return realIndex;
    };
    if (typeof activeIndex === "undefined") activeIndex = $815f8a6d5d7f1a3d$export$81ecffcda7ad6ebb(swiper);
    if (snapGrid.indexOf(translate) >= 0) snapIndex = snapGrid.indexOf(translate);
    else {
        var skip = Math.min(params.slidesPerGroupSkip, activeIndex);
        snapIndex = skip + Math.floor((activeIndex - skip) / params.slidesPerGroup);
    }
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    if (activeIndex === previousIndex) {
        if (snapIndex !== previousSnapIndex) {
            swiper.snapIndex = snapIndex;
            swiper.emit("snapIndexChange");
        }
        if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.realIndex = getVirtualRealIndex(activeIndex);
        return;
    }
    // Get real index
    var realIndex;
    if (swiper.virtual && params.virtual.enabled && params.loop) realIndex = getVirtualRealIndex(activeIndex);
    else if (swiper.slides[activeIndex]) realIndex = parseInt(swiper.slides[activeIndex].getAttribute("data-swiper-slide-index") || activeIndex, 10);
    else realIndex = activeIndex;
    Object.assign(swiper, {
        previousSnapIndex: previousSnapIndex,
        snapIndex: snapIndex,
        previousRealIndex: previousRealIndex,
        realIndex: realIndex,
        previousIndex: previousIndex,
        activeIndex: activeIndex
    });
    if (swiper.initialized) (0, $cb0e9c9aa16a7aa5$export$513ccb98c53b8039)(swiper);
    swiper.emit("activeIndexChange");
    swiper.emit("snapIndexChange");
    if (previousRealIndex !== realIndex) swiper.emit("realIndexChange");
    if (swiper.initialized || swiper.params.runCallbacksOnInit) swiper.emit("slideChange");
}


function $d20cee6bf3a4c809$export$2e2bcd8739ae039(e) {
    var swiper = this;
    var params = swiper.params;
    var slide = e.closest(".".concat(params.slideClass, ", swiper-slide"));
    var slideFound = false;
    var slideIndex;
    if (slide) {
        for(var i = 0; i < swiper.slides.length; i += 1)if (swiper.slides[i] === slide) {
            slideFound = true;
            slideIndex = i;
            break;
        }
    }
    if (slide && slideFound) {
        swiper.clickedSlide = slide;
        if (swiper.virtual && swiper.params.virtual.enabled) swiper.clickedIndex = parseInt(slide.getAttribute("data-swiper-slide-index"), 10);
        else swiper.clickedIndex = slideIndex;
    } else {
        swiper.clickedSlide = undefined;
        swiper.clickedIndex = undefined;
        return;
    }
    if (params.slideToClickedSlide && swiper.clickedIndex !== undefined && swiper.clickedIndex !== swiper.activeIndex) swiper.slideToClickedSlide();
}


var $9416dc2b2e9ac9bd$export$2e2bcd8739ae039 = {
    updateSize: (0, $bc969395b68fcc55$export$2e2bcd8739ae039),
    updateSlides: (0, $f58a94fb8155f41d$export$2e2bcd8739ae039),
    updateAutoHeight: (0, $5eb1dea23abdb26d$export$2e2bcd8739ae039),
    updateSlidesOffset: (0, $6033261e6e8860db$export$2e2bcd8739ae039),
    updateSlidesProgress: (0, $f6ad7011e9b0c675$export$2e2bcd8739ae039),
    updateProgress: (0, $9b6fb767b08e4754$export$2e2bcd8739ae039),
    updateSlidesClasses: (0, $923501e3653b8edb$export$2e2bcd8739ae039),
    updateActiveIndex: (0, $815f8a6d5d7f1a3d$export$2e2bcd8739ae039),
    updateClickedSlide: (0, $d20cee6bf3a4c809$export$2e2bcd8739ae039)
};



function $c39dd5735f19c077$export$2e2bcd8739ae039() {
    var axis = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.isHorizontal() ? "x" : "y";
    var swiper = this;
    var params = swiper.params, rtl = swiper.rtlTranslate, translate = swiper.translate, wrapperEl = swiper.wrapperEl;
    if (params.virtualTranslate) return rtl ? -translate : translate;
    if (params.cssMode) return translate;
    var currentTranslate = (0, $2530e0d256bb8028$export$5ec402b7fcf74398)(wrapperEl, axis);
    currentTranslate += swiper.cssOverflowAdjustment();
    if (rtl) currentTranslate = -currentTranslate;
    return currentTranslate || 0;
}


function $d403a04b65db8f9e$export$2e2bcd8739ae039(translate, byController) {
    var swiper = this;
    var rtl = swiper.rtlTranslate, params = swiper.params, wrapperEl = swiper.wrapperEl, progress = swiper.progress;
    var x = 0;
    var y = 0;
    var z = 0;
    if (swiper.isHorizontal()) x = rtl ? -translate : translate;
    else y = translate;
    if (params.roundLengths) {
        x = Math.floor(x);
        y = Math.floor(y);
    }
    swiper.previousTranslate = swiper.translate;
    swiper.translate = swiper.isHorizontal() ? x : y;
    if (params.cssMode) wrapperEl[swiper.isHorizontal() ? "scrollLeft" : "scrollTop"] = swiper.isHorizontal() ? -x : -y;
    else if (!params.virtualTranslate) {
        if (swiper.isHorizontal()) x -= swiper.cssOverflowAdjustment();
        else y -= swiper.cssOverflowAdjustment();
        wrapperEl.style.transform = "translate3d(".concat(x, "px, ").concat(y, "px, ").concat(z, "px)");
    }
    // Check if we need to update progress
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== progress) swiper.updateProgress(translate);
    swiper.emit("setTranslate", swiper.translate, byController);
}


function $d5ad2f5765708a4e$export$2e2bcd8739ae039() {
    return -this.snapGrid[0];
}


function $eb515c38b02c6e89$export$2e2bcd8739ae039() {
    return -this.snapGrid[this.snapGrid.length - 1];
}



var $9HFeY = parcelRequire("9HFeY");

function $16a54c9afb2aa4cb$export$2e2bcd8739ae039() {
    var translate = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, speed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.params.speed, runCallbacks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, translateBounds = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : true, internal = arguments.length > 4 ? arguments[4] : void 0;
    var swiper = this;
    var params = swiper.params, wrapperEl = swiper.wrapperEl;
    if (swiper.animating && params.preventInteractionOnTransition) return false;
    var minTranslate = swiper.minTranslate();
    var maxTranslate = swiper.maxTranslate();
    var newTranslate;
    if (translateBounds && translate > minTranslate) newTranslate = minTranslate;
    else if (translateBounds && translate < maxTranslate) newTranslate = maxTranslate;
    else newTranslate = translate;
    // Update progress
    swiper.updateProgress(newTranslate);
    if (params.cssMode) {
        var isH = swiper.isHorizontal();
        if (speed === 0) wrapperEl[isH ? "scrollLeft" : "scrollTop"] = -newTranslate;
        else {
            if (!swiper.support.smoothScroll) {
                (0, $2530e0d256bb8028$export$a5dd2b4b1a116d6d)({
                    swiper: swiper,
                    targetPosition: -newTranslate,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            var _obj;
            wrapperEl.scrollTo((_obj = {}, (0, $9HFeY._)(_obj, isH ? "left" : "top", -newTranslate), (0, $9HFeY._)(_obj, "behavior", "smooth"), _obj));
        }
        return true;
    }
    if (speed === 0) {
        swiper.setTransition(0);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionEnd");
        }
    } else {
        swiper.setTransition(speed);
        swiper.setTranslate(newTranslate);
        if (runCallbacks) {
            swiper.emit("beforeTransitionStart", speed, internal);
            swiper.emit("transitionStart");
        }
        if (!swiper.animating) {
            swiper.animating = true;
            if (!swiper.onTranslateToWrapperTransitionEnd) swiper.onTranslateToWrapperTransitionEnd = function transitionEnd(e) {
                if (!swiper || swiper.destroyed) return;
                if (e.target !== this) return;
                swiper.wrapperEl.removeEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
                swiper.onTranslateToWrapperTransitionEnd = null;
                delete swiper.onTranslateToWrapperTransitionEnd;
                if (runCallbacks) swiper.emit("transitionEnd");
            };
            swiper.wrapperEl.addEventListener("transitionend", swiper.onTranslateToWrapperTransitionEnd);
        }
    }
    return true;
}


var $997daff852fc6728$export$2e2bcd8739ae039 = {
    getTranslate: (0, $c39dd5735f19c077$export$2e2bcd8739ae039),
    setTranslate: (0, $d403a04b65db8f9e$export$2e2bcd8739ae039),
    minTranslate: (0, $d5ad2f5765708a4e$export$2e2bcd8739ae039),
    maxTranslate: (0, $eb515c38b02c6e89$export$2e2bcd8739ae039),
    translateTo: (0, $16a54c9afb2aa4cb$export$2e2bcd8739ae039)
};


function $23c8ba7d0a27e6e8$export$2e2bcd8739ae039(duration, byController) {
    var swiper = this;
    if (!swiper.params.cssMode) swiper.wrapperEl.style.transitionDuration = "".concat(duration, "ms");
    swiper.emit("setTransition", duration, byController);
}


function $70634002951bb85d$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, runCallbacks = param.runCallbacks, direction = param.direction, step = param.step;
    var activeIndex = swiper.activeIndex, previousIndex = swiper.previousIndex;
    var dir = direction;
    if (!dir) {
        if (activeIndex > previousIndex) dir = "next";
        else if (activeIndex < previousIndex) dir = "prev";
        else dir = "reset";
    }
    swiper.emit("transition".concat(step));
    if (runCallbacks && activeIndex !== previousIndex) {
        if (dir === "reset") {
            swiper.emit("slideResetTransition".concat(step));
            return;
        }
        swiper.emit("slideChangeTransition".concat(step));
        if (dir === "next") swiper.emit("slideNextTransition".concat(step));
        else swiper.emit("slidePrevTransition".concat(step));
    }
}


function $63db19c0474b347e$export$2e2bcd8739ae039() {
    var runCallbacks = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, direction = arguments.length > 1 ? arguments[1] : void 0;
    var swiper = this;
    var params = swiper.params;
    if (params.cssMode) return;
    if (params.autoHeight) swiper.updateAutoHeight();
    (0, $70634002951bb85d$export$2e2bcd8739ae039)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "Start"
    });
}



function $0a115b16ac10398e$export$2e2bcd8739ae039() {
    var runCallbacks = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, direction = arguments.length > 1 ? arguments[1] : void 0;
    var swiper = this;
    var params = swiper.params;
    swiper.animating = false;
    if (params.cssMode) return;
    swiper.setTransition(0);
    (0, $70634002951bb85d$export$2e2bcd8739ae039)({
        swiper: swiper,
        runCallbacks: runCallbacks,
        direction: direction,
        step: "End"
    });
}


var $75db5665231bfb3c$export$2e2bcd8739ae039 = {
    setTransition: (0, $23c8ba7d0a27e6e8$export$2e2bcd8739ae039),
    transitionStart: (0, $63db19c0474b347e$export$2e2bcd8739ae039),
    transitionEnd: (0, $0a115b16ac10398e$export$2e2bcd8739ae039)
};



var $9HFeY = parcelRequire("9HFeY");

function $857de4dd5917cd57$export$2e2bcd8739ae039() {
    var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, speed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.params.speed, runCallbacks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, internal = arguments.length > 3 ? arguments[3] : void 0, initial = arguments.length > 4 ? arguments[4] : void 0;
    if (typeof index === "string") index = parseInt(index, 10);
    var swiper = this;
    var slideIndex = index;
    if (slideIndex < 0) slideIndex = 0;
    var params = swiper.params, snapGrid = swiper.snapGrid, slidesGrid = swiper.slidesGrid, previousIndex = swiper.previousIndex, activeIndex = swiper.activeIndex, rtl = swiper.rtlTranslate, wrapperEl = swiper.wrapperEl, enabled = swiper.enabled;
    if (swiper.animating && params.preventInteractionOnTransition || !enabled && !internal && !initial) return false;
    var skip = Math.min(swiper.params.slidesPerGroupSkip, slideIndex);
    var snapIndex = skip + Math.floor((slideIndex - skip) / swiper.params.slidesPerGroup);
    if (snapIndex >= snapGrid.length) snapIndex = snapGrid.length - 1;
    var translate = -snapGrid[snapIndex];
    // Normalize slideIndex
    if (params.normalizeSlideIndex) for(var i = 0; i < slidesGrid.length; i += 1){
        var normalizedTranslate = -Math.floor(translate * 100);
        var normalizedGrid = Math.floor(slidesGrid[i] * 100);
        var normalizedGridNext = Math.floor(slidesGrid[i + 1] * 100);
        if (typeof slidesGrid[i + 1] !== "undefined") {
            if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext - (normalizedGridNext - normalizedGrid) / 2) slideIndex = i;
            else if (normalizedTranslate >= normalizedGrid && normalizedTranslate < normalizedGridNext) slideIndex = i + 1;
        } else if (normalizedTranslate >= normalizedGrid) slideIndex = i;
    }
    // Directions locks
    if (swiper.initialized && slideIndex !== activeIndex) {
        if (!swiper.allowSlideNext && (rtl ? translate > swiper.translate && translate > swiper.minTranslate() : translate < swiper.translate && translate < swiper.minTranslate())) return false;
        if (!swiper.allowSlidePrev && translate > swiper.translate && translate > swiper.maxTranslate()) {
            if ((activeIndex || 0) !== slideIndex) return false;
        }
    }
    if (slideIndex !== (previousIndex || 0) && runCallbacks) swiper.emit("beforeSlideChangeStart");
    // Update progress
    swiper.updateProgress(translate);
    var direction;
    if (slideIndex > activeIndex) direction = "next";
    else if (slideIndex < activeIndex) direction = "prev";
    else direction = "reset";
    // Update Index
    if (rtl && -translate === swiper.translate || !rtl && translate === swiper.translate) {
        swiper.updateActiveIndex(slideIndex);
        // Update Height
        if (params.autoHeight) swiper.updateAutoHeight();
        swiper.updateSlidesClasses();
        if (params.effect !== "slide") swiper.setTranslate(translate);
        if (direction !== "reset") {
            swiper.transitionStart(runCallbacks, direction);
            swiper.transitionEnd(runCallbacks, direction);
        }
        return false;
    }
    if (params.cssMode) {
        var isH = swiper.isHorizontal();
        var t = rtl ? translate : -translate;
        if (speed === 0) {
            var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
            if (isVirtual) {
                swiper.wrapperEl.style.scrollSnapType = "none";
                swiper._immediateVirtual = true;
            }
            if (isVirtual && !swiper._cssModeVirtualInitialSet && swiper.params.initialSlide > 0) {
                swiper._cssModeVirtualInitialSet = true;
                requestAnimationFrame(function() {
                    wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
                });
            } else wrapperEl[isH ? "scrollLeft" : "scrollTop"] = t;
            if (isVirtual) requestAnimationFrame(function() {
                swiper.wrapperEl.style.scrollSnapType = "";
                swiper._immediateVirtual = false;
            });
        } else {
            if (!swiper.support.smoothScroll) {
                (0, $2530e0d256bb8028$export$a5dd2b4b1a116d6d)({
                    swiper: swiper,
                    targetPosition: t,
                    side: isH ? "left" : "top"
                });
                return true;
            }
            var _obj;
            wrapperEl.scrollTo((_obj = {}, (0, $9HFeY._)(_obj, isH ? "left" : "top", t), (0, $9HFeY._)(_obj, "behavior", "smooth"), _obj));
        }
        return true;
    }
    swiper.setTransition(speed);
    swiper.setTranslate(translate);
    swiper.updateActiveIndex(slideIndex);
    swiper.updateSlidesClasses();
    swiper.emit("beforeTransitionStart", speed, internal);
    swiper.transitionStart(runCallbacks, direction);
    if (speed === 0) swiper.transitionEnd(runCallbacks, direction);
    else if (!swiper.animating) {
        swiper.animating = true;
        if (!swiper.onSlideToWrapperTransitionEnd) swiper.onSlideToWrapperTransitionEnd = function transitionEnd(e) {
            if (!swiper || swiper.destroyed) return;
            if (e.target !== this) return;
            swiper.wrapperEl.removeEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
            swiper.onSlideToWrapperTransitionEnd = null;
            delete swiper.onSlideToWrapperTransitionEnd;
            swiper.transitionEnd(runCallbacks, direction);
        };
        swiper.wrapperEl.addEventListener("transitionend", swiper.onSlideToWrapperTransitionEnd);
    }
    return true;
}


function $e4ded8fb6a6cd3ef$export$2e2bcd8739ae039() {
    var index = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 0, speed = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this.params.speed, runCallbacks = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, internal = arguments.length > 3 ? arguments[3] : void 0;
    if (typeof index === "string") {
        var indexAsNumber = parseInt(index, 10);
        index = indexAsNumber;
    }
    var swiper = this;
    var newIndex = index;
    if (swiper.params.loop) {
        if (swiper.virtual && swiper.params.virtual.enabled) // eslint-disable-next-line
        newIndex = newIndex + swiper.virtual.slidesBefore;
        else newIndex = swiper.getSlideIndexByData(newIndex);
    }
    return swiper.slideTo(newIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $fdd62bca0d633763$export$2e2bcd8739ae039() {
    var speed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.params.speed, runCallbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, internal = arguments.length > 2 ? arguments[2] : void 0;
    var swiper = this;
    var enabled = swiper.enabled, params = swiper.params, animating = swiper.animating;
    if (!enabled) return swiper;
    var perGroup = params.slidesPerGroup;
    if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) perGroup = Math.max(swiper.slidesPerViewDynamic("current", true), 1);
    var increment = swiper.activeIndex < params.slidesPerGroupSkip ? 1 : perGroup;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: "next"
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    if (params.rewind && swiper.isEnd) return swiper.slideTo(0, speed, runCallbacks, internal);
    return swiper.slideTo(swiper.activeIndex + increment, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $5fcfbef96f4a7882$export$2e2bcd8739ae039() {
    var speed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.params.speed, runCallbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, internal = arguments.length > 2 ? arguments[2] : void 0;
    var normalize = function normalize(val) {
        if (val < 0) return -Math.floor(Math.abs(val));
        return Math.floor(val);
    };
    var swiper = this;
    var params = swiper.params, snapGrid = swiper.snapGrid, slidesGrid = swiper.slidesGrid, rtlTranslate = swiper.rtlTranslate, enabled = swiper.enabled, animating = swiper.animating;
    if (!enabled) return swiper;
    var isVirtual = swiper.virtual && params.virtual.enabled;
    if (params.loop) {
        if (animating && !isVirtual && params.loopPreventsSliding) return false;
        swiper.loopFix({
            direction: "prev"
        });
        // eslint-disable-next-line
        swiper._clientLeft = swiper.wrapperEl.clientLeft;
    }
    var translate = rtlTranslate ? swiper.translate : -swiper.translate;
    var normalizedTranslate = normalize(translate);
    var normalizedSnapGrid = snapGrid.map(function(val) {
        return normalize(val);
    });
    var prevSnap = snapGrid[normalizedSnapGrid.indexOf(normalizedTranslate) - 1];
    if (typeof prevSnap === "undefined" && params.cssMode) {
        var prevSnapIndex;
        snapGrid.forEach(function(snap, snapIndex) {
            if (normalizedTranslate >= snap) // prevSnap = snap;
            prevSnapIndex = snapIndex;
        });
        if (typeof prevSnapIndex !== "undefined") prevSnap = snapGrid[prevSnapIndex > 0 ? prevSnapIndex - 1 : prevSnapIndex];
    }
    var prevIndex = 0;
    if (typeof prevSnap !== "undefined") {
        prevIndex = slidesGrid.indexOf(prevSnap);
        if (prevIndex < 0) prevIndex = swiper.activeIndex - 1;
        if (params.slidesPerView === "auto" && params.slidesPerGroup === 1 && params.slidesPerGroupAuto) {
            prevIndex = prevIndex - swiper.slidesPerViewDynamic("previous", true) + 1;
            prevIndex = Math.max(prevIndex, 0);
        }
    }
    if (params.rewind && swiper.isBeginning) {
        var lastIndex = swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        return swiper.slideTo(lastIndex, speed, runCallbacks, internal);
    }
    return swiper.slideTo(prevIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $42c663c701e945ce$export$2e2bcd8739ae039() {
    var speed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.params.speed, runCallbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, internal = arguments.length > 2 ? arguments[2] : void 0;
    var swiper = this;
    return swiper.slideTo(swiper.activeIndex, speed, runCallbacks, internal);
}


/* eslint no-unused-vars: "off" */ function $f68c7c638fabaf86$export$2e2bcd8739ae039() {
    var speed = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : this.params.speed, runCallbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, internal = arguments.length > 2 ? arguments[2] : void 0, threshold = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0.5;
    var swiper = this;
    var index = swiper.activeIndex;
    var skip = Math.min(swiper.params.slidesPerGroupSkip, index);
    var snapIndex = skip + Math.floor((index - skip) / swiper.params.slidesPerGroup);
    var translate = swiper.rtlTranslate ? swiper.translate : -swiper.translate;
    if (translate >= swiper.snapGrid[snapIndex]) {
        // The current translate is on or after the current snap index, so the choice
        // is between the current index and the one after it.
        var currentSnap = swiper.snapGrid[snapIndex];
        var nextSnap = swiper.snapGrid[snapIndex + 1];
        if (translate - currentSnap > (nextSnap - currentSnap) * threshold) index += swiper.params.slidesPerGroup;
    } else {
        // The current translate is before the current snap index, so the choice
        // is between the current index and the one before it.
        var prevSnap = swiper.snapGrid[snapIndex - 1];
        var currentSnap1 = swiper.snapGrid[snapIndex];
        if (translate - prevSnap <= (currentSnap1 - prevSnap) * threshold) index -= swiper.params.slidesPerGroup;
    }
    index = Math.max(index, 0);
    index = Math.min(index, swiper.slidesGrid.length - 1);
    return swiper.slideTo(index, speed, runCallbacks, internal);
}



function $cc7f821e77113f8b$export$2e2bcd8739ae039() {
    var swiper = this;
    var params = swiper.params, slidesEl = swiper.slidesEl;
    var slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : params.slidesPerView;
    var slideToIndex = swiper.clickedIndex;
    var realIndex;
    var slideSelector = swiper.isElement ? "swiper-slide" : ".".concat(params.slideClass);
    if (params.loop) {
        if (swiper.animating) return;
        realIndex = parseInt(swiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
        if (params.centeredSlides) {
            if (slideToIndex < swiper.loopedSlides - slidesPerView / 2 || slideToIndex > swiper.slides.length - swiper.loopedSlides + slidesPerView / 2) {
                swiper.loopFix();
                slideToIndex = swiper.getSlideIndex((0, $2530e0d256bb8028$export$eb846d859f2895e6)(slidesEl, "".concat(slideSelector, '[data-swiper-slide-index="').concat(realIndex, '"]'))[0]);
                (0, $2530e0d256bb8028$export$bdd553fddd433dcb)(function() {
                    swiper.slideTo(slideToIndex);
                });
            } else swiper.slideTo(slideToIndex);
        } else if (slideToIndex > swiper.slides.length - slidesPerView) {
            swiper.loopFix();
            slideToIndex = swiper.getSlideIndex((0, $2530e0d256bb8028$export$eb846d859f2895e6)(slidesEl, "".concat(slideSelector, '[data-swiper-slide-index="').concat(realIndex, '"]'))[0]);
            (0, $2530e0d256bb8028$export$bdd553fddd433dcb)(function() {
                swiper.slideTo(slideToIndex);
            });
        } else swiper.slideTo(slideToIndex);
    } else swiper.slideTo(slideToIndex);
}


var $cf1d4e88d6b5a9c7$export$2e2bcd8739ae039 = {
    slideTo: (0, $857de4dd5917cd57$export$2e2bcd8739ae039),
    slideToLoop: (0, $e4ded8fb6a6cd3ef$export$2e2bcd8739ae039),
    slideNext: (0, $fdd62bca0d633763$export$2e2bcd8739ae039),
    slidePrev: (0, $5fcfbef96f4a7882$export$2e2bcd8739ae039),
    slideReset: (0, $42c663c701e945ce$export$2e2bcd8739ae039),
    slideToClosest: (0, $f68c7c638fabaf86$export$2e2bcd8739ae039),
    slideToClickedSlide: (0, $cc7f821e77113f8b$export$2e2bcd8739ae039)
};



function $dee390adcf25cbbb$export$2e2bcd8739ae039(slideRealIndex) {
    var swiper = this;
    var params = swiper.params, slidesEl = swiper.slidesEl;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    var slides = (0, $2530e0d256bb8028$export$eb846d859f2895e6)(slidesEl, ".".concat(params.slideClass, ", swiper-slide"));
    slides.forEach(function(el, index) {
        el.setAttribute("data-swiper-slide-index", index);
    });
    swiper.loopFix({
        slideRealIndex: slideRealIndex,
        direction: params.centeredSlides ? undefined : "next"
    });
}


function $d8c795cb3a05d0d6$export$2e2bcd8739ae039() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, slideRealIndex = _ref.slideRealIndex, _ref_slideTo = _ref.slideTo, slideTo = _ref_slideTo === void 0 ? true : _ref_slideTo, direction = _ref.direction, setTranslate = _ref.setTranslate, activeSlideIndex = _ref.activeSlideIndex, byController = _ref.byController, byMousewheel = _ref.byMousewheel;
    var swiper = this;
    if (!swiper.params.loop) return;
    swiper.emit("beforeLoopFix");
    var slides = swiper.slides, allowSlidePrev = swiper.allowSlidePrev, allowSlideNext = swiper.allowSlideNext, slidesEl = swiper.slidesEl, params = swiper.params;
    swiper.allowSlidePrev = true;
    swiper.allowSlideNext = true;
    if (swiper.virtual && params.virtual.enabled) {
        if (slideTo) {
            if (!params.centeredSlides && swiper.snapIndex === 0) swiper.slideTo(swiper.virtual.slides.length, 0, false, true);
            else if (params.centeredSlides && swiper.snapIndex < params.slidesPerView) swiper.slideTo(swiper.virtual.slides.length + swiper.snapIndex, 0, false, true);
            else if (swiper.snapIndex === swiper.snapGrid.length - 1) swiper.slideTo(swiper.virtual.slidesBefore, 0, false, true);
        }
        swiper.allowSlidePrev = allowSlidePrev;
        swiper.allowSlideNext = allowSlideNext;
        swiper.emit("loopFix");
        return;
    }
    var slidesPerView = params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10));
    var loopedSlides = params.loopedSlides || slidesPerView;
    if (loopedSlides % params.slidesPerGroup !== 0) loopedSlides += params.slidesPerGroup - loopedSlides % params.slidesPerGroup;
    swiper.loopedSlides = loopedSlides;
    var prependSlidesIndexes = [];
    var appendSlidesIndexes = [];
    var activeIndex = swiper.activeIndex;
    if (typeof activeSlideIndex === "undefined") activeSlideIndex = swiper.getSlideIndex(swiper.slides.filter(function(el) {
        return el.classList.contains(params.slideActiveClass);
    })[0]);
    else activeIndex = activeSlideIndex;
    var isNext = direction === "next" || !direction;
    var isPrev = direction === "prev" || !direction;
    var slidesPrepended = 0;
    var slidesAppended = 0;
    // prepend last slides before start
    if (activeSlideIndex < loopedSlides) {
        slidesPrepended = Math.max(loopedSlides - activeSlideIndex, params.slidesPerGroup);
        for(var i = 0; i < loopedSlides - activeSlideIndex; i += 1){
            var index = i - Math.floor(i / slides.length) * slides.length;
            prependSlidesIndexes.push(slides.length - index - 1);
        }
    } else if (activeSlideIndex /* + slidesPerView */  > swiper.slides.length - loopedSlides * 2) {
        slidesAppended = Math.max(activeSlideIndex - (swiper.slides.length - loopedSlides * 2), params.slidesPerGroup);
        for(var i1 = 0; i1 < slidesAppended; i1 += 1){
            var index1 = i1 - Math.floor(i1 / slides.length) * slides.length;
            appendSlidesIndexes.push(index1);
        }
    }
    if (isPrev) prependSlidesIndexes.forEach(function(index) {
        swiper.slides[index].swiperLoopMoveDOM = true;
        slidesEl.prepend(swiper.slides[index]);
        swiper.slides[index].swiperLoopMoveDOM = false;
    });
    if (isNext) appendSlidesIndexes.forEach(function(index) {
        swiper.slides[index].swiperLoopMoveDOM = true;
        slidesEl.append(swiper.slides[index]);
        swiper.slides[index].swiperLoopMoveDOM = false;
    });
    swiper.recalcSlides();
    if (params.slidesPerView === "auto") swiper.updateSlides();
    if (params.watchSlidesProgress) swiper.updateSlidesOffset();
    if (slideTo) {
        if (prependSlidesIndexes.length > 0 && isPrev) {
            if (typeof slideRealIndex === "undefined") {
                var currentSlideTranslate = swiper.slidesGrid[activeIndex];
                var newSlideTranslate = swiper.slidesGrid[activeIndex + slidesPrepended];
                var diff = newSlideTranslate - currentSlideTranslate;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff);
                else {
                    swiper.slideTo(activeIndex + slidesPrepended, 0, false, true);
                    if (setTranslate) swiper.touches[swiper.isHorizontal() ? "startX" : "startY"] += diff;
                }
            } else if (setTranslate) swiper.slideToLoop(slideRealIndex, 0, false, true);
        } else if (appendSlidesIndexes.length > 0 && isNext) {
            if (typeof slideRealIndex === "undefined") {
                var currentSlideTranslate1 = swiper.slidesGrid[activeIndex];
                var newSlideTranslate1 = swiper.slidesGrid[activeIndex - slidesAppended];
                var diff1 = newSlideTranslate1 - currentSlideTranslate1;
                if (byMousewheel) swiper.setTranslate(swiper.translate - diff1);
                else {
                    swiper.slideTo(activeIndex - slidesAppended, 0, false, true);
                    if (setTranslate) swiper.touches[swiper.isHorizontal() ? "startX" : "startY"] += diff1;
                }
            } else swiper.slideToLoop(slideRealIndex, 0, false, true);
        }
    }
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.controller && swiper.controller.control && !byController) {
        var loopParams = {
            slideRealIndex: slideRealIndex,
            slideTo: false,
            direction: direction,
            setTranslate: setTranslate,
            activeSlideIndex: activeSlideIndex,
            byController: true
        };
        if (Array.isArray(swiper.controller.control)) swiper.controller.control.forEach(function(c) {
            if (!c.destroyed && c.params.loop) c.loopFix(loopParams);
        });
        else if (swiper.controller.control instanceof swiper.constructor && swiper.controller.control.params.loop) swiper.controller.control.loopFix(loopParams);
    }
    swiper.emit("loopFix");
}


function $9ce028e96d5e4218$export$2e2bcd8739ae039() {
    var swiper = this;
    var params = swiper.params, slidesEl = swiper.slidesEl;
    if (!params.loop || swiper.virtual && swiper.params.virtual.enabled) return;
    swiper.recalcSlides();
    var newSlidesOrder = [];
    swiper.slides.forEach(function(slideEl) {
        var index = typeof slideEl.swiperSlideIndex === "undefined" ? slideEl.getAttribute("data-swiper-slide-index") * 1 : slideEl.swiperSlideIndex;
        newSlidesOrder[index] = slideEl;
    });
    swiper.slides.forEach(function(slideEl) {
        slideEl.removeAttribute("data-swiper-slide-index");
    });
    newSlidesOrder.forEach(function(slideEl) {
        slidesEl.append(slideEl);
    });
    swiper.recalcSlides();
    swiper.slideTo(swiper.realIndex, 0);
}


var $8537fcccb20d8651$export$2e2bcd8739ae039 = {
    loopCreate: (0, $dee390adcf25cbbb$export$2e2bcd8739ae039),
    loopFix: (0, $d8c795cb3a05d0d6$export$2e2bcd8739ae039),
    loopDestroy: (0, $9ce028e96d5e4218$export$2e2bcd8739ae039)
};


function $a92ef3719b02d869$export$2e2bcd8739ae039(moving) {
    var swiper = this;
    if (!swiper.params.simulateTouch || swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    var el = swiper.params.touchEventsTarget === "container" ? swiper.el : swiper.wrapperEl;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    el.style.cursor = "move";
    el.style.cursor = moving ? "grabbing" : "grab";
    if (swiper.isElement) requestAnimationFrame(function() {
        swiper.__preventObserver__ = false;
    });
}


function $77b54fd1473813f3$export$2e2bcd8739ae039() {
    var swiper = this;
    if (swiper.params.watchOverflow && swiper.isLocked || swiper.params.cssMode) return;
    if (swiper.isElement) swiper.__preventObserver__ = true;
    swiper[swiper.params.touchEventsTarget === "container" ? "el" : "wrapperEl"].style.cursor = "";
    if (swiper.isElement) requestAnimationFrame(function() {
        swiper.__preventObserver__ = false;
    });
}


var $90a9ce1d776970a9$export$2e2bcd8739ae039 = {
    setGrabCursor: (0, $a92ef3719b02d869$export$2e2bcd8739ae039),
    unsetGrabCursor: (0, $77b54fd1473813f3$export$2e2bcd8739ae039)
};





// Modified from https://stackoverflow.com/questions/54520554/custom-element-getrootnode-closest-function-crossing-multiple-parent-shadowd
function $3192035b3039ccfe$var$closestElement(selector) {
    var base = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : this;
    function __closestFrom(el) {
        if (!el || el === (0, $e7beec05cc3d4f7e$export$f65ca476c09acec0)() || el === (0, $e7beec05cc3d4f7e$export$38b2d434cce3ea22)()) return null;
        if (el.assignedSlot) el = el.assignedSlot;
        var found = el.closest(selector);
        if (!found && !el.getRootNode) return null;
        return found || __closestFrom(el.getRootNode().host);
    }
    return __closestFrom(base);
}
function $3192035b3039ccfe$export$2e2bcd8739ae039(event) {
    var swiper = this;
    var document = (0, $e7beec05cc3d4f7e$export$f65ca476c09acec0)();
    var window = (0, $e7beec05cc3d4f7e$export$38b2d434cce3ea22)();
    var data = swiper.touchEventsData;
    data.evCache.push(event);
    var params = swiper.params, touches = swiper.touches, enabled = swiper.enabled;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === "mouse") return;
    if (swiper.animating && params.preventInteractionOnTransition) return;
    if (!swiper.animating && params.cssMode && params.loop) swiper.loopFix();
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    var targetEl = e.target;
    if (params.touchEventsTarget === "wrapper") {
        if (!swiper.wrapperEl.contains(targetEl)) return;
    }
    if ("which" in e && e.which === 3) return;
    if ("button" in e && e.button > 0) return;
    if (data.isTouched && data.isMoved) return;
    // change target el for shadow root component
    var swipingClassHasValue = !!params.noSwipingClass && params.noSwipingClass !== "";
    // eslint-disable-next-line
    var eventPath = event.composedPath ? event.composedPath() : event.path;
    if (swipingClassHasValue && e.target && e.target.shadowRoot && eventPath) targetEl = eventPath[0];
    var noSwipingSelector = params.noSwipingSelector ? params.noSwipingSelector : ".".concat(params.noSwipingClass);
    var isTargetShadow = !!(e.target && e.target.shadowRoot);
    // use closestElement for shadow root element to get the actual closest for nested shadow root element
    if (params.noSwiping && (isTargetShadow ? $3192035b3039ccfe$var$closestElement(noSwipingSelector, targetEl) : targetEl.closest(noSwipingSelector))) {
        swiper.allowClick = true;
        return;
    }
    if (params.swipeHandler) {
        if (!targetEl.closest(params.swipeHandler)) return;
    }
    touches.currentX = e.pageX;
    touches.currentY = e.pageY;
    var startX = touches.currentX;
    var startY = touches.currentY;
    // Do NOT start if iOS edge swipe is detected. Otherwise iOS app cannot swipe-to-go-back anymore
    var edgeSwipeDetection = params.edgeSwipeDetection || params.iOSEdgeSwipeDetection;
    var edgeSwipeThreshold = params.edgeSwipeThreshold || params.iOSEdgeSwipeThreshold;
    if (edgeSwipeDetection && (startX <= edgeSwipeThreshold || startX >= window.innerWidth - edgeSwipeThreshold)) {
        if (edgeSwipeDetection === "prevent") event.preventDefault();
        else return;
    }
    Object.assign(data, {
        isTouched: true,
        isMoved: false,
        allowTouchCallbacks: true,
        isScrolling: undefined,
        startMoving: undefined
    });
    touches.startX = startX;
    touches.startY = startY;
    data.touchStartTime = (0, $2530e0d256bb8028$export$461939dd4422153)();
    swiper.allowClick = true;
    swiper.updateSize();
    swiper.swipeDirection = undefined;
    if (params.threshold > 0) data.allowThresholdMove = false;
    var preventDefault = true;
    if (targetEl.matches(data.focusableElements)) {
        preventDefault = false;
        if (targetEl.nodeName === "SELECT") data.isTouched = false;
    }
    if (document.activeElement && document.activeElement.matches(data.focusableElements) && document.activeElement !== targetEl) document.activeElement.blur();
    var shouldPreventDefault = preventDefault && swiper.allowTouchMove && params.touchStartPreventDefault;
    if ((params.touchStartForcePreventDefault || shouldPreventDefault) && !targetEl.isContentEditable) e.preventDefault();
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode && swiper.animating && !params.cssMode) swiper.freeMode.onTouchStart();
    swiper.emit("touchStart", e);
}




function $276df62f8bad120a$export$2e2bcd8739ae039(event) {
    var document = (0, $e7beec05cc3d4f7e$export$f65ca476c09acec0)();
    var swiper = this;
    var data = swiper.touchEventsData;
    var params = swiper.params, touches = swiper.touches, rtl = swiper.rtlTranslate, enabled = swiper.enabled;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === "mouse") return;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (!data.isTouched) {
        if (data.startMoving && data.isScrolling) swiper.emit("touchMoveOpposite", e);
        return;
    }
    var pointerIndex = data.evCache.findIndex(function(cachedEv) {
        return cachedEv.pointerId === e.pointerId;
    });
    if (pointerIndex >= 0) data.evCache[pointerIndex] = e;
    var targetTouch = data.evCache.length > 1 ? data.evCache[0] : e;
    var pageX = targetTouch.pageX;
    var pageY = targetTouch.pageY;
    if (e.preventedByNestedSwiper) {
        touches.startX = pageX;
        touches.startY = pageY;
        return;
    }
    if (!swiper.allowTouchMove) {
        if (!e.target.matches(data.focusableElements)) swiper.allowClick = false;
        if (data.isTouched) {
            Object.assign(touches, {
                startX: pageX,
                startY: pageY,
                prevX: swiper.touches.currentX,
                prevY: swiper.touches.currentY,
                currentX: pageX,
                currentY: pageY
            });
            data.touchStartTime = (0, $2530e0d256bb8028$export$461939dd4422153)();
        }
        return;
    }
    if (params.touchReleaseOnEdges && !params.loop) {
        if (swiper.isVertical()) // Vertical
        {
            if (pageY < touches.startY && swiper.translate <= swiper.maxTranslate() || pageY > touches.startY && swiper.translate >= swiper.minTranslate()) {
                data.isTouched = false;
                data.isMoved = false;
                return;
            }
        } else if (pageX < touches.startX && swiper.translate <= swiper.maxTranslate() || pageX > touches.startX && swiper.translate >= swiper.minTranslate()) return;
    }
    if (document.activeElement) {
        if (e.target === document.activeElement && e.target.matches(data.focusableElements)) {
            data.isMoved = true;
            swiper.allowClick = false;
            return;
        }
    }
    if (data.allowTouchCallbacks) swiper.emit("touchMove", e);
    if (e.targetTouches && e.targetTouches.length > 1) return;
    touches.currentX = pageX;
    touches.currentY = pageY;
    var diffX = touches.currentX - touches.startX;
    var diffY = touches.currentY - touches.startY;
    if (swiper.params.threshold && Math.sqrt(Math.pow(diffX, 2) + Math.pow(diffY, 2)) < swiper.params.threshold) return;
    if (typeof data.isScrolling === "undefined") {
        var touchAngle;
        if (swiper.isHorizontal() && touches.currentY === touches.startY || swiper.isVertical() && touches.currentX === touches.startX) data.isScrolling = false;
        else // eslint-disable-next-line
        if (diffX * diffX + diffY * diffY >= 25) {
            touchAngle = Math.atan2(Math.abs(diffY), Math.abs(diffX)) * 180 / Math.PI;
            data.isScrolling = swiper.isHorizontal() ? touchAngle > params.touchAngle : 90 - touchAngle > params.touchAngle;
        }
    }
    if (data.isScrolling) swiper.emit("touchMoveOpposite", e);
    if (typeof data.startMoving === "undefined") {
        if (touches.currentX !== touches.startX || touches.currentY !== touches.startY) data.startMoving = true;
    }
    if (data.isScrolling || swiper.zoom && swiper.params.zoom && swiper.params.zoom.enabled && data.evCache.length > 1) {
        data.isTouched = false;
        return;
    }
    if (!data.startMoving) return;
    swiper.allowClick = false;
    if (!params.cssMode && e.cancelable) e.preventDefault();
    if (params.touchMoveStopPropagation && !params.nested) e.stopPropagation();
    var diff = swiper.isHorizontal() ? diffX : diffY;
    var touchesDiff = swiper.isHorizontal() ? touches.currentX - touches.previousX : touches.currentY - touches.previousY;
    if (params.oneWayMovement) {
        diff = Math.abs(diff) * (rtl ? 1 : -1);
        touchesDiff = Math.abs(touchesDiff) * (rtl ? 1 : -1);
    }
    touches.diff = diff;
    diff *= params.touchRatio;
    if (rtl) {
        diff = -diff;
        touchesDiff = -touchesDiff;
    }
    var prevTouchesDirection = swiper.touchesDirection;
    swiper.swipeDirection = diff > 0 ? "prev" : "next";
    swiper.touchesDirection = touchesDiff > 0 ? "prev" : "next";
    var isLoop = swiper.params.loop && !params.cssMode;
    if (!data.isMoved) {
        if (isLoop) swiper.loopFix({
            direction: swiper.swipeDirection
        });
        data.startTranslate = swiper.getTranslate();
        swiper.setTransition(0);
        if (swiper.animating) {
            var evt = new window.CustomEvent("transitionend", {
                bubbles: true,
                cancelable: true
            });
            swiper.wrapperEl.dispatchEvent(evt);
        }
        data.allowMomentumBounce = false;
        // Grab Cursor
        if (params.grabCursor && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(true);
        swiper.emit("sliderFirstMove", e);
    }
    var loopFixed;
    if (data.isMoved && prevTouchesDirection !== swiper.touchesDirection && isLoop && Math.abs(diff) >= 1) {
        // need another loop fix
        swiper.loopFix({
            direction: swiper.swipeDirection,
            setTranslate: true
        });
        loopFixed = true;
    }
    swiper.emit("sliderMove", e);
    data.isMoved = true;
    data.currentTranslate = diff + data.startTranslate;
    var disableParentSwiper = true;
    var resistanceRatio = params.resistanceRatio;
    if (params.touchReleaseOnEdges) resistanceRatio = 0;
    if (diff > 0) {
        if (isLoop && !loopFixed && data.currentTranslate > (params.centeredSlides ? swiper.minTranslate() - swiper.size / 2 : swiper.minTranslate())) swiper.loopFix({
            direction: "prev",
            setTranslate: true,
            activeSlideIndex: 0
        });
        if (data.currentTranslate > swiper.minTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.minTranslate() - 1 + Math.pow(-swiper.minTranslate() + data.startTranslate + diff, resistanceRatio);
        }
    } else if (diff < 0) {
        if (isLoop && !loopFixed && data.currentTranslate < (params.centeredSlides ? swiper.maxTranslate() + swiper.size / 2 : swiper.maxTranslate())) swiper.loopFix({
            direction: "next",
            setTranslate: true,
            activeSlideIndex: swiper.slides.length - (params.slidesPerView === "auto" ? swiper.slidesPerViewDynamic() : Math.ceil(parseFloat(params.slidesPerView, 10)))
        });
        if (data.currentTranslate < swiper.maxTranslate()) {
            disableParentSwiper = false;
            if (params.resistance) data.currentTranslate = swiper.maxTranslate() + 1 - Math.pow(swiper.maxTranslate() - data.startTranslate - diff, resistanceRatio);
        }
    }
    if (disableParentSwiper) e.preventedByNestedSwiper = true;
    // Directions locks
    if (!swiper.allowSlideNext && swiper.swipeDirection === "next" && data.currentTranslate < data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && swiper.swipeDirection === "prev" && data.currentTranslate > data.startTranslate) data.currentTranslate = data.startTranslate;
    if (!swiper.allowSlidePrev && !swiper.allowSlideNext) data.currentTranslate = data.startTranslate;
    // Threshold
    if (params.threshold > 0) {
        if (Math.abs(diff) > params.threshold || data.allowThresholdMove) {
            if (!data.allowThresholdMove) {
                data.allowThresholdMove = true;
                touches.startX = touches.currentX;
                touches.startY = touches.currentY;
                data.currentTranslate = data.startTranslate;
                touches.diff = swiper.isHorizontal() ? touches.currentX - touches.startX : touches.currentY - touches.startY;
                return;
            }
        } else {
            data.currentTranslate = data.startTranslate;
            return;
        }
    }
    if (!params.followFinger || params.cssMode) return;
    // Update active index in free mode
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode || params.watchSlidesProgress) {
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    }
    if (params.freeMode && params.freeMode.enabled && swiper.freeMode) swiper.freeMode.onTouchMove();
    // Update progress
    swiper.updateProgress(data.currentTranslate);
    // Update translate
    swiper.setTranslate(data.currentTranslate);
}



function $576f3205d046784b$export$2e2bcd8739ae039(event) {
    var swiper = this;
    var data = swiper.touchEventsData;
    var pointerIndex = data.evCache.findIndex(function(cachedEv) {
        return cachedEv.pointerId === event.pointerId;
    });
    if (pointerIndex >= 0) data.evCache.splice(pointerIndex, 1);
    if ([
        "pointercancel",
        "pointerout",
        "pointerleave"
    ].includes(event.type)) {
        var proceed = event.type === "pointercancel" && (swiper.browser.isSafari || swiper.browser.isWebView);
        if (!proceed) return;
    }
    var params = swiper.params, touches = swiper.touches, rtl = swiper.rtlTranslate, slidesGrid = swiper.slidesGrid, enabled = swiper.enabled;
    if (!enabled) return;
    if (!params.simulateTouch && event.pointerType === "mouse") return;
    var e = event;
    if (e.originalEvent) e = e.originalEvent;
    if (data.allowTouchCallbacks) swiper.emit("touchEnd", e);
    data.allowTouchCallbacks = false;
    if (!data.isTouched) {
        if (data.isMoved && params.grabCursor) swiper.setGrabCursor(false);
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    // Return Grab Cursor
    if (params.grabCursor && data.isMoved && data.isTouched && (swiper.allowSlideNext === true || swiper.allowSlidePrev === true)) swiper.setGrabCursor(false);
    // Time diff
    var touchEndTime = (0, $2530e0d256bb8028$export$461939dd4422153)();
    var timeDiff = touchEndTime - data.touchStartTime;
    // Tap, doubleTap, Click
    if (swiper.allowClick) {
        var pathTree = e.path || e.composedPath && e.composedPath();
        swiper.updateClickedSlide(pathTree && pathTree[0] || e.target);
        swiper.emit("tap click", e);
        if (timeDiff < 300 && touchEndTime - data.lastClickTime < 300) swiper.emit("doubleTap doubleClick", e);
    }
    data.lastClickTime = (0, $2530e0d256bb8028$export$461939dd4422153)();
    (0, $2530e0d256bb8028$export$bdd553fddd433dcb)(function() {
        if (!swiper.destroyed) swiper.allowClick = true;
    });
    if (!data.isTouched || !data.isMoved || !swiper.swipeDirection || touches.diff === 0 || data.currentTranslate === data.startTranslate) {
        data.isTouched = false;
        data.isMoved = false;
        data.startMoving = false;
        return;
    }
    data.isTouched = false;
    data.isMoved = false;
    data.startMoving = false;
    var currentPos;
    if (params.followFinger) currentPos = rtl ? swiper.translate : -swiper.translate;
    else currentPos = -data.currentTranslate;
    if (params.cssMode) return;
    if (params.freeMode && params.freeMode.enabled) {
        swiper.freeMode.onTouchEnd({
            currentPos: currentPos
        });
        return;
    }
    // Find current slide
    var stopIndex = 0;
    var groupSize = swiper.slidesSizesGrid[0];
    for(var i = 0; i < slidesGrid.length; i += i < params.slidesPerGroupSkip ? 1 : params.slidesPerGroup){
        var increment = i < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
        if (typeof slidesGrid[i + increment] !== "undefined") {
            if (currentPos >= slidesGrid[i] && currentPos < slidesGrid[i + increment]) {
                stopIndex = i;
                groupSize = slidesGrid[i + increment] - slidesGrid[i];
            }
        } else if (currentPos >= slidesGrid[i]) {
            stopIndex = i;
            groupSize = slidesGrid[slidesGrid.length - 1] - slidesGrid[slidesGrid.length - 2];
        }
    }
    var rewindFirstIndex = null;
    var rewindLastIndex = null;
    if (params.rewind) {
        if (swiper.isBeginning) rewindLastIndex = params.virtual && params.virtual.enabled && swiper.virtual ? swiper.virtual.slides.length - 1 : swiper.slides.length - 1;
        else if (swiper.isEnd) rewindFirstIndex = 0;
    }
    // Find current slide size
    var ratio = (currentPos - slidesGrid[stopIndex]) / groupSize;
    var increment1 = stopIndex < params.slidesPerGroupSkip - 1 ? 1 : params.slidesPerGroup;
    if (timeDiff > params.longSwipesMs) {
        // Long touches
        if (!params.longSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (swiper.swipeDirection === "next") {
            if (ratio >= params.longSwipesRatio) swiper.slideTo(params.rewind && swiper.isEnd ? rewindFirstIndex : stopIndex + increment1);
            else swiper.slideTo(stopIndex);
        }
        if (swiper.swipeDirection === "prev") {
            if (ratio > 1 - params.longSwipesRatio) swiper.slideTo(stopIndex + increment1);
            else if (rewindLastIndex !== null && ratio < 0 && Math.abs(ratio) > params.longSwipesRatio) swiper.slideTo(rewindLastIndex);
            else swiper.slideTo(stopIndex);
        }
    } else {
        // Short swipes
        if (!params.shortSwipes) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        var isNavButtonTarget = swiper.navigation && (e.target === swiper.navigation.nextEl || e.target === swiper.navigation.prevEl);
        if (!isNavButtonTarget) {
            if (swiper.swipeDirection === "next") swiper.slideTo(rewindFirstIndex !== null ? rewindFirstIndex : stopIndex + increment1);
            if (swiper.swipeDirection === "prev") swiper.slideTo(rewindLastIndex !== null ? rewindLastIndex : stopIndex);
        } else if (e.target === swiper.navigation.nextEl) swiper.slideTo(stopIndex + increment1);
        else swiper.slideTo(stopIndex);
    }
}


function $cbc190eec547105f$export$2e2bcd8739ae039() {
    var swiper = this;
    var params = swiper.params, el = swiper.el;
    if (el && el.offsetWidth === 0) return;
    // Breakpoints
    if (params.breakpoints) swiper.setBreakpoint();
    // Save locks
    var allowSlideNext = swiper.allowSlideNext, allowSlidePrev = swiper.allowSlidePrev, snapGrid = swiper.snapGrid;
    var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
    // Disable locks on resize
    swiper.allowSlideNext = true;
    swiper.allowSlidePrev = true;
    swiper.updateSize();
    swiper.updateSlides();
    swiper.updateSlidesClasses();
    var isVirtualLoop = isVirtual && params.loop;
    if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !swiper.isBeginning && !swiper.params.centeredSlides && !isVirtualLoop) swiper.slideTo(swiper.slides.length - 1, 0, false, true);
    else if (swiper.params.loop && !isVirtual) swiper.slideToLoop(swiper.realIndex, 0, false, true);
    else swiper.slideTo(swiper.activeIndex, 0, false, true);
    if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) {
        clearTimeout(swiper.autoplay.resizeTimeout);
        swiper.autoplay.resizeTimeout = setTimeout(function() {
            if (swiper.autoplay && swiper.autoplay.running && swiper.autoplay.paused) swiper.autoplay.resume();
        }, 500);
    }
    // Return locks after resize
    swiper.allowSlidePrev = allowSlidePrev;
    swiper.allowSlideNext = allowSlideNext;
    if (swiper.params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
}


function $c1e9565349a76dec$export$2e2bcd8739ae039(e) {
    var swiper = this;
    if (!swiper.enabled) return;
    if (!swiper.allowClick) {
        if (swiper.params.preventClicks) e.preventDefault();
        if (swiper.params.preventClicksPropagation && swiper.animating) {
            e.stopPropagation();
            e.stopImmediatePropagation();
        }
    }
}


function $98639d23946d6baf$export$2e2bcd8739ae039() {
    var swiper = this;
    var wrapperEl = swiper.wrapperEl, rtlTranslate = swiper.rtlTranslate, enabled = swiper.enabled;
    if (!enabled) return;
    swiper.previousTranslate = swiper.translate;
    if (swiper.isHorizontal()) swiper.translate = -wrapperEl.scrollLeft;
    else swiper.translate = -wrapperEl.scrollTop;
    // eslint-disable-next-line
    if (swiper.translate === 0) swiper.translate = 0;
    swiper.updateActiveIndex();
    swiper.updateSlidesClasses();
    var newProgress;
    var translatesDiff = swiper.maxTranslate() - swiper.minTranslate();
    if (translatesDiff === 0) newProgress = 0;
    else newProgress = (swiper.translate - swiper.minTranslate()) / translatesDiff;
    if (newProgress !== swiper.progress) swiper.updateProgress(rtlTranslate ? -swiper.translate : swiper.translate);
    swiper.emit("setTranslate", swiper.translate, false);
}



function $526cfcd4482b53dc$export$2e2bcd8739ae039(e) {
    var swiper = this;
    (0, $cb0e9c9aa16a7aa5$export$54749c0631f34ffc)(swiper, e.target);
    if (swiper.params.cssMode || swiper.params.slidesPerView !== "auto" && !swiper.params.autoHeight) return;
    swiper.update();
}


var $b1e6f9d37fb955da$var$dummyEventAttached = false;
function $b1e6f9d37fb955da$var$dummyEventListener() {}
var $b1e6f9d37fb955da$var$events = function(swiper, method) {
    var document = (0, $e7beec05cc3d4f7e$export$f65ca476c09acec0)();
    var params = swiper.params, el = swiper.el, wrapperEl = swiper.wrapperEl, device = swiper.device;
    var capture = !!params.nested;
    var domMethod = method === "on" ? "addEventListener" : "removeEventListener";
    var swiperMethod = method;
    // Touch Events
    el[domMethod]("pointerdown", swiper.onTouchStart, {
        passive: false
    });
    document[domMethod]("pointermove", swiper.onTouchMove, {
        passive: false,
        capture: capture
    });
    document[domMethod]("pointerup", swiper.onTouchEnd, {
        passive: true
    });
    document[domMethod]("pointercancel", swiper.onTouchEnd, {
        passive: true
    });
    document[domMethod]("pointerout", swiper.onTouchEnd, {
        passive: true
    });
    document[domMethod]("pointerleave", swiper.onTouchEnd, {
        passive: true
    });
    // Prevent Links Clicks
    if (params.preventClicks || params.preventClicksPropagation) el[domMethod]("click", swiper.onClick, true);
    if (params.cssMode) wrapperEl[domMethod]("scroll", swiper.onScroll);
    // Resize handler
    if (params.updateOnWindowResize) swiper[swiperMethod](device.ios || device.android ? "resize orientationchange observerUpdate" : "resize observerUpdate", (0, $cbc190eec547105f$export$2e2bcd8739ae039), true);
    else swiper[swiperMethod]("observerUpdate", (0, $cbc190eec547105f$export$2e2bcd8739ae039), true);
    // Images loader
    el[domMethod]("load", swiper.onLoad, {
        capture: true
    });
};
function $b1e6f9d37fb955da$var$attachEvents() {
    var swiper = this;
    var document = (0, $e7beec05cc3d4f7e$export$f65ca476c09acec0)();
    var params = swiper.params;
    swiper.onTouchStart = (0, $3192035b3039ccfe$export$2e2bcd8739ae039).bind(swiper);
    swiper.onTouchMove = (0, $276df62f8bad120a$export$2e2bcd8739ae039).bind(swiper);
    swiper.onTouchEnd = (0, $576f3205d046784b$export$2e2bcd8739ae039).bind(swiper);
    if (params.cssMode) swiper.onScroll = (0, $98639d23946d6baf$export$2e2bcd8739ae039).bind(swiper);
    swiper.onClick = (0, $c1e9565349a76dec$export$2e2bcd8739ae039).bind(swiper);
    swiper.onLoad = (0, $526cfcd4482b53dc$export$2e2bcd8739ae039).bind(swiper);
    if (!$b1e6f9d37fb955da$var$dummyEventAttached) {
        document.addEventListener("touchstart", $b1e6f9d37fb955da$var$dummyEventListener);
        $b1e6f9d37fb955da$var$dummyEventAttached = true;
    }
    $b1e6f9d37fb955da$var$events(swiper, "on");
}
function $b1e6f9d37fb955da$var$detachEvents() {
    var swiper = this;
    $b1e6f9d37fb955da$var$events(swiper, "off");
}
var $b1e6f9d37fb955da$export$2e2bcd8739ae039 = {
    attachEvents: $b1e6f9d37fb955da$var$attachEvents,
    detachEvents: $b1e6f9d37fb955da$var$detachEvents
};



var $e731b6def0f129cd$var$isGridEnabled = function(swiper, params) {
    return swiper.grid && params.grid && params.grid.rows > 1;
};
function $e731b6def0f129cd$export$2e2bcd8739ae039() {
    var swiper = this;
    var realIndex = swiper.realIndex, initialized = swiper.initialized, params = swiper.params, el = swiper.el;
    var breakpoints = params.breakpoints;
    if (!breakpoints || breakpoints && Object.keys(breakpoints).length === 0) return;
    // Get breakpoint for window width and update parameters
    var breakpoint = swiper.getBreakpoint(breakpoints, swiper.params.breakpointsBase, swiper.el);
    if (!breakpoint || swiper.currentBreakpoint === breakpoint) return;
    var breakpointOnlyParams = breakpoint in breakpoints ? breakpoints[breakpoint] : undefined;
    var breakpointParams = breakpointOnlyParams || swiper.originalParams;
    var wasMultiRow = $e731b6def0f129cd$var$isGridEnabled(swiper, params);
    var isMultiRow = $e731b6def0f129cd$var$isGridEnabled(swiper, breakpointParams);
    var wasEnabled = params.enabled;
    if (wasMultiRow && !isMultiRow) {
        el.classList.remove("".concat(params.containerModifierClass, "grid"), "".concat(params.containerModifierClass, "grid-column"));
        swiper.emitContainerClasses();
    } else if (!wasMultiRow && isMultiRow) {
        el.classList.add("".concat(params.containerModifierClass, "grid"));
        if (breakpointParams.grid.fill && breakpointParams.grid.fill === "column" || !breakpointParams.grid.fill && params.grid.fill === "column") el.classList.add("".concat(params.containerModifierClass, "grid-column"));
        swiper.emitContainerClasses();
    }
    // Toggle navigation, pagination, scrollbar
    [
        "navigation",
        "pagination",
        "scrollbar"
    ].forEach(function(prop) {
        if (typeof breakpointParams[prop] === "undefined") return;
        var wasModuleEnabled = params[prop] && params[prop].enabled;
        var isModuleEnabled = breakpointParams[prop] && breakpointParams[prop].enabled;
        if (wasModuleEnabled && !isModuleEnabled) swiper[prop].disable();
        if (!wasModuleEnabled && isModuleEnabled) swiper[prop].enable();
    });
    var directionChanged = breakpointParams.direction && breakpointParams.direction !== params.direction;
    var needsReLoop = params.loop && (breakpointParams.slidesPerView !== params.slidesPerView || directionChanged);
    if (directionChanged && initialized) swiper.changeDirection();
    (0, $2530e0d256bb8028$export$8b58be045bf06082)(swiper.params, breakpointParams);
    var isEnabled = swiper.params.enabled;
    Object.assign(swiper, {
        allowTouchMove: swiper.params.allowTouchMove,
        allowSlideNext: swiper.params.allowSlideNext,
        allowSlidePrev: swiper.params.allowSlidePrev
    });
    if (wasEnabled && !isEnabled) swiper.disable();
    else if (!wasEnabled && isEnabled) swiper.enable();
    swiper.currentBreakpoint = breakpoint;
    swiper.emit("_beforeBreakpoint", breakpointParams);
    if (needsReLoop && initialized) {
        swiper.loopDestroy();
        swiper.loopCreate(realIndex);
        swiper.updateSlides();
    }
    swiper.emit("breakpoint", breakpointParams);
}



function $995a216f4e19dd23$export$2e2bcd8739ae039(breakpoints) {
    var base = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "window", containerEl = arguments.length > 2 ? arguments[2] : void 0;
    if (!breakpoints || base === "container" && !containerEl) return undefined;
    var breakpoint = false;
    var window = (0, $e7beec05cc3d4f7e$export$38b2d434cce3ea22)();
    var currentHeight = base === "window" ? window.innerHeight : containerEl.clientHeight;
    var points = Object.keys(breakpoints).map(function(point) {
        if (typeof point === "string" && point.indexOf("@") === 0) {
            var minRatio = parseFloat(point.substr(1));
            var value = currentHeight * minRatio;
            return {
                value: value,
                point: point
            };
        }
        return {
            value: point,
            point: point
        };
    });
    points.sort(function(a, b) {
        return parseInt(a.value, 10) - parseInt(b.value, 10);
    });
    for(var i = 0; i < points.length; i += 1){
        var _points_i = points[i], point = _points_i.point, value = _points_i.value;
        if (base === "window") {
            if (window.matchMedia("(min-width: ".concat(value, "px)")).matches) breakpoint = point;
        } else if (value <= containerEl.clientWidth) breakpoint = point;
    }
    return breakpoint || "max";
}


var $60e4bd0e612021c2$export$2e2bcd8739ae039 = {
    setBreakpoint: (0, $e731b6def0f129cd$export$2e2bcd8739ae039),
    getBreakpoint: (0, $995a216f4e19dd23$export$2e2bcd8739ae039)
};



var $2b6Uo = parcelRequire("2b6Uo");
function $fe0f8b8637022cf9$var$prepareClasses(entries, prefix) {
    var resultClasses = [];
    entries.forEach(function(item) {
        if (typeof item === "object") Object.keys(item).forEach(function(classNames) {
            if (item[classNames]) resultClasses.push(prefix + classNames);
        });
        else if (typeof item === "string") resultClasses.push(prefix + item);
    });
    return resultClasses;
}
function $fe0f8b8637022cf9$export$2e2bcd8739ae039() {
    var _classNames, _el_classList;
    var swiper = this;
    var classNames = swiper.classNames, params = swiper.params, rtl = swiper.rtl, el = swiper.el, device = swiper.device;
    // prettier-ignore
    var suffixes = $fe0f8b8637022cf9$var$prepareClasses([
        "initialized",
        params.direction,
        {
            "free-mode": swiper.params.freeMode && params.freeMode.enabled
        },
        {
            "autoheight": params.autoHeight
        },
        {
            "rtl": rtl
        },
        {
            "grid": params.grid && params.grid.rows > 1
        },
        {
            "grid-column": params.grid && params.grid.rows > 1 && params.grid.fill === "column"
        },
        {
            "android": device.android
        },
        {
            "ios": device.ios
        },
        {
            "css-mode": params.cssMode
        },
        {
            "centered": params.cssMode && params.centeredSlides
        },
        {
            "watch-progress": params.watchSlidesProgress
        }
    ], params.containerModifierClass);
    (_classNames = classNames).push.apply(_classNames, (0, $2b6Uo._)(suffixes));
    (_el_classList = el.classList).add.apply(_el_classList, (0, $2b6Uo._)(classNames));
    swiper.emitContainerClasses();
}



var $2b6Uo = parcelRequire("2b6Uo");
function $c2c6c269f5724da4$export$2e2bcd8739ae039() {
    var _el_classList;
    var swiper = this;
    var el = swiper.el, classNames = swiper.classNames;
    (_el_classList = el.classList).remove.apply(_el_classList, (0, $2b6Uo._)(classNames));
    swiper.emitContainerClasses();
}


var $b77c6f1fb90ab794$export$2e2bcd8739ae039 = {
    addClasses: (0, $fe0f8b8637022cf9$export$2e2bcd8739ae039),
    removeClasses: (0, $c2c6c269f5724da4$export$2e2bcd8739ae039)
};


function $885fc5f8b61de60e$var$checkOverflow() {
    var swiper = this;
    var wasLocked = swiper.isLocked, params = swiper.params;
    var slidesOffsetBefore = params.slidesOffsetBefore;
    if (slidesOffsetBefore) {
        var lastSlideIndex = swiper.slides.length - 1;
        var lastSlideRightEdge = swiper.slidesGrid[lastSlideIndex] + swiper.slidesSizesGrid[lastSlideIndex] + slidesOffsetBefore * 2;
        swiper.isLocked = swiper.size > lastSlideRightEdge;
    } else swiper.isLocked = swiper.snapGrid.length === 1;
    if (params.allowSlideNext === true) swiper.allowSlideNext = !swiper.isLocked;
    if (params.allowSlidePrev === true) swiper.allowSlidePrev = !swiper.isLocked;
    if (wasLocked && wasLocked !== swiper.isLocked) swiper.isEnd = false;
    if (wasLocked !== swiper.isLocked) swiper.emit(swiper.isLocked ? "lock" : "unlock");
}
var $885fc5f8b61de60e$export$2e2bcd8739ae039 = {
    checkOverflow: $885fc5f8b61de60e$var$checkOverflow
};


var $7502ebb135392435$export$2e2bcd8739ae039 = {
    init: true,
    direction: "horizontal",
    oneWayMovement: false,
    touchEventsTarget: "wrapper",
    initialSlide: 0,
    speed: 300,
    cssMode: false,
    updateOnWindowResize: true,
    resizeObserver: true,
    nested: false,
    createElements: false,
    enabled: true,
    focusableElements: "input, select, option, textarea, button, video, label",
    // Overrides
    width: null,
    height: null,
    //
    preventInteractionOnTransition: false,
    // ssr
    userAgent: null,
    url: null,
    // To support iOS's swipe-to-go-back gesture (when being used in-app).
    edgeSwipeDetection: false,
    edgeSwipeThreshold: 20,
    // Autoheight
    autoHeight: false,
    // Set wrapper width
    setWrapperSize: false,
    // Virtual Translate
    virtualTranslate: false,
    // Effects
    effect: "slide",
    // 'slide' or 'fade' or 'cube' or 'coverflow' or 'flip'
    // Breakpoints
    breakpoints: undefined,
    breakpointsBase: "window",
    // Slides grid
    spaceBetween: 0,
    slidesPerView: 1,
    slidesPerGroup: 1,
    slidesPerGroupSkip: 0,
    slidesPerGroupAuto: false,
    centeredSlides: false,
    centeredSlidesBounds: false,
    slidesOffsetBefore: 0,
    // in px
    slidesOffsetAfter: 0,
    // in px
    normalizeSlideIndex: true,
    centerInsufficientSlides: false,
    // Disable swiper and hide navigation when container not overflow
    watchOverflow: true,
    // Round length
    roundLengths: false,
    // Touches
    touchRatio: 1,
    touchAngle: 45,
    simulateTouch: true,
    shortSwipes: true,
    longSwipes: true,
    longSwipesRatio: 0.5,
    longSwipesMs: 300,
    followFinger: true,
    allowTouchMove: true,
    threshold: 5,
    touchMoveStopPropagation: false,
    touchStartPreventDefault: true,
    touchStartForcePreventDefault: false,
    touchReleaseOnEdges: false,
    // Unique Navigation Elements
    uniqueNavElements: true,
    // Resistance
    resistance: true,
    resistanceRatio: 0.85,
    // Progress
    watchSlidesProgress: false,
    // Cursor
    grabCursor: false,
    // Clicks
    preventClicks: true,
    preventClicksPropagation: true,
    slideToClickedSlide: false,
    // loop
    loop: false,
    loopedSlides: null,
    loopPreventsSliding: true,
    // rewind
    rewind: false,
    // Swiping/no swiping
    allowSlidePrev: true,
    allowSlideNext: true,
    swipeHandler: null,
    // '.swipe-handler',
    noSwiping: true,
    noSwipingClass: "swiper-no-swiping",
    noSwipingSelector: null,
    // Passive Listeners
    passiveListeners: true,
    maxBackfaceHiddenSlides: 10,
    // NS
    containerModifierClass: "swiper-",
    // NEW
    slideClass: "swiper-slide",
    slideActiveClass: "swiper-slide-active",
    slideVisibleClass: "swiper-slide-visible",
    slideNextClass: "swiper-slide-next",
    slidePrevClass: "swiper-slide-prev",
    wrapperClass: "swiper-wrapper",
    lazyPreloaderClass: "swiper-lazy-preloader",
    lazyPreloadPrevNext: 0,
    // Callbacks
    runCallbacksOnInit: true,
    // Internals
    _emitClasses: false
};



function $23266652d47d23d2$export$2e2bcd8739ae039(params, allModulesParams) {
    return function extendParams() {
        var obj = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
        var moduleParamName = Object.keys(obj)[0];
        var moduleParams = obj[moduleParamName];
        if (typeof moduleParams !== "object" || moduleParams === null) {
            (0, $2530e0d256bb8028$export$8b58be045bf06082)(allModulesParams, obj);
            return;
        }
        if ([
            "navigation",
            "pagination",
            "scrollbar"
        ].indexOf(moduleParamName) >= 0 && params[moduleParamName] === true) params[moduleParamName] = {
            auto: true
        };
        if (!(moduleParamName in params && "enabled" in moduleParams)) {
            (0, $2530e0d256bb8028$export$8b58be045bf06082)(allModulesParams, obj);
            return;
        }
        if (params[moduleParamName] === true) params[moduleParamName] = {
            enabled: true
        };
        if (typeof params[moduleParamName] === "object" && !("enabled" in params[moduleParamName])) params[moduleParamName].enabled = true;
        if (!params[moduleParamName]) params[moduleParamName] = {
            enabled: false
        };
        (0, $2530e0d256bb8028$export$8b58be045bf06082)(allModulesParams, obj);
    };
}



var $67b1addace326499$var$prototypes = {
    eventsEmitter: (0, $a2c920a5b0d5576c$export$2e2bcd8739ae039),
    update: (0, $9416dc2b2e9ac9bd$export$2e2bcd8739ae039),
    translate: (0, $997daff852fc6728$export$2e2bcd8739ae039),
    transition: (0, $75db5665231bfb3c$export$2e2bcd8739ae039),
    slide: (0, $cf1d4e88d6b5a9c7$export$2e2bcd8739ae039),
    loop: (0, $8537fcccb20d8651$export$2e2bcd8739ae039),
    grabCursor: (0, $90a9ce1d776970a9$export$2e2bcd8739ae039),
    events: (0, $b1e6f9d37fb955da$export$2e2bcd8739ae039),
    breakpoints: (0, $60e4bd0e612021c2$export$2e2bcd8739ae039),
    checkOverflow: (0, $885fc5f8b61de60e$export$2e2bcd8739ae039),
    classes: (0, $b77c6f1fb90ab794$export$2e2bcd8739ae039)
};
var $67b1addace326499$var$extendedDefaults = {};
var $67b1addace326499$var$Swiper = /*#__PURE__*/ function() {
    "use strict";
    function Swiper() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _swiper_modules;
        (0, $eCXNS._)(this, Swiper);
        var el;
        var params;
        var ref;
        if (args.length === 1 && args[0].constructor && Object.prototype.toString.call(args[0]).slice(8, -1) === "Object") params = args[0];
        else ref = (0, $iFZdg._)(args, 2), el = ref[0], params = ref[1], ref;
        if (!params) params = {};
        params = (0, $2530e0d256bb8028$export$8b58be045bf06082)({}, params);
        if (el && !params.el) params.el = el;
        var document1 = (0, $e7beec05cc3d4f7e$export$f65ca476c09acec0)();
        if (params.el && typeof params.el === "string" && document1.querySelectorAll(params.el).length > 1) {
            var swipers = [];
            document1.querySelectorAll(params.el).forEach(function(containerEl) {
                var newParams = (0, $2530e0d256bb8028$export$8b58be045bf06082)({}, params, {
                    el: containerEl
                });
                swipers.push(new Swiper(newParams));
            });
            // eslint-disable-next-line no-constructor-return
            return swipers;
        }
        // Swiper Instance
        var swiper = this;
        swiper.__swiper__ = true;
        swiper.support = (0, $650ff7d2717c3f6c$export$d61c7b85ff180578)();
        swiper.device = (0, $1825746e4b4aecad$export$30c823bc834d6ab4)({
            userAgent: params.userAgent
        });
        swiper.browser = (0, $11ad6cf6563a68be$export$89e15fc796a4a429)();
        swiper.eventsListeners = {};
        swiper.eventsAnyListeners = [];
        swiper.modules = (0, $2b6Uo._)(swiper.__modules__);
        if (params.modules && Array.isArray(params.modules)) (_swiper_modules = swiper.modules).push.apply(_swiper_modules, (0, $2b6Uo._)(params.modules));
        var allModulesParams = {};
        swiper.modules.forEach(function(mod) {
            mod({
                params: params,
                swiper: swiper,
                extendParams: (0, $23266652d47d23d2$export$2e2bcd8739ae039)(params, allModulesParams),
                on: swiper.on.bind(swiper),
                once: swiper.once.bind(swiper),
                off: swiper.off.bind(swiper),
                emit: swiper.emit.bind(swiper)
            });
        });
        // Extend defaults with modules params
        var swiperParams = (0, $2530e0d256bb8028$export$8b58be045bf06082)({}, (0, $7502ebb135392435$export$2e2bcd8739ae039), allModulesParams);
        // Extend defaults with passed params
        swiper.params = (0, $2530e0d256bb8028$export$8b58be045bf06082)({}, swiperParams, $67b1addace326499$var$extendedDefaults, params);
        swiper.originalParams = (0, $2530e0d256bb8028$export$8b58be045bf06082)({}, swiper.params);
        swiper.passedParams = (0, $2530e0d256bb8028$export$8b58be045bf06082)({}, params);
        // add event listeners
        if (swiper.params && swiper.params.on) Object.keys(swiper.params.on).forEach(function(eventName) {
            swiper.on(eventName, swiper.params.on[eventName]);
        });
        if (swiper.params && swiper.params.onAny) swiper.onAny(swiper.params.onAny);
        // Extend Swiper
        Object.assign(swiper, {
            enabled: swiper.params.enabled,
            el: el,
            // Classes
            classNames: [],
            // Slides
            slides: [],
            slidesGrid: [],
            snapGrid: [],
            slidesSizesGrid: [],
            // isDirection
            isHorizontal: function() {
                return swiper.params.direction === "horizontal";
            },
            isVertical: function() {
                return swiper.params.direction === "vertical";
            },
            // Indexes
            activeIndex: 0,
            realIndex: 0,
            //
            isBeginning: true,
            isEnd: false,
            // Props
            translate: 0,
            previousTranslate: 0,
            progress: 0,
            velocity: 0,
            animating: false,
            cssOverflowAdjustment: function() {
                // Returns 0 unless `translate` is > 2**23
                // Should be subtracted from css values to prevent overflow
                return Math.trunc(this.translate / Math.pow(2, 23)) * Math.pow(2, 23);
            },
            // Locks
            allowSlideNext: swiper.params.allowSlideNext,
            allowSlidePrev: swiper.params.allowSlidePrev,
            // Touch Events
            touchEventsData: {
                isTouched: undefined,
                isMoved: undefined,
                allowTouchCallbacks: undefined,
                touchStartTime: undefined,
                isScrolling: undefined,
                currentTranslate: undefined,
                startTranslate: undefined,
                allowThresholdMove: undefined,
                // Form elements to match
                focusableElements: swiper.params.focusableElements,
                // Last click time
                lastClickTime: 0,
                clickTimeout: undefined,
                // Velocities
                velocities: [],
                allowMomentumBounce: undefined,
                startMoving: undefined,
                evCache: []
            },
            // Clicks
            allowClick: true,
            // Touches
            allowTouchMove: swiper.params.allowTouchMove,
            touches: {
                startX: 0,
                startY: 0,
                currentX: 0,
                currentY: 0,
                diff: 0
            },
            // Images
            imagesToLoad: [],
            imagesLoaded: 0
        });
        swiper.emit("_swiper");
        // Init
        if (swiper.params.init) swiper.init();
        // Return app instance
        // eslint-disable-next-line no-constructor-return
        return swiper;
    }
    (0, $7M9bt._)(Swiper, [
        {
            key: "getSlideIndex",
            value: function getSlideIndex(slideEl) {
                var _this = this, slidesEl = _this.slidesEl, params = _this.params;
                var slides = (0, $2530e0d256bb8028$export$eb846d859f2895e6)(slidesEl, ".".concat(params.slideClass, ", swiper-slide"));
                var firstSlideIndex = (0, $2530e0d256bb8028$export$371885c503a01623)(slides[0]);
                return (0, $2530e0d256bb8028$export$371885c503a01623)(slideEl) - firstSlideIndex;
            }
        },
        {
            key: "getSlideIndexByData",
            value: function getSlideIndexByData(index) {
                return this.getSlideIndex(this.slides.filter(function(slideEl) {
                    return slideEl.getAttribute("data-swiper-slide-index") * 1 === index;
                })[0]);
            }
        },
        {
            key: "recalcSlides",
            value: function recalcSlides() {
                var swiper = this;
                var slidesEl = swiper.slidesEl, params = swiper.params;
                swiper.slides = (0, $2530e0d256bb8028$export$eb846d859f2895e6)(slidesEl, ".".concat(params.slideClass, ", swiper-slide"));
            }
        },
        {
            key: "enable",
            value: function enable() {
                var swiper = this;
                if (swiper.enabled) return;
                swiper.enabled = true;
                if (swiper.params.grabCursor) swiper.setGrabCursor();
                swiper.emit("enable");
            }
        },
        {
            key: "disable",
            value: function disable() {
                var swiper = this;
                if (!swiper.enabled) return;
                swiper.enabled = false;
                if (swiper.params.grabCursor) swiper.unsetGrabCursor();
                swiper.emit("disable");
            }
        },
        {
            key: "setProgress",
            value: function setProgress(progress, speed) {
                var swiper = this;
                progress = Math.min(Math.max(progress, 0), 1);
                var min = swiper.minTranslate();
                var max = swiper.maxTranslate();
                var current = (max - min) * progress + min;
                swiper.translateTo(current, typeof speed === "undefined" ? 0 : speed);
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
            }
        },
        {
            key: "emitContainerClasses",
            value: function emitContainerClasses() {
                var swiper = this;
                if (!swiper.params._emitClasses || !swiper.el) return;
                var cls = swiper.el.className.split(" ").filter(function(className) {
                    return className.indexOf("swiper") === 0 || className.indexOf(swiper.params.containerModifierClass) === 0;
                });
                swiper.emit("_containerClasses", cls.join(" "));
            }
        },
        {
            key: "getSlideClasses",
            value: function getSlideClasses(slideEl) {
                var swiper = this;
                if (swiper.destroyed) return "";
                return slideEl.className.split(" ").filter(function(className) {
                    return className.indexOf("swiper-slide") === 0 || className.indexOf(swiper.params.slideClass) === 0;
                }).join(" ");
            }
        },
        {
            key: "emitSlidesClasses",
            value: function emitSlidesClasses() {
                var swiper = this;
                if (!swiper.params._emitClasses || !swiper.el) return;
                var updates = [];
                swiper.slides.forEach(function(slideEl) {
                    var classNames = swiper.getSlideClasses(slideEl);
                    updates.push({
                        slideEl: slideEl,
                        classNames: classNames
                    });
                    swiper.emit("_slideClass", slideEl, classNames);
                });
                swiper.emit("_slideClasses", updates);
            }
        },
        {
            key: "slidesPerViewDynamic",
            value: function slidesPerViewDynamic() {
                var view = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "current", exact = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                var swiper = this;
                var params = swiper.params, slides = swiper.slides, slidesGrid = swiper.slidesGrid, slidesSizesGrid = swiper.slidesSizesGrid, swiperSize = swiper.size, activeIndex = swiper.activeIndex;
                var spv = 1;
                if (params.centeredSlides) {
                    var slideSize = slides[activeIndex] ? slides[activeIndex].swiperSlideSize : 0;
                    var breakLoop;
                    for(var i = activeIndex + 1; i < slides.length; i += 1)if (slides[i] && !breakLoop) {
                        slideSize += slides[i].swiperSlideSize;
                        spv += 1;
                        if (slideSize > swiperSize) breakLoop = true;
                    }
                    for(var i1 = activeIndex - 1; i1 >= 0; i1 -= 1)if (slides[i1] && !breakLoop) {
                        slideSize += slides[i1].swiperSlideSize;
                        spv += 1;
                        if (slideSize > swiperSize) breakLoop = true;
                    }
                } else {
                    // eslint-disable-next-line
                    if (view === "current") for(var i2 = activeIndex + 1; i2 < slides.length; i2 += 1){
                        var slideInView = exact ? slidesGrid[i2] + slidesSizesGrid[i2] - slidesGrid[activeIndex] < swiperSize : slidesGrid[i2] - slidesGrid[activeIndex] < swiperSize;
                        if (slideInView) spv += 1;
                    }
                    else // previous
                    for(var i3 = activeIndex - 1; i3 >= 0; i3 -= 1){
                        var slideInView1 = slidesGrid[activeIndex] - slidesGrid[i3] < swiperSize;
                        if (slideInView1) spv += 1;
                    }
                }
                return spv;
            }
        },
        {
            key: "update",
            value: function update() {
                var setTranslate = function setTranslate() {
                    var translateValue = swiper.rtlTranslate ? swiper.translate * -1 : swiper.translate;
                    var newTranslate = Math.min(Math.max(translateValue, swiper.maxTranslate()), swiper.minTranslate());
                    swiper.setTranslate(newTranslate);
                    swiper.updateActiveIndex();
                    swiper.updateSlidesClasses();
                };
                var swiper = this;
                if (!swiper || swiper.destroyed) return;
                var snapGrid = swiper.snapGrid, params = swiper.params;
                // Breakpoints
                if (params.breakpoints) swiper.setBreakpoint();
                (0, $2b6Uo._)(swiper.el.querySelectorAll('[loading="lazy"]')).forEach(function(imageEl) {
                    if (imageEl.complete) (0, $cb0e9c9aa16a7aa5$export$54749c0631f34ffc)(swiper, imageEl);
                });
                swiper.updateSize();
                swiper.updateSlides();
                swiper.updateProgress();
                swiper.updateSlidesClasses();
                var translated;
                if (params.freeMode && params.freeMode.enabled && !params.cssMode) {
                    setTranslate();
                    if (params.autoHeight) swiper.updateAutoHeight();
                } else {
                    if ((params.slidesPerView === "auto" || params.slidesPerView > 1) && swiper.isEnd && !params.centeredSlides) {
                        var slides = swiper.virtual && params.virtual.enabled ? swiper.virtual.slides : swiper.slides;
                        translated = swiper.slideTo(slides.length - 1, 0, false, true);
                    } else translated = swiper.slideTo(swiper.activeIndex, 0, false, true);
                    if (!translated) setTranslate();
                }
                if (params.watchOverflow && snapGrid !== swiper.snapGrid) swiper.checkOverflow();
                swiper.emit("update");
            }
        },
        {
            key: "changeDirection",
            value: function changeDirection(newDirection) {
                var needUpdate = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var swiper = this;
                var currentDirection = swiper.params.direction;
                if (!newDirection) // eslint-disable-next-line
                newDirection = currentDirection === "horizontal" ? "vertical" : "horizontal";
                if (newDirection === currentDirection || newDirection !== "horizontal" && newDirection !== "vertical") return swiper;
                swiper.el.classList.remove("".concat(swiper.params.containerModifierClass).concat(currentDirection));
                swiper.el.classList.add("".concat(swiper.params.containerModifierClass).concat(newDirection));
                swiper.emitContainerClasses();
                swiper.params.direction = newDirection;
                swiper.slides.forEach(function(slideEl) {
                    if (newDirection === "vertical") slideEl.style.width = "";
                    else slideEl.style.height = "";
                });
                swiper.emit("changeDirection");
                if (needUpdate) swiper.update();
                return swiper;
            }
        },
        {
            key: "changeLanguageDirection",
            value: function changeLanguageDirection(direction) {
                var swiper = this;
                if (swiper.rtl && direction === "rtl" || !swiper.rtl && direction === "ltr") return;
                swiper.rtl = direction === "rtl";
                swiper.rtlTranslate = swiper.params.direction === "horizontal" && swiper.rtl;
                if (swiper.rtl) {
                    swiper.el.classList.add("".concat(swiper.params.containerModifierClass, "rtl"));
                    swiper.el.dir = "rtl";
                } else {
                    swiper.el.classList.remove("".concat(swiper.params.containerModifierClass, "rtl"));
                    swiper.el.dir = "ltr";
                }
                swiper.update();
            }
        },
        {
            key: "mount",
            value: function mount(element) {
                var swiper = this;
                if (swiper.mounted) return true;
                // Find el
                var el = element || swiper.params.el;
                if (typeof el === "string") el = document.querySelector(el);
                if (!el) return false;
                el.swiper = swiper;
                if (el.shadowEl) swiper.isElement = true;
                var getWrapperSelector = function() {
                    return ".".concat((swiper.params.wrapperClass || "").trim().split(" ").join("."));
                };
                var getWrapper = function() {
                    if (el && el.shadowRoot && el.shadowRoot.querySelector) {
                        var res = el.shadowRoot.querySelector(getWrapperSelector());
                        // Children needs to return slot items
                        return res;
                    }
                    return (0, $2530e0d256bb8028$export$eb846d859f2895e6)(el, getWrapperSelector())[0];
                };
                // Find Wrapper
                var wrapperEl = getWrapper();
                if (!wrapperEl && swiper.params.createElements) {
                    wrapperEl = (0, $2530e0d256bb8028$export$c8a8987d4410bf2d)("div", swiper.params.wrapperClass);
                    el.append(wrapperEl);
                    (0, $2530e0d256bb8028$export$eb846d859f2895e6)(el, ".".concat(swiper.params.slideClass)).forEach(function(slideEl) {
                        wrapperEl.append(slideEl);
                    });
                }
                Object.assign(swiper, {
                    el: el,
                    wrapperEl: wrapperEl,
                    slidesEl: swiper.isElement ? el : wrapperEl,
                    mounted: true,
                    // RTL
                    rtl: el.dir.toLowerCase() === "rtl" || (0, $2530e0d256bb8028$export$4184470d4bd0f986)(el, "direction") === "rtl",
                    rtlTranslate: swiper.params.direction === "horizontal" && (el.dir.toLowerCase() === "rtl" || (0, $2530e0d256bb8028$export$4184470d4bd0f986)(el, "direction") === "rtl"),
                    wrongRTL: (0, $2530e0d256bb8028$export$4184470d4bd0f986)(wrapperEl, "display") === "-webkit-box"
                });
                return true;
            }
        },
        {
            key: "init",
            value: function init(el) {
                var swiper = this;
                if (swiper.initialized) return swiper;
                var mounted = swiper.mount(el);
                if (mounted === false) return swiper;
                swiper.emit("beforeInit");
                // Set breakpoint
                if (swiper.params.breakpoints) swiper.setBreakpoint();
                // Add Classes
                swiper.addClasses();
                // Update size
                swiper.updateSize();
                // Update slides
                swiper.updateSlides();
                if (swiper.params.watchOverflow) swiper.checkOverflow();
                // Set Grab Cursor
                if (swiper.params.grabCursor && swiper.enabled) swiper.setGrabCursor();
                // Slide To Initial Slide
                if (swiper.params.loop && swiper.virtual && swiper.params.virtual.enabled) swiper.slideTo(swiper.params.initialSlide + swiper.virtual.slidesBefore, 0, swiper.params.runCallbacksOnInit, false, true);
                else swiper.slideTo(swiper.params.initialSlide, 0, swiper.params.runCallbacksOnInit, false, true);
                // Create loop
                if (swiper.params.loop) swiper.loopCreate();
                // Attach events
                swiper.attachEvents();
                (0, $2b6Uo._)(swiper.el.querySelectorAll('[loading="lazy"]')).forEach(function(imageEl) {
                    if (imageEl.complete) (0, $cb0e9c9aa16a7aa5$export$54749c0631f34ffc)(swiper, imageEl);
                    else imageEl.addEventListener("load", function(e) {
                        (0, $cb0e9c9aa16a7aa5$export$54749c0631f34ffc)(swiper, e.target);
                    });
                });
                (0, $cb0e9c9aa16a7aa5$export$513ccb98c53b8039)(swiper);
                // Init Flag
                swiper.initialized = true;
                (0, $cb0e9c9aa16a7aa5$export$513ccb98c53b8039)(swiper);
                // Emit
                swiper.emit("init");
                swiper.emit("afterInit");
                return swiper;
            }
        },
        {
            key: "destroy",
            value: function destroy() {
                var deleteInstance = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true, cleanStyles = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                var swiper = this;
                var params = swiper.params, el = swiper.el, wrapperEl = swiper.wrapperEl, slides = swiper.slides;
                if (typeof swiper.params === "undefined" || swiper.destroyed) return null;
                swiper.emit("beforeDestroy");
                // Init Flag
                swiper.initialized = false;
                // Detach events
                swiper.detachEvents();
                // Destroy loop
                if (params.loop) swiper.loopDestroy();
                // Cleanup styles
                if (cleanStyles) {
                    swiper.removeClasses();
                    el.removeAttribute("style");
                    wrapperEl.removeAttribute("style");
                    if (slides && slides.length) slides.forEach(function(slideEl) {
                        slideEl.classList.remove(params.slideVisibleClass, params.slideActiveClass, params.slideNextClass, params.slidePrevClass);
                        slideEl.removeAttribute("style");
                        slideEl.removeAttribute("data-swiper-slide-index");
                    });
                }
                swiper.emit("destroy");
                // Detach emitter events
                Object.keys(swiper.eventsListeners).forEach(function(eventName) {
                    swiper.off(eventName);
                });
                if (deleteInstance !== false) {
                    swiper.el.swiper = null;
                    (0, $2530e0d256bb8028$export$8694e5c03a4df8e6)(swiper);
                }
                swiper.destroyed = true;
                return null;
            }
        }
    ], [
        {
            key: "extendDefaults",
            value: function extendDefaults(newDefaults) {
                (0, $2530e0d256bb8028$export$8b58be045bf06082)($67b1addace326499$var$extendedDefaults, newDefaults);
            }
        },
        {
            key: "extendedDefaults",
            get: function get() {
                return $67b1addace326499$var$extendedDefaults;
            }
        },
        {
            key: "defaults",
            get: function get() {
                return 0, $7502ebb135392435$export$2e2bcd8739ae039;
            }
        },
        {
            key: "installModule",
            value: function installModule(mod) {
                if (!Swiper.prototype.__modules__) Swiper.prototype.__modules__ = [];
                var modules = Swiper.prototype.__modules__;
                if (typeof mod === "function" && modules.indexOf(mod) < 0) modules.push(mod);
            }
        },
        {
            key: "use",
            value: function use(module) {
                if (Array.isArray(module)) {
                    module.forEach(function(m) {
                        return Swiper.installModule(m);
                    });
                    return Swiper;
                }
                Swiper.installModule(module);
                return Swiper;
            }
        }
    ]);
    return Swiper;
}();
Object.keys($67b1addace326499$var$prototypes).forEach(function(prototypeGroup) {
    Object.keys($67b1addace326499$var$prototypes[prototypeGroup]).forEach(function(protoMethod) {
        $67b1addace326499$var$Swiper.prototype[protoMethod] = $67b1addace326499$var$prototypes[prototypeGroup][protoMethod];
    });
});
$67b1addace326499$var$Swiper.use([
    (0, $6d20db31b0c0bc88$export$2e2bcd8739ae039),
    (0, $261aaf38d343d095$export$2e2bcd8739ae039)
]);
var $67b1addace326499$export$2e2bcd8739ae039 = $67b1addace326499$var$Swiper;



var $2b6Uo = parcelRequire("2b6Uo");


function $850400a17f874cc7$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    var renderSlide = function renderSlide(slide, index) {
        var params = swiper.params.virtual;
        if (params.cache && swiper.virtual.cache[index]) return swiper.virtual.cache[index];
        // eslint-disable-next-line
        var slideEl;
        if (params.renderSlide) {
            slideEl = params.renderSlide.call(swiper, slide, index);
            if (typeof slideEl === "string") {
                tempDOM.innerHTML = slideEl;
                slideEl = tempDOM.children[0];
            }
        } else if (swiper.isElement) slideEl = (0, $2530e0d256bb8028$export$c8a8987d4410bf2d)("swiper-slide");
        else slideEl = (0, $2530e0d256bb8028$export$c8a8987d4410bf2d)("div", swiper.params.slideClass);
        slideEl.setAttribute("data-swiper-slide-index", index);
        if (!params.renderSlide) slideEl.innerHTML = slide;
        if (params.cache) swiper.virtual.cache[index] = slideEl;
        return slideEl;
    };
    var update = function update(force) {
        var _swiper_params = swiper.params, slidesPerView = _swiper_params.slidesPerView, slidesPerGroup = _swiper_params.slidesPerGroup, centeredSlides = _swiper_params.centeredSlides, isLoop = _swiper_params.loop;
        var _swiper_params_virtual = swiper.params.virtual, addSlidesBefore = _swiper_params_virtual.addSlidesBefore, addSlidesAfter = _swiper_params_virtual.addSlidesAfter;
        var _swiper_virtual = swiper.virtual, previousFrom = _swiper_virtual.from, previousTo = _swiper_virtual.to, slides = _swiper_virtual.slides, previousSlidesGrid = _swiper_virtual.slidesGrid, previousOffset = _swiper_virtual.offset;
        if (!swiper.params.cssMode) swiper.updateActiveIndex();
        var activeIndex = swiper.activeIndex || 0;
        var offsetProp;
        if (swiper.rtlTranslate) offsetProp = "right";
        else offsetProp = swiper.isHorizontal() ? "left" : "top";
        var slidesAfter;
        var slidesBefore;
        if (centeredSlides) {
            slidesAfter = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesAfter;
            slidesBefore = Math.floor(slidesPerView / 2) + slidesPerGroup + addSlidesBefore;
        } else {
            slidesAfter = slidesPerView + (slidesPerGroup - 1) + addSlidesAfter;
            slidesBefore = (isLoop ? slidesPerView : slidesPerGroup) + addSlidesBefore;
        }
        var from = activeIndex - slidesBefore;
        var to = activeIndex + slidesAfter;
        if (!isLoop) {
            from = Math.max(from, 0);
            to = Math.min(to, slides.length - 1);
        }
        var offset = (swiper.slidesGrid[from] || 0) - (swiper.slidesGrid[0] || 0);
        if (isLoop && activeIndex >= slidesBefore) {
            from -= slidesBefore;
            if (!centeredSlides) offset += swiper.slidesGrid[0];
        } else if (isLoop && activeIndex < slidesBefore) {
            from = -slidesBefore;
            if (centeredSlides) offset += swiper.slidesGrid[0];
        }
        Object.assign(swiper.virtual, {
            from: from,
            to: to,
            offset: offset,
            slidesGrid: swiper.slidesGrid,
            slidesBefore: slidesBefore,
            slidesAfter: slidesAfter
        });
        function onRendered() {
            swiper.updateSlides();
            swiper.updateProgress();
            swiper.updateSlidesClasses();
            emit("virtualUpdate");
        }
        if (previousFrom === from && previousTo === to && !force) {
            if (swiper.slidesGrid !== previousSlidesGrid && offset !== previousOffset) swiper.slides.forEach(function(slideEl) {
                slideEl.style[offsetProp] = "".concat(offset - Math.abs(swiper.cssOverflowAdjustment()), "px");
            });
            swiper.updateProgress();
            emit("virtualUpdate");
            return;
        }
        if (swiper.params.virtual.renderExternal) {
            swiper.params.virtual.renderExternal.call(swiper, {
                offset: offset,
                from: from,
                to: to,
                slides: function getSlides() {
                    var slidesToRender = [];
                    for(var i = from; i <= to; i += 1)slidesToRender.push(slides[i]);
                    return slidesToRender;
                }()
            });
            if (swiper.params.virtual.renderExternalUpdate) onRendered();
            else emit("virtualUpdate");
            return;
        }
        var prependIndexes = [];
        var appendIndexes = [];
        var getSlideIndex = function(index) {
            var slideIndex = index;
            if (index < 0) slideIndex = slides.length + index;
            else if (slideIndex >= slides.length) // eslint-disable-next-line
            slideIndex = slideIndex - slides.length;
            return slideIndex;
        };
        if (force) swiper.slidesEl.querySelectorAll(".".concat(swiper.params.slideClass, ", swiper-slide")).forEach(function(slideEl) {
            slideEl.remove();
        });
        else {
            for(var i = previousFrom; i <= previousTo; i += 1)if (i < from || i > to) {
                var slideIndex = getSlideIndex(i);
                swiper.slidesEl.querySelectorAll(".".concat(swiper.params.slideClass, '[data-swiper-slide-index="').concat(slideIndex, '"], swiper-slide[data-swiper-slide-index="').concat(slideIndex, '"]')).forEach(function(slideEl) {
                    slideEl.remove();
                });
            }
        }
        var loopFrom = isLoop ? -slides.length : 0;
        var loopTo = isLoop ? slides.length * 2 : slides.length;
        for(var i1 = loopFrom; i1 < loopTo; i1 += 1)if (i1 >= from && i1 <= to) {
            var slideIndex1 = getSlideIndex(i1);
            if (typeof previousTo === "undefined" || force) appendIndexes.push(slideIndex1);
            else {
                if (i1 > previousTo) appendIndexes.push(slideIndex1);
                if (i1 < previousFrom) prependIndexes.push(slideIndex1);
            }
        }
        appendIndexes.forEach(function(index) {
            swiper.slidesEl.append(renderSlide(slides[index], index));
        });
        if (isLoop) for(var i2 = prependIndexes.length - 1; i2 >= 0; i2 -= 1){
            var index = prependIndexes[i2];
            swiper.slidesEl.prepend(renderSlide(slides[index], index));
        }
        else {
            prependIndexes.sort(function(a, b) {
                return b - a;
            });
            prependIndexes.forEach(function(index) {
                swiper.slidesEl.prepend(renderSlide(slides[index], index));
            });
        }
        (0, $2530e0d256bb8028$export$eb846d859f2895e6)(swiper.slidesEl, ".swiper-slide, swiper-slide").forEach(function(slideEl) {
            slideEl.style[offsetProp] = "".concat(offset - Math.abs(swiper.cssOverflowAdjustment()), "px");
        });
        onRendered();
    };
    var appendSlide = function appendSlide(slides) {
        if (typeof slides === "object" && "length" in slides) {
            for(var i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.push(slides[i]);
        } else swiper.virtual.slides.push(slides);
        update(true);
    };
    var prependSlide = function prependSlide(slides) {
        var activeIndex = swiper.activeIndex;
        var newActiveIndex = activeIndex + 1;
        var numberOfNewSlides = 1;
        if (Array.isArray(slides)) {
            for(var i = 0; i < slides.length; i += 1)if (slides[i]) swiper.virtual.slides.unshift(slides[i]);
            newActiveIndex = activeIndex + slides.length;
            numberOfNewSlides = slides.length;
        } else swiper.virtual.slides.unshift(slides);
        if (swiper.params.virtual.cache) {
            var cache = swiper.virtual.cache;
            var newCache = {};
            Object.keys(cache).forEach(function(cachedIndex) {
                var cachedEl = cache[cachedIndex];
                var cachedElIndex = cachedEl.getAttribute("data-swiper-slide-index");
                if (cachedElIndex) cachedEl.setAttribute("data-swiper-slide-index", parseInt(cachedElIndex, 10) + numberOfNewSlides);
                newCache[parseInt(cachedIndex, 10) + numberOfNewSlides] = cachedEl;
            });
            swiper.virtual.cache = newCache;
        }
        update(true);
        swiper.slideTo(newActiveIndex, 0);
    };
    var removeSlide = function removeSlide(slidesIndexes) {
        if (typeof slidesIndexes === "undefined" || slidesIndexes === null) return;
        var activeIndex = swiper.activeIndex;
        if (Array.isArray(slidesIndexes)) for(var i = slidesIndexes.length - 1; i >= 0; i -= 1){
            swiper.virtual.slides.splice(slidesIndexes[i], 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes[i]];
            if (slidesIndexes[i] < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        else {
            swiper.virtual.slides.splice(slidesIndexes, 1);
            if (swiper.params.virtual.cache) delete swiper.virtual.cache[slidesIndexes];
            if (slidesIndexes < activeIndex) activeIndex -= 1;
            activeIndex = Math.max(activeIndex, 0);
        }
        update(true);
        swiper.slideTo(activeIndex, 0);
    };
    var removeAllSlides = function removeAllSlides() {
        swiper.virtual.slides = [];
        if (swiper.params.virtual.cache) swiper.virtual.cache = {};
        update(true);
        swiper.slideTo(0, 0);
    };
    extendParams({
        virtual: {
            enabled: false,
            slides: [],
            cache: true,
            renderSlide: null,
            renderExternal: null,
            renderExternalUpdate: true,
            addSlidesBefore: 0,
            addSlidesAfter: 0
        }
    });
    var cssModeTimeout;
    var document = (0, $e7beec05cc3d4f7e$export$f65ca476c09acec0)();
    swiper.virtual = {
        cache: {},
        from: undefined,
        to: undefined,
        slides: [],
        offset: 0,
        slidesGrid: []
    };
    var tempDOM = document.createElement("div");
    on("beforeInit", function() {
        if (!swiper.params.virtual.enabled) return;
        var domSlidesAssigned;
        if (typeof swiper.passedParams.virtual.slides === "undefined") {
            var slides = (0, $2b6Uo._)(swiper.slidesEl.children).filter(function(el) {
                return el.matches(".".concat(swiper.params.slideClass, ", swiper-slide"));
            });
            if (slides && slides.length) {
                swiper.virtual.slides = (0, $2b6Uo._)(slides);
                domSlidesAssigned = true;
                slides.forEach(function(slideEl, slideIndex) {
                    slideEl.setAttribute("data-swiper-slide-index", slideIndex);
                    swiper.virtual.cache[slideIndex] = slideEl;
                    slideEl.remove();
                });
            }
        }
        if (!domSlidesAssigned) swiper.virtual.slides = swiper.params.virtual.slides;
        swiper.classNames.push("".concat(swiper.params.containerModifierClass, "virtual"));
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
        if (!swiper.params.initialSlide) update();
    });
    on("setTranslate", function() {
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode && !swiper._immediateVirtual) {
            clearTimeout(cssModeTimeout);
            cssModeTimeout = setTimeout(function() {
                update();
            }, 100);
        } else update();
    });
    on("init update resize", function() {
        if (!swiper.params.virtual.enabled) return;
        if (swiper.params.cssMode) (0, $2530e0d256bb8028$export$a607267f322101fd)(swiper.wrapperEl, "--swiper-virtual-size", "".concat(swiper.virtualSize, "px"));
    });
    Object.assign(swiper.virtual, {
        appendSlide: appendSlide,
        prependSlide: prependSlide,
        removeSlide: removeSlide,
        removeAllSlides: removeAllSlides,
        update: update
    });
}


/* eslint-disable consistent-return */ 

function $fe7e810c9bcbc309$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    var handle = function handle(event) {
        if (!swiper.enabled) return;
        var rtl = swiper.rtlTranslate;
        var e = event;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        var kc = e.keyCode || e.charCode;
        var pageUpDown = swiper.params.keyboard.pageUpDown;
        var isPageUp = pageUpDown && kc === 33;
        var isPageDown = pageUpDown && kc === 34;
        var isArrowLeft = kc === 37;
        var isArrowRight = kc === 39;
        var isArrowUp = kc === 38;
        var isArrowDown = kc === 40;
        // Directions locks
        if (!swiper.allowSlideNext && (swiper.isHorizontal() && isArrowRight || swiper.isVertical() && isArrowDown || isPageDown)) return false;
        if (!swiper.allowSlidePrev && (swiper.isHorizontal() && isArrowLeft || swiper.isVertical() && isArrowUp || isPageUp)) return false;
        if (e.shiftKey || e.altKey || e.ctrlKey || e.metaKey) return undefined;
        if (document.activeElement && document.activeElement.nodeName && (document.activeElement.nodeName.toLowerCase() === "input" || document.activeElement.nodeName.toLowerCase() === "textarea")) return undefined;
        if (swiper.params.keyboard.onlyInViewport && (isPageUp || isPageDown || isArrowLeft || isArrowRight || isArrowUp || isArrowDown)) {
            var inView = false;
            // Check that swiper should be inside of visible area of window
            if ((0, $2530e0d256bb8028$export$aedc7b608ca8e855)(swiper.el, ".".concat(swiper.params.slideClass, ", swiper-slide")).length > 0 && (0, $2530e0d256bb8028$export$aedc7b608ca8e855)(swiper.el, ".".concat(swiper.params.slideActiveClass)).length === 0) return undefined;
            var el = swiper.el;
            var swiperWidth = el.clientWidth;
            var swiperHeight = el.clientHeight;
            var windowWidth = window.innerWidth;
            var windowHeight = window.innerHeight;
            var swiperOffset = (0, $2530e0d256bb8028$export$d7820ec56f35bbaa)(el);
            if (rtl) swiperOffset.left -= el.scrollLeft;
            var swiperCoord = [
                [
                    swiperOffset.left,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top
                ],
                [
                    swiperOffset.left,
                    swiperOffset.top + swiperHeight
                ],
                [
                    swiperOffset.left + swiperWidth,
                    swiperOffset.top + swiperHeight
                ]
            ];
            for(var i = 0; i < swiperCoord.length; i += 1){
                var point = swiperCoord[i];
                if (point[0] >= 0 && point[0] <= windowWidth && point[1] >= 0 && point[1] <= windowHeight) {
                    if (point[0] === 0 && point[1] === 0) continue; // eslint-disable-line
                    inView = true;
                }
            }
            if (!inView) return undefined;
        }
        if (swiper.isHorizontal()) {
            if (isPageUp || isPageDown || isArrowLeft || isArrowRight) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if ((isPageDown || isArrowRight) && !rtl || (isPageUp || isArrowLeft) && rtl) swiper.slideNext();
            if ((isPageUp || isArrowLeft) && !rtl || (isPageDown || isArrowRight) && rtl) swiper.slidePrev();
        } else {
            if (isPageUp || isPageDown || isArrowUp || isArrowDown) {
                if (e.preventDefault) e.preventDefault();
                else e.returnValue = false;
            }
            if (isPageDown || isArrowDown) swiper.slideNext();
            if (isPageUp || isArrowUp) swiper.slidePrev();
        }
        emit("keyPress", kc);
        return undefined;
    };
    var enable = function enable() {
        if (swiper.keyboard.enabled) return;
        document.addEventListener("keydown", handle);
        swiper.keyboard.enabled = true;
    };
    var disable = function disable() {
        if (!swiper.keyboard.enabled) return;
        document.removeEventListener("keydown", handle);
        swiper.keyboard.enabled = false;
    };
    var document = (0, $e7beec05cc3d4f7e$export$f65ca476c09acec0)();
    var window = (0, $e7beec05cc3d4f7e$export$38b2d434cce3ea22)();
    swiper.keyboard = {
        enabled: false
    };
    extendParams({
        keyboard: {
            enabled: false,
            onlyInViewport: true,
            pageUpDown: true
        }
    });
    on("init", function() {
        if (swiper.params.keyboard.enabled) enable();
    });
    on("destroy", function() {
        if (swiper.keyboard.enabled) disable();
    });
    Object.assign(swiper.keyboard, {
        enable: enable,
        disable: disable
    });
}


/* eslint-disable consistent-return */ 

function $ecda534c36993466$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    var normalize = function normalize(e) {
        // Reasonable defaults
        var PIXEL_STEP = 10;
        var LINE_HEIGHT = 40;
        var PAGE_HEIGHT = 800;
        var sX = 0;
        var sY = 0; // spinX, spinY
        var pX = 0;
        var pY = 0; // pixelX, pixelY
        // Legacy
        if ("detail" in e) sY = e.detail;
        if ("wheelDelta" in e) sY = -e.wheelDelta / 120;
        if ("wheelDeltaY" in e) sY = -e.wheelDeltaY / 120;
        if ("wheelDeltaX" in e) sX = -e.wheelDeltaX / 120;
        // side scrolling on FF with DOMMouseScroll
        if ("axis" in e && e.axis === e.HORIZONTAL_AXIS) {
            sX = sY;
            sY = 0;
        }
        pX = sX * PIXEL_STEP;
        pY = sY * PIXEL_STEP;
        if ("deltaY" in e) pY = e.deltaY;
        if ("deltaX" in e) pX = e.deltaX;
        if (e.shiftKey && !pX) {
            // if user scrolls with shift he wants horizontal scroll
            pX = pY;
            pY = 0;
        }
        if ((pX || pY) && e.deltaMode) {
            if (e.deltaMode === 1) {
                // delta in LINE units
                pX *= LINE_HEIGHT;
                pY *= LINE_HEIGHT;
            } else {
                // delta in PAGE units
                pX *= PAGE_HEIGHT;
                pY *= PAGE_HEIGHT;
            }
        }
        // Fall-back if spin cannot be determined
        if (pX && !sX) sX = pX < 1 ? -1 : 1;
        if (pY && !sY) sY = pY < 1 ? -1 : 1;
        return {
            spinX: sX,
            spinY: sY,
            pixelX: pX,
            pixelY: pY
        };
    };
    var handleMouseEnter = function handleMouseEnter() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = true;
    };
    var handleMouseLeave = function handleMouseLeave() {
        if (!swiper.enabled) return;
        swiper.mouseEntered = false;
    };
    var animateSlider = function animateSlider(newEvent) {
        if (swiper.params.mousewheel.thresholdDelta && newEvent.delta < swiper.params.mousewheel.thresholdDelta) // Prevent if delta of wheel scroll delta is below configured threshold
        return false;
        if (swiper.params.mousewheel.thresholdTime && (0, $2530e0d256bb8028$export$461939dd4422153)() - lastScrollTime < swiper.params.mousewheel.thresholdTime) // Prevent if time between scrolls is below configured threshold
        return false;
        // If the movement is NOT big enough and
        // if the last time the user scrolled was too close to the current one (avoid continuously triggering the slider):
        //   Don't go any further (avoid insignificant scroll movement).
        if (newEvent.delta >= 6 && (0, $2530e0d256bb8028$export$461939dd4422153)() - lastScrollTime < 60) // Return false as a default
        return true;
        // If user is scrolling towards the end:
        //   If the slider hasn't hit the latest slide or
        //   if the slider is a loop and
        //   if the slider isn't moving right now:
        //     Go to next slide and
        //     emit a scroll event.
        // Else (the user is scrolling towards the beginning) and
        // if the slider hasn't hit the first slide or
        // if the slider is a loop and
        // if the slider isn't moving right now:
        //   Go to prev slide and
        //   emit a scroll event.
        if (newEvent.direction < 0) {
            if ((!swiper.isEnd || swiper.params.loop) && !swiper.animating) {
                swiper.slideNext();
                emit("scroll", newEvent.raw);
            }
        } else if ((!swiper.isBeginning || swiper.params.loop) && !swiper.animating) {
            swiper.slidePrev();
            emit("scroll", newEvent.raw);
        }
        // If you got here is because an animation has been triggered so store the current time
        lastScrollTime = new window.Date().getTime();
        // Return false as a default
        return false;
    };
    var releaseScroll = function releaseScroll(newEvent) {
        var params = swiper.params.mousewheel;
        if (newEvent.direction < 0) {
            if (swiper.isEnd && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
            return true;
        } else if (swiper.isBeginning && !swiper.params.loop && params.releaseOnEdges) // Return true to animate scroll on edges
        return true;
        return false;
    };
    var handle = function handle(event1) {
        var e = event1;
        var disableParentSwiper = true;
        if (!swiper.enabled) return;
        // Ignore event if the target or its parents have the swiper-no-mousewheel class
        if (event1.target.closest(".".concat(swiper.params.mousewheel.noMousewheelClass))) return;
        var params = swiper.params.mousewheel;
        if (swiper.params.cssMode) e.preventDefault();
        var targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== "container") targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        var targetElContainsTarget = targetEl && targetEl.contains(e.target);
        if (!swiper.mouseEntered && !targetElContainsTarget && !params.releaseOnEdges) return true;
        if (e.originalEvent) e = e.originalEvent; // jquery fix
        var delta = 0;
        var rtlFactor = swiper.rtlTranslate ? -1 : 1;
        var data = normalize(e);
        if (params.forceToAxis) {
            if (swiper.isHorizontal()) {
                if (Math.abs(data.pixelX) > Math.abs(data.pixelY)) delta = -data.pixelX * rtlFactor;
                else return true;
            } else if (Math.abs(data.pixelY) > Math.abs(data.pixelX)) delta = -data.pixelY;
            else return true;
        } else delta = Math.abs(data.pixelX) > Math.abs(data.pixelY) ? -data.pixelX * rtlFactor : -data.pixelY;
        if (delta === 0) return true;
        if (params.invert) delta = -delta;
        // Get the scroll positions
        var positions = swiper.getTranslate() + delta * params.sensitivity;
        if (positions >= swiper.minTranslate()) positions = swiper.minTranslate();
        if (positions <= swiper.maxTranslate()) positions = swiper.maxTranslate();
        // When loop is true:
        //     the disableParentSwiper will be true.
        // When loop is false:
        //     if the scroll positions is not on edge,
        //     then the disableParentSwiper will be true.
        //     if the scroll on edge positions,
        //     then the disableParentSwiper will be false.
        disableParentSwiper = swiper.params.loop ? true : !(positions === swiper.minTranslate() || positions === swiper.maxTranslate());
        if (disableParentSwiper && swiper.params.nested) e.stopPropagation();
        if (!swiper.params.freeMode || !swiper.params.freeMode.enabled) {
            // Register the new event in a variable which stores the relevant data
            var newEvent = {
                time: (0, $2530e0d256bb8028$export$461939dd4422153)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta),
                raw: event1
            };
            // Keep the most recent events
            if (recentWheelEvents.length >= 2) recentWheelEvents.shift(); // only store the last N events
            var prevEvent = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
            recentWheelEvents.push(newEvent);
            // If there is at least one previous recorded event:
            //   If direction has changed or
            //   if the scroll is quicker than the previous one:
            //     Animate the slider.
            // Else (this is the first time the wheel is moved):
            //     Animate the slider.
            if (prevEvent) {
                if (newEvent.direction !== prevEvent.direction || newEvent.delta > prevEvent.delta || newEvent.time > prevEvent.time + 150) animateSlider(newEvent);
            } else animateSlider(newEvent);
            // If it's time to release the scroll:
            //   Return now so you don't hit the preventDefault.
            if (releaseScroll(newEvent)) return true;
        } else {
            // Freemode or scrollContainer:
            // If we recently snapped after a momentum scroll, then ignore wheel events
            // to give time for the deceleration to finish. Stop ignoring after 500 msecs
            // or if it's a new scroll (larger delta or inverse sign as last event before
            // an end-of-momentum snap).
            var newEvent1 = {
                time: (0, $2530e0d256bb8028$export$461939dd4422153)(),
                delta: Math.abs(delta),
                direction: Math.sign(delta)
            };
            var ignoreWheelEvents = lastEventBeforeSnap && newEvent1.time < lastEventBeforeSnap.time + 500 && newEvent1.delta <= lastEventBeforeSnap.delta && newEvent1.direction === lastEventBeforeSnap.direction;
            if (!ignoreWheelEvents) {
                lastEventBeforeSnap = undefined;
                var position = swiper.getTranslate() + delta * params.sensitivity;
                var wasBeginning = swiper.isBeginning;
                var wasEnd = swiper.isEnd;
                if (position >= swiper.minTranslate()) position = swiper.minTranslate();
                if (position <= swiper.maxTranslate()) position = swiper.maxTranslate();
                swiper.setTransition(0);
                swiper.setTranslate(position);
                swiper.updateProgress();
                swiper.updateActiveIndex();
                swiper.updateSlidesClasses();
                if (!wasBeginning && swiper.isBeginning || !wasEnd && swiper.isEnd) swiper.updateSlidesClasses();
                if (swiper.params.loop) swiper.loopFix({
                    direction: newEvent1.direction < 0 ? "next" : "prev",
                    byMousewheel: true
                });
                if (swiper.params.freeMode.sticky) {
                    // When wheel scrolling starts with sticky (aka snap) enabled, then detect
                    // the end of a momentum scroll by storing recent (N=15?) wheel events.
                    // 1. do all N events have decreasing or same (absolute value) delta?
                    // 2. did all N events arrive in the last M (M=500?) msecs?
                    // 3. does the earliest event have an (absolute value) delta that's
                    //    at least P (P=1?) larger than the most recent event's delta?
                    // 4. does the latest event have a delta that's smaller than Q (Q=6?) pixels?
                    // If 1-4 are "yes" then we're near the end of a momentum scroll deceleration.
                    // Snap immediately and ignore remaining wheel events in this scroll.
                    // See comment above for "remaining wheel events in this scroll" determination.
                    // If 1-4 aren't satisfied, then wait to snap until 500ms after the last event.
                    clearTimeout(timeout);
                    timeout = undefined;
                    if (recentWheelEvents.length >= 15) recentWheelEvents.shift(); // only store the last N events
                    var prevEvent1 = recentWheelEvents.length ? recentWheelEvents[recentWheelEvents.length - 1] : undefined;
                    var firstEvent = recentWheelEvents[0];
                    recentWheelEvents.push(newEvent1);
                    if (prevEvent1 && (newEvent1.delta > prevEvent1.delta || newEvent1.direction !== prevEvent1.direction)) // Increasing or reverse-sign delta means the user started scrolling again. Clear the wheel event log.
                    recentWheelEvents.splice(0);
                    else if (recentWheelEvents.length >= 15 && newEvent1.time - firstEvent.time < 500 && firstEvent.delta - newEvent1.delta >= 1 && newEvent1.delta <= 6) {
                        // We're at the end of the deceleration of a momentum scroll, so there's no need
                        // to wait for more events. Snap ASAP on the next tick.
                        // Also, because there's some remaining momentum we'll bias the snap in the
                        // direction of the ongoing scroll because it's better UX for the scroll to snap
                        // in the same direction as the scroll instead of reversing to snap.  Therefore,
                        // if it's already scrolled more than 20% in the current direction, keep going.
                        var snapToThreshold = delta > 0 ? 0.8 : 0.2;
                        lastEventBeforeSnap = newEvent1;
                        recentWheelEvents.splice(0);
                        timeout = (0, $2530e0d256bb8028$export$bdd553fddd433dcb)(function() {
                            swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                        }, 0); // no delay; move on next tick
                    }
                    if (!timeout) // if we get here, then we haven't detected the end of a momentum scroll, so
                    // we'll consider a scroll "complete" when there haven't been any wheel events
                    // for 500ms.
                    timeout = (0, $2530e0d256bb8028$export$bdd553fddd433dcb)(function() {
                        var snapToThreshold = 0.5;
                        lastEventBeforeSnap = newEvent1;
                        recentWheelEvents.splice(0);
                        swiper.slideToClosest(swiper.params.speed, true, undefined, snapToThreshold);
                    }, 500);
                }
                // Emit event
                if (!ignoreWheelEvents) emit("scroll", e);
                // Stop autoplay
                if (swiper.params.autoplay && swiper.params.autoplayDisableOnInteraction) swiper.autoplay.stop();
                // Return page scroll on edge positions
                if (position === swiper.minTranslate() || position === swiper.maxTranslate()) return true;
            }
        }
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        return false;
    };
    var events = function events(method) {
        var targetEl = swiper.el;
        if (swiper.params.mousewheel.eventsTarget !== "container") targetEl = document.querySelector(swiper.params.mousewheel.eventsTarget);
        targetEl[method]("mouseenter", handleMouseEnter);
        targetEl[method]("mouseleave", handleMouseLeave);
        targetEl[method]("wheel", handle);
    };
    var enable = function enable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.removeEventListener("wheel", handle);
            return true;
        }
        if (swiper.mousewheel.enabled) return false;
        events("addEventListener");
        swiper.mousewheel.enabled = true;
        return true;
    };
    var disable = function disable() {
        if (swiper.params.cssMode) {
            swiper.wrapperEl.addEventListener(event, handle);
            return true;
        }
        if (!swiper.mousewheel.enabled) return false;
        events("removeEventListener");
        swiper.mousewheel.enabled = false;
        return true;
    };
    var window = (0, $e7beec05cc3d4f7e$export$38b2d434cce3ea22)();
    extendParams({
        mousewheel: {
            enabled: false,
            releaseOnEdges: false,
            invert: false,
            forceToAxis: false,
            sensitivity: 1,
            eventsTarget: "container",
            thresholdDelta: null,
            thresholdTime: null,
            noMousewheelClass: "swiper-no-mousewheel"
        }
    });
    swiper.mousewheel = {
        enabled: false
    };
    var timeout;
    var lastScrollTime = (0, $2530e0d256bb8028$export$461939dd4422153)();
    var lastEventBeforeSnap;
    var recentWheelEvents = [];
    on("init", function() {
        if (!swiper.params.mousewheel.enabled && swiper.params.cssMode) disable();
        if (swiper.params.mousewheel.enabled) enable();
    });
    on("destroy", function() {
        if (swiper.params.cssMode) enable();
        if (swiper.mousewheel.enabled) disable();
    });
    Object.assign(swiper.mousewheel, {
        enable: enable,
        disable: disable
    });
}



var $2b6Uo = parcelRequire("2b6Uo");

function $bac4f32cdf410388$export$2e2bcd8739ae039(swiper, originalParams, params, checkProps) {
    if (swiper.params.createElements) Object.keys(checkProps).forEach(function(key) {
        if (!params[key] && params.auto === true) {
            var element = (0, $2530e0d256bb8028$export$eb846d859f2895e6)(swiper.el, ".".concat(checkProps[key]))[0];
            if (!element) {
                element = (0, $2530e0d256bb8028$export$c8a8987d4410bf2d)("div", checkProps[key]);
                element.className = checkProps[key];
                swiper.el.append(element);
            }
            params[key] = element;
            originalParams[key] = element;
        }
    });
    return params;
}


function $1ab9a3fbacfaf36b$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    var getEl = function getEl(el) {
        var res;
        if (el && typeof el === "string" && swiper.isElement) {
            res = swiper.el.shadowRoot.querySelector(el);
            if (res) return res;
        }
        if (el) {
            if (typeof el === "string") res = (0, $2b6Uo._)(document.querySelectorAll(el));
            if (swiper.params.uniqueNavElements && typeof el === "string" && res.length > 1 && swiper.el.querySelectorAll(el).length === 1) res = swiper.el.querySelector(el);
        }
        if (el && !res) return el;
        // if (Array.isArray(res) && res.length === 1) res = res[0];
        return res;
    };
    var toggleEl = function toggleEl(el, disabled) {
        var params = swiper.params.navigation;
        el = makeElementsArray(el);
        el.forEach(function(subEl) {
            if (subEl) {
                var _subEl_classList;
                (_subEl_classList = subEl.classList)[disabled ? "add" : "remove"].apply(_subEl_classList, (0, $2b6Uo._)(params.disabledClass.split(" ")));
                if (subEl.tagName === "BUTTON") subEl.disabled = disabled;
                if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
            }
        });
    };
    var update = function update() {
        // Update Navigation Buttons
        var _swiper_navigation = swiper.navigation, nextEl = _swiper_navigation.nextEl, prevEl = _swiper_navigation.prevEl;
        if (swiper.params.loop) {
            toggleEl(prevEl, false);
            toggleEl(nextEl, false);
            return;
        }
        toggleEl(prevEl, swiper.isBeginning && !swiper.params.rewind);
        toggleEl(nextEl, swiper.isEnd && !swiper.params.rewind);
    };
    var onPrevClick = function onPrevClick(e) {
        e.preventDefault();
        if (swiper.isBeginning && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slidePrev();
        emit("navigationPrev");
    };
    var onNextClick = function onNextClick(e) {
        e.preventDefault();
        if (swiper.isEnd && !swiper.params.loop && !swiper.params.rewind) return;
        swiper.slideNext();
        emit("navigationNext");
    };
    var init = function init() {
        var params = swiper.params.navigation;
        swiper.params.navigation = (0, $bac4f32cdf410388$export$2e2bcd8739ae039)(swiper, swiper.originalParams.navigation, swiper.params.navigation, {
            nextEl: "swiper-button-next",
            prevEl: "swiper-button-prev"
        });
        if (!(params.nextEl || params.prevEl)) return;
        var nextEl = getEl(params.nextEl);
        var prevEl = getEl(params.prevEl);
        Object.assign(swiper.navigation, {
            nextEl: nextEl,
            prevEl: prevEl
        });
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        var initButton = function(el, dir) {
            var _el_classList;
            if (el) el.addEventListener("click", dir === "next" ? onNextClick : onPrevClick);
            if (!swiper.enabled && el) (_el_classList = el.classList).add.apply(_el_classList, (0, $2b6Uo._)(params.lockClass.split(" ")));
        };
        nextEl.forEach(function(el) {
            return initButton(el, "next");
        });
        prevEl.forEach(function(el) {
            return initButton(el, "prev");
        });
    };
    var destroy = function destroy() {
        var _swiper_navigation = swiper.navigation, nextEl = _swiper_navigation.nextEl, prevEl = _swiper_navigation.prevEl;
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        var destroyButton = function(el, dir) {
            var _el_classList;
            el.removeEventListener("click", dir === "next" ? onNextClick : onPrevClick);
            (_el_classList = el.classList).remove.apply(_el_classList, (0, $2b6Uo._)(swiper.params.navigation.disabledClass.split(" ")));
        };
        nextEl.forEach(function(el) {
            return destroyButton(el, "next");
        });
        prevEl.forEach(function(el) {
            return destroyButton(el, "prev");
        });
    };
    extendParams({
        navigation: {
            nextEl: null,
            prevEl: null,
            hideOnClick: false,
            disabledClass: "swiper-button-disabled",
            hiddenClass: "swiper-button-hidden",
            lockClass: "swiper-button-lock",
            navigationDisabledClass: "swiper-navigation-disabled"
        }
    });
    swiper.navigation = {
        nextEl: null,
        prevEl: null
    };
    var makeElementsArray = function(el) {
        if (!Array.isArray(el)) el = [
            el
        ].filter(function(e) {
            return !!e;
        });
        return el;
    };
    on("init", function() {
        if (swiper.params.navigation.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            update();
        }
    });
    on("toEdge fromEdge lock unlock", function() {
        update();
    });
    on("destroy", function() {
        destroy();
    });
    on("enable disable", function() {
        var _swiper_navigation = swiper.navigation, nextEl = _swiper_navigation.nextEl, prevEl = _swiper_navigation.prevEl;
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        (0, $2b6Uo._)(nextEl).concat((0, $2b6Uo._)(prevEl)).filter(function(el) {
            return !!el;
        }).forEach(function(el) {
            return el.classList[swiper.enabled ? "remove" : "add"](swiper.params.navigation.lockClass);
        });
    });
    on("click", function(_s, e) {
        var _swiper_navigation = swiper.navigation, nextEl = _swiper_navigation.nextEl, prevEl = _swiper_navigation.prevEl;
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        var targetEl = e.target;
        if (swiper.params.navigation.hideOnClick && !prevEl.includes(targetEl) && !nextEl.includes(targetEl)) {
            if (swiper.pagination && swiper.params.pagination && swiper.params.pagination.clickable && (swiper.pagination.el === targetEl || swiper.pagination.el.contains(targetEl))) return;
            var isHidden;
            if (nextEl.length) isHidden = nextEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            else if (prevEl.length) isHidden = prevEl[0].classList.contains(swiper.params.navigation.hiddenClass);
            if (isHidden === true) emit("navigationShow");
            else emit("navigationHide");
            (0, $2b6Uo._)(nextEl).concat((0, $2b6Uo._)(prevEl)).filter(function(el) {
                return !!el;
            }).forEach(function(el) {
                return el.classList.toggle(swiper.params.navigation.hiddenClass);
            });
        }
    });
    var enable = function() {
        var _swiper_el_classList;
        (_swiper_el_classList = swiper.el.classList).remove.apply(_swiper_el_classList, (0, $2b6Uo._)(swiper.params.navigation.navigationDisabledClass.split(" ")));
        init();
        update();
    };
    var disable = function() {
        var _swiper_el_classList;
        (_swiper_el_classList = swiper.el.classList).add.apply(_swiper_el_classList, (0, $2b6Uo._)(swiper.params.navigation.navigationDisabledClass.split(" ")));
        destroy();
    };
    Object.assign(swiper.navigation, {
        enable: enable,
        disable: disable,
        update: update,
        init: init,
        destroy: destroy
    });
}



var $2b6Uo = parcelRequire("2b6Uo");
function $170bd1112a818e3a$export$2e2bcd8739ae039() {
    var classes = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return ".".concat(classes.trim().replace(/([\.:!+\/])/g, "\\$1") // eslint-disable-line
    .replace(/ /g, "."));
}




function $d52f13beb9c2eee2$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    var isPaginationDisabled = function isPaginationDisabled() {
        return !swiper.params.pagination.el || !swiper.pagination.el || Array.isArray(swiper.pagination.el) && swiper.pagination.el.length === 0;
    };
    var setSideBullets = function setSideBullets(bulletEl, position) {
        var bulletActiveClass = swiper.params.pagination.bulletActiveClass;
        if (!bulletEl) return;
        bulletEl = bulletEl["".concat(position === "prev" ? "previous" : "next", "ElementSibling")];
        if (bulletEl) {
            bulletEl.classList.add("".concat(bulletActiveClass, "-").concat(position));
            bulletEl = bulletEl["".concat(position === "prev" ? "previous" : "next", "ElementSibling")];
            if (bulletEl) bulletEl.classList.add("".concat(bulletActiveClass, "-").concat(position, "-").concat(position));
        }
    };
    var onBulletClick = function onBulletClick(e) {
        var bulletEl = e.target.closest((0, $170bd1112a818e3a$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass));
        if (!bulletEl) return;
        e.preventDefault();
        var index = (0, $2530e0d256bb8028$export$371885c503a01623)(bulletEl) * swiper.params.slidesPerGroup;
        if (swiper.params.loop) {
            if (swiper.realIndex === index) return;
            var newSlideIndex = swiper.getSlideIndexByData(index);
            var currentSlideIndex = swiper.getSlideIndexByData(swiper.realIndex);
            if (newSlideIndex > swiper.slides.length - swiper.loopedSlides) swiper.loopFix({
                direction: newSlideIndex > currentSlideIndex ? "next" : "prev",
                activeSlideIndex: newSlideIndex,
                slideTo: false
            });
            swiper.slideToLoop(index);
        } else swiper.slideTo(index);
    };
    var update = function update() {
        // Render || Update Pagination bullets/items
        var rtl = swiper.rtl;
        var params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        var el = swiper.pagination.el;
        el = makeElementsArray(el);
        // Current/Total
        var current;
        var previousIndex;
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        var total = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
        if (swiper.params.loop) {
            previousIndex = swiper.previousRealIndex || 0;
            current = swiper.params.slidesPerGroup > 1 ? Math.floor(swiper.realIndex / swiper.params.slidesPerGroup) : swiper.realIndex;
        } else if (typeof swiper.snapIndex !== "undefined") {
            current = swiper.snapIndex;
            previousIndex = swiper.previousSnapIndex;
        } else {
            previousIndex = swiper.previousIndex || 0;
            current = swiper.activeIndex || 0;
        }
        // Types
        if (params.type === "bullets" && swiper.pagination.bullets && swiper.pagination.bullets.length > 0) {
            var bullets = swiper.pagination.bullets;
            var firstIndex;
            var lastIndex;
            var midIndex;
            if (params.dynamicBullets) {
                bulletSize = (0, $2530e0d256bb8028$export$863f37913038cf77)(bullets[0], swiper.isHorizontal() ? "width" : "height", true);
                el.forEach(function(subEl) {
                    subEl.style[swiper.isHorizontal() ? "width" : "height"] = "".concat(bulletSize * (params.dynamicMainBullets + 4), "px");
                });
                if (params.dynamicMainBullets > 1 && previousIndex !== undefined) {
                    dynamicBulletIndex += current - (previousIndex || 0);
                    if (dynamicBulletIndex > params.dynamicMainBullets - 1) dynamicBulletIndex = params.dynamicMainBullets - 1;
                    else if (dynamicBulletIndex < 0) dynamicBulletIndex = 0;
                }
                firstIndex = Math.max(current - dynamicBulletIndex, 0);
                lastIndex = firstIndex + (Math.min(bullets.length, params.dynamicMainBullets) - 1);
                midIndex = (lastIndex + firstIndex) / 2;
            }
            bullets.forEach(function(bulletEl) {
                var _bulletEl_classList;
                var classesToRemove = (0, $2b6Uo._)([
                    "",
                    "-next",
                    "-next-next",
                    "-prev",
                    "-prev-prev",
                    "-main"
                ].map(function(suffix) {
                    return "".concat(params.bulletActiveClass).concat(suffix);
                })).map(function(s) {
                    return typeof s === "string" && s.includes(" ") ? s.split(" ") : s;
                }).flat();
                (_bulletEl_classList = bulletEl.classList).remove.apply(_bulletEl_classList, (0, $2b6Uo._)(classesToRemove));
            });
            if (el.length > 1) bullets.forEach(function(bullet) {
                var _bullet_classList;
                var bulletIndex = (0, $2530e0d256bb8028$export$371885c503a01623)(bullet);
                if (bulletIndex === current) (_bullet_classList = bullet.classList).add.apply(_bullet_classList, (0, $2b6Uo._)(params.bulletActiveClass.split(" ")));
                else if (swiper.isElement) bullet.setAttribute("part", "bullet");
                if (params.dynamicBullets) {
                    var _bullet_classList1;
                    if (bulletIndex >= firstIndex && bulletIndex <= lastIndex) (_bullet_classList1 = bullet.classList).add.apply(_bullet_classList1, (0, $2b6Uo._)("".concat(params.bulletActiveClass, "-main").split(" ")));
                    if (bulletIndex === firstIndex) setSideBullets(bullet, "prev");
                    if (bulletIndex === lastIndex) setSideBullets(bullet, "next");
                }
            });
            else {
                var _bullet_classList;
                var bullet = bullets[current];
                if (bullet) (_bullet_classList = bullet.classList).add.apply(_bullet_classList, (0, $2b6Uo._)(params.bulletActiveClass.split(" ")));
                if (swiper.isElement) bullets.forEach(function(bulletEl, bulletIndex) {
                    bulletEl.setAttribute("part", bulletIndex === current ? "bullet-active" : "bullet");
                });
                if (params.dynamicBullets) {
                    var _bullets_i_classList;
                    var firstDisplayedBullet = bullets[firstIndex];
                    var lastDisplayedBullet = bullets[lastIndex];
                    for(var i = firstIndex; i <= lastIndex; i += 1)if (bullets[i]) (_bullets_i_classList = bullets[i].classList).add.apply(_bullets_i_classList, (0, $2b6Uo._)("".concat(params.bulletActiveClass, "-main").split(" ")));
                    setSideBullets(firstDisplayedBullet, "prev");
                    setSideBullets(lastDisplayedBullet, "next");
                }
            }
            if (params.dynamicBullets) {
                var dynamicBulletsLength = Math.min(bullets.length, params.dynamicMainBullets + 4);
                var bulletsOffset = (bulletSize * dynamicBulletsLength - bulletSize) / 2 - midIndex * bulletSize;
                var offsetProp = rtl ? "right" : "left";
                bullets.forEach(function(bullet) {
                    bullet.style[swiper.isHorizontal() ? offsetProp : "top"] = "".concat(bulletsOffset, "px");
                });
            }
        }
        el.forEach(function(subEl, subElIndex) {
            if (params.type === "fraction") {
                subEl.querySelectorAll((0, $170bd1112a818e3a$export$2e2bcd8739ae039)(params.currentClass)).forEach(function(fractionEl) {
                    fractionEl.textContent = params.formatFractionCurrent(current + 1);
                });
                subEl.querySelectorAll((0, $170bd1112a818e3a$export$2e2bcd8739ae039)(params.totalClass)).forEach(function(totalEl) {
                    totalEl.textContent = params.formatFractionTotal(total);
                });
            }
            if (params.type === "progressbar") {
                var progressbarDirection;
                if (params.progressbarOpposite) progressbarDirection = swiper.isHorizontal() ? "vertical" : "horizontal";
                else progressbarDirection = swiper.isHorizontal() ? "horizontal" : "vertical";
                var scale = (current + 1) / total;
                var scaleX = 1;
                var scaleY = 1;
                if (progressbarDirection === "horizontal") scaleX = scale;
                else scaleY = scale;
                subEl.querySelectorAll((0, $170bd1112a818e3a$export$2e2bcd8739ae039)(params.progressbarFillClass)).forEach(function(progressEl) {
                    progressEl.style.transform = "translate3d(0,0,0) scaleX(".concat(scaleX, ") scaleY(").concat(scaleY, ")");
                    progressEl.style.transitionDuration = "".concat(swiper.params.speed, "ms");
                });
            }
            if (params.type === "custom" && params.renderCustom) {
                subEl.innerHTML = params.renderCustom(swiper, current + 1, total);
                if (subElIndex === 0) emit("paginationRender", subEl);
            } else {
                if (subElIndex === 0) emit("paginationRender", subEl);
                emit("paginationUpdate", subEl);
            }
            if (swiper.params.watchOverflow && swiper.enabled) subEl.classList[swiper.isLocked ? "add" : "remove"](params.lockClass);
        });
    };
    var render = function render() {
        // Render Container
        var params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        var slidesLength = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.slides.length : swiper.slides.length;
        var el = swiper.pagination.el;
        el = makeElementsArray(el);
        var paginationHTML = "";
        if (params.type === "bullets") {
            var numberOfBullets = swiper.params.loop ? Math.ceil(slidesLength / swiper.params.slidesPerGroup) : swiper.snapGrid.length;
            if (swiper.params.freeMode && swiper.params.freeMode.enabled && numberOfBullets > slidesLength) numberOfBullets = slidesLength;
            for(var i = 0; i < numberOfBullets; i += 1)if (params.renderBullet) paginationHTML += params.renderBullet.call(swiper, i, params.bulletClass);
            else // prettier-ignore
            paginationHTML += "<".concat(params.bulletElement, " ").concat(swiper.isElement ? 'part="bullet"' : "", ' class="').concat(params.bulletClass, '"></').concat(params.bulletElement, ">");
        }
        if (params.type === "fraction") {
            if (params.renderFraction) paginationHTML = params.renderFraction.call(swiper, params.currentClass, params.totalClass);
            else paginationHTML = '<span class="'.concat(params.currentClass, '"></span>') + " / " + '<span class="'.concat(params.totalClass, '"></span>');
        }
        if (params.type === "progressbar") {
            if (params.renderProgressbar) paginationHTML = params.renderProgressbar.call(swiper, params.progressbarFillClass);
            else paginationHTML = '<span class="'.concat(params.progressbarFillClass, '"></span>');
        }
        swiper.pagination.bullets = [];
        el.forEach(function(subEl) {
            var _swiper_pagination_bullets;
            if (params.type !== "custom") subEl.innerHTML = paginationHTML || "";
            if (params.type === "bullets") (_swiper_pagination_bullets = swiper.pagination.bullets).push.apply(_swiper_pagination_bullets, (0, $2b6Uo._)(subEl.querySelectorAll((0, $170bd1112a818e3a$export$2e2bcd8739ae039)(params.bulletClass))));
        });
        if (params.type !== "custom") emit("paginationRender", el[0]);
    };
    var init = function init() {
        swiper.params.pagination = (0, $bac4f32cdf410388$export$2e2bcd8739ae039)(swiper, swiper.originalParams.pagination, swiper.params.pagination, {
            el: "swiper-pagination"
        });
        var params = swiper.params.pagination;
        if (!params.el) return;
        var el;
        if (typeof params.el === "string" && swiper.isElement) el = swiper.el.shadowRoot.querySelector(params.el);
        if (!el && typeof params.el === "string") el = (0, $2b6Uo._)(document.querySelectorAll(params.el));
        if (!el) el = params.el;
        if (!el || el.length === 0) return;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && Array.isArray(el) && el.length > 1) {
            el = (0, $2b6Uo._)(swiper.el.querySelectorAll(params.el));
            // check if it belongs to another nested Swiper
            if (el.length > 1) el = el.filter(function(subEl) {
                if ((0, $2530e0d256bb8028$export$aedc7b608ca8e855)(subEl, ".swiper")[0] !== swiper.el) return false;
                return true;
            })[0];
        }
        if (Array.isArray(el) && el.length === 1) el = el[0];
        Object.assign(swiper.pagination, {
            el: el
        });
        el = makeElementsArray(el);
        el.forEach(function(subEl) {
            if (params.type === "bullets" && params.clickable) subEl.classList.add(params.clickableClass);
            subEl.classList.add(params.modifierClass + params.type);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
            if (params.type === "bullets" && params.dynamicBullets) {
                subEl.classList.add("".concat(params.modifierClass).concat(params.type, "-dynamic"));
                dynamicBulletIndex = 0;
                if (params.dynamicMainBullets < 1) params.dynamicMainBullets = 1;
            }
            if (params.type === "progressbar" && params.progressbarOpposite) subEl.classList.add(params.progressbarOppositeClass);
            if (params.clickable) subEl.addEventListener("click", onBulletClick);
            if (!swiper.enabled) subEl.classList.add(params.lockClass);
        });
    };
    var destroy = function destroy() {
        var _subEl_classList;
        var params = swiper.params.pagination;
        if (isPaginationDisabled()) return;
        var el = swiper.pagination.el;
        if (el) {
            el = makeElementsArray(el);
            el.forEach(function(subEl) {
                subEl.classList.remove(params.hiddenClass);
                subEl.classList.remove(params.modifierClass + params.type);
                subEl.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
                if (params.clickable) subEl.removeEventListener("click", onBulletClick);
            });
        }
        if (swiper.pagination.bullets) swiper.pagination.bullets.forEach(function(subEl) {
            return (_subEl_classList = subEl.classList).remove.apply(_subEl_classList, (0, $2b6Uo._)(params.bulletActiveClass.split(" ")));
        });
    };
    var pfx = "swiper-pagination";
    extendParams({
        pagination: {
            el: null,
            bulletElement: "span",
            clickable: false,
            hideOnClick: false,
            renderBullet: null,
            renderProgressbar: null,
            renderFraction: null,
            renderCustom: null,
            progressbarOpposite: false,
            type: "bullets",
            // 'bullets' or 'progressbar' or 'fraction' or 'custom'
            dynamicBullets: false,
            dynamicMainBullets: 1,
            formatFractionCurrent: function(number) {
                return number;
            },
            formatFractionTotal: function(number) {
                return number;
            },
            bulletClass: "".concat(pfx, "-bullet"),
            bulletActiveClass: "".concat(pfx, "-bullet-active"),
            modifierClass: "".concat(pfx, "-"),
            currentClass: "".concat(pfx, "-current"),
            totalClass: "".concat(pfx, "-total"),
            hiddenClass: "".concat(pfx, "-hidden"),
            progressbarFillClass: "".concat(pfx, "-progressbar-fill"),
            progressbarOppositeClass: "".concat(pfx, "-progressbar-opposite"),
            clickableClass: "".concat(pfx, "-clickable"),
            lockClass: "".concat(pfx, "-lock"),
            horizontalClass: "".concat(pfx, "-horizontal"),
            verticalClass: "".concat(pfx, "-vertical"),
            paginationDisabledClass: "".concat(pfx, "-disabled")
        }
    });
    swiper.pagination = {
        el: null,
        bullets: []
    };
    var bulletSize;
    var dynamicBulletIndex = 0;
    var makeElementsArray = function(el) {
        if (!Array.isArray(el)) el = [
            el
        ].filter(function(e) {
            return !!e;
        });
        return el;
    };
    on("changeDirection", function() {
        if (!swiper.pagination || !swiper.pagination.el) return;
        var params = swiper.params.pagination;
        var el = swiper.pagination.el;
        el = makeElementsArray(el);
        el.forEach(function(subEl) {
            subEl.classList.remove(params.horizontalClass, params.verticalClass);
            subEl.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        });
    });
    on("init", function() {
        if (swiper.params.pagination.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            render();
            update();
        }
    });
    on("activeIndexChange", function() {
        if (typeof swiper.snapIndex === "undefined") update();
    });
    on("snapIndexChange", function() {
        update();
    });
    on("snapGridLengthChange", function() {
        render();
        update();
    });
    on("destroy", function() {
        destroy();
    });
    on("enable disable", function() {
        var el = swiper.pagination.el;
        if (el) {
            el = makeElementsArray(el);
            el.forEach(function(subEl) {
                return subEl.classList[swiper.enabled ? "remove" : "add"](swiper.params.pagination.lockClass);
            });
        }
    });
    on("lock unlock", function() {
        update();
    });
    on("click", function(_s, e) {
        var targetEl = e.target;
        var el = swiper.pagination.el;
        if (!Array.isArray(el)) el = [
            el
        ].filter(function(element) {
            return !!element;
        });
        if (swiper.params.pagination.el && swiper.params.pagination.hideOnClick && el && el.length > 0 && !targetEl.classList.contains(swiper.params.pagination.bulletClass)) {
            if (swiper.navigation && (swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl || swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl)) return;
            var isHidden = el[0].classList.contains(swiper.params.pagination.hiddenClass);
            if (isHidden === true) emit("paginationShow");
            else emit("paginationHide");
            el.forEach(function(subEl) {
                return subEl.classList.toggle(swiper.params.pagination.hiddenClass);
            });
        }
    });
    var enable = function() {
        swiper.el.classList.remove(swiper.params.pagination.paginationDisabledClass);
        var el = swiper.pagination.el;
        if (el) {
            el = makeElementsArray(el);
            el.forEach(function(subEl) {
                return subEl.classList.remove(swiper.params.pagination.paginationDisabledClass);
            });
        }
        init();
        render();
        update();
    };
    var disable = function() {
        swiper.el.classList.add(swiper.params.pagination.paginationDisabledClass);
        var el = swiper.pagination.el;
        if (el) {
            el = makeElementsArray(el);
            el.forEach(function(subEl) {
                return subEl.classList.add(swiper.params.pagination.paginationDisabledClass);
            });
        }
        destroy();
    };
    Object.assign(swiper.pagination, {
        enable: enable,
        disable: disable,
        render: render,
        update: update,
        init: init,
        destroy: destroy
    });
}





function $ac92ce5da80bdca1$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    var setTranslate = function setTranslate() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        var scrollbar = swiper.scrollbar, rtl = swiper.rtlTranslate;
        var dragEl = scrollbar.dragEl, el = scrollbar.el;
        var params = swiper.params.scrollbar;
        var progress = swiper.params.loop ? swiper.progressLoop : swiper.progress;
        var newSize = dragSize;
        var newPos = (trackSize - dragSize) * progress;
        if (rtl) {
            newPos = -newPos;
            if (newPos > 0) {
                newSize = dragSize - newPos;
                newPos = 0;
            } else if (-newPos + dragSize > trackSize) newSize = trackSize + newPos;
        } else if (newPos < 0) {
            newSize = dragSize + newPos;
            newPos = 0;
        } else if (newPos + dragSize > trackSize) newSize = trackSize - newPos;
        if (swiper.isHorizontal()) {
            dragEl.style.transform = "translate3d(".concat(newPos, "px, 0, 0)");
            dragEl.style.width = "".concat(newSize, "px");
        } else {
            dragEl.style.transform = "translate3d(0px, ".concat(newPos, "px, 0)");
            dragEl.style.height = "".concat(newSize, "px");
        }
        if (params.hide) {
            clearTimeout(timeout);
            el.style.opacity = 1;
            timeout = setTimeout(function() {
                el.style.opacity = 0;
                el.style.transitionDuration = "400ms";
            }, 1000);
        }
    };
    var setTransition = function setTransition(duration) {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        swiper.scrollbar.dragEl.style.transitionDuration = "".concat(duration, "ms");
    };
    var updateSize = function updateSize() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        var scrollbar = swiper.scrollbar;
        var dragEl = scrollbar.dragEl, el = scrollbar.el;
        dragEl.style.width = "";
        dragEl.style.height = "";
        trackSize = swiper.isHorizontal() ? el.offsetWidth : el.offsetHeight;
        divider = swiper.size / (swiper.virtualSize + swiper.params.slidesOffsetBefore - (swiper.params.centeredSlides ? swiper.snapGrid[0] : 0));
        if (swiper.params.scrollbar.dragSize === "auto") dragSize = trackSize * divider;
        else dragSize = parseInt(swiper.params.scrollbar.dragSize, 10);
        if (swiper.isHorizontal()) dragEl.style.width = "".concat(dragSize, "px");
        else dragEl.style.height = "".concat(dragSize, "px");
        if (divider >= 1) el.style.display = "none";
        else el.style.display = "";
        if (swiper.params.scrollbar.hide) el.style.opacity = 0;
        if (swiper.params.watchOverflow && swiper.enabled) scrollbar.el.classList[swiper.isLocked ? "add" : "remove"](swiper.params.scrollbar.lockClass);
    };
    var getPointerPosition = function getPointerPosition(e) {
        return swiper.isHorizontal() ? e.clientX : e.clientY;
    };
    var setDragPosition = function setDragPosition(e) {
        var scrollbar = swiper.scrollbar, rtl = swiper.rtlTranslate;
        var el = scrollbar.el;
        var positionRatio;
        positionRatio = (getPointerPosition(e) - (0, $2530e0d256bb8028$export$d7820ec56f35bbaa)(el)[swiper.isHorizontal() ? "left" : "top"] - (dragStartPos !== null ? dragStartPos : dragSize / 2)) / (trackSize - dragSize);
        positionRatio = Math.max(Math.min(positionRatio, 1), 0);
        if (rtl) positionRatio = 1 - positionRatio;
        var position = swiper.minTranslate() + (swiper.maxTranslate() - swiper.minTranslate()) * positionRatio;
        swiper.updateProgress(position);
        swiper.setTranslate(position);
        swiper.updateActiveIndex();
        swiper.updateSlidesClasses();
    };
    var onDragStart = function onDragStart(e) {
        var params = swiper.params.scrollbar;
        var scrollbar = swiper.scrollbar, wrapperEl = swiper.wrapperEl;
        var el = scrollbar.el, dragEl = scrollbar.dragEl;
        isTouched = true;
        dragStartPos = e.target === dragEl ? getPointerPosition(e) - e.target.getBoundingClientRect()[swiper.isHorizontal() ? "left" : "top"] : null;
        e.preventDefault();
        e.stopPropagation();
        wrapperEl.style.transitionDuration = "100ms";
        dragEl.style.transitionDuration = "100ms";
        setDragPosition(e);
        clearTimeout(dragTimeout);
        el.style.transitionDuration = "0ms";
        if (params.hide) el.style.opacity = 1;
        if (swiper.params.cssMode) swiper.wrapperEl.style["scroll-snap-type"] = "none";
        emit("scrollbarDragStart", e);
    };
    var onDragMove = function onDragMove(e) {
        var scrollbar = swiper.scrollbar, wrapperEl = swiper.wrapperEl;
        var el = scrollbar.el, dragEl = scrollbar.dragEl;
        if (!isTouched) return;
        if (e.preventDefault) e.preventDefault();
        else e.returnValue = false;
        setDragPosition(e);
        wrapperEl.style.transitionDuration = "0ms";
        el.style.transitionDuration = "0ms";
        dragEl.style.transitionDuration = "0ms";
        emit("scrollbarDragMove", e);
    };
    var onDragEnd = function onDragEnd(e) {
        var params = swiper.params.scrollbar;
        var scrollbar = swiper.scrollbar, wrapperEl = swiper.wrapperEl;
        var el = scrollbar.el;
        if (!isTouched) return;
        isTouched = false;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style["scroll-snap-type"] = "";
            wrapperEl.style.transitionDuration = "";
        }
        if (params.hide) {
            clearTimeout(dragTimeout);
            dragTimeout = (0, $2530e0d256bb8028$export$bdd553fddd433dcb)(function() {
                el.style.opacity = 0;
                el.style.transitionDuration = "400ms";
            }, 1000);
        }
        emit("scrollbarDragEnd", e);
        if (params.snapOnRelease) swiper.slideToClosest();
    };
    var events = function events(method) {
        var scrollbar = swiper.scrollbar, params = swiper.params;
        var el = scrollbar.el;
        if (!el) return;
        var target = el;
        var activeListener = params.passiveListeners ? {
            passive: false,
            capture: false
        } : false;
        var passiveListener = params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        if (!target) return;
        var eventMethod = method === "on" ? "addEventListener" : "removeEventListener";
        target[eventMethod]("pointerdown", onDragStart, activeListener);
        document[eventMethod]("pointermove", onDragMove, activeListener);
        document[eventMethod]("pointerup", onDragEnd, passiveListener);
    };
    var enableDraggable = function enableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("on");
    };
    var disableDraggable = function disableDraggable() {
        if (!swiper.params.scrollbar.el || !swiper.scrollbar.el) return;
        events("off");
    };
    var init = function init() {
        var scrollbar = swiper.scrollbar, swiperEl = swiper.el;
        swiper.params.scrollbar = (0, $bac4f32cdf410388$export$2e2bcd8739ae039)(swiper, swiper.originalParams.scrollbar, swiper.params.scrollbar, {
            el: "swiper-scrollbar"
        });
        var params = swiper.params.scrollbar;
        if (!params.el) return;
        var el;
        if (typeof params.el === "string" && swiper.isElement) el = swiper.el.shadowRoot.querySelector(params.el);
        if (!el && typeof params.el === "string") el = document.querySelectorAll(params.el);
        else if (!el) el = params.el;
        if (swiper.params.uniqueNavElements && typeof params.el === "string" && el.length > 1 && swiperEl.querySelectorAll(params.el).length === 1) el = swiperEl.querySelector(params.el);
        if (el.length > 0) el = el[0];
        el.classList.add(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        var dragEl;
        if (el) {
            dragEl = el.querySelector(".".concat(swiper.params.scrollbar.dragClass));
            if (!dragEl) {
                dragEl = (0, $2530e0d256bb8028$export$c8a8987d4410bf2d)("div", swiper.params.scrollbar.dragClass);
                el.append(dragEl);
            }
        }
        Object.assign(scrollbar, {
            el: el,
            dragEl: dragEl
        });
        if (params.draggable) enableDraggable();
        if (el) el.classList[swiper.enabled ? "remove" : "add"](swiper.params.scrollbar.lockClass);
    };
    var destroy = function destroy() {
        var params = swiper.params.scrollbar;
        var el = swiper.scrollbar.el;
        if (el) el.classList.remove(swiper.isHorizontal() ? params.horizontalClass : params.verticalClass);
        disableDraggable();
    };
    var document = (0, $e7beec05cc3d4f7e$export$f65ca476c09acec0)();
    var isTouched = false;
    var timeout = null;
    var dragTimeout = null;
    var dragStartPos;
    var dragSize;
    var trackSize;
    var divider;
    extendParams({
        scrollbar: {
            el: null,
            dragSize: "auto",
            hide: false,
            draggable: false,
            snapOnRelease: true,
            lockClass: "swiper-scrollbar-lock",
            dragClass: "swiper-scrollbar-drag",
            scrollbarDisabledClass: "swiper-scrollbar-disabled",
            horizontalClass: "swiper-scrollbar-horizontal",
            verticalClass: "swiper-scrollbar-vertical"
        }
    });
    swiper.scrollbar = {
        el: null,
        dragEl: null
    };
    on("init", function() {
        if (swiper.params.scrollbar.enabled === false) // eslint-disable-next-line
        disable();
        else {
            init();
            updateSize();
            setTranslate();
        }
    });
    on("update resize observerUpdate lock unlock", function() {
        updateSize();
    });
    on("setTranslate", function() {
        setTranslate();
    });
    on("setTransition", function(_s, duration) {
        setTransition(duration);
    });
    on("enable disable", function() {
        var el = swiper.scrollbar.el;
        if (el) el.classList[swiper.enabled ? "remove" : "add"](swiper.params.scrollbar.lockClass);
    });
    on("destroy", function() {
        destroy();
    });
    var enable = function() {
        swiper.el.classList.remove(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.remove(swiper.params.scrollbar.scrollbarDisabledClass);
        init();
        updateSize();
        setTranslate();
    };
    var disable = function() {
        swiper.el.classList.add(swiper.params.scrollbar.scrollbarDisabledClass);
        if (swiper.scrollbar.el) swiper.scrollbar.el.classList.add(swiper.params.scrollbar.scrollbarDisabledClass);
        destroy();
    };
    Object.assign(swiper.scrollbar, {
        enable: enable,
        disable: disable,
        updateSize: updateSize,
        setTranslate: setTranslate,
        init: init,
        destroy: destroy
    });
}



function $7192c4eae02ecb63$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        parallax: {
            enabled: false
        }
    });
    var setTransform = function(el, progress) {
        var rtl = swiper.rtl;
        var rtlFactor = rtl ? -1 : 1;
        var p = el.getAttribute("data-swiper-parallax") || "0";
        var x = el.getAttribute("data-swiper-parallax-x");
        var y = el.getAttribute("data-swiper-parallax-y");
        var scale = el.getAttribute("data-swiper-parallax-scale");
        var opacity = el.getAttribute("data-swiper-parallax-opacity");
        var rotate = el.getAttribute("data-swiper-parallax-rotate");
        if (x || y) {
            x = x || "0";
            y = y || "0";
        } else if (swiper.isHorizontal()) {
            x = p;
            y = "0";
        } else {
            y = p;
            x = "0";
        }
        if (x.indexOf("%") >= 0) x = "".concat(parseInt(x, 10) * progress * rtlFactor, "%");
        else x = "".concat(x * progress * rtlFactor, "px");
        if (y.indexOf("%") >= 0) y = "".concat(parseInt(y, 10) * progress, "%");
        else y = "".concat(y * progress, "px");
        if (typeof opacity !== "undefined" && opacity !== null) {
            var currentOpacity = opacity - (opacity - 1) * (1 - Math.abs(progress));
            el.style.opacity = currentOpacity;
        }
        var transform = "translate3d(".concat(x, ", ").concat(y, ", 0px)");
        if (typeof scale !== "undefined" && scale !== null) {
            var currentScale = scale - (scale - 1) * (1 - Math.abs(progress));
            transform += " scale(".concat(currentScale, ")");
        }
        if (rotate && typeof rotate !== "undefined" && rotate !== null) {
            var currentRotate = rotate * progress * -1;
            transform += " rotate(".concat(currentRotate, "deg)");
        }
        el.style.transform = transform;
    };
    var setTranslate = function() {
        var el = swiper.el, slides = swiper.slides, progress = swiper.progress, snapGrid = swiper.snapGrid;
        (0, $2530e0d256bb8028$export$eb846d859f2895e6)(el, "[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").forEach(function(subEl) {
            setTransform(subEl, progress);
        });
        slides.forEach(function(slideEl, slideIndex) {
            var slideProgress = slideEl.progress;
            if (swiper.params.slidesPerGroup > 1 && swiper.params.slidesPerView !== "auto") slideProgress += Math.ceil(slideIndex / 2) - progress * (snapGrid.length - 1);
            slideProgress = Math.min(Math.max(slideProgress, -1), 1);
            slideEl.querySelectorAll("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale], [data-swiper-parallax-rotate]").forEach(function(subEl) {
                setTransform(subEl, slideProgress);
            });
        });
    };
    var setTransition = function() {
        var duration = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : swiper.params.speed;
        var el = swiper.el;
        el.querySelectorAll("[data-swiper-parallax], [data-swiper-parallax-x], [data-swiper-parallax-y], [data-swiper-parallax-opacity], [data-swiper-parallax-scale]").forEach(function(parallaxEl) {
            var parallaxDuration = parseInt(parallaxEl.getAttribute("data-swiper-parallax-duration"), 10) || duration;
            if (duration === 0) parallaxDuration = 0;
            parallaxEl.style.transitionDuration = "".concat(parallaxDuration, "ms");
        });
    };
    on("beforeInit", function() {
        if (!swiper.params.parallax.enabled) return;
        swiper.params.watchSlidesProgress = true;
        swiper.originalParams.watchSlidesProgress = true;
    });
    on("init", function() {
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTranslate", function() {
        if (!swiper.params.parallax.enabled) return;
        setTranslate();
    });
    on("setTransition", function(_swiper, duration) {
        if (!swiper.params.parallax.enabled) return;
        setTransition(duration);
    });
}



var $iFZdg = parcelRequire("iFZdg");

var $2b6Uo = parcelRequire("2b6Uo");


function $f14e8dc96cfe0ae1$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit;
    var getDistanceBetweenTouches = function getDistanceBetweenTouches() {
        if (evCache.length < 2) return 1;
        var x1 = evCache[0].pageX;
        var y1 = evCache[0].pageY;
        var x2 = evCache[1].pageX;
        var y2 = evCache[1].pageY;
        var distance = Math.sqrt(Math.pow(x2 - x1, 2) + Math.pow(y2 - y1, 2));
        return distance;
    };
    var getScaleOrigin = function getScaleOrigin() {
        if (evCache.length < 2) return {
            x: null,
            y: null
        };
        var box = gesture.imageEl.getBoundingClientRect();
        return [
            (evCache[0].pageX + (evCache[1].pageX - evCache[0].pageX) / 2 - box.x) / currentScale,
            (evCache[0].pageY + (evCache[1].pageY - evCache[0].pageY) / 2 - box.y) / currentScale
        ];
    };
    var getSlideSelector = function getSlideSelector() {
        return swiper.isElement ? "swiper-slide" : ".".concat(swiper.params.slideClass);
    };
    var eventWithinSlide = function eventWithinSlide(e) {
        var slideSelector = getSlideSelector();
        if (e.target.matches(slideSelector)) return true;
        if (swiper.slides.filter(function(slideEl) {
            return slideEl.contains(e.target);
        }).length > 0) return true;
        return false;
    };
    var eventWithinZoomContainer = function eventWithinZoomContainer(e) {
        var selector = ".".concat(swiper.params.zoom.containerClass);
        if (e.target.matches(selector)) return true;
        if ((0, $2b6Uo._)(swiper.el.querySelectorAll(selector)).filter(function(containerEl) {
            return containerEl.contains(e.target);
        }).length > 0) return true;
        return false;
    };
    var onGestureStart = // Events
    function onGestureStart(e) {
        if (e.pointerType === "mouse") evCache.splice(0, evCache.length);
        if (!eventWithinSlide(e)) return;
        var params = swiper.params.zoom;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        evCache.push(e);
        if (evCache.length < 2) return;
        fakeGestureTouched = true;
        gesture.scaleStart = getDistanceBetweenTouches();
        if (!gesture.slideEl) {
            gesture.slideEl = e.target.closest(".".concat(swiper.params.slideClass, ", swiper-slide"));
            if (!gesture.slideEl) gesture.slideEl = swiper.slides[swiper.activeIndex];
            var imageEl = gesture.slideEl.querySelector(".".concat(params.containerClass));
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $2530e0d256bb8028$export$aedc7b608ca8e855)(gesture.imageEl, ".".concat(params.containerClass))[0];
            else gesture.imageWrapEl = undefined;
            if (!gesture.imageWrapEl) {
                gesture.imageEl = undefined;
                return;
            }
            gesture.maxRatio = gesture.imageWrapEl.getAttribute("data-swiper-zoom") || params.maxRatio;
        }
        if (gesture.imageEl) {
            var _getScaleOrigin = (0, $iFZdg._)(getScaleOrigin(), 2), originX = _getScaleOrigin[0], originY = _getScaleOrigin[1];
            gesture.originX = originX;
            gesture.originY = originY;
            gesture.imageEl.style.transitionDuration = "0ms";
        }
        isScaling = true;
    };
    var onGestureChange = function onGestureChange(e) {
        if (!eventWithinSlide(e)) return;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        var pointerIndex = evCache.findIndex(function(cachedEv) {
            return cachedEv.pointerId === e.pointerId;
        });
        if (pointerIndex >= 0) evCache[pointerIndex] = e;
        if (evCache.length < 2) return;
        fakeGestureMoved = true;
        gesture.scaleMove = getDistanceBetweenTouches();
        if (!gesture.imageEl) return;
        zoom.scale = gesture.scaleMove / gesture.scaleStart * currentScale;
        if (zoom.scale > gesture.maxRatio) zoom.scale = gesture.maxRatio - 1 + Math.pow(zoom.scale - gesture.maxRatio + 1, 0.5);
        if (zoom.scale < params.minRatio) zoom.scale = params.minRatio + 1 - Math.pow(params.minRatio - zoom.scale + 1, 0.5);
        gesture.imageEl.style.transform = "translate3d(0,0,0) scale(".concat(zoom.scale, ")");
    };
    var onGestureEnd = function onGestureEnd(e) {
        if (!eventWithinSlide(e)) return;
        if (e.pointerType === "mouse" && e.type === "pointerout") return;
        var params = swiper.params.zoom;
        var zoom = swiper.zoom;
        var pointerIndex = evCache.findIndex(function(cachedEv) {
            return cachedEv.pointerId === e.pointerId;
        });
        if (pointerIndex >= 0) evCache.splice(pointerIndex, 1);
        if (!fakeGestureTouched || !fakeGestureMoved) return;
        fakeGestureTouched = false;
        fakeGestureMoved = false;
        if (!gesture.imageEl) return;
        zoom.scale = Math.max(Math.min(zoom.scale, gesture.maxRatio), params.minRatio);
        gesture.imageEl.style.transitionDuration = "".concat(swiper.params.speed, "ms");
        gesture.imageEl.style.transform = "translate3d(0,0,0) scale(".concat(zoom.scale, ")");
        currentScale = zoom.scale;
        isScaling = false;
        if (zoom.scale > 1 && gesture.slideEl) gesture.slideEl.classList.add("".concat(params.zoomedSlideClass));
        else if (zoom.scale <= 1 && gesture.slideEl) gesture.slideEl.classList.remove("".concat(params.zoomedSlideClass));
        if (zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
            gesture.slideEl = undefined;
        }
    };
    var onTouchStart = function onTouchStart(e) {
        var device = swiper.device;
        if (!gesture.imageEl) return;
        if (image.isTouched) return;
        if (device.android && e.cancelable) e.preventDefault();
        image.isTouched = true;
        var event = evCache.length > 0 ? evCache[0] : e;
        image.touchesStart.x = event.pageX;
        image.touchesStart.y = event.pageY;
    };
    var onTouchMove = function onTouchMove(e) {
        if (!eventWithinSlide(e) || !eventWithinZoomContainer(e)) return;
        var zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !gesture.slideEl) return;
        if (!image.isMoved) {
            image.width = gesture.imageEl.offsetWidth;
            image.height = gesture.imageEl.offsetHeight;
            image.startX = (0, $2530e0d256bb8028$export$5ec402b7fcf74398)(gesture.imageWrapEl, "x") || 0;
            image.startY = (0, $2530e0d256bb8028$export$5ec402b7fcf74398)(gesture.imageWrapEl, "y") || 0;
            gesture.slideWidth = gesture.slideEl.offsetWidth;
            gesture.slideHeight = gesture.slideEl.offsetHeight;
            gesture.imageWrapEl.style.transitionDuration = "0ms";
        }
        // Define if we need image drag
        var scaledWidth = image.width * zoom.scale;
        var scaledHeight = image.height * zoom.scale;
        if (scaledWidth < gesture.slideWidth && scaledHeight < gesture.slideHeight) return;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.touchesCurrent.x = evCache.length > 0 ? evCache[0].pageX : e.pageX;
        image.touchesCurrent.y = evCache.length > 0 ? evCache[0].pageY : e.pageY;
        var touchesDiff = Math.max(Math.abs(image.touchesCurrent.x - image.touchesStart.x), Math.abs(image.touchesCurrent.y - image.touchesStart.y));
        if (touchesDiff > 5) swiper.allowClick = false;
        if (!image.isMoved && !isScaling) {
            if (swiper.isHorizontal() && (Math.floor(image.minX) === Math.floor(image.startX) && image.touchesCurrent.x < image.touchesStart.x || Math.floor(image.maxX) === Math.floor(image.startX) && image.touchesCurrent.x > image.touchesStart.x)) {
                image.isTouched = false;
                return;
            }
            if (!swiper.isHorizontal() && (Math.floor(image.minY) === Math.floor(image.startY) && image.touchesCurrent.y < image.touchesStart.y || Math.floor(image.maxY) === Math.floor(image.startY) && image.touchesCurrent.y > image.touchesStart.y)) {
                image.isTouched = false;
                return;
            }
        }
        if (e.cancelable) e.preventDefault();
        e.stopPropagation();
        image.isMoved = true;
        var scaleRatio = (zoom.scale - currentScale) / (gesture.maxRatio - swiper.params.zoom.minRatio);
        var originX = gesture.originX, originY = gesture.originY;
        image.currentX = image.touchesCurrent.x - image.touchesStart.x + image.startX + scaleRatio * (image.width - originX * 2);
        image.currentY = image.touchesCurrent.y - image.touchesStart.y + image.startY + scaleRatio * (image.height - originY * 2);
        if (image.currentX < image.minX) image.currentX = image.minX + 1 - Math.pow(image.minX - image.currentX + 1, 0.8);
        if (image.currentX > image.maxX) image.currentX = image.maxX - 1 + Math.pow(image.currentX - image.maxX + 1, 0.8);
        if (image.currentY < image.minY) image.currentY = image.minY + 1 - Math.pow(image.minY - image.currentY + 1, 0.8);
        if (image.currentY > image.maxY) image.currentY = image.maxY - 1 + Math.pow(image.currentY - image.maxY + 1, 0.8);
        // Velocity
        if (!velocity.prevPositionX) velocity.prevPositionX = image.touchesCurrent.x;
        if (!velocity.prevPositionY) velocity.prevPositionY = image.touchesCurrent.y;
        if (!velocity.prevTime) velocity.prevTime = Date.now();
        velocity.x = (image.touchesCurrent.x - velocity.prevPositionX) / (Date.now() - velocity.prevTime) / 2;
        velocity.y = (image.touchesCurrent.y - velocity.prevPositionY) / (Date.now() - velocity.prevTime) / 2;
        if (Math.abs(image.touchesCurrent.x - velocity.prevPositionX) < 2) velocity.x = 0;
        if (Math.abs(image.touchesCurrent.y - velocity.prevPositionY) < 2) velocity.y = 0;
        velocity.prevPositionX = image.touchesCurrent.x;
        velocity.prevPositionY = image.touchesCurrent.y;
        velocity.prevTime = Date.now();
        gesture.imageWrapEl.style.transform = "translate3d(".concat(image.currentX, "px, ").concat(image.currentY, "px,0)");
    };
    var onTouchEnd = function onTouchEnd() {
        var zoom = swiper.zoom;
        if (!gesture.imageEl) return;
        if (!image.isTouched || !image.isMoved) {
            image.isTouched = false;
            image.isMoved = false;
            return;
        }
        image.isTouched = false;
        image.isMoved = false;
        var momentumDurationX = 300;
        var momentumDurationY = 300;
        var momentumDistanceX = velocity.x * momentumDurationX;
        var newPositionX = image.currentX + momentumDistanceX;
        var momentumDistanceY = velocity.y * momentumDurationY;
        var newPositionY = image.currentY + momentumDistanceY;
        // Fix duration
        if (velocity.x !== 0) momentumDurationX = Math.abs((newPositionX - image.currentX) / velocity.x);
        if (velocity.y !== 0) momentumDurationY = Math.abs((newPositionY - image.currentY) / velocity.y);
        var momentumDuration = Math.max(momentumDurationX, momentumDurationY);
        image.currentX = newPositionX;
        image.currentY = newPositionY;
        // Define if we need image drag
        var scaledWidth = image.width * zoom.scale;
        var scaledHeight = image.height * zoom.scale;
        image.minX = Math.min(gesture.slideWidth / 2 - scaledWidth / 2, 0);
        image.maxX = -image.minX;
        image.minY = Math.min(gesture.slideHeight / 2 - scaledHeight / 2, 0);
        image.maxY = -image.minY;
        image.currentX = Math.max(Math.min(image.currentX, image.maxX), image.minX);
        image.currentY = Math.max(Math.min(image.currentY, image.maxY), image.minY);
        gesture.imageWrapEl.style.transitionDuration = "".concat(momentumDuration, "ms");
        gesture.imageWrapEl.style.transform = "translate3d(".concat(image.currentX, "px, ").concat(image.currentY, "px,0)");
    };
    var onTransitionEnd = function onTransitionEnd() {
        var zoom = swiper.zoom;
        if (gesture.slideEl && swiper.activeIndex !== swiper.slides.indexOf(gesture.slideEl)) {
            if (gesture.imageEl) gesture.imageEl.style.transform = "translate3d(0,0,0) scale(1)";
            if (gesture.imageWrapEl) gesture.imageWrapEl.style.transform = "translate3d(0,0,0)";
            gesture.slideEl.classList.remove("".concat(swiper.params.zoom.zoomedSlideClass));
            zoom.scale = 1;
            currentScale = 1;
            gesture.slideEl = undefined;
            gesture.imageEl = undefined;
            gesture.imageWrapEl = undefined;
            gesture.originX = 0;
            gesture.originY = 0;
        }
    };
    var zoomIn = function zoomIn(e) {
        var zoom = swiper.zoom;
        var params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (e && e.target) gesture.slideEl = e.target.closest(".".concat(swiper.params.slideClass, ", swiper-slide"));
            if (!gesture.slideEl) {
                if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $2530e0d256bb8028$export$eb846d859f2895e6)(swiper.slidesEl, ".".concat(swiper.params.slideActiveClass))[0];
                else gesture.slideEl = swiper.slides[swiper.activeIndex];
            }
            var imageEl = gesture.slideEl.querySelector(".".concat(params.containerClass));
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $2530e0d256bb8028$export$aedc7b608ca8e855)(gesture.imageEl, ".".concat(params.containerClass))[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "hidden";
            swiper.wrapperEl.style.touchAction = "none";
        }
        gesture.slideEl.classList.add("".concat(params.zoomedSlideClass));
        var touchX;
        var touchY;
        var offsetX;
        var offsetY;
        var diffX;
        var diffY;
        var translateX;
        var translateY;
        var imageWidth;
        var imageHeight;
        var scaledWidth;
        var scaledHeight;
        var translateMinX;
        var translateMinY;
        var translateMaxX;
        var translateMaxY;
        var slideWidth;
        var slideHeight;
        if (typeof image.touchesStart.x === "undefined" && e) {
            touchX = e.pageX;
            touchY = e.pageY;
        } else {
            touchX = image.touchesStart.x;
            touchY = image.touchesStart.y;
        }
        var forceZoomRatio = typeof e === "number" ? e : null;
        if (currentScale === 1 && forceZoomRatio) {
            touchX = undefined;
            touchY = undefined;
        }
        zoom.scale = forceZoomRatio || gesture.imageWrapEl.getAttribute("data-swiper-zoom") || params.maxRatio;
        currentScale = forceZoomRatio || gesture.imageWrapEl.getAttribute("data-swiper-zoom") || params.maxRatio;
        if (e && !(currentScale === 1 && forceZoomRatio)) {
            slideWidth = gesture.slideEl.offsetWidth;
            slideHeight = gesture.slideEl.offsetHeight;
            offsetX = (0, $2530e0d256bb8028$export$d7820ec56f35bbaa)(gesture.slideEl).left + window.scrollX;
            offsetY = (0, $2530e0d256bb8028$export$d7820ec56f35bbaa)(gesture.slideEl).top + window.scrollY;
            diffX = offsetX + slideWidth / 2 - touchX;
            diffY = offsetY + slideHeight / 2 - touchY;
            imageWidth = gesture.imageEl.offsetWidth;
            imageHeight = gesture.imageEl.offsetHeight;
            scaledWidth = imageWidth * zoom.scale;
            scaledHeight = imageHeight * zoom.scale;
            translateMinX = Math.min(slideWidth / 2 - scaledWidth / 2, 0);
            translateMinY = Math.min(slideHeight / 2 - scaledHeight / 2, 0);
            translateMaxX = -translateMinX;
            translateMaxY = -translateMinY;
            translateX = diffX * zoom.scale;
            translateY = diffY * zoom.scale;
            if (translateX < translateMinX) translateX = translateMinX;
            if (translateX > translateMaxX) translateX = translateMaxX;
            if (translateY < translateMinY) translateY = translateMinY;
            if (translateY > translateMaxY) translateY = translateMaxY;
        } else {
            translateX = 0;
            translateY = 0;
        }
        if (forceZoomRatio && zoom.scale === 1) {
            gesture.originX = 0;
            gesture.originY = 0;
        }
        gesture.imageWrapEl.style.transitionDuration = "300ms";
        gesture.imageWrapEl.style.transform = "translate3d(".concat(translateX, "px, ").concat(translateY, "px,0)");
        gesture.imageEl.style.transitionDuration = "300ms";
        gesture.imageEl.style.transform = "translate3d(0,0,0) scale(".concat(zoom.scale, ")");
    };
    var zoomOut = function zoomOut() {
        var zoom = swiper.zoom;
        var params = swiper.params.zoom;
        if (!gesture.slideEl) {
            if (swiper.params.virtual && swiper.params.virtual.enabled && swiper.virtual) gesture.slideEl = (0, $2530e0d256bb8028$export$eb846d859f2895e6)(swiper.slidesEl, ".".concat(swiper.params.slideActiveClass))[0];
            else gesture.slideEl = swiper.slides[swiper.activeIndex];
            var imageEl = gesture.slideEl.querySelector(".".concat(params.containerClass));
            if (imageEl) imageEl = imageEl.querySelectorAll("picture, img, svg, canvas, .swiper-zoom-target")[0];
            gesture.imageEl = imageEl;
            if (imageEl) gesture.imageWrapEl = (0, $2530e0d256bb8028$export$aedc7b608ca8e855)(gesture.imageEl, ".".concat(params.containerClass))[0];
            else gesture.imageWrapEl = undefined;
        }
        if (!gesture.imageEl || !gesture.imageWrapEl) return;
        if (swiper.params.cssMode) {
            swiper.wrapperEl.style.overflow = "";
            swiper.wrapperEl.style.touchAction = "";
        }
        zoom.scale = 1;
        currentScale = 1;
        gesture.imageWrapEl.style.transitionDuration = "300ms";
        gesture.imageWrapEl.style.transform = "translate3d(0,0,0)";
        gesture.imageEl.style.transitionDuration = "300ms";
        gesture.imageEl.style.transform = "translate3d(0,0,0) scale(1)";
        gesture.slideEl.classList.remove("".concat(params.zoomedSlideClass));
        gesture.slideEl = undefined;
        gesture.originX = 0;
        gesture.originY = 0;
    };
    var zoomToggle = // Toggle Zoom
    function zoomToggle(e) {
        var zoom = swiper.zoom;
        if (zoom.scale && zoom.scale !== 1) // Zoom Out
        zoomOut();
        else // Zoom In
        zoomIn(e);
    };
    var getListeners = function getListeners() {
        var passiveListener = swiper.params.passiveListeners ? {
            passive: true,
            capture: false
        } : false;
        var activeListenerWithCapture = swiper.params.passiveListeners ? {
            passive: false,
            capture: true
        } : true;
        return {
            passiveListener: passiveListener,
            activeListenerWithCapture: activeListenerWithCapture
        };
    };
    var enable = // Attach/Detach Events
    function enable() {
        var zoom = swiper.zoom;
        if (zoom.enabled) return;
        zoom.enabled = true;
        var _getListeners = getListeners(), passiveListener = _getListeners.passiveListener, activeListenerWithCapture = _getListeners.activeListenerWithCapture;
        // Scale image
        swiper.wrapperEl.addEventListener("pointerdown", onGestureStart, passiveListener);
        swiper.wrapperEl.addEventListener("pointermove", onGestureChange, activeListenerWithCapture);
        [
            "pointerup",
            "pointercancel",
            "pointerout"
        ].forEach(function(eventName) {
            swiper.wrapperEl.addEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.addEventListener("pointermove", onTouchMove, activeListenerWithCapture);
    };
    var disable = function disable() {
        var zoom = swiper.zoom;
        if (!zoom.enabled) return;
        zoom.enabled = false;
        var _getListeners = getListeners(), passiveListener = _getListeners.passiveListener, activeListenerWithCapture = _getListeners.activeListenerWithCapture;
        // Scale image
        swiper.wrapperEl.removeEventListener("pointerdown", onGestureStart, passiveListener);
        swiper.wrapperEl.removeEventListener("pointermove", onGestureChange, activeListenerWithCapture);
        [
            "pointerup",
            "pointercancel",
            "pointerout"
        ].forEach(function(eventName) {
            swiper.wrapperEl.removeEventListener(eventName, onGestureEnd, passiveListener);
        });
        // Move image
        swiper.wrapperEl.removeEventListener("pointermove", onTouchMove, activeListenerWithCapture);
    };
    var window = (0, $e7beec05cc3d4f7e$export$38b2d434cce3ea22)();
    extendParams({
        zoom: {
            enabled: false,
            maxRatio: 3,
            minRatio: 1,
            toggle: true,
            containerClass: "swiper-zoom-container",
            zoomedSlideClass: "swiper-slide-zoomed"
        }
    });
    swiper.zoom = {
        enabled: false
    };
    var currentScale = 1;
    var isScaling = false;
    var fakeGestureTouched;
    var fakeGestureMoved;
    var evCache = [];
    var gesture = {
        originX: 0,
        originY: 0,
        slideEl: undefined,
        slideWidth: undefined,
        slideHeight: undefined,
        imageEl: undefined,
        imageWrapEl: undefined,
        maxRatio: 3
    };
    var image = {
        isTouched: undefined,
        isMoved: undefined,
        currentX: undefined,
        currentY: undefined,
        minX: undefined,
        minY: undefined,
        maxX: undefined,
        maxY: undefined,
        width: undefined,
        height: undefined,
        startX: undefined,
        startY: undefined,
        touchesStart: {},
        touchesCurrent: {}
    };
    var velocity = {
        x: undefined,
        y: undefined,
        prevPositionX: undefined,
        prevPositionY: undefined,
        prevTime: undefined
    };
    var scale = 1;
    Object.defineProperty(swiper.zoom, "scale", {
        get: function() {
            return scale;
        },
        set: function(value) {
            if (scale !== value) {
                var imageEl = gesture.imageEl;
                var slideEl = gesture.slideEl;
                emit("zoomChange", value, imageEl, slideEl);
            }
            scale = value;
        }
    });
    on("init", function() {
        if (swiper.params.zoom.enabled) enable();
    });
    on("destroy", function() {
        disable();
    });
    on("touchStart", function(_s, e) {
        if (!swiper.zoom.enabled) return;
        onTouchStart(e);
    });
    on("touchEnd", function(_s, e) {
        if (!swiper.zoom.enabled) return;
        onTouchEnd(e);
    });
    on("doubleTap", function(_s, e) {
        if (!swiper.animating && swiper.params.zoom.enabled && swiper.zoom.enabled && swiper.params.zoom.toggle) zoomToggle(e);
    });
    on("transitionEnd", function() {
        if (swiper.zoom.enabled && swiper.params.zoom.enabled) onTransitionEnd();
    });
    on("slideChange", function() {
        if (swiper.zoom.enabled && swiper.params.zoom.enabled && swiper.params.cssMode) onTransitionEnd();
    });
    Object.assign(swiper.zoom, {
        enable: enable,
        disable: disable,
        in: zoomIn,
        out: zoomOut,
        toggle: zoomToggle
    });
}


/* eslint no-bitwise: ["error", { "allow": [">>"] }] */ 
function $841f8dd1135530f2$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    var LinearSpline = function LinearSpline(x, y) {
        var binarySearch = function search() {
            var maxIndex;
            var minIndex;
            var guess;
            return function(array, val) {
                minIndex = -1;
                maxIndex = array.length;
                while(maxIndex - minIndex > 1){
                    guess = maxIndex + minIndex >> 1;
                    if (array[guess] <= val) minIndex = guess;
                    else maxIndex = guess;
                }
                return maxIndex;
            };
        }();
        this.x = x;
        this.y = y;
        this.lastIndex = x.length - 1;
        // Given an x value (x2), return the expected y2 value:
        // (x1,y1) is the known point before given value,
        // (x3,y3) is the known point after given value.
        var i1;
        var i3;
        this.interpolate = function interpolate(x2) {
            if (!x2) return 0;
            // Get the indexes of x1 and x3 (the array indexes before and after given x2):
            i3 = binarySearch(this.x, x2);
            i1 = i3 - 1;
            // We have our indexes i1 & i3, so we can calculate already:
            // y2 := ((x2−x1) × (y3−y1)) ÷ (x3−x1) + y1
            return (x2 - this.x[i1]) * (this.y[i3] - this.y[i1]) / (this.x[i3] - this.x[i1]) + this.y[i1];
        };
        return this;
    };
    var getInterpolateFunction = function getInterpolateFunction(c) {
        swiper.controller.spline = swiper.params.loop ? new LinearSpline(swiper.slidesGrid, c.slidesGrid) : new LinearSpline(swiper.snapGrid, c.snapGrid);
    };
    var setTranslate = function setTranslate(_t, byController) {
        var controlled = swiper.controller.control;
        var multiplier;
        var controlledTranslate;
        var Swiper = swiper.constructor;
        function setControlledTranslate(c) {
            if (c.destroyed) return;
            // this will create an Interpolate function based on the snapGrids
            // x is the Grid of the scrolled scroller and y will be the controlled scroller
            // it makes sense to create this only once and recall it for the interpolation
            // the function does a lot of value caching for performance
            var translate = swiper.rtlTranslate ? -swiper.translate : swiper.translate;
            if (swiper.params.controller.by === "slide") {
                getInterpolateFunction(c);
                // i am not sure why the values have to be multiplicated this way, tried to invert the snapGrid
                // but it did not work out
                controlledTranslate = -swiper.controller.spline.interpolate(-translate);
            }
            if (!controlledTranslate || swiper.params.controller.by === "container") {
                multiplier = (c.maxTranslate() - c.minTranslate()) / (swiper.maxTranslate() - swiper.minTranslate());
                if (Number.isNaN(multiplier) || !Number.isFinite(multiplier)) multiplier = 1;
                controlledTranslate = (translate - swiper.minTranslate()) * multiplier + c.minTranslate();
            }
            if (swiper.params.controller.inverse) controlledTranslate = c.maxTranslate() - controlledTranslate;
            c.updateProgress(controlledTranslate);
            c.setTranslate(controlledTranslate, swiper);
            c.updateActiveIndex();
            c.updateSlidesClasses();
        }
        if (Array.isArray(controlled)) {
            for(var i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTranslate(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTranslate(controlled);
    };
    var setTransition = function setTransition(duration, byController) {
        var Swiper = swiper.constructor;
        var controlled = swiper.controller.control;
        var i;
        function setControlledTransition(c) {
            if (c.destroyed) return;
            c.setTransition(duration, swiper);
            if (duration !== 0) {
                c.transitionStart();
                if (c.params.autoHeight) (0, $2530e0d256bb8028$export$bdd553fddd433dcb)(function() {
                    c.updateAutoHeight();
                });
                (0, $2530e0d256bb8028$export$6b974c5889da0bb5)(c.wrapperEl, function() {
                    if (!controlled) return;
                    c.transitionEnd();
                });
            }
        }
        if (Array.isArray(controlled)) {
            for(i = 0; i < controlled.length; i += 1)if (controlled[i] !== byController && controlled[i] instanceof Swiper) setControlledTransition(controlled[i]);
        } else if (controlled instanceof Swiper && byController !== controlled) setControlledTransition(controlled);
    };
    var removeSpline = function removeSpline() {
        if (!swiper.controller.control) return;
        if (swiper.controller.spline) {
            swiper.controller.spline = undefined;
            delete swiper.controller.spline;
        }
    };
    extendParams({
        controller: {
            control: undefined,
            inverse: false,
            by: "slide" // or 'container'
        }
    });
    swiper.controller = {
        control: undefined
    };
    on("beforeInit", function() {
        if (typeof window !== "undefined" && // eslint-disable-line
        (typeof swiper.params.controller.control === "string" || swiper.params.controller.control instanceof HTMLElement)) {
            var controlElement = document.querySelector(swiper.params.controller.control);
            if (controlElement && controlElement.swiper) swiper.controller.control = controlElement.swiper;
            else if (controlElement) {
                var onControllerSwiper = function(e) {
                    swiper.controller.control = e.detail[0];
                    swiper.update();
                    controlElement.removeEventListener("init", onControllerSwiper);
                };
                controlElement.addEventListener("init", onControllerSwiper);
            }
            return;
        }
        swiper.controller.control = swiper.params.controller.control;
    });
    on("update", function() {
        removeSpline();
    });
    on("resize", function() {
        removeSpline();
    });
    on("observerUpdate", function() {
        removeSpline();
    });
    on("setTranslate", function(_s, translate, byController) {
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTranslate(translate, byController);
    });
    on("setTransition", function(_s, duration, byController) {
        if (!swiper.controller.control || swiper.controller.control.destroyed) return;
        swiper.controller.setTransition(duration, byController);
    });
    Object.assign(swiper.controller, {
        setTranslate: setTranslate,
        setTransition: setTransition
    });
}




function $612f1032cc628f07$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    var notify = function notify(message) {
        var notification = liveRegion;
        if (notification.length === 0) return;
        notification.innerHTML = "";
        notification.innerHTML = message;
    };
    var getRandomNumber = function getRandomNumber() {
        var size = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 16;
        var randomChar = function() {
            return Math.round(16 * Math.random()).toString(16);
        };
        return "x".repeat(size).replace(/x/g, randomChar);
    };
    var makeElFocusable = function makeElFocusable(el) {
        el = makeElementsArray(el);
        el.forEach(function(subEl) {
            subEl.setAttribute("tabIndex", "0");
        });
    };
    var makeElNotFocusable = function makeElNotFocusable(el) {
        el = makeElementsArray(el);
        el.forEach(function(subEl) {
            subEl.setAttribute("tabIndex", "-1");
        });
    };
    var addElRole = function addElRole(el, role) {
        el = makeElementsArray(el);
        el.forEach(function(subEl) {
            subEl.setAttribute("role", role);
        });
    };
    var addElRoleDescription = function addElRoleDescription(el, description) {
        el = makeElementsArray(el);
        el.forEach(function(subEl) {
            subEl.setAttribute("aria-roledescription", description);
        });
    };
    var addElControls = function addElControls(el, controls) {
        el = makeElementsArray(el);
        el.forEach(function(subEl) {
            subEl.setAttribute("aria-controls", controls);
        });
    };
    var addElLabel = function addElLabel(el, label) {
        el = makeElementsArray(el);
        el.forEach(function(subEl) {
            subEl.setAttribute("aria-label", label);
        });
    };
    var addElId = function addElId(el, id) {
        el = makeElementsArray(el);
        el.forEach(function(subEl) {
            subEl.setAttribute("id", id);
        });
    };
    var addElLive = function addElLive(el, live) {
        el = makeElementsArray(el);
        el.forEach(function(subEl) {
            subEl.setAttribute("aria-live", live);
        });
    };
    var disableEl = function disableEl(el) {
        el = makeElementsArray(el);
        el.forEach(function(subEl) {
            subEl.setAttribute("aria-disabled", true);
        });
    };
    var enableEl = function enableEl(el) {
        el = makeElementsArray(el);
        el.forEach(function(subEl) {
            subEl.setAttribute("aria-disabled", false);
        });
    };
    var onEnterOrSpaceKey = function onEnterOrSpaceKey(e) {
        if (e.keyCode !== 13 && e.keyCode !== 32) return;
        var params = swiper.params.a11y;
        var targetEl = e.target;
        if (swiper.pagination && swiper.pagination.el && (targetEl === swiper.pagination.el || swiper.pagination.el.contains(e.target))) {
            if (!e.target.matches((0, $170bd1112a818e3a$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass))) return;
        }
        if (swiper.navigation && swiper.navigation.nextEl && targetEl === swiper.navigation.nextEl) {
            if (!(swiper.isEnd && !swiper.params.loop)) swiper.slideNext();
            if (swiper.isEnd) notify(params.lastSlideMessage);
            else notify(params.nextSlideMessage);
        }
        if (swiper.navigation && swiper.navigation.prevEl && targetEl === swiper.navigation.prevEl) {
            if (!(swiper.isBeginning && !swiper.params.loop)) swiper.slidePrev();
            if (swiper.isBeginning) notify(params.firstSlideMessage);
            else notify(params.prevSlideMessage);
        }
        if (swiper.pagination && targetEl.matches((0, $170bd1112a818e3a$export$2e2bcd8739ae039)(swiper.params.pagination.bulletClass))) targetEl.click();
    };
    var updateNavigation = function updateNavigation() {
        if (swiper.params.loop || swiper.params.rewind || !swiper.navigation) return;
        var _swiper_navigation = swiper.navigation, nextEl = _swiper_navigation.nextEl, prevEl = _swiper_navigation.prevEl;
        if (prevEl) {
            if (swiper.isBeginning) {
                disableEl(prevEl);
                makeElNotFocusable(prevEl);
            } else {
                enableEl(prevEl);
                makeElFocusable(prevEl);
            }
        }
        if (nextEl) {
            if (swiper.isEnd) {
                disableEl(nextEl);
                makeElNotFocusable(nextEl);
            } else {
                enableEl(nextEl);
                makeElFocusable(nextEl);
            }
        }
    };
    var hasPagination = function hasPagination() {
        return swiper.pagination && swiper.pagination.bullets && swiper.pagination.bullets.length;
    };
    var hasClickablePagination = function hasClickablePagination() {
        return hasPagination() && swiper.params.pagination.clickable;
    };
    var updatePagination = function updatePagination() {
        var params = swiper.params.a11y;
        if (!hasPagination()) return;
        swiper.pagination.bullets.forEach(function(bulletEl) {
            if (swiper.params.pagination.clickable) {
                makeElFocusable(bulletEl);
                if (!swiper.params.pagination.renderBullet) {
                    addElRole(bulletEl, "button");
                    addElLabel(bulletEl, params.paginationBulletMessage.replace(/\{\{index\}\}/, (0, $2530e0d256bb8028$export$371885c503a01623)(bulletEl) + 1));
                }
            }
            if (bulletEl.matches((0, $170bd1112a818e3a$export$2e2bcd8739ae039)(swiper.params.pagination.bulletActiveClass))) bulletEl.setAttribute("aria-current", "true");
            else bulletEl.removeAttribute("aria-current");
        });
    };
    var destroy = function destroy() {
        if (liveRegion) liveRegion.remove();
        var _ref = swiper.navigation ? swiper.navigation : {}, nextEl = _ref.nextEl, prevEl = _ref.prevEl;
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        if (nextEl) nextEl.forEach(function(el) {
            return el.removeEventListener("keydown", onEnterOrSpaceKey);
        });
        if (prevEl) prevEl.forEach(function(el) {
            return el.removeEventListener("keydown", onEnterOrSpaceKey);
        });
        // Pagination
        if (hasClickablePagination()) {
            var paginationEl = Array.isArray(swiper.pagination.el) ? swiper.pagination.el : [
                swiper.pagination.el
            ];
            paginationEl.forEach(function(el) {
                el.removeEventListener("keydown", onEnterOrSpaceKey);
            });
        }
        // Tab focus
        swiper.el.removeEventListener("focus", handleFocus, true);
        swiper.el.removeEventListener("pointerdown", handlePointerDown, true);
        swiper.el.removeEventListener("pointerup", handlePointerUp, true);
    };
    extendParams({
        a11y: {
            enabled: true,
            notificationClass: "swiper-notification",
            prevSlideMessage: "Previous slide",
            nextSlideMessage: "Next slide",
            firstSlideMessage: "This is the first slide",
            lastSlideMessage: "This is the last slide",
            paginationBulletMessage: "Go to slide {{index}}",
            slideLabelMessage: "{{index}} / {{slidesLength}}",
            containerMessage: null,
            containerRoleDescriptionMessage: null,
            itemRoleDescriptionMessage: null,
            slideRole: "group",
            id: null
        }
    });
    swiper.a11y = {
        clicked: false
    };
    var liveRegion = null;
    var makeElementsArray = function(el) {
        if (!Array.isArray(el)) el = [
            el
        ].filter(function(e) {
            return !!e;
        });
        return el;
    };
    var initNavEl = function(el, wrapperId, message) {
        makeElFocusable(el);
        if (el.tagName !== "BUTTON") {
            addElRole(el, "button");
            el.addEventListener("keydown", onEnterOrSpaceKey);
        }
        addElLabel(el, message);
        addElControls(el, wrapperId);
    };
    var handlePointerDown = function() {
        swiper.a11y.clicked = true;
    };
    var handlePointerUp = function() {
        requestAnimationFrame(function() {
            requestAnimationFrame(function() {
                if (!swiper.destroyed) swiper.a11y.clicked = false;
            });
        });
    };
    var handleFocus = function(e) {
        if (swiper.a11y.clicked) return;
        var slideEl = e.target.closest(".".concat(swiper.params.slideClass, ", swiper-slide"));
        if (!slideEl || !swiper.slides.includes(slideEl)) return;
        var isActive = swiper.slides.indexOf(slideEl) === swiper.activeIndex;
        var isVisible = swiper.params.watchSlidesProgress && swiper.visibleSlides && swiper.visibleSlides.includes(slideEl);
        if (isActive || isVisible) return;
        if (e.sourceCapabilities && e.sourceCapabilities.firesTouchEvents) return;
        if (swiper.isHorizontal()) swiper.el.scrollLeft = 0;
        else swiper.el.scrollTop = 0;
        swiper.slideTo(swiper.slides.indexOf(slideEl), 0);
    };
    var initSlides = function() {
        var params = swiper.params.a11y;
        if (params.itemRoleDescriptionMessage) addElRoleDescription(swiper.slides, params.itemRoleDescriptionMessage);
        if (params.slideRole) addElRole(swiper.slides, params.slideRole);
        var slidesLength = swiper.slides.length;
        if (params.slideLabelMessage) swiper.slides.forEach(function(slideEl, index) {
            var slideIndex = swiper.params.loop ? parseInt(slideEl.getAttribute("data-swiper-slide-index"), 10) : index;
            var ariaLabelMessage = params.slideLabelMessage.replace(/\{\{index\}\}/, slideIndex + 1).replace(/\{\{slidesLength\}\}/, slidesLength);
            addElLabel(slideEl, ariaLabelMessage);
        });
    };
    var init = function() {
        var params = swiper.params.a11y;
        if (swiper.isElement) swiper.el.shadowEl.append(liveRegion);
        else swiper.el.append(liveRegion);
        // Container
        var containerEl = swiper.el;
        if (params.containerRoleDescriptionMessage) addElRoleDescription(containerEl, params.containerRoleDescriptionMessage);
        if (params.containerMessage) addElLabel(containerEl, params.containerMessage);
        // Wrapper
        var wrapperEl = swiper.wrapperEl;
        var wrapperId = params.id || wrapperEl.getAttribute("id") || "swiper-wrapper-".concat(getRandomNumber(16));
        var live = swiper.params.autoplay && swiper.params.autoplay.enabled ? "off" : "polite";
        addElId(wrapperEl, wrapperId);
        addElLive(wrapperEl, live);
        // Slide
        initSlides();
        // Navigation
        var _ref = swiper.navigation ? swiper.navigation : {}, nextEl = _ref.nextEl, prevEl = _ref.prevEl;
        nextEl = makeElementsArray(nextEl);
        prevEl = makeElementsArray(prevEl);
        if (nextEl) nextEl.forEach(function(el) {
            return initNavEl(el, wrapperId, params.nextSlideMessage);
        });
        if (prevEl) prevEl.forEach(function(el) {
            return initNavEl(el, wrapperId, params.prevSlideMessage);
        });
        // Pagination
        if (hasClickablePagination()) {
            var paginationEl = Array.isArray(swiper.pagination.el) ? swiper.pagination.el : [
                swiper.pagination.el
            ];
            paginationEl.forEach(function(el) {
                el.addEventListener("keydown", onEnterOrSpaceKey);
            });
        }
        // Tab focus
        swiper.el.addEventListener("focus", handleFocus, true);
        swiper.el.addEventListener("pointerdown", handlePointerDown, true);
        swiper.el.addEventListener("pointerup", handlePointerUp, true);
    };
    on("beforeInit", function() {
        liveRegion = (0, $2530e0d256bb8028$export$c8a8987d4410bf2d)("span", swiper.params.a11y.notificationClass);
        liveRegion.setAttribute("aria-live", "assertive");
        liveRegion.setAttribute("aria-atomic", "true");
    });
    on("afterInit", function() {
        if (!swiper.params.a11y.enabled) return;
        init();
    });
    on("slidesLengthChange snapGridLengthChange slidesGridLengthChange", function() {
        if (!swiper.params.a11y.enabled) return;
        initSlides();
    });
    on("fromEdge toEdge afterInit lock unlock", function() {
        if (!swiper.params.a11y.enabled) return;
        updateNavigation();
    });
    on("paginationUpdate", function() {
        if (!swiper.params.a11y.enabled) return;
        updatePagination();
    });
    on("destroy", function() {
        if (!swiper.params.a11y.enabled) return;
        destroy();
    });
}



function $0231e03f7b2b006a$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        history: {
            enabled: false,
            root: "",
            replaceState: false,
            key: "slides",
            keepQuery: false
        }
    });
    var initialized = false;
    var paths = {};
    var slugify = function(text) {
        return text.toString().replace(/\s+/g, "-").replace(/[^\w-]+/g, "").replace(/--+/g, "-").replace(/^-+/, "").replace(/-+$/, "");
    };
    var getPathValues = function(urlOverride) {
        var window = (0, $e7beec05cc3d4f7e$export$38b2d434cce3ea22)();
        var location;
        if (urlOverride) location = new URL(urlOverride);
        else location = window.location;
        var pathArray = location.pathname.slice(1).split("/").filter(function(part) {
            return part !== "";
        });
        var total = pathArray.length;
        var key = pathArray[total - 2];
        var value = pathArray[total - 1];
        return {
            key: key,
            value: value
        };
    };
    var setHistory = function(key, index) {
        var window = (0, $e7beec05cc3d4f7e$export$38b2d434cce3ea22)();
        if (!initialized || !swiper.params.history.enabled) return;
        var location;
        if (swiper.params.url) location = new URL(swiper.params.url);
        else location = window.location;
        var slide = swiper.slides[index];
        var value = slugify(slide.getAttribute("data-history"));
        if (swiper.params.history.root.length > 0) {
            var root = swiper.params.history.root;
            if (root[root.length - 1] === "/") root = root.slice(0, root.length - 1);
            value = "".concat(root, "/").concat(key ? "".concat(key, "/") : "").concat(value);
        } else if (!location.pathname.includes(key)) value = "".concat(key ? "".concat(key, "/") : "").concat(value);
        if (swiper.params.history.keepQuery) value += location.search;
        var currentState = window.history.state;
        if (currentState && currentState.value === value) return;
        if (swiper.params.history.replaceState) window.history.replaceState({
            value: value
        }, null, value);
        else window.history.pushState({
            value: value
        }, null, value);
    };
    var scrollToSlide = function(speed, value, runCallbacks) {
        if (value) for(var i = 0, length = swiper.slides.length; i < length; i += 1){
            var slide = swiper.slides[i];
            var slideHistory = slugify(slide.getAttribute("data-history"));
            if (slideHistory === value) {
                var index = swiper.getSlideIndex(slide);
                swiper.slideTo(index, speed, runCallbacks);
            }
        }
        else swiper.slideTo(0, speed, runCallbacks);
    };
    var setHistoryPopState = function() {
        paths = getPathValues(swiper.params.url);
        scrollToSlide(swiper.params.speed, paths.value, false);
    };
    var init = function() {
        var window = (0, $e7beec05cc3d4f7e$export$38b2d434cce3ea22)();
        if (!swiper.params.history) return;
        if (!window.history || !window.history.pushState) {
            swiper.params.history.enabled = false;
            swiper.params.hashNavigation.enabled = true;
            return;
        }
        initialized = true;
        paths = getPathValues(swiper.params.url);
        if (!paths.key && !paths.value) {
            if (!swiper.params.history.replaceState) window.addEventListener("popstate", setHistoryPopState);
            return;
        }
        scrollToSlide(0, paths.value, swiper.params.runCallbacksOnInit);
        if (!swiper.params.history.replaceState) window.addEventListener("popstate", setHistoryPopState);
    };
    var destroy = function() {
        var window = (0, $e7beec05cc3d4f7e$export$38b2d434cce3ea22)();
        if (!swiper.params.history.replaceState) window.removeEventListener("popstate", setHistoryPopState);
    };
    on("init", function() {
        if (swiper.params.history.enabled) init();
    });
    on("destroy", function() {
        if (swiper.params.history.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", function() {
        if (initialized) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
    on("slideChange", function() {
        if (initialized && swiper.params.cssMode) setHistory(swiper.params.history.key, swiper.activeIndex);
    });
}




function $ce30973406309962$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, emit = param.emit, on = param.on;
    var initialized = false;
    var document = (0, $e7beec05cc3d4f7e$export$f65ca476c09acec0)();
    var window = (0, $e7beec05cc3d4f7e$export$38b2d434cce3ea22)();
    extendParams({
        hashNavigation: {
            enabled: false,
            replaceState: false,
            watchState: false,
            getSlideIndex: function(_s, hash) {
                if (swiper.virtual && swiper.params.virtual.enabled) {
                    var slideWithHash = swiper.slides.filter(function(slideEl) {
                        return slideEl.getAttribute("data-hash") === hash;
                    })[0];
                    if (!slideWithHash) return 0;
                    var index = parseInt(slideWithHash.getAttribute("data-swiper-slide-index"), 10);
                    return index;
                }
                return swiper.getSlideIndex((0, $2530e0d256bb8028$export$eb846d859f2895e6)(swiper.slidesEl, ".".concat(swiper.params.slideClass, '[data-hash="').concat(hash, '"], swiper-slide[data-hash="').concat(hash, '"]'))[0]);
            }
        }
    });
    var onHashChange = function() {
        emit("hashChange");
        var newHash = document.location.hash.replace("#", "");
        var activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector('[data-swiper-slide-index="'.concat(swiper.activeIndex, '"]')) : swiper.slides[swiper.activeIndex];
        var activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute("data-hash") : "";
        if (newHash !== activeSlideHash) {
            var newIndex = swiper.params.hashNavigation.getSlideIndex(swiper, newHash);
            if (typeof newIndex === "undefined" || Number.isNaN(newIndex)) return;
            swiper.slideTo(newIndex);
        }
    };
    var setHash = function() {
        if (!initialized || !swiper.params.hashNavigation.enabled) return;
        var activeSlideEl = swiper.virtual && swiper.params.virtual.enabled ? swiper.slidesEl.querySelector('[data-swiper-slide-index="'.concat(swiper.activeIndex, '"]')) : swiper.slides[swiper.activeIndex];
        var activeSlideHash = activeSlideEl ? activeSlideEl.getAttribute("data-hash") || activeSlideEl.getAttribute("data-history") : "";
        if (swiper.params.hashNavigation.replaceState && window.history && window.history.replaceState) {
            window.history.replaceState(null, null, "#".concat(activeSlideHash) || "");
            emit("hashSet");
        } else {
            document.location.hash = activeSlideHash || "";
            emit("hashSet");
        }
    };
    var init = function() {
        if (!swiper.params.hashNavigation.enabled || swiper.params.history && swiper.params.history.enabled) return;
        initialized = true;
        var hash = document.location.hash.replace("#", "");
        if (hash) {
            var speed = 0;
            var index = swiper.params.hashNavigation.getSlideIndex(swiper, hash);
            swiper.slideTo(index || 0, speed, swiper.params.runCallbacksOnInit, true);
        }
        if (swiper.params.hashNavigation.watchState) window.addEventListener("hashchange", onHashChange);
    };
    var destroy = function() {
        if (swiper.params.hashNavigation.watchState) window.removeEventListener("hashchange", onHashChange);
    };
    on("init", function() {
        if (swiper.params.hashNavigation.enabled) init();
    });
    on("destroy", function() {
        if (swiper.params.hashNavigation.enabled) destroy();
    });
    on("transitionEnd _freeModeNoMomentumRelease", function() {
        if (initialized) setHash();
    });
    on("slideChange", function() {
        if (initialized && swiper.params.cssMode) setHash();
    });
}


/* eslint no-underscore-dangle: "off" */ /* eslint no-use-before-define: "off" */ 
function $3afada740de650bf$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on, emit = param.emit, params = param.params;
    swiper.autoplay = {
        running: false,
        paused: false,
        timeLeft: 0
    };
    extendParams({
        autoplay: {
            enabled: false,
            delay: 3000,
            waitForTransition: true,
            disableOnInteraction: true,
            stopOnLastSlide: false,
            reverseDirection: false,
            pauseOnMouseEnter: false
        }
    });
    var timeout;
    var raf;
    var autoplayDelayTotal = params && params.autoplay ? params.autoplay.delay : 3000;
    var autoplayDelayCurrent = params && params.autoplay ? params.autoplay.delay : 3000;
    var autoplayTimeLeft;
    var autoplayStartTime = new Date().getTime;
    var wasPaused;
    var isTouched;
    var pausedByTouch;
    var touchStartTimeout;
    var slideChanged;
    var pausedByInteraction;
    function onTransitionEnd(e) {
        if (!swiper || swiper.destroyed || !swiper.wrapperEl) return;
        if (e.target !== swiper.wrapperEl) return;
        swiper.wrapperEl.removeEventListener("transitionend", onTransitionEnd);
        resume();
    }
    var calcTimeLeft = function() {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.autoplay.paused) wasPaused = true;
        else if (wasPaused) {
            autoplayDelayCurrent = autoplayTimeLeft;
            wasPaused = false;
        }
        var timeLeft = swiper.autoplay.paused ? autoplayTimeLeft : autoplayStartTime + autoplayDelayCurrent - new Date().getTime();
        swiper.autoplay.timeLeft = timeLeft;
        emit("autoplayTimeLeft", timeLeft, timeLeft / autoplayDelayTotal);
        raf = requestAnimationFrame(function() {
            calcTimeLeft();
        });
    };
    var getSlideDelay = function() {
        var activeSlideEl;
        if (swiper.virtual && swiper.params.virtual.enabled) activeSlideEl = swiper.slides.filter(function(slideEl) {
            return slideEl.classList.contains("swiper-slide-active");
        })[0];
        else activeSlideEl = swiper.slides[swiper.activeIndex];
        if (!activeSlideEl) return undefined;
        var currentSlideDelay = parseInt(activeSlideEl.getAttribute("data-swiper-autoplay"), 10);
        return currentSlideDelay;
    };
    var run = function(delayForce) {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        cancelAnimationFrame(raf);
        calcTimeLeft();
        var delay = typeof delayForce === "undefined" ? swiper.params.autoplay.delay : delayForce;
        autoplayDelayTotal = swiper.params.autoplay.delay;
        autoplayDelayCurrent = swiper.params.autoplay.delay;
        var currentSlideDelay = getSlideDelay();
        if (!Number.isNaN(currentSlideDelay) && currentSlideDelay > 0 && typeof delayForce === "undefined") {
            delay = currentSlideDelay;
            autoplayDelayTotal = currentSlideDelay;
            autoplayDelayCurrent = currentSlideDelay;
        }
        autoplayTimeLeft = delay;
        var speed = swiper.params.speed;
        var proceed = function() {
            if (!swiper || swiper.destroyed) return;
            if (swiper.params.autoplay.reverseDirection) {
                if (!swiper.isBeginning || swiper.params.loop || swiper.params.rewind) {
                    swiper.slidePrev(speed, true, true);
                    emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(swiper.slides.length - 1, speed, true, true);
                    emit("autoplay");
                }
            } else {
                if (!swiper.isEnd || swiper.params.loop || swiper.params.rewind) {
                    swiper.slideNext(speed, true, true);
                    emit("autoplay");
                } else if (!swiper.params.autoplay.stopOnLastSlide) {
                    swiper.slideTo(0, speed, true, true);
                    emit("autoplay");
                }
            }
            if (swiper.params.cssMode) {
                autoplayStartTime = new Date().getTime();
                requestAnimationFrame(function() {
                    run();
                });
            }
        };
        if (delay > 0) {
            clearTimeout(timeout);
            timeout = setTimeout(function() {
                proceed();
            }, delay);
        } else requestAnimationFrame(function() {
            proceed();
        });
        // eslint-disable-next-line
        return delay;
    };
    var start = function() {
        swiper.autoplay.running = true;
        run();
        emit("autoplayStart");
    };
    var stop = function() {
        swiper.autoplay.running = false;
        clearTimeout(timeout);
        cancelAnimationFrame(raf);
        emit("autoplayStop");
    };
    var pause = function(internal, reset) {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        clearTimeout(timeout);
        if (!internal) pausedByInteraction = true;
        var proceed = function() {
            emit("autoplayPause");
            if (swiper.params.autoplay.waitForTransition) swiper.wrapperEl.addEventListener("transitionend", onTransitionEnd);
            else resume();
        };
        swiper.autoplay.paused = true;
        if (reset) {
            if (slideChanged) autoplayTimeLeft = swiper.params.autoplay.delay;
            slideChanged = false;
            proceed();
            return;
        }
        var delay = autoplayTimeLeft || swiper.params.autoplay.delay;
        autoplayTimeLeft = delay - (new Date().getTime() - autoplayStartTime);
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop) return;
        if (autoplayTimeLeft < 0) autoplayTimeLeft = 0;
        proceed();
    };
    var resume = function() {
        if (swiper.isEnd && autoplayTimeLeft < 0 && !swiper.params.loop || swiper.destroyed || !swiper.autoplay.running) return;
        autoplayStartTime = new Date().getTime();
        if (pausedByInteraction) {
            pausedByInteraction = false;
            run(autoplayTimeLeft);
        } else run();
        swiper.autoplay.paused = false;
        emit("autoplayResume");
    };
    var onVisibilityChange = function() {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        var document = (0, $e7beec05cc3d4f7e$export$f65ca476c09acec0)();
        if (document.visibilityState === "hidden") {
            pausedByInteraction = true;
            pause(true);
        }
        if (document.visibilityState === "visible") resume();
    };
    var onPointerEnter = function(e) {
        if (e.pointerType !== "mouse") return;
        pausedByInteraction = true;
        pause(true);
    };
    var onPointerLeave = function(e) {
        if (e.pointerType !== "mouse") return;
        if (swiper.autoplay.paused) resume();
    };
    var attachMouseEvents = function() {
        if (swiper.params.autoplay.pauseOnMouseEnter) {
            swiper.el.addEventListener("pointerenter", onPointerEnter);
            swiper.el.addEventListener("pointerleave", onPointerLeave);
        }
    };
    var detachMouseEvents = function() {
        swiper.el.removeEventListener("pointerenter", onPointerEnter);
        swiper.el.removeEventListener("pointerleave", onPointerLeave);
    };
    var attachDocumentEvents = function() {
        var document = (0, $e7beec05cc3d4f7e$export$f65ca476c09acec0)();
        document.addEventListener("visibilitychange", onVisibilityChange);
    };
    var detachDocumentEvents = function() {
        var document = (0, $e7beec05cc3d4f7e$export$f65ca476c09acec0)();
        document.removeEventListener("visibilitychange", onVisibilityChange);
    };
    on("init", function() {
        if (swiper.params.autoplay.enabled) {
            attachMouseEvents();
            attachDocumentEvents();
            autoplayStartTime = new Date().getTime();
            start();
        }
    });
    on("destroy", function() {
        detachMouseEvents();
        detachDocumentEvents();
        if (swiper.autoplay.running) stop();
    });
    on("beforeTransitionStart", function(_s, speed, internal) {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (internal || !swiper.params.autoplay.disableOnInteraction) pause(true, true);
        else stop();
    });
    on("sliderFirstMove", function() {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        if (swiper.params.autoplay.disableOnInteraction) {
            stop();
            return;
        }
        isTouched = true;
        pausedByTouch = false;
        pausedByInteraction = false;
        touchStartTimeout = setTimeout(function() {
            pausedByInteraction = true;
            pausedByTouch = true;
            pause(true);
        }, 200);
    });
    on("touchEnd", function() {
        if (swiper.destroyed || !swiper.autoplay.running || !isTouched) return;
        clearTimeout(touchStartTimeout);
        clearTimeout(timeout);
        if (swiper.params.autoplay.disableOnInteraction) {
            pausedByTouch = false;
            isTouched = false;
            return;
        }
        if (pausedByTouch && swiper.params.cssMode) resume();
        pausedByTouch = false;
        isTouched = false;
    });
    on("slideChange", function() {
        if (swiper.destroyed || !swiper.autoplay.running) return;
        slideChanged = true;
    });
    Object.assign(swiper.autoplay, {
        start: start,
        stop: stop,
        pause: pause,
        resume: resume
    });
}




function $ec33d32eb46e8073$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    var onThumbClick = function onThumbClick() {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        var clickedIndex = thumbsSwiper.clickedIndex;
        var clickedSlide = thumbsSwiper.clickedSlide;
        if (clickedSlide && clickedSlide.classList.contains(swiper.params.thumbs.slideThumbActiveClass)) return;
        if (typeof clickedIndex === "undefined" || clickedIndex === null) return;
        var slideToIndex;
        if (thumbsSwiper.params.loop) slideToIndex = parseInt(thumbsSwiper.clickedSlide.getAttribute("data-swiper-slide-index"), 10);
        else slideToIndex = clickedIndex;
        if (swiper.params.loop) swiper.slideToLoop(slideToIndex);
        else swiper.slideTo(slideToIndex);
    };
    var init = function init() {
        var _swiper_params = swiper.params, thumbsParams = _swiper_params.thumbs;
        if (initialized) return false;
        initialized = true;
        var SwiperClass = swiper.constructor;
        if (thumbsParams.swiper instanceof SwiperClass) {
            swiper.thumbs.swiper = thumbsParams.swiper;
            Object.assign(swiper.thumbs.swiper.originalParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            Object.assign(swiper.thumbs.swiper.params, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper.update();
        } else if ((0, $2530e0d256bb8028$export$a6cdc56e425d0d0a)(thumbsParams.swiper)) {
            var thumbsSwiperParams = Object.assign({}, thumbsParams.swiper);
            Object.assign(thumbsSwiperParams, {
                watchSlidesProgress: true,
                slideToClickedSlide: false
            });
            swiper.thumbs.swiper = new SwiperClass(thumbsSwiperParams);
            swiperCreated = true;
        }
        swiper.thumbs.swiper.el.classList.add(swiper.params.thumbs.thumbsContainerClass);
        swiper.thumbs.swiper.on("tap", onThumbClick);
        return true;
    };
    var update = function update(initial) {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        var slidesPerView = thumbsSwiper.params.slidesPerView === "auto" ? thumbsSwiper.slidesPerViewDynamic() : thumbsSwiper.params.slidesPerView;
        // Activate thumbs
        var thumbsToActivate = 1;
        var thumbActiveClass = swiper.params.thumbs.slideThumbActiveClass;
        if (swiper.params.slidesPerView > 1 && !swiper.params.centeredSlides) thumbsToActivate = swiper.params.slidesPerView;
        if (!swiper.params.thumbs.multipleActiveThumbs) thumbsToActivate = 1;
        thumbsToActivate = Math.floor(thumbsToActivate);
        thumbsSwiper.slides.forEach(function(slideEl) {
            return slideEl.classList.remove(thumbActiveClass);
        });
        if (thumbsSwiper.params.loop || thumbsSwiper.params.virtual && thumbsSwiper.params.virtual.enabled) for(var i = 0; i < thumbsToActivate; i += 1)(0, $2530e0d256bb8028$export$eb846d859f2895e6)(thumbsSwiper.slidesEl, '[data-swiper-slide-index="'.concat(swiper.realIndex + i, '"]')).forEach(function(slideEl) {
            slideEl.classList.add(thumbActiveClass);
        });
        else {
            for(var i1 = 0; i1 < thumbsToActivate; i1 += 1)if (thumbsSwiper.slides[swiper.realIndex + i1]) thumbsSwiper.slides[swiper.realIndex + i1].classList.add(thumbActiveClass);
        }
        var autoScrollOffset = swiper.params.thumbs.autoScrollOffset;
        var useOffset = autoScrollOffset && !thumbsSwiper.params.loop;
        if (swiper.realIndex !== thumbsSwiper.realIndex || useOffset) {
            var currentThumbsIndex = thumbsSwiper.activeIndex;
            var newThumbsIndex;
            var direction;
            if (thumbsSwiper.params.loop) {
                var newThumbsSlide = thumbsSwiper.slides.filter(function(slideEl) {
                    return slideEl.getAttribute("data-swiper-slide-index") === "".concat(swiper.realIndex);
                })[0];
                newThumbsIndex = thumbsSwiper.slides.indexOf(newThumbsSlide);
                direction = swiper.activeIndex > swiper.previousIndex ? "next" : "prev";
            } else {
                newThumbsIndex = swiper.realIndex;
                direction = newThumbsIndex > swiper.previousIndex ? "next" : "prev";
            }
            if (useOffset) newThumbsIndex += direction === "next" ? autoScrollOffset : -1 * autoScrollOffset;
            if (thumbsSwiper.visibleSlidesIndexes && thumbsSwiper.visibleSlidesIndexes.indexOf(newThumbsIndex) < 0) {
                if (thumbsSwiper.params.centeredSlides) {
                    if (newThumbsIndex > currentThumbsIndex) newThumbsIndex = newThumbsIndex - Math.floor(slidesPerView / 2) + 1;
                    else newThumbsIndex = newThumbsIndex + Math.floor(slidesPerView / 2) - 1;
                } else newThumbsIndex > currentThumbsIndex && thumbsSwiper.params.slidesPerGroup;
                thumbsSwiper.slideTo(newThumbsIndex, initial ? 0 : undefined);
            }
        }
    };
    extendParams({
        thumbs: {
            swiper: null,
            multipleActiveThumbs: true,
            autoScrollOffset: 0,
            slideThumbActiveClass: "swiper-slide-thumb-active",
            thumbsContainerClass: "swiper-thumbs"
        }
    });
    var initialized = false;
    var swiperCreated = false;
    swiper.thumbs = {
        swiper: null
    };
    on("beforeInit", function() {
        var thumbs = swiper.params.thumbs;
        if (!thumbs || !thumbs.swiper) return;
        if (typeof thumbs.swiper === "string" || thumbs.swiper instanceof HTMLElement) {
            var document = (0, $e7beec05cc3d4f7e$export$f65ca476c09acec0)();
            var getThumbsElementAndInit = function() {
                var thumbsElement = typeof thumbs.swiper === "string" ? document.querySelector(thumbs.swiper) : thumbs.swiper;
                if (thumbsElement && thumbsElement.swiper) {
                    thumbs.swiper = thumbsElement.swiper;
                    init();
                    update(true);
                } else if (thumbsElement) {
                    var onThumbsSwiper = function(e) {
                        thumbs.swiper = e.detail[0];
                        thumbsElement.removeEventListener("init", onThumbsSwiper);
                        init();
                        update(true);
                        thumbs.swiper.update();
                        swiper.update();
                    };
                    thumbsElement.addEventListener("init", onThumbsSwiper);
                }
                return thumbsElement;
            };
            var watchForThumbsToAppear = function() {
                if (swiper.destroyed) return;
                var thumbsElement = getThumbsElementAndInit();
                if (!thumbsElement) requestAnimationFrame(watchForThumbsToAppear);
            };
            requestAnimationFrame(watchForThumbsToAppear);
        } else {
            init();
            update(true);
        }
    });
    on("slideChange update resize observerUpdate", function() {
        update();
    });
    on("setTransition", function(_s, duration) {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        thumbsSwiper.setTransition(duration);
    });
    on("beforeDestroy", function() {
        var thumbsSwiper = swiper.thumbs.swiper;
        if (!thumbsSwiper || thumbsSwiper.destroyed) return;
        if (swiperCreated) thumbsSwiper.destroy();
    });
    Object.assign(swiper.thumbs, {
        init: init,
        update: update
    });
}



function $6d9eea4cb68e26d8$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, emit = param.emit, once = param.once;
    var onTouchStart = function onTouchStart() {
        if (swiper.params.cssMode) return;
        var translate = swiper.getTranslate();
        swiper.setTranslate(translate);
        swiper.setTransition(0);
        swiper.touchEventsData.velocities.length = 0;
        swiper.freeMode.onTouchEnd({
            currentPos: swiper.rtl ? swiper.translate : -swiper.translate
        });
    };
    var onTouchMove = function onTouchMove() {
        if (swiper.params.cssMode) return;
        var data = swiper.touchEventsData, touches = swiper.touches;
        // Velocity
        if (data.velocities.length === 0) data.velocities.push({
            position: touches[swiper.isHorizontal() ? "startX" : "startY"],
            time: data.touchStartTime
        });
        data.velocities.push({
            position: touches[swiper.isHorizontal() ? "currentX" : "currentY"],
            time: (0, $2530e0d256bb8028$export$461939dd4422153)()
        });
    };
    var onTouchEnd = function onTouchEnd(param) {
        var currentPos = param.currentPos;
        if (swiper.params.cssMode) return;
        var params = swiper.params, wrapperEl = swiper.wrapperEl, rtl = swiper.rtlTranslate, snapGrid = swiper.snapGrid, data = swiper.touchEventsData;
        // Time diff
        var touchEndTime = (0, $2530e0d256bb8028$export$461939dd4422153)();
        var timeDiff = touchEndTime - data.touchStartTime;
        if (currentPos < -swiper.minTranslate()) {
            swiper.slideTo(swiper.activeIndex);
            return;
        }
        if (currentPos > -swiper.maxTranslate()) {
            if (swiper.slides.length < snapGrid.length) swiper.slideTo(snapGrid.length - 1);
            else swiper.slideTo(swiper.slides.length - 1);
            return;
        }
        if (params.freeMode.momentum) {
            if (data.velocities.length > 1) {
                var lastMoveEvent = data.velocities.pop();
                var velocityEvent = data.velocities.pop();
                var distance = lastMoveEvent.position - velocityEvent.position;
                var time = lastMoveEvent.time - velocityEvent.time;
                swiper.velocity = distance / time;
                swiper.velocity /= 2;
                if (Math.abs(swiper.velocity) < params.freeMode.minimumVelocity) swiper.velocity = 0;
                // this implies that the user stopped moving a finger then released.
                // There would be no events with distance zero, so the last event is stale.
                if (time > 150 || (0, $2530e0d256bb8028$export$461939dd4422153)() - lastMoveEvent.time > 300) swiper.velocity = 0;
            } else swiper.velocity = 0;
            swiper.velocity *= params.freeMode.momentumVelocityRatio;
            data.velocities.length = 0;
            var momentumDuration = 1000 * params.freeMode.momentumRatio;
            var momentumDistance = swiper.velocity * momentumDuration;
            var newPosition = swiper.translate + momentumDistance;
            if (rtl) newPosition = -newPosition;
            var doBounce = false;
            var afterBouncePosition;
            var bounceAmount = Math.abs(swiper.velocity) * 20 * params.freeMode.momentumBounceRatio;
            var needsLoopFix;
            if (newPosition < swiper.maxTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition + swiper.maxTranslate() < -bounceAmount) newPosition = swiper.maxTranslate() - bounceAmount;
                    afterBouncePosition = swiper.maxTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.maxTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (newPosition > swiper.minTranslate()) {
                if (params.freeMode.momentumBounce) {
                    if (newPosition - swiper.minTranslate() > bounceAmount) newPosition = swiper.minTranslate() + bounceAmount;
                    afterBouncePosition = swiper.minTranslate();
                    doBounce = true;
                    data.allowMomentumBounce = true;
                } else newPosition = swiper.minTranslate();
                if (params.loop && params.centeredSlides) needsLoopFix = true;
            } else if (params.freeMode.sticky) {
                var nextSlide;
                for(var j = 0; j < snapGrid.length; j += 1)if (snapGrid[j] > -newPosition) {
                    nextSlide = j;
                    break;
                }
                if (Math.abs(snapGrid[nextSlide] - newPosition) < Math.abs(snapGrid[nextSlide - 1] - newPosition) || swiper.swipeDirection === "next") newPosition = snapGrid[nextSlide];
                else newPosition = snapGrid[nextSlide - 1];
                newPosition = -newPosition;
            }
            if (needsLoopFix) once("transitionEnd", function() {
                swiper.loopFix();
            });
            // Fix duration
            if (swiper.velocity !== 0) {
                if (rtl) momentumDuration = Math.abs((-newPosition - swiper.translate) / swiper.velocity);
                else momentumDuration = Math.abs((newPosition - swiper.translate) / swiper.velocity);
                if (params.freeMode.sticky) {
                    // If freeMode.sticky is active and the user ends a swipe with a slow-velocity
                    // event, then durations can be 20+ seconds to slide one (or zero!) slides.
                    // It's easy to see this when simulating touch with mouse events. To fix this,
                    // limit single-slide swipes to the default slide duration. This also has the
                    // nice side effect of matching slide speed if the user stopped moving before
                    // lifting finger or mouse vs. moving slowly before lifting the finger/mouse.
                    // For faster swipes, also apply limits (albeit higher ones).
                    var moveDistance = Math.abs((rtl ? -newPosition : newPosition) - swiper.translate);
                    var currentSlideSize = swiper.slidesSizesGrid[swiper.activeIndex];
                    if (moveDistance < currentSlideSize) momentumDuration = params.speed;
                    else if (moveDistance < 2 * currentSlideSize) momentumDuration = params.speed * 1.5;
                    else momentumDuration = params.speed * 2.5;
                }
            } else if (params.freeMode.sticky) {
                swiper.slideToClosest();
                return;
            }
            if (params.freeMode.momentumBounce && doBounce) {
                swiper.updateProgress(afterBouncePosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                swiper.animating = true;
                (0, $2530e0d256bb8028$export$6b974c5889da0bb5)(wrapperEl, function() {
                    if (!swiper || swiper.destroyed || !data.allowMomentumBounce) return;
                    emit("momentumBounce");
                    swiper.setTransition(params.speed);
                    setTimeout(function() {
                        swiper.setTranslate(afterBouncePosition);
                        (0, $2530e0d256bb8028$export$6b974c5889da0bb5)(wrapperEl, function() {
                            if (!swiper || swiper.destroyed) return;
                            swiper.transitionEnd();
                        });
                    }, 0);
                });
            } else if (swiper.velocity) {
                emit("_freeModeNoMomentumRelease");
                swiper.updateProgress(newPosition);
                swiper.setTransition(momentumDuration);
                swiper.setTranslate(newPosition);
                swiper.transitionStart(true, swiper.swipeDirection);
                if (!swiper.animating) {
                    swiper.animating = true;
                    (0, $2530e0d256bb8028$export$6b974c5889da0bb5)(wrapperEl, function() {
                        if (!swiper || swiper.destroyed) return;
                        swiper.transitionEnd();
                    });
                }
            } else swiper.updateProgress(newPosition);
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        } else if (params.freeMode.sticky) {
            swiper.slideToClosest();
            return;
        } else if (params.freeMode) emit("_freeModeNoMomentumRelease");
        if (!params.freeMode.momentum || timeDiff >= params.longSwipesMs) {
            swiper.updateProgress();
            swiper.updateActiveIndex();
            swiper.updateSlidesClasses();
        }
    };
    extendParams({
        freeMode: {
            enabled: false,
            momentum: true,
            momentumRatio: 1,
            momentumBounce: true,
            momentumBounceRatio: 1,
            momentumVelocityRatio: 1,
            sticky: false,
            minimumVelocity: 0.02
        }
    });
    Object.assign(swiper, {
        freeMode: {
            onTouchStart: onTouchStart,
            onTouchMove: onTouchMove,
            onTouchEnd: onTouchEnd
        }
    });
}



var $2b6Uo = parcelRequire("2b6Uo");
function $bf1721f15cc9f696$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams;
    extendParams({
        grid: {
            rows: 1,
            fill: "column"
        }
    });
    var slidesNumberEvenToRows;
    var slidesPerRow;
    var numFullColumns;
    var getSpaceBetween = function() {
        var spaceBetween = swiper.params.spaceBetween;
        if (typeof spaceBetween === "string" && spaceBetween.indexOf("%") >= 0) spaceBetween = parseFloat(spaceBetween.replace("%", "")) / 100 * swiper.size;
        else if (typeof spaceBetween === "string") spaceBetween = parseFloat(spaceBetween);
        return spaceBetween;
    };
    var initSlides = function(slidesLength) {
        var slidesPerView = swiper.params.slidesPerView;
        var _swiper_params_grid = swiper.params.grid, rows = _swiper_params_grid.rows, fill = _swiper_params_grid.fill;
        numFullColumns = Math.floor(slidesLength / rows);
        if (Math.floor(slidesLength / rows) === slidesLength / rows) slidesNumberEvenToRows = slidesLength;
        else slidesNumberEvenToRows = Math.ceil(slidesLength / rows) * rows;
        if (slidesPerView !== "auto" && fill === "row") slidesNumberEvenToRows = Math.max(slidesNumberEvenToRows, slidesPerView * rows);
        slidesPerRow = slidesNumberEvenToRows / rows;
    };
    var updateSlide = function(i, slide, slidesLength, getDirectionLabel) {
        var slidesPerGroup = swiper.params.slidesPerGroup;
        var spaceBetween = getSpaceBetween();
        var _swiper_params_grid = swiper.params.grid, rows = _swiper_params_grid.rows, fill = _swiper_params_grid.fill;
        // Set slides order
        var newSlideOrderIndex;
        var column;
        var row;
        if (fill === "row" && slidesPerGroup > 1) {
            var groupIndex = Math.floor(i / (slidesPerGroup * rows));
            var slideIndexInGroup = i - rows * slidesPerGroup * groupIndex;
            var columnsInGroup = groupIndex === 0 ? slidesPerGroup : Math.min(Math.ceil((slidesLength - groupIndex * rows * slidesPerGroup) / rows), slidesPerGroup);
            row = Math.floor(slideIndexInGroup / columnsInGroup);
            column = slideIndexInGroup - row * columnsInGroup + groupIndex * slidesPerGroup;
            newSlideOrderIndex = column + row * slidesNumberEvenToRows / rows;
            slide.style.order = newSlideOrderIndex;
        } else if (fill === "column") {
            column = Math.floor(i / rows);
            row = i - column * rows;
            if (column > numFullColumns || column === numFullColumns && row === rows - 1) {
                row += 1;
                if (row >= rows) {
                    row = 0;
                    column += 1;
                }
            }
        } else {
            row = Math.floor(i / slidesPerRow);
            column = i - row * slidesPerRow;
        }
        slide.row = row;
        slide.column = column;
        slide.style[getDirectionLabel("margin-top")] = row !== 0 ? spaceBetween && "".concat(spaceBetween, "px") : "";
    };
    var updateWrapperSize = function(slideSize, snapGrid, getDirectionLabel) {
        var _swiper_params = swiper.params, centeredSlides = _swiper_params.centeredSlides, roundLengths = _swiper_params.roundLengths;
        var spaceBetween = getSpaceBetween();
        var rows = swiper.params.grid.rows;
        swiper.virtualSize = (slideSize + spaceBetween) * slidesNumberEvenToRows;
        swiper.virtualSize = Math.ceil(swiper.virtualSize / rows) - spaceBetween;
        swiper.wrapperEl.style[getDirectionLabel("width")] = "".concat(swiper.virtualSize + spaceBetween, "px");
        if (centeredSlides) {
            var _snapGrid;
            var newSlidesGrid = [];
            for(var i = 0; i < snapGrid.length; i += 1){
                var slidesGridItem = snapGrid[i];
                if (roundLengths) slidesGridItem = Math.floor(slidesGridItem);
                if (snapGrid[i] < swiper.virtualSize + snapGrid[0]) newSlidesGrid.push(slidesGridItem);
            }
            snapGrid.splice(0, snapGrid.length);
            (_snapGrid = snapGrid).push.apply(_snapGrid, (0, $2b6Uo._)(newSlidesGrid));
        }
    };
    swiper.grid = {
        initSlides: initSlides,
        updateSlide: updateSlide,
        updateWrapperSize: updateWrapperSize
    };
}


function $560b5a80aef91f96$export$2e2bcd8739ae039(slides) {
    var swiper = this;
    var params = swiper.params, slidesEl = swiper.slidesEl;
    if (params.loop) swiper.loopDestroy();
    var appendElement = function(slideEl) {
        if (typeof slideEl === "string") {
            var tempDOM = document.createElement("div");
            tempDOM.innerHTML = slideEl;
            slidesEl.append(tempDOM.children[0]);
            tempDOM.innerHTML = "";
        } else slidesEl.append(slideEl);
    };
    if (typeof slides === "object" && "length" in slides) {
        for(var i = 0; i < slides.length; i += 1)if (slides[i]) appendElement(slides[i]);
    } else appendElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
}


function $2ac4644cf5409330$export$2e2bcd8739ae039(slides) {
    var swiper = this;
    var params = swiper.params, activeIndex = swiper.activeIndex, slidesEl = swiper.slidesEl;
    if (params.loop) swiper.loopDestroy();
    var newActiveIndex = activeIndex + 1;
    var prependElement = function(slideEl) {
        if (typeof slideEl === "string") {
            var tempDOM = document.createElement("div");
            tempDOM.innerHTML = slideEl;
            slidesEl.prepend(tempDOM.children[0]);
            tempDOM.innerHTML = "";
        } else slidesEl.prepend(slideEl);
    };
    if (typeof slides === "object" && "length" in slides) {
        for(var i = 0; i < slides.length; i += 1)if (slides[i]) prependElement(slides[i]);
        newActiveIndex = activeIndex + slides.length;
    } else prependElement(slides);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    swiper.slideTo(newActiveIndex, 0, false);
}


function $b4c8f70ab902f152$export$2e2bcd8739ae039(index, slides) {
    var swiper = this;
    var params = swiper.params, activeIndex = swiper.activeIndex, slidesEl = swiper.slidesEl;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
        swiper.recalcSlides();
    }
    var baseLength = swiper.slides.length;
    if (index <= 0) {
        swiper.prependSlide(slides);
        return;
    }
    if (index >= baseLength) {
        swiper.appendSlide(slides);
        return;
    }
    var newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + 1 : activeIndexBuffer;
    var slidesBuffer = [];
    for(var i = baseLength - 1; i >= index; i -= 1){
        var currentSlide = swiper.slides[i];
        currentSlide.remove();
        slidesBuffer.unshift(currentSlide);
    }
    if (typeof slides === "object" && "length" in slides) {
        for(var i1 = 0; i1 < slides.length; i1 += 1)if (slides[i1]) slidesEl.append(slides[i1]);
        newActiveIndex = activeIndexBuffer > index ? activeIndexBuffer + slides.length : activeIndexBuffer;
    } else slidesEl.append(slides);
    for(var i2 = 0; i2 < slidesBuffer.length; i2 += 1)slidesEl.append(slidesBuffer[i2]);
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}


function $4dd95f11ce8195ca$export$2e2bcd8739ae039(slidesIndexes) {
    var swiper = this;
    var params = swiper.params, activeIndex = swiper.activeIndex;
    var activeIndexBuffer = activeIndex;
    if (params.loop) {
        activeIndexBuffer -= swiper.loopedSlides;
        swiper.loopDestroy();
    }
    var newActiveIndex = activeIndexBuffer;
    var indexToRemove;
    if (typeof slidesIndexes === "object" && "length" in slidesIndexes) {
        for(var i = 0; i < slidesIndexes.length; i += 1){
            indexToRemove = slidesIndexes[i];
            if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
            if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        }
        newActiveIndex = Math.max(newActiveIndex, 0);
    } else {
        indexToRemove = slidesIndexes;
        if (swiper.slides[indexToRemove]) swiper.slides[indexToRemove].remove();
        if (indexToRemove < newActiveIndex) newActiveIndex -= 1;
        newActiveIndex = Math.max(newActiveIndex, 0);
    }
    swiper.recalcSlides();
    if (params.loop) swiper.loopCreate();
    if (!params.observer || swiper.isElement) swiper.update();
    if (params.loop) swiper.slideTo(newActiveIndex + swiper.loopedSlides, 0, false);
    else swiper.slideTo(newActiveIndex, 0, false);
}


function $ac3310298c6a5ac9$export$2e2bcd8739ae039() {
    var swiper = this;
    var slidesIndexes = [];
    for(var i = 0; i < swiper.slides.length; i += 1)slidesIndexes.push(i);
    swiper.removeSlide(slidesIndexes);
}


function $9ac6ff33caf552ab$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper;
    Object.assign(swiper, {
        appendSlide: (0, $560b5a80aef91f96$export$2e2bcd8739ae039).bind(swiper),
        prependSlide: (0, $2ac4644cf5409330$export$2e2bcd8739ae039).bind(swiper),
        addSlide: (0, $b4c8f70ab902f152$export$2e2bcd8739ae039).bind(swiper),
        removeSlide: (0, $4dd95f11ce8195ca$export$2e2bcd8739ae039).bind(swiper),
        removeAllSlides: (0, $ac3310298c6a5ac9$export$2e2bcd8739ae039).bind(swiper)
    });
}


function $875cc300def4fdb1$export$2e2bcd8739ae039(params) {
    var effect = params.effect, swiper = params.swiper, on = params.on, setTranslate = params.setTranslate, setTransition = params.setTransition, overwriteParams = params.overwriteParams, perspective = params.perspective, recreateShadows = params.recreateShadows, getEffectParams = params.getEffectParams;
    on("beforeInit", function() {
        if (swiper.params.effect !== effect) return;
        swiper.classNames.push("".concat(swiper.params.containerModifierClass).concat(effect));
        if (perspective && perspective()) swiper.classNames.push("".concat(swiper.params.containerModifierClass, "3d"));
        var overwriteParamsResult = overwriteParams ? overwriteParams() : {};
        Object.assign(swiper.params, overwriteParamsResult);
        Object.assign(swiper.originalParams, overwriteParamsResult);
    });
    on("setTranslate", function() {
        if (swiper.params.effect !== effect) return;
        setTranslate();
    });
    on("setTransition", function(_s, duration) {
        if (swiper.params.effect !== effect) return;
        setTransition(duration);
    });
    on("transitionEnd", function() {
        if (swiper.params.effect !== effect) return;
        if (recreateShadows) {
            if (!getEffectParams || !getEffectParams().slideShadows) return;
            // remove shadows
            swiper.slides.forEach(function(slideEl) {
                slideEl.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach(function(shadowEl) {
                    return shadowEl.remove();
                });
            });
            // create new one
            recreateShadows();
        }
    });
    var requireUpdateOnVirtual;
    on("virtualUpdate", function() {
        if (swiper.params.effect !== effect) return;
        if (!swiper.slides.length) requireUpdateOnVirtual = true;
        requestAnimationFrame(function() {
            if (requireUpdateOnVirtual && swiper.slides && swiper.slides.length) {
                setTranslate();
                requireUpdateOnVirtual = false;
            }
        });
    });
}



function $82947fd1b5606cef$export$2e2bcd8739ae039(effectParams, slideEl) {
    var transformEl = (0, $2530e0d256bb8028$export$616841b86f802685)(slideEl);
    if (transformEl !== slideEl) {
        transformEl.style.backfaceVisibility = "hidden";
        transformEl.style["-webkit-backface-visibility"] = "hidden";
    }
    return transformEl;
}



function $de1c1a422e0a2bda$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, duration = param.duration, transformElements = param.transformElements, allSlides = param.allSlides;
    var activeIndex = swiper.activeIndex;
    var getSlide = function(el) {
        if (!el.parentElement) {
            // assume shadow root
            var slide = swiper.slides.filter(function(slideEl) {
                return slideEl.shadowEl && slideEl.shadowEl === el.parentNode;
            })[0];
            return slide;
        }
        return el.parentElement;
    };
    if (swiper.params.virtualTranslate && duration !== 0) {
        var eventTriggered = false;
        var transitionEndTarget;
        if (allSlides) transitionEndTarget = transformElements;
        else transitionEndTarget = transformElements.filter(function(transformEl) {
            var el = transformEl.classList.contains("swiper-slide-transform") ? getSlide(transformEl) : transformEl;
            return swiper.getSlideIndex(el) === activeIndex;
        });
        transitionEndTarget.forEach(function(el) {
            (0, $2530e0d256bb8028$export$6b974c5889da0bb5)(el, function() {
                if (eventTriggered) return;
                if (!swiper || swiper.destroyed) return;
                eventTriggered = true;
                swiper.animating = false;
                var evt = new window.CustomEvent("transitionend", {
                    bubbles: true,
                    cancelable: true
                });
                swiper.wrapperEl.dispatchEvent(evt);
            });
        });
    }
}



function $8b63023041b0d34f$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        fadeEffect: {
            crossFade: false
        }
    });
    var setTranslate = function() {
        var slides = swiper.slides;
        var params = swiper.params.fadeEffect;
        for(var i = 0; i < slides.length; i += 1){
            var slideEl = swiper.slides[i];
            var offset = slideEl.swiperSlideOffset;
            var tx = -offset;
            if (!swiper.params.virtualTranslate) tx -= swiper.translate;
            var ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
            }
            var slideOpacity = swiper.params.fadeEffect.crossFade ? Math.max(1 - Math.abs(slideEl.progress), 0) : 1 + Math.min(Math.max(slideEl.progress, -1), 0);
            var targetEl = (0, $82947fd1b5606cef$export$2e2bcd8739ae039)(params, slideEl);
            targetEl.style.opacity = slideOpacity;
            targetEl.style.transform = "translate3d(".concat(tx, "px, ").concat(ty, "px, 0px)");
        }
    };
    var setTransition = function(duration) {
        var transformElements = swiper.slides.map(function(slideEl) {
            return (0, $2530e0d256bb8028$export$616841b86f802685)(slideEl);
        });
        transformElements.forEach(function(el) {
            el.style.transitionDuration = "".concat(duration, "ms");
        });
        (0, $de1c1a422e0a2bda$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $875cc300def4fdb1$export$2e2bcd8739ae039)({
        effect: "fade",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        overwriteParams: function() {
            return {
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            };
        }
    });
}




function $68511757a143c966$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        cubeEffect: {
            slideShadows: true,
            shadow: true,
            shadowOffset: 20,
            shadowScale: 0.94
        }
    });
    var createSlideShadows = function(slideEl, progress, isHorizontal) {
        var shadowBefore = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
        var shadowAfter = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
        if (!shadowBefore) {
            shadowBefore = (0, $2530e0d256bb8028$export$c8a8987d4410bf2d)("div", "swiper-slide-shadow-".concat(isHorizontal ? "left" : "top"));
            slideEl.append(shadowBefore);
        }
        if (!shadowAfter) {
            shadowAfter = (0, $2530e0d256bb8028$export$c8a8987d4410bf2d)("div", "swiper-slide-shadow-".concat(isHorizontal ? "right" : "bottom"));
            slideEl.append(shadowAfter);
        }
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    var recreateShadows = function() {
        // create new ones
        var isHorizontal = swiper.isHorizontal();
        swiper.slides.forEach(function(slideEl) {
            var progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress, isHorizontal);
        });
    };
    var setTranslate = function() {
        var el = swiper.el, wrapperEl = swiper.wrapperEl, slides = swiper.slides, swiperWidth = swiper.width, swiperHeight = swiper.height, rtl = swiper.rtlTranslate, swiperSize = swiper.size, browser = swiper.browser;
        var params = swiper.params.cubeEffect;
        var isHorizontal = swiper.isHorizontal();
        var isVirtual = swiper.virtual && swiper.params.virtual.enabled;
        var wrapperRotate = 0;
        var cubeShadowEl;
        if (params.shadow) {
            if (isHorizontal) {
                cubeShadowEl = swiper.slidesEl.querySelector(".swiper-cube-shadow");
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $2530e0d256bb8028$export$c8a8987d4410bf2d)("div", "swiper-cube-shadow");
                    swiper.slidesEl.append(cubeShadowEl);
                }
                cubeShadowEl.style.height = "".concat(swiperWidth, "px");
            } else {
                cubeShadowEl = el.querySelector(".swiper-cube-shadow");
                if (!cubeShadowEl) {
                    cubeShadowEl = (0, $2530e0d256bb8028$export$c8a8987d4410bf2d)("div", "swiper-cube-shadow");
                    el.append(cubeShadowEl);
                }
            }
        }
        for(var i = 0; i < slides.length; i += 1){
            var slideEl = slides[i];
            var slideIndex = i;
            if (isVirtual) slideIndex = parseInt(slideEl.getAttribute("data-swiper-slide-index"), 10);
            var slideAngle = slideIndex * 90;
            var round = Math.floor(slideAngle / 360);
            if (rtl) {
                slideAngle = -slideAngle;
                round = Math.floor(-slideAngle / 360);
            }
            var progress = Math.max(Math.min(slideEl.progress, 1), -1);
            var tx = 0;
            var ty = 0;
            var tz = 0;
            if (slideIndex % 4 === 0) {
                tx = -round * 4 * swiperSize;
                tz = 0;
            } else if ((slideIndex - 1) % 4 === 0) {
                tx = 0;
                tz = -round * 4 * swiperSize;
            } else if ((slideIndex - 2) % 4 === 0) {
                tx = swiperSize + round * 4 * swiperSize;
                tz = swiperSize;
            } else if ((slideIndex - 3) % 4 === 0) {
                tx = -swiperSize;
                tz = 3 * swiperSize + swiperSize * 4 * round;
            }
            if (rtl) tx = -tx;
            if (!isHorizontal) {
                ty = tx;
                tx = 0;
            }
            var transform = "rotateX(".concat(isHorizontal ? 0 : -slideAngle, "deg) rotateY(").concat(isHorizontal ? slideAngle : 0, "deg) translate3d(").concat(tx, "px, ").concat(ty, "px, ").concat(tz, "px)");
            if (progress <= 1 && progress > -1) {
                wrapperRotate = slideIndex * 90 + progress * 90;
                if (rtl) wrapperRotate = -slideIndex * 90 - progress * 90;
            }
            slideEl.style.transform = transform;
            if (params.slideShadows) createSlideShadows(slideEl, progress, isHorizontal);
        }
        wrapperEl.style.transformOrigin = "50% 50% -".concat(swiperSize / 2, "px");
        wrapperEl.style["-webkit-transform-origin"] = "50% 50% -".concat(swiperSize / 2, "px");
        if (params.shadow) {
            if (isHorizontal) cubeShadowEl.style.transform = "translate3d(0px, ".concat(swiperWidth / 2 + params.shadowOffset, "px, ").concat(-swiperWidth / 2, "px) rotateX(90deg) rotateZ(0deg) scale(").concat(params.shadowScale, ")");
            else {
                var shadowAngle = Math.abs(wrapperRotate) - Math.floor(Math.abs(wrapperRotate) / 90) * 90;
                var multiplier = 1.5 - (Math.sin(shadowAngle * 2 * Math.PI / 360) / 2 + Math.cos(shadowAngle * 2 * Math.PI / 360) / 2);
                var scale1 = params.shadowScale;
                var scale2 = params.shadowScale / multiplier;
                var offset = params.shadowOffset;
                cubeShadowEl.style.transform = "scale3d(".concat(scale1, ", 1, ").concat(scale2, ") translate3d(0px, ").concat(swiperHeight / 2 + offset, "px, ").concat(-swiperHeight / 2 / scale2, "px) rotateX(-90deg)");
            }
        }
        var zFactor = (browser.isSafari || browser.isWebView) && browser.needPerspectiveFix ? -swiperSize / 2 : 0;
        wrapperEl.style.transform = "translate3d(0px,0,".concat(zFactor, "px) rotateX(").concat(swiper.isHorizontal() ? 0 : wrapperRotate, "deg) rotateY(").concat(swiper.isHorizontal() ? -wrapperRotate : 0, "deg)");
        wrapperEl.style.setProperty("--swiper-cube-translate-z", "".concat(zFactor, "px"));
    };
    var setTransition = function(duration) {
        var el = swiper.el, slides = swiper.slides;
        slides.forEach(function(slideEl) {
            slideEl.style.transitionDuration = "".concat(duration, "ms");
            slideEl.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach(function(subEl) {
                subEl.style.transitionDuration = "".concat(duration, "ms");
            });
        });
        if (swiper.params.cubeEffect.shadow && !swiper.isHorizontal()) {
            var shadowEl = el.querySelector(".swiper-cube-shadow");
            if (shadowEl) shadowEl.style.transitionDuration = "".concat(duration, "ms");
        }
    };
    (0, $875cc300def4fdb1$export$2e2bcd8739ae039)({
        effect: "cube",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: function() {
            return swiper.params.cubeEffect;
        },
        perspective: function() {
            return true;
        },
        overwriteParams: function() {
            return {
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                resistanceRatio: 0,
                spaceBetween: 0,
                centeredSlides: false,
                virtualTranslate: true
            };
        }
    });
}



function $0242e3e52b0323e3$export$2e2bcd8739ae039(params, slideEl, side) {
    var shadowClass = "swiper-slide-shadow".concat(side ? "-".concat(side) : "");
    var shadowContainer = (0, $2530e0d256bb8028$export$616841b86f802685)(slideEl);
    var shadowEl = shadowContainer.querySelector(".".concat(shadowClass));
    if (!shadowEl) {
        shadowEl = (0, $2530e0d256bb8028$export$c8a8987d4410bf2d)("div", "swiper-slide-shadow".concat(side ? "-".concat(side) : ""));
        shadowContainer.append(shadowEl);
    }
    return shadowEl;
}






function $93462c85263ab301$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        flipEffect: {
            slideShadows: true,
            limitRotation: true
        }
    });
    var createSlideShadows = function(slideEl, progress, params) {
        var shadowBefore = swiper.isHorizontal() ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
        var shadowAfter = swiper.isHorizontal() ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
        if (!shadowBefore) shadowBefore = (0, $0242e3e52b0323e3$export$2e2bcd8739ae039)(params, slideEl, swiper.isHorizontal() ? "left" : "top");
        if (!shadowAfter) shadowAfter = (0, $0242e3e52b0323e3$export$2e2bcd8739ae039)(params, slideEl, swiper.isHorizontal() ? "right" : "bottom");
        if (shadowBefore) shadowBefore.style.opacity = Math.max(-progress, 0);
        if (shadowAfter) shadowAfter.style.opacity = Math.max(progress, 0);
    };
    var recreateShadows = function() {
        // Set shadows
        var params = swiper.params.flipEffect;
        swiper.slides.forEach(function(slideEl) {
            var progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            createSlideShadows(slideEl, progress, params);
        });
    };
    var setTranslate = function() {
        var slides = swiper.slides, rtl = swiper.rtlTranslate;
        var params = swiper.params.flipEffect;
        for(var i = 0; i < slides.length; i += 1){
            var slideEl = slides[i];
            var progress = slideEl.progress;
            if (swiper.params.flipEffect.limitRotation) progress = Math.max(Math.min(slideEl.progress, 1), -1);
            var offset = slideEl.swiperSlideOffset;
            var rotate = -180 * progress;
            var rotateY = rotate;
            var rotateX = 0;
            var tx = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            var ty = 0;
            if (!swiper.isHorizontal()) {
                ty = tx;
                tx = 0;
                rotateX = -rotateY;
                rotateY = 0;
            } else if (rtl) rotateY = -rotateY;
            slideEl.style.zIndex = -Math.abs(Math.round(progress)) + slides.length;
            if (params.slideShadows) createSlideShadows(slideEl, progress, params);
            var transform = "translate3d(".concat(tx, "px, ").concat(ty, "px, 0px) rotateX(").concat(rotateX, "deg) rotateY(").concat(rotateY, "deg)");
            var targetEl = (0, $82947fd1b5606cef$export$2e2bcd8739ae039)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    var setTransition = function(duration) {
        var transformElements = swiper.slides.map(function(slideEl) {
            return (0, $2530e0d256bb8028$export$616841b86f802685)(slideEl);
        });
        transformElements.forEach(function(el) {
            el.style.transitionDuration = "".concat(duration, "ms");
            el.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach(function(shadowEl) {
                shadowEl.style.transitionDuration = "".concat(duration, "ms");
            });
        });
        (0, $de1c1a422e0a2bda$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $875cc300def4fdb1$export$2e2bcd8739ae039)({
        effect: "flip",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        recreateShadows: recreateShadows,
        getEffectParams: function() {
            return swiper.params.flipEffect;
        },
        perspective: function() {
            return true;
        },
        overwriteParams: function() {
            return {
                slidesPerView: 1,
                slidesPerGroup: 1,
                watchSlidesProgress: true,
                spaceBetween: 0,
                virtualTranslate: !swiper.params.cssMode
            };
        }
    });
}






function $3d3953fa2b605b9b$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        coverflowEffect: {
            rotate: 50,
            stretch: 0,
            depth: 100,
            scale: 1,
            modifier: 1,
            slideShadows: true
        }
    });
    var setTranslate = function() {
        var swiperWidth = swiper.width, swiperHeight = swiper.height, slides = swiper.slides, slidesSizesGrid = swiper.slidesSizesGrid;
        var params = swiper.params.coverflowEffect;
        var isHorizontal = swiper.isHorizontal();
        var transform = swiper.translate;
        var center = isHorizontal ? -transform + swiperWidth / 2 : -transform + swiperHeight / 2;
        var rotate = isHorizontal ? params.rotate : -params.rotate;
        var translate = params.depth;
        // Each slide offset from center
        for(var i = 0, length = slides.length; i < length; i += 1){
            var slideEl = slides[i];
            var slideSize = slidesSizesGrid[i];
            var slideOffset = slideEl.swiperSlideOffset;
            var centerOffset = (center - slideOffset - slideSize / 2) / slideSize;
            var offsetMultiplier = typeof params.modifier === "function" ? params.modifier(centerOffset) : centerOffset * params.modifier;
            var rotateY = isHorizontal ? rotate * offsetMultiplier : 0;
            var rotateX = isHorizontal ? 0 : rotate * offsetMultiplier;
            // var rotateZ = 0
            var translateZ = -translate * Math.abs(offsetMultiplier);
            var stretch = params.stretch;
            // Allow percentage to make a relative stretch for responsive sliders
            if (typeof stretch === "string" && stretch.indexOf("%") !== -1) stretch = parseFloat(params.stretch) / 100 * slideSize;
            var translateY = isHorizontal ? 0 : stretch * offsetMultiplier;
            var translateX = isHorizontal ? stretch * offsetMultiplier : 0;
            var scale = 1 - (1 - params.scale) * Math.abs(offsetMultiplier);
            // Fix for ultra small values
            if (Math.abs(translateX) < 0.001) translateX = 0;
            if (Math.abs(translateY) < 0.001) translateY = 0;
            if (Math.abs(translateZ) < 0.001) translateZ = 0;
            if (Math.abs(rotateY) < 0.001) rotateY = 0;
            if (Math.abs(rotateX) < 0.001) rotateX = 0;
            if (Math.abs(scale) < 0.001) scale = 0;
            var slideTransform = "translate3d(".concat(translateX, "px,").concat(translateY, "px,").concat(translateZ, "px)  rotateX(").concat(rotateX, "deg) rotateY(").concat(rotateY, "deg) scale(").concat(scale, ")");
            var targetEl = (0, $82947fd1b5606cef$export$2e2bcd8739ae039)(params, slideEl);
            targetEl.style.transform = slideTransform;
            slideEl.style.zIndex = -Math.abs(Math.round(offsetMultiplier)) + 1;
            if (params.slideShadows) {
                // Set shadows
                var shadowBeforeEl = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-left") : slideEl.querySelector(".swiper-slide-shadow-top");
                var shadowAfterEl = isHorizontal ? slideEl.querySelector(".swiper-slide-shadow-right") : slideEl.querySelector(".swiper-slide-shadow-bottom");
                if (!shadowBeforeEl) shadowBeforeEl = (0, $0242e3e52b0323e3$export$2e2bcd8739ae039)(params, slideEl, isHorizontal ? "left" : "top");
                if (!shadowAfterEl) shadowAfterEl = (0, $0242e3e52b0323e3$export$2e2bcd8739ae039)(params, slideEl, isHorizontal ? "right" : "bottom");
                if (shadowBeforeEl) shadowBeforeEl.style.opacity = offsetMultiplier > 0 ? offsetMultiplier : 0;
                if (shadowAfterEl) shadowAfterEl.style.opacity = -offsetMultiplier > 0 ? -offsetMultiplier : 0;
            }
        }
    };
    var setTransition = function(duration) {
        var transformElements = swiper.slides.map(function(slideEl) {
            return (0, $2530e0d256bb8028$export$616841b86f802685)(slideEl);
        });
        transformElements.forEach(function(el) {
            el.style.transitionDuration = "".concat(duration, "ms");
            el.querySelectorAll(".swiper-slide-shadow-top, .swiper-slide-shadow-right, .swiper-slide-shadow-bottom, .swiper-slide-shadow-left").forEach(function(shadowEl) {
                shadowEl.style.transitionDuration = "".concat(duration, "ms");
            });
        });
    };
    (0, $875cc300def4fdb1$export$2e2bcd8739ae039)({
        effect: "coverflow",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: function() {
            return true;
        },
        overwriteParams: function() {
            return {
                watchSlidesProgress: true
            };
        }
    });
}







function $b78842bd61b76a02$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        creativeEffect: {
            limitProgress: 1,
            shadowPerProgress: false,
            progressMultiplier: 1,
            perspective: true,
            prev: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            },
            next: {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                opacity: 1,
                scale: 1
            }
        }
    });
    var getTranslateValue = function(value) {
        if (typeof value === "string") return value;
        return "".concat(value, "px");
    };
    var setTranslate = function() {
        var _loop = function(i) {
            var slideEl = slides[i];
            var slideProgress = slideEl.progress;
            var progress = Math.min(Math.max(slideEl.progress, -params.limitProgress), params.limitProgress);
            var originalProgress = progress;
            if (!isCenteredSlides) originalProgress = Math.min(Math.max(slideEl.originalProgress, -params.limitProgress), params.limitProgress);
            var offset = slideEl.swiperSlideOffset;
            var t = [
                swiper.params.cssMode ? -offset - swiper.translate : -offset,
                0,
                0
            ];
            var r = [
                0,
                0,
                0
            ];
            var custom = false;
            if (!swiper.isHorizontal()) {
                t[1] = t[0];
                t[0] = 0;
            }
            var data = {
                translate: [
                    0,
                    0,
                    0
                ],
                rotate: [
                    0,
                    0,
                    0
                ],
                scale: 1,
                opacity: 1
            };
            if (progress < 0) {
                data = params.next;
                custom = true;
            } else if (progress > 0) {
                data = params.prev;
                custom = true;
            }
            // set translate
            t.forEach(function(value, index) {
                t[index] = "calc(".concat(value, "px + (").concat(getTranslateValue(data.translate[index]), " * ").concat(Math.abs(progress * multiplier), "))");
            });
            // set rotates
            r.forEach(function(value, index) {
                r[index] = data.rotate[index] * Math.abs(progress * multiplier);
            });
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            var translateString = t.join(", ");
            var rotateString = "rotateX(".concat(r[0], "deg) rotateY(").concat(r[1], "deg) rotateZ(").concat(r[2], "deg)");
            var scaleString = originalProgress < 0 ? "scale(".concat(1 + (1 - data.scale) * originalProgress * multiplier, ")") : "scale(".concat(1 - (1 - data.scale) * originalProgress * multiplier, ")");
            var opacityString = originalProgress < 0 ? 1 + (1 - data.opacity) * originalProgress * multiplier : 1 - (1 - data.opacity) * originalProgress * multiplier;
            var transform = "translate3d(".concat(translateString, ") ").concat(rotateString, " ").concat(scaleString);
            // Set shadows
            if (custom && data.shadow || !custom) {
                var shadowEl = slideEl.querySelector(".swiper-slide-shadow");
                if (!shadowEl && data.shadow) shadowEl = (0, $0242e3e52b0323e3$export$2e2bcd8739ae039)(params, slideEl);
                if (shadowEl) {
                    var shadowOpacity = params.shadowPerProgress ? progress * (1 / params.limitProgress) : progress;
                    shadowEl.style.opacity = Math.min(Math.max(Math.abs(shadowOpacity), 0), 1);
                }
            }
            var targetEl = (0, $82947fd1b5606cef$export$2e2bcd8739ae039)(params, slideEl);
            targetEl.style.transform = transform;
            targetEl.style.opacity = opacityString;
            if (data.origin) targetEl.style.transformOrigin = data.origin;
        };
        var slides = swiper.slides, wrapperEl = swiper.wrapperEl, slidesSizesGrid = swiper.slidesSizesGrid;
        var params = swiper.params.creativeEffect;
        var multiplier = params.progressMultiplier;
        var isCenteredSlides = swiper.params.centeredSlides;
        if (isCenteredSlides) {
            var margin = slidesSizesGrid[0] / 2 - swiper.params.slidesOffsetBefore || 0;
            wrapperEl.style.transform = "translateX(calc(50% - ".concat(margin, "px))");
        }
        for(var i = 0; i < slides.length; i += 1)_loop(i);
    };
    var setTransition = function(duration) {
        var transformElements = swiper.slides.map(function(slideEl) {
            return (0, $2530e0d256bb8028$export$616841b86f802685)(slideEl);
        });
        transformElements.forEach(function(el) {
            el.style.transitionDuration = "".concat(duration, "ms");
            el.querySelectorAll(".swiper-slide-shadow").forEach(function(shadowEl) {
                shadowEl.style.transitionDuration = "".concat(duration, "ms");
            });
        });
        (0, $de1c1a422e0a2bda$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements,
            allSlides: true
        });
    };
    (0, $875cc300def4fdb1$export$2e2bcd8739ae039)({
        effect: "creative",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: function() {
            return swiper.params.creativeEffect.perspective;
        },
        overwriteParams: function() {
            return {
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            };
        }
    });
}







function $42ed2615f3de0d00$export$2e2bcd8739ae039(param) {
    var swiper = param.swiper, extendParams = param.extendParams, on = param.on;
    extendParams({
        cardsEffect: {
            slideShadows: true,
            rotate: true,
            perSlideRotate: 2,
            perSlideOffset: 8
        }
    });
    var setTranslate = function() {
        var slides = swiper.slides, activeIndex = swiper.activeIndex, rtl = swiper.rtlTranslate;
        var params = swiper.params.cardsEffect;
        var _swiper_touchEventsData = swiper.touchEventsData, startTranslate = _swiper_touchEventsData.startTranslate, isTouched = _swiper_touchEventsData.isTouched;
        var currentTranslate = rtl ? -swiper.translate : swiper.translate;
        for(var i = 0; i < slides.length; i += 1){
            var slideEl = slides[i];
            var slideProgress = slideEl.progress;
            var progress = Math.min(Math.max(slideProgress, -4), 4);
            var offset = slideEl.swiperSlideOffset;
            if (swiper.params.centeredSlides && !swiper.params.cssMode) swiper.wrapperEl.style.transform = "translateX(".concat(swiper.minTranslate(), "px)");
            if (swiper.params.centeredSlides && swiper.params.cssMode) offset -= slides[0].swiperSlideOffset;
            var tX = swiper.params.cssMode ? -offset - swiper.translate : -offset;
            var tY = 0;
            var tZ = -100 * Math.abs(progress);
            var scale = 1;
            var rotate = -params.perSlideRotate * progress;
            var tXAdd = params.perSlideOffset - Math.abs(progress) * 0.75;
            var slideIndex = swiper.virtual && swiper.params.virtual.enabled ? swiper.virtual.from + i : i;
            var isSwipeToNext = (slideIndex === activeIndex || slideIndex === activeIndex - 1) && progress > 0 && progress < 1 && (isTouched || swiper.params.cssMode) && currentTranslate < startTranslate;
            var isSwipeToPrev = (slideIndex === activeIndex || slideIndex === activeIndex + 1) && progress < 0 && progress > -1 && (isTouched || swiper.params.cssMode) && currentTranslate > startTranslate;
            if (isSwipeToNext || isSwipeToPrev) {
                var subProgress = Math.pow(1 - Math.abs((Math.abs(progress) - 0.5) / 0.5), 0.5);
                rotate += -28 * progress * subProgress;
                scale += -0.5 * subProgress;
                tXAdd += 96 * subProgress;
                tY = "".concat(-25 * subProgress * Math.abs(progress), "%");
            }
            if (progress < 0) // next
            tX = "calc(".concat(tX, "px ").concat(rtl ? "-" : "+", " (").concat(tXAdd * Math.abs(progress), "%))");
            else if (progress > 0) // prev
            tX = "calc(".concat(tX, "px ").concat(rtl ? "-" : "+", " (-").concat(tXAdd * Math.abs(progress), "%))");
            else tX = "".concat(tX, "px");
            if (!swiper.isHorizontal()) {
                var prevY = tY;
                tY = tX;
                tX = prevY;
            }
            var scaleString = progress < 0 ? "".concat(1 + (1 - scale) * progress) : "".concat(1 - (1 - scale) * progress);
            /* eslint-disable */ var transform = "\n        translate3d(".concat(tX, ", ").concat(tY, ", ").concat(tZ, "px)\n        rotateZ(").concat(params.rotate ? rtl ? -rotate : rotate : 0, "deg)\n        scale(").concat(scaleString, ")\n      ");
            /* eslint-enable */ if (params.slideShadows) {
                // Set shadows
                var shadowEl = slideEl.querySelector(".swiper-slide-shadow");
                if (!shadowEl) shadowEl = (0, $0242e3e52b0323e3$export$2e2bcd8739ae039)(params, slideEl);
                if (shadowEl) shadowEl.style.opacity = Math.min(Math.max((Math.abs(progress) - 0.5) / 0.5, 0), 1);
            }
            slideEl.style.zIndex = -Math.abs(Math.round(slideProgress)) + slides.length;
            var targetEl = (0, $82947fd1b5606cef$export$2e2bcd8739ae039)(params, slideEl);
            targetEl.style.transform = transform;
        }
    };
    var setTransition = function(duration) {
        var transformElements = swiper.slides.map(function(slideEl) {
            return (0, $2530e0d256bb8028$export$616841b86f802685)(slideEl);
        });
        transformElements.forEach(function(el) {
            el.style.transitionDuration = "".concat(duration, "ms");
            el.querySelectorAll(".swiper-slide-shadow").forEach(function(shadowEl) {
                shadowEl.style.transitionDuration = "".concat(duration, "ms");
            });
        });
        (0, $de1c1a422e0a2bda$export$2e2bcd8739ae039)({
            swiper: swiper,
            duration: duration,
            transformElements: transformElements
        });
    };
    (0, $875cc300def4fdb1$export$2e2bcd8739ae039)({
        effect: "cards",
        swiper: swiper,
        on: on,
        setTranslate: setTranslate,
        setTransition: setTransition,
        perspective: function() {
            return true;
        },
        overwriteParams: function() {
            return {
                watchSlidesProgress: true,
                virtualTranslate: !swiper.params.cssMode
            };
        }
    });
}




var $769c57c096b9da1a$var$swiper = new (0, $67b1addace326499$export$2e2bcd8739ae039)(".heroswiper", {
    modules: [
        (0, $1ab9a3fbacfaf36b$export$2e2bcd8739ae039),
        (0, $d52f13beb9c2eee2$export$2e2bcd8739ae039)
    ],
    loop: true,
    grabCursor: true,
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    },
    on: {
        init: function init(s) {
            /* console.log('swiper initialized'); */ var prevSlide = s.realIndex == 0 ? s.slides.length : s.realIndex;
            var nextSLide = s.realIndex == s.slides.length - 1 ? 1 : s.realIndex + 2;
            document.querySelector(".swiper-button-prev").textContent = prevSlide;
            document.querySelector(".swiper-button-next").textContent = nextSLide;
        },
        slideChange: function slideChange(s) {
            var prevSlide = s.realIndex == 0 ? s.slides.length : s.realIndex;
            var nextSLide = s.realIndex == s.slides.length - 1 ? 1 : s.realIndex + 2;
            document.querySelector(".swiper-button-prev").textContent = prevSlide;
            document.querySelector(".swiper-button-next").textContent = nextSLide;
        /* console.log('Links:' + (s.realIndex == 0 ? s.slides.length : s.realIndex));
			console.log('Rechts:'+  (s.realIndex == s.slides.length-1 ? 1 : s.realIndex + 2)); */ }
    }
});


/* import jQuery from "jquery";
window.$ = window.jQuery = jQuery; */ 
var $9862c1136591c008$var$swiper = new (0, $67b1addace326499$export$2e2bcd8739ae039)(".teaserswiper", {
    modules: [
        (0, $1ab9a3fbacfaf36b$export$2e2bcd8739ae039),
        (0, $d52f13beb9c2eee2$export$2e2bcd8739ae039)
    ],
    grabCursor: true,
    autoHeight: true,
    pagination: {
        el: ".swiper-pagination",
        clickable: true
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    }
});


/* import jQuery from "jquery";
window.$ = window.jQuery = jQuery; */ 
var $5afdf4d8fec1a746$var$swiper = new (0, $67b1addace326499$export$2e2bcd8739ae039)(".serviceswiper", {
    modules: [
        (0, $1ab9a3fbacfaf36b$export$2e2bcd8739ae039),
        (0, $d52f13beb9c2eee2$export$2e2bcd8739ae039)
    ],
    grabCursor: true,
    pagination: {
        el: ".swiper-pagination"
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    },
    slidesPerView: 1,
    spaceBetween: 40,
    breakpoints: {
        768: {
            slidesPerView: 2,
            spaceBetween: 40
        },
        1200: {
            slidesPerView: 3,
            spaceBetween: 40
        },
        1400: {
            slidesPerView: 4,
            spaceBetween: 40
        }
    }
});


/* import jQuery from "jquery";
window.$ = window.jQuery = jQuery; */ 
var $ea317e3fb1f0a3ba$var$swiper = new (0, $67b1addace326499$export$2e2bcd8739ae039)(".bigteaserswiper", {
    modules: [
        (0, $1ab9a3fbacfaf36b$export$2e2bcd8739ae039),
        (0, $d52f13beb9c2eee2$export$2e2bcd8739ae039)
    ],
    grabCursor: true,
    pagination: {
        el: ".swiper-pagination"
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    },
    slidesPerView: 1,
    spaceBetween: 0
});


/* import jQuery from "jquery";
window.$ = window.jQuery = jQuery; */ 
var $c49290bfdc251bbd$var$swiper = new (0, $67b1addace326499$export$2e2bcd8739ae039)(".smallteaserswiper", {
    modules: [
        (0, $1ab9a3fbacfaf36b$export$2e2bcd8739ae039),
        (0, $d52f13beb9c2eee2$export$2e2bcd8739ae039)
    ],
    autoplay: {
        delay: 2500,
        pauseOnMouseEnter: true,
        disableOnInteraction: false
    },
    grabCursor: true,
    pagination: {
        el: ".swiper-pagination"
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    },
    slidesPerView: 1,
    spaceBetween: 0
});


/* import jQuery from "jquery";
window.$ = window.jQuery = jQuery; */ 
var $b5f0d1895743552c$var$swiper = new (0, $67b1addace326499$export$2e2bcd8739ae039)(".objectswiper-thumbs", {
    spaceBetween: 16,
    slidesPerView: 5,
    freeMode: true,
    watchSlidesProgress: true
});
var $b5f0d1895743552c$var$swiper2 = new (0, $67b1addace326499$export$2e2bcd8739ae039)(".objectswiper", {
    modules: [
        (0, $1ab9a3fbacfaf36b$export$2e2bcd8739ae039),
        (0, $d52f13beb9c2eee2$export$2e2bcd8739ae039),
        (0, $ec33d32eb46e8073$export$2e2bcd8739ae039)
    ],
    spaceBetween: 20,
    grabCursor: true,
    autoHeight: true,
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    },
    thumbs: {
        swiper: $b5f0d1895743552c$var$swiper
    }
});


/* import $ from "jquery"; */ 

/* import jQuery from "jquery";
window.$ = window.jQuery = jQuery; */ 
var $1abcad490af8a389$var$swiper = new (0, $67b1addace326499$export$2e2bcd8739ae039)(".careerswiper", {
    modules: [
        (0, $1ab9a3fbacfaf36b$export$2e2bcd8739ae039),
        (0, $d52f13beb9c2eee2$export$2e2bcd8739ae039)
    ],
    autoplay: false,
    grabCursor: true,
    pagination: {
        el: ".swiper-pagination"
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    },
    slidesPerView: 1,
    spaceBetween: 0
});


/* import jQuery from "jquery";
window.$ = window.jQuery = jQuery; */ 
var $d8f1795d21e96042$var$swiper = new (0, $67b1addace326499$export$2e2bcd8739ae039)(".immolistswiper", {
    modules: [
        (0, $1ab9a3fbacfaf36b$export$2e2bcd8739ae039),
        (0, $d52f13beb9c2eee2$export$2e2bcd8739ae039)
    ],
    grabCursor: true,
    loop: true,
    pagination: {
        el: ".swiper-pagination"
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    },
    slidesPerView: 1,
    spaceBetween: 0
});


/* import jQuery from "jquery";
window.$ = window.jQuery = jQuery; */ 
var $fc53d4d790b715a2$var$swiper = new (0, $67b1addace326499$export$2e2bcd8739ae039)(".immodetailswiper", {
    modules: [
        (0, $1ab9a3fbacfaf36b$export$2e2bcd8739ae039),
        (0, $d52f13beb9c2eee2$export$2e2bcd8739ae039)
    ],
    grabCursor: true,
    loop: true,
    pagination: {
        el: ".swiper-pagination"
    },
    navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev"
    },
    slidesPerView: 1,
    spaceBetween: 0
});
if (document.querySelector("[data-pdf]")) document.querySelector("[data-pdf]").addEventListener("click", function(e) {
    e.preventDefault();
    var url = "https://microservice.unternehmen-online.de/document/create?config=wesermarschd&target_url=" + btoa(e.target.dataset["pdf"]);
    window.open(url, "_blank");
});


/* import jQuery from "jquery";
window.$ = window.jQuery = jQuery; */ 
var $22yUM = parcelRequire("22yUM");
function $15b6935538b1baf3$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $15b6935538b1baf3$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $15b6935538b1baf3$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $15b6935538b1baf3$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
/*!
 * Splide.js
 * Version  : 4.1.4
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */ var $15b6935538b1baf3$var$MEDIA_PREFERS_REDUCED_MOTION = "(prefers-reduced-motion: reduce)";
var $15b6935538b1baf3$var$CREATED = 1;
var $15b6935538b1baf3$var$MOUNTED = 2;
var $15b6935538b1baf3$var$IDLE = 3;
var $15b6935538b1baf3$var$MOVING = 4;
var $15b6935538b1baf3$var$SCROLLING = 5;
var $15b6935538b1baf3$var$DRAGGING = 6;
var $15b6935538b1baf3$var$DESTROYED = 7;
var $15b6935538b1baf3$var$STATES = {
    CREATED: $15b6935538b1baf3$var$CREATED,
    MOUNTED: $15b6935538b1baf3$var$MOUNTED,
    IDLE: $15b6935538b1baf3$var$IDLE,
    MOVING: $15b6935538b1baf3$var$MOVING,
    SCROLLING: $15b6935538b1baf3$var$SCROLLING,
    DRAGGING: $15b6935538b1baf3$var$DRAGGING,
    DESTROYED: $15b6935538b1baf3$var$DESTROYED
};
function $15b6935538b1baf3$var$empty(array) {
    array.length = 0;
}
function $15b6935538b1baf3$var$slice(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $15b6935538b1baf3$var$apply(func) {
    return func.bind.apply(func, [
        null
    ].concat($15b6935538b1baf3$var$slice(arguments, 1)));
}
var $15b6935538b1baf3$var$nextTick = setTimeout;
var $15b6935538b1baf3$var$noop = function noop() {};
function $15b6935538b1baf3$var$raf(func) {
    return requestAnimationFrame(func);
}
function $15b6935538b1baf3$var$typeOf(type, subject) {
    return (typeof subject === "undefined" ? "undefined" : (0, $22yUM._)(subject)) === type;
}
function $15b6935538b1baf3$var$isObject(subject) {
    return !$15b6935538b1baf3$var$isNull(subject) && $15b6935538b1baf3$var$typeOf("object", subject);
}
var $15b6935538b1baf3$var$isArray = Array.isArray;
var $15b6935538b1baf3$var$isFunction = $15b6935538b1baf3$var$apply($15b6935538b1baf3$var$typeOf, "function");
var $15b6935538b1baf3$var$isString = $15b6935538b1baf3$var$apply($15b6935538b1baf3$var$typeOf, "string");
var $15b6935538b1baf3$var$isUndefined = $15b6935538b1baf3$var$apply($15b6935538b1baf3$var$typeOf, "undefined");
function $15b6935538b1baf3$var$isNull(subject) {
    return subject === null;
}
function $15b6935538b1baf3$var$isHTMLElement(subject) {
    try {
        return subject instanceof (subject.ownerDocument.defaultView || window).HTMLElement;
    } catch (e) {
        return false;
    }
}
function $15b6935538b1baf3$var$toArray(value) {
    return $15b6935538b1baf3$var$isArray(value) ? value : [
        value
    ];
}
function $15b6935538b1baf3$var$forEach(values, iteratee) {
    $15b6935538b1baf3$var$toArray(values).forEach(iteratee);
}
function $15b6935538b1baf3$var$includes(array, value) {
    return array.indexOf(value) > -1;
}
function $15b6935538b1baf3$var$push(array, items) {
    array.push.apply(array, $15b6935538b1baf3$var$toArray(items));
    return array;
}
function $15b6935538b1baf3$var$toggleClass(elm, classes, add) {
    if (elm) $15b6935538b1baf3$var$forEach(classes, function(name) {
        if (name) elm.classList[add ? "add" : "remove"](name);
    });
}
function $15b6935538b1baf3$var$addClass(elm, classes) {
    $15b6935538b1baf3$var$toggleClass(elm, $15b6935538b1baf3$var$isString(classes) ? classes.split(" ") : classes, true);
}
function $15b6935538b1baf3$var$append(parent, children) {
    $15b6935538b1baf3$var$forEach(children, parent.appendChild.bind(parent));
}
function $15b6935538b1baf3$var$before(nodes, ref) {
    $15b6935538b1baf3$var$forEach(nodes, function(node) {
        var parent = (ref || node).parentNode;
        if (parent) parent.insertBefore(node, ref);
    });
}
function $15b6935538b1baf3$var$matches(elm, selector) {
    return $15b6935538b1baf3$var$isHTMLElement(elm) && (elm["msMatchesSelector"] || elm.matches).call(elm, selector);
}
function $15b6935538b1baf3$var$children(parent, selector) {
    var children2 = parent ? $15b6935538b1baf3$var$slice(parent.children) : [];
    return selector ? children2.filter(function(child) {
        return $15b6935538b1baf3$var$matches(child, selector);
    }) : children2;
}
function $15b6935538b1baf3$var$child(parent, selector) {
    return selector ? $15b6935538b1baf3$var$children(parent, selector)[0] : parent.firstElementChild;
}
var $15b6935538b1baf3$var$ownKeys = Object.keys;
function $15b6935538b1baf3$var$forOwn(object, iteratee, right) {
    if (object) (right ? $15b6935538b1baf3$var$ownKeys(object).reverse() : $15b6935538b1baf3$var$ownKeys(object)).forEach(function(key) {
        key !== "__proto__" && iteratee(object[key], key);
    });
    return object;
}
function $15b6935538b1baf3$var$assign(object) {
    $15b6935538b1baf3$var$slice(arguments, 1).forEach(function(source) {
        $15b6935538b1baf3$var$forOwn(source, function(value, key) {
            object[key] = source[key];
        });
    });
    return object;
}
function $15b6935538b1baf3$var$merge(object) {
    $15b6935538b1baf3$var$slice(arguments, 1).forEach(function(source) {
        $15b6935538b1baf3$var$forOwn(source, function(value, key) {
            if ($15b6935538b1baf3$var$isArray(value)) object[key] = value.slice();
            else if ($15b6935538b1baf3$var$isObject(value)) object[key] = $15b6935538b1baf3$var$merge({}, $15b6935538b1baf3$var$isObject(object[key]) ? object[key] : {}, value);
            else object[key] = value;
        });
    });
    return object;
}
function $15b6935538b1baf3$var$omit(object, keys) {
    $15b6935538b1baf3$var$forEach(keys || $15b6935538b1baf3$var$ownKeys(object), function(key) {
        delete object[key];
    });
}
function $15b6935538b1baf3$var$removeAttribute(elms, attrs) {
    $15b6935538b1baf3$var$forEach(elms, function(elm) {
        $15b6935538b1baf3$var$forEach(attrs, function(attr) {
            elm && elm.removeAttribute(attr);
        });
    });
}
function $15b6935538b1baf3$var$setAttribute(elms, attrs, value) {
    if ($15b6935538b1baf3$var$isObject(attrs)) $15b6935538b1baf3$var$forOwn(attrs, function(value2, name) {
        $15b6935538b1baf3$var$setAttribute(elms, name, value2);
    });
    else $15b6935538b1baf3$var$forEach(elms, function(elm) {
        $15b6935538b1baf3$var$isNull(value) || value === "" ? $15b6935538b1baf3$var$removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
}
function $15b6935538b1baf3$var$create(tag, attrs, parent) {
    var elm = document.createElement(tag);
    if (attrs) $15b6935538b1baf3$var$isString(attrs) ? $15b6935538b1baf3$var$addClass(elm, attrs) : $15b6935538b1baf3$var$setAttribute(elm, attrs);
    parent && $15b6935538b1baf3$var$append(parent, elm);
    return elm;
}
function $15b6935538b1baf3$var$style(elm, prop, value) {
    if ($15b6935538b1baf3$var$isUndefined(value)) return getComputedStyle(elm)[prop];
    if (!$15b6935538b1baf3$var$isNull(value)) elm.style[prop] = "" + value;
}
function $15b6935538b1baf3$var$display(elm, display2) {
    $15b6935538b1baf3$var$style(elm, "display", display2);
}
function $15b6935538b1baf3$var$focus(elm) {
    elm["setActive"] && elm["setActive"]() || elm.focus({
        preventScroll: true
    });
}
function $15b6935538b1baf3$var$getAttribute(elm, attr) {
    return elm.getAttribute(attr);
}
function $15b6935538b1baf3$var$hasClass(elm, className) {
    return elm && elm.classList.contains(className);
}
function $15b6935538b1baf3$var$rect(target) {
    return target.getBoundingClientRect();
}
function $15b6935538b1baf3$var$remove(nodes) {
    $15b6935538b1baf3$var$forEach(nodes, function(node) {
        if (node && node.parentNode) node.parentNode.removeChild(node);
    });
}
function $15b6935538b1baf3$var$parseHtml(html) {
    return $15b6935538b1baf3$var$child(new DOMParser().parseFromString(html, "text/html").body);
}
function $15b6935538b1baf3$var$prevent(e, stopPropagation) {
    e.preventDefault();
    if (stopPropagation) {
        e.stopPropagation();
        e.stopImmediatePropagation();
    }
}
function $15b6935538b1baf3$var$query(parent, selector) {
    return parent && parent.querySelector(selector);
}
function $15b6935538b1baf3$var$queryAll(parent, selector) {
    return selector ? $15b6935538b1baf3$var$slice(parent.querySelectorAll(selector)) : [];
}
function $15b6935538b1baf3$var$removeClass(elm, classes) {
    $15b6935538b1baf3$var$toggleClass(elm, classes, false);
}
function $15b6935538b1baf3$var$timeOf(e) {
    return e.timeStamp;
}
function $15b6935538b1baf3$var$unit(value) {
    return $15b6935538b1baf3$var$isString(value) ? value : value ? value + "px" : "";
}
var $15b6935538b1baf3$var$PROJECT_CODE = "splide";
var $15b6935538b1baf3$var$DATA_ATTRIBUTE = "data-" + $15b6935538b1baf3$var$PROJECT_CODE;
function $15b6935538b1baf3$var$assert(condition, message) {
    if (!condition) throw new Error("[" + $15b6935538b1baf3$var$PROJECT_CODE + "] " + (message || ""));
}
var $15b6935538b1baf3$var$min = Math.min, $15b6935538b1baf3$var$max = Math.max, $15b6935538b1baf3$var$floor = Math.floor, $15b6935538b1baf3$var$ceil = Math.ceil, $15b6935538b1baf3$var$abs = Math.abs;
function $15b6935538b1baf3$var$approximatelyEqual(x, y, epsilon) {
    return $15b6935538b1baf3$var$abs(x - y) < epsilon;
}
function $15b6935538b1baf3$var$between(number, x, y, exclusive) {
    var minimum = $15b6935538b1baf3$var$min(x, y);
    var maximum = $15b6935538b1baf3$var$max(x, y);
    return exclusive ? minimum < number && number < maximum : minimum <= number && number <= maximum;
}
function $15b6935538b1baf3$var$clamp(number, x, y) {
    var minimum = $15b6935538b1baf3$var$min(x, y);
    var maximum = $15b6935538b1baf3$var$max(x, y);
    return $15b6935538b1baf3$var$min($15b6935538b1baf3$var$max(minimum, number), maximum);
}
function $15b6935538b1baf3$var$sign(x) {
    return +(x > 0) - +(x < 0);
}
function $15b6935538b1baf3$var$camelToKebab(string) {
    return string.replace(/([a-z0-9])([A-Z])/g, "$1-$2").toLowerCase();
}
function $15b6935538b1baf3$var$format(string, replacements) {
    $15b6935538b1baf3$var$forEach(replacements, function(replacement) {
        string = string.replace("%s", "" + replacement);
    });
    return string;
}
function $15b6935538b1baf3$var$pad(number) {
    return number < 10 ? "0" + number : "" + number;
}
var $15b6935538b1baf3$var$ids = {};
function $15b6935538b1baf3$var$uniqueId(prefix) {
    return "" + prefix + $15b6935538b1baf3$var$pad($15b6935538b1baf3$var$ids[prefix] = ($15b6935538b1baf3$var$ids[prefix] || 0) + 1);
}
function $15b6935538b1baf3$export$c473e36ef1bda729() {
    var bind = function bind(targets, events, callback, options) {
        forEachEvent(targets, events, function(target, event, namespace) {
            var isEventTarget = "addEventListener" in target;
            var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
            isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
            listeners.push([
                target,
                event,
                namespace,
                callback,
                remover
            ]);
        });
    };
    var unbind = function unbind(targets, events, callback) {
        forEachEvent(targets, events, function(target, event, namespace) {
            listeners = listeners.filter(function(listener) {
                if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
                    listener[4]();
                    return false;
                }
                return true;
            });
        });
    };
    var dispatch = function dispatch(target, type, detail) {
        var e;
        var bubbles = true;
        if (typeof CustomEvent === "function") e = new CustomEvent(type, {
            bubbles: bubbles,
            detail: detail
        });
        else {
            e = document.createEvent("CustomEvent");
            e.initCustomEvent(type, bubbles, false, detail);
        }
        target.dispatchEvent(e);
        return e;
    };
    var forEachEvent = function forEachEvent(targets, events, iteratee) {
        $15b6935538b1baf3$var$forEach(targets, function(target) {
            target && $15b6935538b1baf3$var$forEach(events, function(events2) {
                events2.split(" ").forEach(function(eventNS) {
                    var fragment = eventNS.split(".");
                    iteratee(target, fragment[0], fragment[1]);
                });
            });
        });
    };
    var destroy = function destroy() {
        listeners.forEach(function(data) {
            data[4]();
        });
        $15b6935538b1baf3$var$empty(listeners);
    };
    var listeners = [];
    return {
        bind: bind,
        unbind: unbind,
        dispatch: dispatch,
        destroy: destroy
    };
}
var $15b6935538b1baf3$export$d300dc1a2634364b = "mounted";
var $15b6935538b1baf3$export$d8dac49b4532735a = "ready";
var $15b6935538b1baf3$export$2aa493d7c3275167 = "move";
var $15b6935538b1baf3$export$fe5802204b967f0d = "moved";
var $15b6935538b1baf3$export$5adb665701eda1ce = "click";
var $15b6935538b1baf3$export$92e3eae133acac4c = "active";
var $15b6935538b1baf3$export$6bcbb81035c12cea = "inactive";
var $15b6935538b1baf3$export$6a5b3445e4066a53 = "visible";
var $15b6935538b1baf3$export$8c5c7a21d54563e9 = "hidden";
var $15b6935538b1baf3$export$7f4701ac5e05e39f = "refresh";
var $15b6935538b1baf3$export$db40ab7c0855fa5c = "updated";
var $15b6935538b1baf3$export$7e019dae5103a285 = "resize";
var $15b6935538b1baf3$export$d637eba1e9e28482 = "resized";
var $15b6935538b1baf3$export$e84bf5065c9087ac = "drag";
var $15b6935538b1baf3$export$8e9f636d2c722196 = "dragging";
var $15b6935538b1baf3$export$90ea576bd3fdeb60 = "dragged";
var $15b6935538b1baf3$export$49801896908b5e33 = "scroll";
var $15b6935538b1baf3$export$ff8164bff3202b9 = "scrolled";
var $15b6935538b1baf3$export$6cbac5b662a31e1b = "overflow";
var $15b6935538b1baf3$export$88c4cf7419e470cd = "destroy";
var $15b6935538b1baf3$export$8647f6b043e04e9d = "arrows:mounted";
var $15b6935538b1baf3$export$d467f9343b961f75 = "arrows:updated";
var $15b6935538b1baf3$export$bf89a4e4349c9778 = "pagination:mounted";
var $15b6935538b1baf3$export$eb2019082ed6de0b = "pagination:updated";
var $15b6935538b1baf3$export$84015c33508f94ec = "navigation:mounted";
var $15b6935538b1baf3$export$23663268a31b79e2 = "autoplay:play";
var $15b6935538b1baf3$export$185723258309b608 = "autoplay:playing";
var $15b6935538b1baf3$export$16a1e4f3d0368265 = "autoplay:pause";
var $15b6935538b1baf3$export$9f64346e17f0ec8e = "lazyload:loaded";
var $15b6935538b1baf3$export$6d5af59619d10e6a = "sk";
var $15b6935538b1baf3$export$f0af896383d5adff = "sh";
var $15b6935538b1baf3$export$28dea85f216954dc = "ei";
function $15b6935538b1baf3$export$f188226459c8a3ff(Splide2) {
    var on = function on(events, callback) {
        binder.bind(bus, $15b6935538b1baf3$var$toArray(events).join(" "), function(e) {
            callback.apply(callback, $15b6935538b1baf3$var$isArray(e.detail) ? e.detail : []);
        });
    };
    var emit = function emit(event) {
        binder.dispatch(bus, event, $15b6935538b1baf3$var$slice(arguments, 1));
    };
    var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
    var binder = $15b6935538b1baf3$export$c473e36ef1bda729();
    if (Splide2) Splide2.event.on($15b6935538b1baf3$export$88c4cf7419e470cd, binder.destroy);
    return $15b6935538b1baf3$var$assign(binder, {
        bus: bus,
        on: on,
        off: $15b6935538b1baf3$var$apply(binder.unbind, bus),
        emit: emit
    });
}
function $15b6935538b1baf3$export$46ad21b25b6dccf0(interval, onInterval, onUpdate, limit) {
    var start = function start(resume) {
        resume || cancel();
        startTime = now() - (resume ? rate * interval : 0);
        paused = false;
        id = $15b6935538b1baf3$var$raf(update);
    };
    var pause = function pause() {
        paused = true;
    };
    var rewind = function rewind() {
        startTime = now();
        rate = 0;
        if (onUpdate) onUpdate(rate);
    };
    var cancel = function cancel() {
        id && cancelAnimationFrame(id);
        rate = 0;
        id = 0;
        paused = true;
    };
    var set = function set(time) {
        interval = time;
    };
    var isPaused = function isPaused() {
        return paused;
    };
    var now = Date.now;
    var startTime;
    var rate = 0;
    var id;
    var paused = true;
    var count = 0;
    function update() {
        if (!paused) {
            rate = interval ? $15b6935538b1baf3$var$min((now() - startTime) / interval, 1) : 1;
            onUpdate && onUpdate(rate);
            if (rate >= 1) {
                onInterval();
                startTime = now();
                if (limit && ++count >= limit) return pause();
            }
            id = $15b6935538b1baf3$var$raf(update);
        }
    }
    return {
        start: start,
        rewind: rewind,
        pause: pause,
        cancel: cancel,
        set: set,
        isPaused: isPaused
    };
}
function $15b6935538b1baf3$export$7254cc27399e90bd(initialState) {
    var set = function set(value) {
        state = value;
    };
    var is = function is(states) {
        return $15b6935538b1baf3$var$includes($15b6935538b1baf3$var$toArray(states), state);
    };
    var state = initialState;
    return {
        set: set,
        is: is
    };
}
function $15b6935538b1baf3$export$efff0f5979573c99(func, duration) {
    var interval = $15b6935538b1baf3$export$46ad21b25b6dccf0(duration || 0, func, null, 1);
    return function() {
        interval.isPaused() && interval.start();
    };
}
function $15b6935538b1baf3$var$Media(Splide2, Components2, options) {
    var setup = function setup() {
        var isMin = options.mediaQuery === "min";
        $15b6935538b1baf3$var$ownKeys(breakpoints).sort(function(n, m) {
            return isMin ? +n - +m : +m - +n;
        }).forEach(function(key) {
            register(breakpoints[key], "(" + (isMin ? "min" : "max") + "-width:" + key + "px)");
        });
        register(reducedMotion, $15b6935538b1baf3$var$MEDIA_PREFERS_REDUCED_MOTION);
        update();
    };
    var destroy = function destroy(completely) {
        if (completely) binder.destroy();
    };
    var register = function register(options2, query) {
        var queryList = matchMedia(query);
        binder.bind(queryList, "change", update);
        queries.push([
            options2,
            queryList
        ]);
    };
    var update = function update() {
        var destroyed = state.is($15b6935538b1baf3$var$DESTROYED);
        var direction = options.direction;
        var merged = queries.reduce(function(merged2, entry) {
            return $15b6935538b1baf3$var$merge(merged2, entry[1].matches ? entry[0] : {});
        }, {});
        $15b6935538b1baf3$var$omit(options);
        set(merged);
        if (options.destroy) Splide2.destroy(options.destroy === "completely");
        else if (destroyed) {
            destroy(true);
            Splide2.mount();
        } else direction !== options.direction && Splide2.refresh();
    };
    var reduce = function reduce(enable) {
        if (matchMedia($15b6935538b1baf3$var$MEDIA_PREFERS_REDUCED_MOTION).matches) enable ? $15b6935538b1baf3$var$merge(options, reducedMotion) : $15b6935538b1baf3$var$omit(options, $15b6935538b1baf3$var$ownKeys(reducedMotion));
    };
    var set = function set(opts, base, notify) {
        $15b6935538b1baf3$var$merge(options, opts);
        base && $15b6935538b1baf3$var$merge(Object.getPrototypeOf(options), opts);
        if (notify || !state.is($15b6935538b1baf3$var$CREATED)) Splide2.emit($15b6935538b1baf3$export$db40ab7c0855fa5c, options);
    };
    var state = Splide2.state;
    var breakpoints = options.breakpoints || {};
    var reducedMotion = options.reducedMotion || {};
    var binder = $15b6935538b1baf3$export$c473e36ef1bda729();
    var queries = [];
    return {
        setup: setup,
        destroy: destroy,
        reduce: reduce,
        set: set
    };
}
var $15b6935538b1baf3$var$ARROW = "Arrow";
var $15b6935538b1baf3$var$ARROW_LEFT = $15b6935538b1baf3$var$ARROW + "Left";
var $15b6935538b1baf3$var$ARROW_RIGHT = $15b6935538b1baf3$var$ARROW + "Right";
var $15b6935538b1baf3$var$ARROW_UP = $15b6935538b1baf3$var$ARROW + "Up";
var $15b6935538b1baf3$var$ARROW_DOWN = $15b6935538b1baf3$var$ARROW + "Down";
var $15b6935538b1baf3$export$373e92e0788ff06e = "ltr";
var $15b6935538b1baf3$export$850f7749a2909601 = "rtl";
var $15b6935538b1baf3$export$97170d9824b89709 = "ttb";
var $15b6935538b1baf3$var$ORIENTATION_MAP = {
    width: [
        "height"
    ],
    left: [
        "top",
        "right"
    ],
    right: [
        "bottom",
        "left"
    ],
    x: [
        "y"
    ],
    X: [
        "Y"
    ],
    Y: [
        "X"
    ],
    ArrowLeft: [
        $15b6935538b1baf3$var$ARROW_UP,
        $15b6935538b1baf3$var$ARROW_RIGHT
    ],
    ArrowRight: [
        $15b6935538b1baf3$var$ARROW_DOWN,
        $15b6935538b1baf3$var$ARROW_LEFT
    ]
};
function $15b6935538b1baf3$var$Direction(Splide2, Components2, options) {
    var resolve = function resolve(prop, axisOnly, direction) {
        direction = direction || options.direction;
        var index = direction === $15b6935538b1baf3$export$850f7749a2909601 && !axisOnly ? 1 : direction === $15b6935538b1baf3$export$97170d9824b89709 ? 0 : -1;
        return $15b6935538b1baf3$var$ORIENTATION_MAP[prop] && $15b6935538b1baf3$var$ORIENTATION_MAP[prop][index] || prop.replace(/width|left|right/i, function(match, offset) {
            var replacement = $15b6935538b1baf3$var$ORIENTATION_MAP[match.toLowerCase()][index] || match;
            return offset > 0 ? replacement.charAt(0).toUpperCase() + replacement.slice(1) : replacement;
        });
    };
    var orient = function orient(value) {
        return value * (options.direction === $15b6935538b1baf3$export$850f7749a2909601 ? 1 : -1);
    };
    return {
        resolve: resolve,
        orient: orient
    };
}
var $15b6935538b1baf3$var$ROLE = "role";
var $15b6935538b1baf3$var$TAB_INDEX = "tabindex";
var $15b6935538b1baf3$var$DISABLED = "disabled";
var $15b6935538b1baf3$var$ARIA_PREFIX = "aria-";
var $15b6935538b1baf3$var$ARIA_CONTROLS = $15b6935538b1baf3$var$ARIA_PREFIX + "controls";
var $15b6935538b1baf3$var$ARIA_CURRENT = $15b6935538b1baf3$var$ARIA_PREFIX + "current";
var $15b6935538b1baf3$var$ARIA_SELECTED = $15b6935538b1baf3$var$ARIA_PREFIX + "selected";
var $15b6935538b1baf3$var$ARIA_LABEL = $15b6935538b1baf3$var$ARIA_PREFIX + "label";
var $15b6935538b1baf3$var$ARIA_LABELLEDBY = $15b6935538b1baf3$var$ARIA_PREFIX + "labelledby";
var $15b6935538b1baf3$var$ARIA_HIDDEN = $15b6935538b1baf3$var$ARIA_PREFIX + "hidden";
var $15b6935538b1baf3$var$ARIA_ORIENTATION = $15b6935538b1baf3$var$ARIA_PREFIX + "orientation";
var $15b6935538b1baf3$var$ARIA_ROLEDESCRIPTION = $15b6935538b1baf3$var$ARIA_PREFIX + "roledescription";
var $15b6935538b1baf3$var$ARIA_LIVE = $15b6935538b1baf3$var$ARIA_PREFIX + "live";
var $15b6935538b1baf3$var$ARIA_BUSY = $15b6935538b1baf3$var$ARIA_PREFIX + "busy";
var $15b6935538b1baf3$var$ARIA_ATOMIC = $15b6935538b1baf3$var$ARIA_PREFIX + "atomic";
var $15b6935538b1baf3$var$ALL_ATTRIBUTES = [
    $15b6935538b1baf3$var$ROLE,
    $15b6935538b1baf3$var$TAB_INDEX,
    $15b6935538b1baf3$var$DISABLED,
    $15b6935538b1baf3$var$ARIA_CONTROLS,
    $15b6935538b1baf3$var$ARIA_CURRENT,
    $15b6935538b1baf3$var$ARIA_LABEL,
    $15b6935538b1baf3$var$ARIA_LABELLEDBY,
    $15b6935538b1baf3$var$ARIA_HIDDEN,
    $15b6935538b1baf3$var$ARIA_ORIENTATION,
    $15b6935538b1baf3$var$ARIA_ROLEDESCRIPTION
];
var $15b6935538b1baf3$var$CLASS_PREFIX = $15b6935538b1baf3$var$PROJECT_CODE + "__";
var $15b6935538b1baf3$var$STATUS_CLASS_PREFIX = "is-";
var $15b6935538b1baf3$export$93b21159ad85c843 = $15b6935538b1baf3$var$PROJECT_CODE;
var $15b6935538b1baf3$export$7738b09ac0a98952 = $15b6935538b1baf3$var$CLASS_PREFIX + "track";
var $15b6935538b1baf3$export$19cc2a5451235cae = $15b6935538b1baf3$var$CLASS_PREFIX + "list";
var $15b6935538b1baf3$export$8d922915837a38d3 = $15b6935538b1baf3$var$CLASS_PREFIX + "slide";
var $15b6935538b1baf3$export$2c1ba4a4f1aa4947 = $15b6935538b1baf3$export$8d922915837a38d3 + "--clone";
var $15b6935538b1baf3$export$e9ba7e444ba60a12 = $15b6935538b1baf3$export$8d922915837a38d3 + "__container";
var $15b6935538b1baf3$export$a26cbd955fecf11e = $15b6935538b1baf3$var$CLASS_PREFIX + "arrows";
var $15b6935538b1baf3$export$516e7d18e13a2dca = $15b6935538b1baf3$var$CLASS_PREFIX + "arrow";
var $15b6935538b1baf3$export$58ea3db24c33b76 = $15b6935538b1baf3$export$516e7d18e13a2dca + "--prev";
var $15b6935538b1baf3$export$4885afd7098a65c2 = $15b6935538b1baf3$export$516e7d18e13a2dca + "--next";
var $15b6935538b1baf3$export$cbf8e5a0ab95eda3 = $15b6935538b1baf3$var$CLASS_PREFIX + "pagination";
var $15b6935538b1baf3$export$52f2cca6a5eee805 = $15b6935538b1baf3$export$cbf8e5a0ab95eda3 + "__page";
var $15b6935538b1baf3$export$4c82dc32b1c4ace5 = $15b6935538b1baf3$var$CLASS_PREFIX + "progress";
var $15b6935538b1baf3$export$2c9b091c749f4409 = $15b6935538b1baf3$export$4c82dc32b1c4ace5 + "__bar";
var $15b6935538b1baf3$export$a29701deef84b825 = $15b6935538b1baf3$var$CLASS_PREFIX + "toggle";
var $15b6935538b1baf3$export$d9d247d51b430dbb = $15b6935538b1baf3$export$a29701deef84b825 + "__play";
var $15b6935538b1baf3$export$3529f201a419925b = $15b6935538b1baf3$export$a29701deef84b825 + "__pause";
var $15b6935538b1baf3$export$3e5381ee3fab8374 = $15b6935538b1baf3$var$CLASS_PREFIX + "spinner";
var $15b6935538b1baf3$export$bb78d7c200da8960 = $15b6935538b1baf3$var$CLASS_PREFIX + "sr";
var $15b6935538b1baf3$export$7761661e2d5b9388 = $15b6935538b1baf3$var$STATUS_CLASS_PREFIX + "initialized";
var $15b6935538b1baf3$export$72d36ecf3758cb4b = $15b6935538b1baf3$var$STATUS_CLASS_PREFIX + "active";
var $15b6935538b1baf3$export$e423ac4972f5e196 = $15b6935538b1baf3$var$STATUS_CLASS_PREFIX + "prev";
var $15b6935538b1baf3$export$457a2d20827a2779 = $15b6935538b1baf3$var$STATUS_CLASS_PREFIX + "next";
var $15b6935538b1baf3$export$53ca4621bbab9a = $15b6935538b1baf3$var$STATUS_CLASS_PREFIX + "visible";
var $15b6935538b1baf3$export$d22ec4ccb7996ba2 = $15b6935538b1baf3$var$STATUS_CLASS_PREFIX + "loading";
var $15b6935538b1baf3$export$b6f202a162a09100 = $15b6935538b1baf3$var$STATUS_CLASS_PREFIX + "focus-in";
var $15b6935538b1baf3$export$cd908cd1dd625e29 = $15b6935538b1baf3$var$STATUS_CLASS_PREFIX + "overflow";
var $15b6935538b1baf3$export$49f9eaea10ebf193 = [
    $15b6935538b1baf3$export$72d36ecf3758cb4b,
    $15b6935538b1baf3$export$53ca4621bbab9a,
    $15b6935538b1baf3$export$e423ac4972f5e196,
    $15b6935538b1baf3$export$457a2d20827a2779,
    $15b6935538b1baf3$export$d22ec4ccb7996ba2,
    $15b6935538b1baf3$export$b6f202a162a09100,
    $15b6935538b1baf3$export$cd908cd1dd625e29
];
var $15b6935538b1baf3$export$ba41d43e4a419565 = {
    slide: $15b6935538b1baf3$export$8d922915837a38d3,
    clone: $15b6935538b1baf3$export$2c1ba4a4f1aa4947,
    arrows: $15b6935538b1baf3$export$a26cbd955fecf11e,
    arrow: $15b6935538b1baf3$export$516e7d18e13a2dca,
    prev: $15b6935538b1baf3$export$58ea3db24c33b76,
    next: $15b6935538b1baf3$export$4885afd7098a65c2,
    pagination: $15b6935538b1baf3$export$cbf8e5a0ab95eda3,
    page: $15b6935538b1baf3$export$52f2cca6a5eee805,
    spinner: $15b6935538b1baf3$export$3e5381ee3fab8374
};
function $15b6935538b1baf3$var$closest(from, selector) {
    if ($15b6935538b1baf3$var$isFunction(from.closest)) return from.closest(selector);
    var elm = from;
    while(elm && elm.nodeType === 1){
        if ($15b6935538b1baf3$var$matches(elm, selector)) break;
        elm = elm.parentElement;
    }
    return elm;
}
var $15b6935538b1baf3$var$FRICTION = 5;
var $15b6935538b1baf3$var$LOG_INTERVAL = 200;
var $15b6935538b1baf3$var$POINTER_DOWN_EVENTS = "touchstart mousedown";
var $15b6935538b1baf3$var$POINTER_MOVE_EVENTS = "touchmove mousemove";
var $15b6935538b1baf3$var$POINTER_UP_EVENTS = "touchend touchcancel mouseup click";
function $15b6935538b1baf3$var$Elements(Splide2, Components2, options) {
    var setup = function setup() {
        collect();
        init();
        update();
    };
    var mount = function mount() {
        on($15b6935538b1baf3$export$7f4701ac5e05e39f, destroy);
        on($15b6935538b1baf3$export$7f4701ac5e05e39f, setup);
        on($15b6935538b1baf3$export$db40ab7c0855fa5c, update);
        bind(document, $15b6935538b1baf3$var$POINTER_DOWN_EVENTS + " keydown", function(e) {
            isUsingKey = e.type === "keydown";
        }, {
            capture: true
        });
        bind(root, "focusin", function() {
            $15b6935538b1baf3$var$toggleClass(root, $15b6935538b1baf3$export$b6f202a162a09100, !!isUsingKey);
        });
    };
    var destroy = function destroy(completely) {
        var attrs = $15b6935538b1baf3$var$ALL_ATTRIBUTES.concat("style");
        $15b6935538b1baf3$var$empty(slides);
        $15b6935538b1baf3$var$removeClass(root, rootClasses);
        $15b6935538b1baf3$var$removeClass(track, trackClasses);
        $15b6935538b1baf3$var$removeAttribute([
            track,
            list
        ], attrs);
        $15b6935538b1baf3$var$removeAttribute(root, completely ? attrs : [
            "style",
            $15b6935538b1baf3$var$ARIA_ROLEDESCRIPTION
        ]);
    };
    var update = function update() {
        $15b6935538b1baf3$var$removeClass(root, rootClasses);
        $15b6935538b1baf3$var$removeClass(track, trackClasses);
        rootClasses = getClasses($15b6935538b1baf3$export$93b21159ad85c843);
        trackClasses = getClasses($15b6935538b1baf3$export$7738b09ac0a98952);
        $15b6935538b1baf3$var$addClass(root, rootClasses);
        $15b6935538b1baf3$var$addClass(track, trackClasses);
        $15b6935538b1baf3$var$setAttribute(root, $15b6935538b1baf3$var$ARIA_LABEL, options.label);
        $15b6935538b1baf3$var$setAttribute(root, $15b6935538b1baf3$var$ARIA_LABELLEDBY, options.labelledby);
    };
    var collect = function collect() {
        track = find("." + $15b6935538b1baf3$export$7738b09ac0a98952);
        list = $15b6935538b1baf3$var$child(track, "." + $15b6935538b1baf3$export$19cc2a5451235cae);
        $15b6935538b1baf3$var$assert(track && list, "A track/list element is missing.");
        $15b6935538b1baf3$var$push(slides, $15b6935538b1baf3$var$children(list, "." + $15b6935538b1baf3$export$8d922915837a38d3 + ":not(." + $15b6935538b1baf3$export$2c1ba4a4f1aa4947 + ")"));
        $15b6935538b1baf3$var$forOwn({
            arrows: $15b6935538b1baf3$export$a26cbd955fecf11e,
            pagination: $15b6935538b1baf3$export$cbf8e5a0ab95eda3,
            prev: $15b6935538b1baf3$export$58ea3db24c33b76,
            next: $15b6935538b1baf3$export$4885afd7098a65c2,
            bar: $15b6935538b1baf3$export$2c9b091c749f4409,
            toggle: $15b6935538b1baf3$export$a29701deef84b825
        }, function(className, key) {
            elements[key] = find("." + className);
        });
        $15b6935538b1baf3$var$assign(elements, {
            root: root,
            track: track,
            list: list,
            slides: slides
        });
    };
    var init = function init() {
        var id = root.id || $15b6935538b1baf3$var$uniqueId($15b6935538b1baf3$var$PROJECT_CODE);
        var role = options.role;
        root.id = id;
        track.id = track.id || id + "-track";
        list.id = list.id || id + "-list";
        if (!$15b6935538b1baf3$var$getAttribute(root, $15b6935538b1baf3$var$ROLE) && root.tagName !== "SECTION" && role) $15b6935538b1baf3$var$setAttribute(root, $15b6935538b1baf3$var$ROLE, role);
        $15b6935538b1baf3$var$setAttribute(root, $15b6935538b1baf3$var$ARIA_ROLEDESCRIPTION, i18n.carousel);
        $15b6935538b1baf3$var$setAttribute(list, $15b6935538b1baf3$var$ROLE, "presentation");
    };
    var find = function find(selector) {
        var elm = $15b6935538b1baf3$var$query(root, selector);
        return elm && $15b6935538b1baf3$var$closest(elm, "." + $15b6935538b1baf3$export$93b21159ad85c843) === root ? elm : void 0;
    };
    var getClasses = function getClasses(base) {
        return [
            base + "--" + options.type,
            base + "--" + options.direction,
            options.drag && base + "--draggable",
            options.isNavigation && base + "--nav",
            base === $15b6935538b1baf3$export$93b21159ad85c843 && $15b6935538b1baf3$export$72d36ecf3758cb4b
        ];
    };
    var _EventInterface = $15b6935538b1baf3$export$f188226459c8a3ff(Splide2), on = _EventInterface.on, bind = _EventInterface.bind;
    var root = Splide2.root;
    var i18n = options.i18n;
    var elements = {};
    var slides = [];
    var rootClasses = [];
    var trackClasses = [];
    var track;
    var list;
    var isUsingKey;
    return $15b6935538b1baf3$var$assign(elements, {
        setup: setup,
        mount: mount,
        destroy: destroy
    });
}
var $15b6935538b1baf3$export$e5a58a5ee5b54c22 = "slide";
var $15b6935538b1baf3$export$f42383286ed1223d = "loop";
var $15b6935538b1baf3$export$742b62a5690c060 = "fade";
function $15b6935538b1baf3$var$Slide$1(Splide2, index, slideIndex, slide) {
    var mount = function mount() {
        if (!isClone) {
            slide.id = root.id + "-slide" + $15b6935538b1baf3$var$pad(index + 1);
            $15b6935538b1baf3$var$setAttribute(slide, $15b6935538b1baf3$var$ROLE, pagination ? "tabpanel" : "group");
            $15b6935538b1baf3$var$setAttribute(slide, $15b6935538b1baf3$var$ARIA_ROLEDESCRIPTION, i18n.slide);
            $15b6935538b1baf3$var$setAttribute(slide, $15b6935538b1baf3$var$ARIA_LABEL, label || $15b6935538b1baf3$var$format(i18n.slideLabel, [
                index + 1,
                Splide2.length
            ]));
        }
        listen();
    };
    var listen = function listen() {
        bind(slide, "click", $15b6935538b1baf3$var$apply(emit, $15b6935538b1baf3$export$5adb665701eda1ce, self));
        bind(slide, "keydown", $15b6935538b1baf3$var$apply(emit, $15b6935538b1baf3$export$6d5af59619d10e6a, self));
        on([
            $15b6935538b1baf3$export$fe5802204b967f0d,
            $15b6935538b1baf3$export$f0af896383d5adff,
            $15b6935538b1baf3$export$ff8164bff3202b9
        ], update);
        on($15b6935538b1baf3$export$84015c33508f94ec, initNavigation);
        if (updateOnMove) on($15b6935538b1baf3$export$2aa493d7c3275167, onMove);
    };
    var destroy = function destroy() {
        destroyed = true;
        event.destroy();
        $15b6935538b1baf3$var$removeClass(slide, $15b6935538b1baf3$export$49f9eaea10ebf193);
        $15b6935538b1baf3$var$removeAttribute(slide, $15b6935538b1baf3$var$ALL_ATTRIBUTES);
        $15b6935538b1baf3$var$setAttribute(slide, "style", styles);
        $15b6935538b1baf3$var$setAttribute(slide, $15b6935538b1baf3$var$ARIA_LABEL, label || "");
    };
    var initNavigation = function initNavigation() {
        var controls = Splide2.splides.map(function(target) {
            var Slide2 = target.splide.Components.Slides.getAt(index);
            return Slide2 ? Slide2.slide.id : "";
        }).join(" ");
        $15b6935538b1baf3$var$setAttribute(slide, $15b6935538b1baf3$var$ARIA_LABEL, $15b6935538b1baf3$var$format(i18n.slideX, (isClone ? slideIndex : index) + 1));
        $15b6935538b1baf3$var$setAttribute(slide, $15b6935538b1baf3$var$ARIA_CONTROLS, controls);
        $15b6935538b1baf3$var$setAttribute(slide, $15b6935538b1baf3$var$ROLE, slideFocus ? "button" : "");
        slideFocus && $15b6935538b1baf3$var$removeAttribute(slide, $15b6935538b1baf3$var$ARIA_ROLEDESCRIPTION);
    };
    var onMove = function onMove() {
        if (!destroyed) update();
    };
    var update = function update() {
        if (!destroyed) {
            var curr = Splide2.index;
            updateActivity();
            updateVisibility();
            $15b6935538b1baf3$var$toggleClass(slide, $15b6935538b1baf3$export$e423ac4972f5e196, index === curr - 1);
            $15b6935538b1baf3$var$toggleClass(slide, $15b6935538b1baf3$export$457a2d20827a2779, index === curr + 1);
        }
    };
    var updateActivity = function updateActivity() {
        var active = isActive();
        if (active !== $15b6935538b1baf3$var$hasClass(slide, $15b6935538b1baf3$export$72d36ecf3758cb4b)) {
            $15b6935538b1baf3$var$toggleClass(slide, $15b6935538b1baf3$export$72d36ecf3758cb4b, active);
            $15b6935538b1baf3$var$setAttribute(slide, $15b6935538b1baf3$var$ARIA_CURRENT, isNavigation && active || "");
            emit(active ? $15b6935538b1baf3$export$92e3eae133acac4c : $15b6935538b1baf3$export$6bcbb81035c12cea, self);
        }
    };
    var updateVisibility = function updateVisibility() {
        var visible = isVisible();
        var hidden = !visible && (!isActive() || isClone);
        if (!Splide2.state.is([
            $15b6935538b1baf3$var$MOVING,
            $15b6935538b1baf3$var$SCROLLING
        ])) $15b6935538b1baf3$var$setAttribute(slide, $15b6935538b1baf3$var$ARIA_HIDDEN, hidden || "");
        $15b6935538b1baf3$var$setAttribute($15b6935538b1baf3$var$queryAll(slide, options.focusableNodes || ""), $15b6935538b1baf3$var$TAB_INDEX, hidden ? -1 : "");
        if (slideFocus) $15b6935538b1baf3$var$setAttribute(slide, $15b6935538b1baf3$var$TAB_INDEX, hidden ? -1 : 0);
        if (visible !== $15b6935538b1baf3$var$hasClass(slide, $15b6935538b1baf3$export$53ca4621bbab9a)) {
            $15b6935538b1baf3$var$toggleClass(slide, $15b6935538b1baf3$export$53ca4621bbab9a, visible);
            emit(visible ? $15b6935538b1baf3$export$6a5b3445e4066a53 : $15b6935538b1baf3$export$8c5c7a21d54563e9, self);
        }
        if (!visible && document.activeElement === slide) {
            var Slide2 = Components.Slides.getAt(Splide2.index);
            Slide2 && $15b6935538b1baf3$var$focus(Slide2.slide);
        }
    };
    var style$1 = function style$1(prop, value, useContainer) {
        $15b6935538b1baf3$var$style(useContainer && container || slide, prop, value);
    };
    var isActive = function isActive() {
        var curr = Splide2.index;
        return curr === index || options.cloneStatus && curr === slideIndex;
    };
    var isVisible = function isVisible() {
        if (Splide2.is($15b6935538b1baf3$export$742b62a5690c060)) return isActive();
        var trackRect = $15b6935538b1baf3$var$rect(Components.Elements.track);
        var slideRect = $15b6935538b1baf3$var$rect(slide);
        var left = resolve("left", true);
        var right = resolve("right", true);
        return $15b6935538b1baf3$var$floor(trackRect[left]) <= $15b6935538b1baf3$var$ceil(slideRect[left]) && $15b6935538b1baf3$var$floor(slideRect[right]) <= $15b6935538b1baf3$var$ceil(trackRect[right]);
    };
    var isWithin = function isWithin(from, distance) {
        var diff = $15b6935538b1baf3$var$abs(from - index);
        if (!isClone && (options.rewind || Splide2.is($15b6935538b1baf3$export$f42383286ed1223d))) diff = $15b6935538b1baf3$var$min(diff, Splide2.length - diff);
        return diff <= distance;
    };
    var event = $15b6935538b1baf3$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var Components = Splide2.Components, root = Splide2.root, options = Splide2.options;
    var isNavigation = options.isNavigation, updateOnMove = options.updateOnMove, i18n = options.i18n, pagination = options.pagination, slideFocus = options.slideFocus;
    var resolve = Components.Direction.resolve;
    var styles = $15b6935538b1baf3$var$getAttribute(slide, "style");
    var label = $15b6935538b1baf3$var$getAttribute(slide, $15b6935538b1baf3$var$ARIA_LABEL);
    var isClone = slideIndex > -1;
    var container = $15b6935538b1baf3$var$child(slide, "." + $15b6935538b1baf3$export$e9ba7e444ba60a12);
    var destroyed;
    var self = {
        index: index,
        slideIndex: slideIndex,
        slide: slide,
        container: container,
        isClone: isClone,
        mount: mount,
        destroy: destroy,
        update: update,
        style: style$1,
        isWithin: isWithin
    };
    return self;
}
function $15b6935538b1baf3$var$Slides(Splide2, Components2, options) {
    var mount = function mount() {
        init();
        on($15b6935538b1baf3$export$7f4701ac5e05e39f, destroy);
        on($15b6935538b1baf3$export$7f4701ac5e05e39f, init);
    };
    var init = function init() {
        slides.forEach(function(slide, index) {
            register(slide, index, -1);
        });
    };
    var destroy = function destroy() {
        forEach$1(function(Slide2) {
            Slide2.destroy();
        });
        $15b6935538b1baf3$var$empty(Slides2);
    };
    var update = function update() {
        forEach$1(function(Slide2) {
            Slide2.update();
        });
    };
    var register = function register(slide, index, slideIndex) {
        var object = $15b6935538b1baf3$var$Slide$1(Splide2, index, slideIndex, slide);
        object.mount();
        Slides2.push(object);
        Slides2.sort(function(Slide1, Slide2) {
            return Slide1.index - Slide2.index;
        });
    };
    var get = function get(excludeClones) {
        return excludeClones ? filter(function(Slide2) {
            return !Slide2.isClone;
        }) : Slides2;
    };
    var getIn = function getIn(page) {
        var _$Controller = Components2.Controller;
        var index = _$Controller.toIndex(page);
        var max = _$Controller.hasFocus() ? 1 : options.perPage;
        return filter(function(Slide2) {
            return $15b6935538b1baf3$var$between(Slide2.index, index, index + max - 1);
        });
    };
    var getAt = function getAt(index) {
        return filter(index)[0];
    };
    var add = function add(items, index) {
        $15b6935538b1baf3$var$forEach(items, function(slide) {
            if ($15b6935538b1baf3$var$isString(slide)) slide = $15b6935538b1baf3$var$parseHtml(slide);
            if ($15b6935538b1baf3$var$isHTMLElement(slide)) {
                var ref = slides[index];
                ref ? $15b6935538b1baf3$var$before(slide, ref) : $15b6935538b1baf3$var$append(list, slide);
                $15b6935538b1baf3$var$addClass(slide, options.classes.slide);
                observeImages(slide, $15b6935538b1baf3$var$apply(emit, $15b6935538b1baf3$export$7e019dae5103a285));
            }
        });
        emit($15b6935538b1baf3$export$7f4701ac5e05e39f);
    };
    var remove$1 = function remove$1(matcher) {
        $15b6935538b1baf3$var$remove(filter(matcher).map(function(Slide2) {
            return Slide2.slide;
        }));
        emit($15b6935538b1baf3$export$7f4701ac5e05e39f);
    };
    var forEach$1 = function forEach$1(iteratee, excludeClones) {
        get(excludeClones).forEach(iteratee);
    };
    var filter = function filter(matcher) {
        return Slides2.filter($15b6935538b1baf3$var$isFunction(matcher) ? matcher : function(Slide2) {
            return $15b6935538b1baf3$var$isString(matcher) ? $15b6935538b1baf3$var$matches(Slide2.slide, matcher) : $15b6935538b1baf3$var$includes($15b6935538b1baf3$var$toArray(matcher), Slide2.index);
        });
    };
    var style = function style(prop, value, useContainer) {
        forEach$1(function(Slide2) {
            Slide2.style(prop, value, useContainer);
        });
    };
    var observeImages = function observeImages(elm, callback) {
        var images = $15b6935538b1baf3$var$queryAll(elm, "img");
        var length = images.length;
        if (length) images.forEach(function(img) {
            bind(img, "load error", function() {
                if (!--length) callback();
            });
        });
        else callback();
    };
    var getLength = function getLength(excludeClones) {
        return excludeClones ? slides.length : Slides2.length;
    };
    var isEnough = function isEnough() {
        return Slides2.length > options.perPage;
    };
    var _EventInterface2 = $15b6935538b1baf3$export$f188226459c8a3ff(Splide2), on = _EventInterface2.on, emit = _EventInterface2.emit, bind = _EventInterface2.bind;
    var _Components2$Elements = Components2.Elements, slides = _Components2$Elements.slides, list = _Components2$Elements.list;
    var Slides2 = [];
    return {
        mount: mount,
        destroy: destroy,
        update: update,
        register: register,
        get: get,
        getIn: getIn,
        getAt: getAt,
        add: add,
        remove: remove$1,
        forEach: forEach$1,
        filter: filter,
        style: style,
        getLength: getLength,
        isEnough: isEnough
    };
}
function $15b6935538b1baf3$var$Layout(Splide2, Components2, options) {
    var mount = function mount() {
        init();
        bind(window, "resize load", $15b6935538b1baf3$export$efff0f5979573c99($15b6935538b1baf3$var$apply(emit, $15b6935538b1baf3$export$7e019dae5103a285)));
        on([
            $15b6935538b1baf3$export$db40ab7c0855fa5c,
            $15b6935538b1baf3$export$7f4701ac5e05e39f
        ], init);
        on($15b6935538b1baf3$export$7e019dae5103a285, resize);
    };
    var init = function init() {
        vertical = options.direction === $15b6935538b1baf3$export$97170d9824b89709;
        $15b6935538b1baf3$var$style(root, "maxWidth", $15b6935538b1baf3$var$unit(options.width));
        $15b6935538b1baf3$var$style(track, resolve("paddingLeft"), cssPadding(false));
        $15b6935538b1baf3$var$style(track, resolve("paddingRight"), cssPadding(true));
        resize(true);
    };
    var resize = function resize(force) {
        var newRect = $15b6935538b1baf3$var$rect(root);
        if (force || rootRect.width !== newRect.width || rootRect.height !== newRect.height) {
            $15b6935538b1baf3$var$style(track, "height", cssTrackHeight());
            styleSlides(resolve("marginRight"), $15b6935538b1baf3$var$unit(options.gap));
            styleSlides("width", cssSlideWidth());
            styleSlides("height", cssSlideHeight(), true);
            rootRect = newRect;
            emit($15b6935538b1baf3$export$d637eba1e9e28482);
            if (overflow !== (overflow = isOverflow())) {
                $15b6935538b1baf3$var$toggleClass(root, $15b6935538b1baf3$export$cd908cd1dd625e29, overflow);
                emit($15b6935538b1baf3$export$6cbac5b662a31e1b, overflow);
            }
        }
    };
    var cssPadding = function cssPadding(right) {
        var padding = options.padding;
        var prop = resolve(right ? "right" : "left");
        return padding && $15b6935538b1baf3$var$unit(padding[prop] || ($15b6935538b1baf3$var$isObject(padding) ? 0 : padding)) || "0px";
    };
    var cssTrackHeight = function cssTrackHeight() {
        var height = "";
        if (vertical) {
            height = cssHeight();
            $15b6935538b1baf3$var$assert(height, "height or heightRatio is missing.");
            height = "calc(" + height + " - " + cssPadding(false) + " - " + cssPadding(true) + ")";
        }
        return height;
    };
    var cssHeight = function cssHeight() {
        return $15b6935538b1baf3$var$unit(options.height || $15b6935538b1baf3$var$rect(list).width * options.heightRatio);
    };
    var cssSlideWidth = function cssSlideWidth() {
        return options.autoWidth ? null : $15b6935538b1baf3$var$unit(options.fixedWidth) || (vertical ? "" : cssSlideSize());
    };
    var cssSlideHeight = function cssSlideHeight() {
        return $15b6935538b1baf3$var$unit(options.fixedHeight) || (vertical ? options.autoHeight ? null : cssSlideSize() : cssHeight());
    };
    var cssSlideSize = function cssSlideSize() {
        var gap = $15b6935538b1baf3$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    };
    var listSize = function listSize() {
        return $15b6935538b1baf3$var$rect(list)[resolve("width")];
    };
    var slideSize = function slideSize(index, withoutGap) {
        var Slide = getAt(index || 0);
        return Slide ? $15b6935538b1baf3$var$rect(Slide.slide)[resolve("width")] + (withoutGap ? 0 : getGap()) : 0;
    };
    var totalSize = function totalSize(index, withoutGap) {
        var Slide = getAt(index);
        if (Slide) {
            var right = $15b6935538b1baf3$var$rect(Slide.slide)[resolve("right")];
            var left = $15b6935538b1baf3$var$rect(list)[resolve("left")];
            return $15b6935538b1baf3$var$abs(right - left) + (withoutGap ? 0 : getGap());
        }
        return 0;
    };
    var sliderSize = function sliderSize(withoutGap) {
        return totalSize(Splide2.length - 1) - totalSize(0) + slideSize(0, withoutGap);
    };
    var getGap = function getGap() {
        var Slide = getAt(0);
        return Slide && parseFloat($15b6935538b1baf3$var$style(Slide.slide, resolve("marginRight"))) || 0;
    };
    var getPadding = function getPadding(right) {
        return parseFloat($15b6935538b1baf3$var$style(track, resolve("padding" + (right ? "Right" : "Left")))) || 0;
    };
    var isOverflow = function isOverflow() {
        return Splide2.is($15b6935538b1baf3$export$742b62a5690c060) || sliderSize(true) > listSize();
    };
    var _EventInterface3 = $15b6935538b1baf3$export$f188226459c8a3ff(Splide2), on = _EventInterface3.on, bind = _EventInterface3.bind, emit = _EventInterface3.emit;
    var _$Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var _Components2$Elements2 = Components2.Elements, root = _Components2$Elements2.root, track = _Components2$Elements2.track, list = _Components2$Elements2.list;
    var getAt = _$Slides.getAt, styleSlides = _$Slides.style;
    var vertical;
    var rootRect;
    var overflow;
    return {
        mount: mount,
        resize: resize,
        listSize: listSize,
        slideSize: slideSize,
        sliderSize: sliderSize,
        totalSize: totalSize,
        getPadding: getPadding,
        isOverflow: isOverflow
    };
}
var $15b6935538b1baf3$var$MULTIPLIER = 2;
function $15b6935538b1baf3$var$Clones(Splide2, Components2, options) {
    var mount = function mount() {
        on($15b6935538b1baf3$export$7f4701ac5e05e39f, remount);
        on([
            $15b6935538b1baf3$export$db40ab7c0855fa5c,
            $15b6935538b1baf3$export$7e019dae5103a285
        ], observe);
        if (cloneCount = computeCloneCount()) {
            generate(cloneCount);
            Components2.Layout.resize(true);
        }
    };
    var remount = function remount() {
        destroy();
        mount();
    };
    var destroy = function destroy() {
        $15b6935538b1baf3$var$remove(clones);
        $15b6935538b1baf3$var$empty(clones);
        event.destroy();
    };
    var observe = function observe() {
        var count = computeCloneCount();
        if (cloneCount !== count) {
            if (cloneCount < count || !count) event.emit($15b6935538b1baf3$export$7f4701ac5e05e39f);
        }
    };
    var generate = function generate(count) {
        var slides = _$Slides.get().slice();
        var length = slides.length;
        if (length) {
            while(slides.length < count)$15b6935538b1baf3$var$push(slides, slides);
            $15b6935538b1baf3$var$push(slides.slice(-count), slides.slice(0, count)).forEach(function(Slide, index) {
                var isHead = index < count;
                var clone = cloneDeep(Slide.slide, index);
                isHead ? $15b6935538b1baf3$var$before(clone, slides[0].slide) : $15b6935538b1baf3$var$append(_$Elements.list, clone);
                $15b6935538b1baf3$var$push(clones, clone);
                _$Slides.register(clone, index - count + (isHead ? 0 : length), Slide.index);
            });
        }
    };
    var cloneDeep = function cloneDeep(elm, index) {
        var clone = elm.cloneNode(true);
        $15b6935538b1baf3$var$addClass(clone, options.classes.clone);
        clone.id = Splide2.root.id + "-clone" + $15b6935538b1baf3$var$pad(index + 1);
        return clone;
    };
    var computeCloneCount = function computeCloneCount() {
        var clones2 = options.clones;
        if (!Splide2.is($15b6935538b1baf3$export$f42383286ed1223d)) clones2 = 0;
        else if ($15b6935538b1baf3$var$isUndefined(clones2)) {
            var fixedSize = options[resolve("fixedWidth")] && Components2.Layout.slideSize(0);
            var fixedCount = fixedSize && $15b6935538b1baf3$var$ceil($15b6935538b1baf3$var$rect(_$Elements.track)[resolve("width")] / fixedSize);
            clones2 = fixedCount || options[resolve("autoWidth")] && Splide2.length || options.perPage * $15b6935538b1baf3$var$MULTIPLIER;
        }
        return clones2;
    };
    var event = $15b6935538b1baf3$export$f188226459c8a3ff(Splide2);
    var on = event.on;
    var _$Elements = Components2.Elements, _$Slides = Components2.Slides;
    var resolve = Components2.Direction.resolve;
    var clones = [];
    var cloneCount;
    return {
        mount: mount,
        destroy: destroy
    };
}
function $15b6935538b1baf3$var$Move(Splide2, Components2, options) {
    var mount = function mount() {
        Transition = Components2.Transition;
        on([
            $15b6935538b1baf3$export$d300dc1a2634364b,
            $15b6935538b1baf3$export$d637eba1e9e28482,
            $15b6935538b1baf3$export$db40ab7c0855fa5c,
            $15b6935538b1baf3$export$7f4701ac5e05e39f
        ], reposition);
    };
    var reposition = function reposition() {
        if (!Components2.Controller.isBusy()) {
            Components2.Scroll.cancel();
            jump(Splide2.index);
            Components2.Slides.update();
        }
    };
    var move = function move(dest, index, prev, callback) {
        if (dest !== index && canShift(dest > prev)) {
            cancel();
            translate(shift(getPosition(), dest > prev), true);
        }
        set($15b6935538b1baf3$var$MOVING);
        emit($15b6935538b1baf3$export$2aa493d7c3275167, index, prev, dest);
        Transition.start(index, function() {
            set($15b6935538b1baf3$var$IDLE);
            emit($15b6935538b1baf3$export$fe5802204b967f0d, index, prev, dest);
            callback && callback();
        });
    };
    var jump = function jump(index) {
        translate(toPosition(index, true));
    };
    var translate = function translate(position, preventLoop) {
        if (!Splide2.is($15b6935538b1baf3$export$742b62a5690c060)) {
            var destination = preventLoop ? position : loop(position);
            $15b6935538b1baf3$var$style(list, "transform", "translate" + resolve("X") + "(" + destination + "px)");
            position !== destination && emit($15b6935538b1baf3$export$f0af896383d5adff);
        }
    };
    var loop = function loop(position) {
        if (Splide2.is($15b6935538b1baf3$export$f42383286ed1223d)) {
            var index = toIndex(position);
            var exceededMax = index > Components2.Controller.getEnd();
            var exceededMin = index < 0;
            if (exceededMin || exceededMax) position = shift(position, exceededMax);
        }
        return position;
    };
    var shift = function shift(position, backwards) {
        var excess = position - getLimit(backwards);
        var size = sliderSize();
        position -= orient(size * ($15b6935538b1baf3$var$ceil($15b6935538b1baf3$var$abs(excess) / size) || 1)) * (backwards ? 1 : -1);
        return position;
    };
    var cancel = function cancel() {
        translate(getPosition(), true);
        Transition.cancel();
    };
    var toIndex = function toIndex(position) {
        var _$Slides = Components2.Slides.get();
        var index = 0;
        var minDistance = Infinity;
        for(var i = 0; i < _$Slides.length; i++){
            var slideIndex = _$Slides[i].index;
            var distance = $15b6935538b1baf3$var$abs(toPosition(slideIndex, true) - position);
            if (distance <= minDistance) {
                minDistance = distance;
                index = slideIndex;
            } else break;
        }
        return index;
    };
    var toPosition = function toPosition(index, trimming) {
        var position = orient(totalSize(index - 1) - offset(index));
        return trimming ? trim(position) : position;
    };
    var getPosition = function getPosition() {
        var left = resolve("left");
        return $15b6935538b1baf3$var$rect(list)[left] - $15b6935538b1baf3$var$rect(track)[left] + orient(getPadding(false));
    };
    var trim = function trim(position) {
        if (options.trimSpace && Splide2.is($15b6935538b1baf3$export$e5a58a5ee5b54c22)) position = $15b6935538b1baf3$var$clamp(position, 0, orient(sliderSize(true) - listSize()));
        return position;
    };
    var offset = function offset(index) {
        var focus = options.focus;
        return focus === "center" ? (listSize() - slideSize(index, true)) / 2 : +focus * slideSize(index) || 0;
    };
    var getLimit = function getLimit(max) {
        return toPosition(max ? Components2.Controller.getEnd() : 0, !!options.trimSpace);
    };
    var canShift = function canShift(backwards) {
        var shifted = orient(shift(getPosition(), backwards));
        return backwards ? shifted >= 0 : shifted <= list[resolve("scrollWidth")] - $15b6935538b1baf3$var$rect(track)[resolve("width")];
    };
    var exceededLimit = function exceededLimit(max, position) {
        position = $15b6935538b1baf3$var$isUndefined(position) ? getPosition() : position;
        var exceededMin = max !== true && orient(position) < orient(getLimit(false));
        var exceededMax = max !== false && orient(position) > orient(getLimit(true));
        return exceededMin || exceededMax;
    };
    var _EventInterface4 = $15b6935538b1baf3$export$f188226459c8a3ff(Splide2), on = _EventInterface4.on, emit = _EventInterface4.emit;
    var set = Splide2.state.set;
    var _Components2$Layout = Components2.Layout, slideSize = _Components2$Layout.slideSize, getPadding = _Components2$Layout.getPadding, totalSize = _Components2$Layout.totalSize, listSize = _Components2$Layout.listSize, sliderSize = _Components2$Layout.sliderSize;
    var _Components2$Directio = Components2.Direction, resolve = _Components2$Directio.resolve, orient = _Components2$Directio.orient;
    var _Components2$Elements3 = Components2.Elements, list = _Components2$Elements3.list, track = _Components2$Elements3.track;
    var Transition;
    return {
        mount: mount,
        move: move,
        jump: jump,
        translate: translate,
        shift: shift,
        cancel: cancel,
        toIndex: toIndex,
        toPosition: toPosition,
        getPosition: getPosition,
        getLimit: getLimit,
        exceededLimit: exceededLimit,
        reposition: reposition
    };
}
function $15b6935538b1baf3$var$Controller(Splide2, Components2, options) {
    var mount = function mount() {
        init();
        on([
            $15b6935538b1baf3$export$db40ab7c0855fa5c,
            $15b6935538b1baf3$export$7f4701ac5e05e39f,
            $15b6935538b1baf3$export$28dea85f216954dc
        ], init);
        on($15b6935538b1baf3$export$d637eba1e9e28482, onResized);
    };
    var init = function init() {
        slideCount = getLength(true);
        perMove = options.perMove;
        perPage = options.perPage;
        endIndex = getEnd();
        var index = $15b6935538b1baf3$var$clamp(currIndex, 0, omitEnd ? endIndex : slideCount - 1);
        if (index !== currIndex) {
            currIndex = index;
            _$Move.reposition();
        }
    };
    var onResized = function onResized() {
        if (endIndex !== getEnd()) emit($15b6935538b1baf3$export$28dea85f216954dc);
    };
    var go = function go(control, allowSameIndex, callback) {
        if (!isBusy()) {
            var dest = parse(control);
            var index = loop(dest);
            if (index > -1 && (allowSameIndex || index !== currIndex)) {
                setIndex(index);
                _$Move.move(dest, index, prevIndex, callback);
            }
        }
    };
    var scroll = function scroll(destination, duration, snap, callback) {
        Components2.Scroll.scroll(destination, duration, snap, function() {
            var index = loop(_$Move.toIndex(getPosition()));
            setIndex(omitEnd ? $15b6935538b1baf3$var$min(index, endIndex) : index);
            callback && callback();
        });
    };
    var parse = function parse(control) {
        var index = currIndex;
        if ($15b6935538b1baf3$var$isString(control)) {
            var _ref = control.match(/([+\-<>])(\d+)?/) || [], indicator = _ref[1], number = _ref[2];
            if (indicator === "+" || indicator === "-") index = computeDestIndex(currIndex + +("" + indicator + (+number || 1)), currIndex);
            else if (indicator === ">") index = number ? toIndex(+number) : getNext(true);
            else if (indicator === "<") index = getPrev(true);
        } else index = isLoop ? control : $15b6935538b1baf3$var$clamp(control, 0, endIndex);
        return index;
    };
    var getAdjacent = function getAdjacent(prev, destination) {
        var number = perMove || (hasFocus() ? 1 : perPage);
        var dest = computeDestIndex(currIndex + number * (prev ? -1 : 1), currIndex, !(perMove || hasFocus()));
        if (dest === -1 && isSlide) {
            if (!$15b6935538b1baf3$var$approximatelyEqual(getPosition(), getLimit(!prev), 1)) return prev ? 0 : endIndex;
        }
        return destination ? dest : loop(dest);
    };
    var computeDestIndex = function computeDestIndex(dest, from, snapPage) {
        if (isEnough() || hasFocus()) {
            var index = computeMovableDestIndex(dest);
            if (index !== dest) {
                from = dest;
                dest = index;
                snapPage = false;
            }
            if (dest < 0 || dest > endIndex) {
                if (!perMove && ($15b6935538b1baf3$var$between(0, dest, from, true) || $15b6935538b1baf3$var$between(endIndex, from, dest, true))) dest = toIndex(toPage(dest));
                else {
                    if (isLoop) dest = snapPage ? dest < 0 ? -(slideCount % perPage || perPage) : slideCount : dest;
                    else if (options.rewind) dest = dest < 0 ? endIndex : 0;
                    else dest = -1;
                }
            } else if (snapPage && dest !== from) dest = toIndex(toPage(from) + (dest < from ? -1 : 1));
        } else dest = -1;
        return dest;
    };
    var computeMovableDestIndex = function computeMovableDestIndex(dest) {
        if (isSlide && options.trimSpace === "move" && dest !== currIndex) {
            var position = getPosition();
            while(position === toPosition(dest, true) && $15b6935538b1baf3$var$between(dest, 0, Splide2.length - 1, !options.rewind))dest < currIndex ? --dest : ++dest;
        }
        return dest;
    };
    var loop = function loop(index) {
        return isLoop ? (index + slideCount) % slideCount || 0 : index;
    };
    var getEnd = function getEnd() {
        var end = slideCount - (hasFocus() || isLoop && perMove ? 1 : perPage);
        while(omitEnd && end-- > 0)if (toPosition(slideCount - 1, true) !== toPosition(end, true)) {
            end++;
            break;
        }
        return $15b6935538b1baf3$var$clamp(end, 0, slideCount - 1);
    };
    var toIndex = function toIndex(page) {
        return $15b6935538b1baf3$var$clamp(hasFocus() ? page : perPage * page, 0, endIndex);
    };
    var toPage = function toPage(index) {
        return hasFocus() ? $15b6935538b1baf3$var$min(index, endIndex) : $15b6935538b1baf3$var$floor((index >= endIndex ? slideCount - 1 : index) / perPage);
    };
    var toDest = function toDest(destination) {
        var closest = _$Move.toIndex(destination);
        return isSlide ? $15b6935538b1baf3$var$clamp(closest, 0, endIndex) : closest;
    };
    var setIndex = function setIndex(index) {
        if (index !== currIndex) {
            prevIndex = currIndex;
            currIndex = index;
        }
    };
    var getIndex = function getIndex(prev) {
        return prev ? prevIndex : currIndex;
    };
    var hasFocus = function hasFocus() {
        return !$15b6935538b1baf3$var$isUndefined(options.focus) || options.isNavigation;
    };
    var isBusy = function isBusy() {
        return Splide2.state.is([
            $15b6935538b1baf3$var$MOVING,
            $15b6935538b1baf3$var$SCROLLING
        ]) && !!options.waitForTransition;
    };
    var _EventInterface5 = $15b6935538b1baf3$export$f188226459c8a3ff(Splide2), on = _EventInterface5.on, emit = _EventInterface5.emit;
    var _$Move = Components2.Move;
    var getPosition = _$Move.getPosition, getLimit = _$Move.getLimit, toPosition = _$Move.toPosition;
    var _Components2$Slides = Components2.Slides, isEnough = _Components2$Slides.isEnough, getLength = _Components2$Slides.getLength;
    var omitEnd = options.omitEnd;
    var isLoop = Splide2.is($15b6935538b1baf3$export$f42383286ed1223d);
    var isSlide = Splide2.is($15b6935538b1baf3$export$e5a58a5ee5b54c22);
    var getNext = $15b6935538b1baf3$var$apply(getAdjacent, false);
    var getPrev = $15b6935538b1baf3$var$apply(getAdjacent, true);
    var currIndex = options.start || 0;
    var endIndex;
    var prevIndex = currIndex;
    var slideCount;
    var perMove;
    var perPage;
    return {
        mount: mount,
        go: go,
        scroll: scroll,
        getNext: getNext,
        getPrev: getPrev,
        getAdjacent: getAdjacent,
        getEnd: getEnd,
        setIndex: setIndex,
        getIndex: getIndex,
        toIndex: toIndex,
        toPage: toPage,
        toDest: toDest,
        hasFocus: hasFocus,
        isBusy: isBusy
    };
}
var $15b6935538b1baf3$var$XML_NAME_SPACE = "http://www.w3.org/2000/svg";
var $15b6935538b1baf3$var$PATH = "m15.5 0.932-4.3 4.38 14.5 14.6-14.5 14.5 4.3 4.4 14.6-14.6 4.4-4.3-4.4-4.4-14.6-14.6z";
var $15b6935538b1baf3$var$SIZE = 40;
function $15b6935538b1baf3$var$Arrows(Splide2, Components2, options) {
    var mount = function mount() {
        init();
        on($15b6935538b1baf3$export$db40ab7c0855fa5c, remount);
    };
    var remount = function remount() {
        destroy();
        mount();
    };
    var init = function init() {
        var enabled = options.arrows;
        if (enabled && !(prev && next)) createArrows();
        if (prev && next) {
            $15b6935538b1baf3$var$assign(arrows, {
                prev: prev,
                next: next
            });
            $15b6935538b1baf3$var$display(wrapper, enabled ? "" : "none");
            $15b6935538b1baf3$var$addClass(wrapper, wrapperClasses = $15b6935538b1baf3$export$a26cbd955fecf11e + "--" + options.direction);
            if (enabled) {
                listen();
                update();
                $15b6935538b1baf3$var$setAttribute([
                    prev,
                    next
                ], $15b6935538b1baf3$var$ARIA_CONTROLS, track.id);
                emit($15b6935538b1baf3$export$8647f6b043e04e9d, prev, next);
            }
        }
    };
    var destroy = function destroy() {
        event.destroy();
        $15b6935538b1baf3$var$removeClass(wrapper, wrapperClasses);
        if (created) {
            $15b6935538b1baf3$var$remove(placeholder ? [
                prev,
                next
            ] : wrapper);
            prev = next = null;
        } else $15b6935538b1baf3$var$removeAttribute([
            prev,
            next
        ], $15b6935538b1baf3$var$ALL_ATTRIBUTES);
    };
    var listen = function listen() {
        on([
            $15b6935538b1baf3$export$d300dc1a2634364b,
            $15b6935538b1baf3$export$fe5802204b967f0d,
            $15b6935538b1baf3$export$7f4701ac5e05e39f,
            $15b6935538b1baf3$export$ff8164bff3202b9,
            $15b6935538b1baf3$export$28dea85f216954dc
        ], update);
        bind(next, "click", $15b6935538b1baf3$var$apply(go, ">"));
        bind(prev, "click", $15b6935538b1baf3$var$apply(go, "<"));
    };
    var go = function go(control) {
        _$Controller.go(control, true);
    };
    var createArrows = function createArrows() {
        wrapper = placeholder || $15b6935538b1baf3$var$create("div", classes.arrows);
        prev = createArrow(true);
        next = createArrow(false);
        created = true;
        $15b6935538b1baf3$var$append(wrapper, [
            prev,
            next
        ]);
        !placeholder && $15b6935538b1baf3$var$before(wrapper, track);
    };
    var createArrow = function createArrow(prev2) {
        var arrow = '<button class="' + classes.arrow + " " + (prev2 ? classes.prev : classes.next) + '" type="button"><svg xmlns="' + $15b6935538b1baf3$var$XML_NAME_SPACE + '" viewBox="0 0 ' + $15b6935538b1baf3$var$SIZE + " " + $15b6935538b1baf3$var$SIZE + '" width="' + $15b6935538b1baf3$var$SIZE + '" height="' + $15b6935538b1baf3$var$SIZE + '" focusable="false"><path d="' + (options.arrowPath || $15b6935538b1baf3$var$PATH) + '" />';
        return $15b6935538b1baf3$var$parseHtml(arrow);
    };
    var update = function update() {
        if (prev && next) {
            var index = Splide2.index;
            var prevIndex = _$Controller.getPrev();
            var nextIndex = _$Controller.getNext();
            var prevLabel = prevIndex > -1 && index < prevIndex ? i18n.last : i18n.prev;
            var nextLabel = nextIndex > -1 && index > nextIndex ? i18n.first : i18n.next;
            prev.disabled = prevIndex < 0;
            next.disabled = nextIndex < 0;
            $15b6935538b1baf3$var$setAttribute(prev, $15b6935538b1baf3$var$ARIA_LABEL, prevLabel);
            $15b6935538b1baf3$var$setAttribute(next, $15b6935538b1baf3$var$ARIA_LABEL, nextLabel);
            emit($15b6935538b1baf3$export$d467f9343b961f75, prev, next, prevIndex, nextIndex);
        }
    };
    var event = $15b6935538b1baf3$export$f188226459c8a3ff(Splide2);
    var on = event.on, bind = event.bind, emit = event.emit;
    var classes = options.classes, i18n = options.i18n;
    var _$Elements = Components2.Elements, _$Controller = Components2.Controller;
    var placeholder = _$Elements.arrows, track = _$Elements.track;
    var wrapper = placeholder;
    var prev = _$Elements.prev;
    var next = _$Elements.next;
    var created;
    var wrapperClasses;
    var arrows = {};
    return {
        arrows: arrows,
        mount: mount,
        destroy: destroy,
        update: update
    };
}
var $15b6935538b1baf3$var$INTERVAL_DATA_ATTRIBUTE = $15b6935538b1baf3$var$DATA_ATTRIBUTE + "-interval";
function $15b6935538b1baf3$var$Autoplay(Splide2, Components2, options) {
    var mount = function mount() {
        if (autoplay) {
            listen();
            toggle && $15b6935538b1baf3$var$setAttribute(toggle, $15b6935538b1baf3$var$ARIA_CONTROLS, _$Elements.track.id);
            stopped || play();
            update();
        }
    };
    var listen = function listen() {
        if (options.pauseOnHover) bind(root, "mouseenter mouseleave", function(e) {
            hovered = e.type === "mouseenter";
            autoToggle();
        });
        if (options.pauseOnFocus) bind(root, "focusin focusout", function(e) {
            focused = e.type === "focusin";
            autoToggle();
        });
        if (toggle) bind(toggle, "click", function() {
            stopped ? play() : pause(true);
        });
        on([
            $15b6935538b1baf3$export$2aa493d7c3275167,
            $15b6935538b1baf3$export$49801896908b5e33,
            $15b6935538b1baf3$export$7f4701ac5e05e39f
        ], interval.rewind);
        on($15b6935538b1baf3$export$2aa493d7c3275167, onMove);
    };
    var play = function play() {
        if (isPaused() && Components2.Slides.isEnough()) {
            interval.start(!options.resetProgress);
            focused = hovered = stopped = false;
            update();
            emit($15b6935538b1baf3$export$23663268a31b79e2);
        }
    };
    var pause = function pause(stop) {
        if (stop === void 0) stop = true;
        stopped = !!stop;
        update();
        if (!isPaused()) {
            interval.pause();
            emit($15b6935538b1baf3$export$16a1e4f3d0368265);
        }
    };
    var autoToggle = function autoToggle() {
        if (!stopped) hovered || focused ? pause(false) : play();
    };
    var update = function update() {
        if (toggle) {
            $15b6935538b1baf3$var$toggleClass(toggle, $15b6935538b1baf3$export$72d36ecf3758cb4b, !stopped);
            $15b6935538b1baf3$var$setAttribute(toggle, $15b6935538b1baf3$var$ARIA_LABEL, options.i18n[stopped ? "play" : "pause"]);
        }
    };
    var onAnimationFrame = function onAnimationFrame(rate) {
        var bar = _$Elements.bar;
        bar && $15b6935538b1baf3$var$style(bar, "width", rate * 100 + "%");
        emit($15b6935538b1baf3$export$185723258309b608, rate);
    };
    var onMove = function onMove(index) {
        var Slide = Components2.Slides.getAt(index);
        interval.set(Slide && +$15b6935538b1baf3$var$getAttribute(Slide.slide, $15b6935538b1baf3$var$INTERVAL_DATA_ATTRIBUTE) || options.interval);
    };
    var _EventInterface6 = $15b6935538b1baf3$export$f188226459c8a3ff(Splide2), on = _EventInterface6.on, bind = _EventInterface6.bind, emit = _EventInterface6.emit;
    var interval = $15b6935538b1baf3$export$46ad21b25b6dccf0(options.interval, Splide2.go.bind(Splide2, ">"), onAnimationFrame);
    var isPaused = interval.isPaused;
    var _$Elements = Components2.Elements, _Components2$Elements4 = Components2.Elements, root = _Components2$Elements4.root, toggle = _Components2$Elements4.toggle;
    var autoplay = options.autoplay;
    var hovered;
    var focused;
    var stopped = autoplay === "pause";
    return {
        mount: mount,
        destroy: interval.cancel,
        play: play,
        pause: pause,
        isPaused: isPaused
    };
}
function $15b6935538b1baf3$var$Cover(Splide2, Components2, options) {
    var mount = function mount() {
        if (options.cover) {
            on($15b6935538b1baf3$export$9f64346e17f0ec8e, $15b6935538b1baf3$var$apply(toggle, true));
            on([
                $15b6935538b1baf3$export$d300dc1a2634364b,
                $15b6935538b1baf3$export$db40ab7c0855fa5c,
                $15b6935538b1baf3$export$7f4701ac5e05e39f
            ], $15b6935538b1baf3$var$apply(cover, true));
        }
    };
    var cover = function cover(cover2) {
        Components2.Slides.forEach(function(Slide) {
            var img = $15b6935538b1baf3$var$child(Slide.container || Slide.slide, "img");
            if (img && img.src) toggle(cover2, img, Slide);
        });
    };
    var toggle = function toggle(cover2, img, Slide) {
        Slide.style("background", cover2 ? 'center/cover no-repeat url("' + img.src + '")' : "", true);
        $15b6935538b1baf3$var$display(img, cover2 ? "none" : "");
    };
    var _EventInterface7 = $15b6935538b1baf3$export$f188226459c8a3ff(Splide2), on = _EventInterface7.on;
    return {
        mount: mount,
        destroy: $15b6935538b1baf3$var$apply(cover, false)
    };
}
var $15b6935538b1baf3$var$BOUNCE_DIFF_THRESHOLD = 10;
var $15b6935538b1baf3$var$BOUNCE_DURATION = 600;
var $15b6935538b1baf3$var$FRICTION_FACTOR = 0.6;
var $15b6935538b1baf3$var$BASE_VELOCITY = 1.5;
var $15b6935538b1baf3$var$MIN_DURATION = 800;
function $15b6935538b1baf3$var$Scroll(Splide2, Components2, options) {
    var mount = function mount() {
        on($15b6935538b1baf3$export$2aa493d7c3275167, clear);
        on([
            $15b6935538b1baf3$export$db40ab7c0855fa5c,
            $15b6935538b1baf3$export$7f4701ac5e05e39f
        ], cancel);
    };
    var scroll = function scroll(destination, duration, snap, onScrolled, noConstrain) {
        var from = getPosition();
        clear();
        if (snap && (!isSlide || !exceededLimit())) {
            var size = Components2.Layout.sliderSize();
            var offset = $15b6935538b1baf3$var$sign(destination) * size * $15b6935538b1baf3$var$floor($15b6935538b1baf3$var$abs(destination) / size) || 0;
            destination = _$Move.toPosition(Components2.Controller.toDest(destination % size)) + offset;
        }
        var noDistance = $15b6935538b1baf3$var$approximatelyEqual(from, destination, 1);
        friction = 1;
        duration = noDistance ? 0 : duration || $15b6935538b1baf3$var$max($15b6935538b1baf3$var$abs(destination - from) / $15b6935538b1baf3$var$BASE_VELOCITY, $15b6935538b1baf3$var$MIN_DURATION);
        callback = onScrolled;
        interval = $15b6935538b1baf3$export$46ad21b25b6dccf0(duration, onEnd, $15b6935538b1baf3$var$apply(update, from, destination, noConstrain), 1);
        set($15b6935538b1baf3$var$SCROLLING);
        emit($15b6935538b1baf3$export$49801896908b5e33);
        interval.start();
    };
    var onEnd = function onEnd() {
        set($15b6935538b1baf3$var$IDLE);
        callback && callback();
        emit($15b6935538b1baf3$export$ff8164bff3202b9);
    };
    var update = function update(from, to, noConstrain, rate) {
        var position = getPosition();
        var target = from + (to - from) * easing(rate);
        var diff = (target - position) * friction;
        translate(position + diff);
        if (isSlide && !noConstrain && exceededLimit()) {
            friction *= $15b6935538b1baf3$var$FRICTION_FACTOR;
            if ($15b6935538b1baf3$var$abs(diff) < $15b6935538b1baf3$var$BOUNCE_DIFF_THRESHOLD) scroll(getLimit(exceededLimit(true)), $15b6935538b1baf3$var$BOUNCE_DURATION, false, callback, true);
        }
    };
    var clear = function clear() {
        if (interval) interval.cancel();
    };
    var cancel = function cancel() {
        if (interval && !interval.isPaused()) {
            clear();
            onEnd();
        }
    };
    var easing = function easing(t) {
        var easingFunc = options.easingFunc;
        return easingFunc ? easingFunc(t) : 1 - Math.pow(1 - t, 4);
    };
    var _EventInterface8 = $15b6935538b1baf3$export$f188226459c8a3ff(Splide2), on = _EventInterface8.on, emit = _EventInterface8.emit;
    var set = Splide2.state.set;
    var _$Move = Components2.Move;
    var getPosition = _$Move.getPosition, getLimit = _$Move.getLimit, exceededLimit = _$Move.exceededLimit, translate = _$Move.translate;
    var isSlide = Splide2.is($15b6935538b1baf3$export$e5a58a5ee5b54c22);
    var interval;
    var callback;
    var friction = 1;
    return {
        mount: mount,
        destroy: clear,
        scroll: scroll,
        cancel: cancel
    };
}
var $15b6935538b1baf3$var$SCROLL_LISTENER_OPTIONS = {
    passive: false,
    capture: true
};
function $15b6935538b1baf3$var$Drag(Splide2, Components2, options) {
    var mount = function mount() {
        bind(track, $15b6935538b1baf3$var$POINTER_MOVE_EVENTS, $15b6935538b1baf3$var$noop, $15b6935538b1baf3$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $15b6935538b1baf3$var$POINTER_UP_EVENTS, $15b6935538b1baf3$var$noop, $15b6935538b1baf3$var$SCROLL_LISTENER_OPTIONS);
        bind(track, $15b6935538b1baf3$var$POINTER_DOWN_EVENTS, onPointerDown, $15b6935538b1baf3$var$SCROLL_LISTENER_OPTIONS);
        bind(track, "click", onClick, {
            capture: true
        });
        bind(track, "dragstart", $15b6935538b1baf3$var$prevent);
        on([
            $15b6935538b1baf3$export$d300dc1a2634364b,
            $15b6935538b1baf3$export$db40ab7c0855fa5c
        ], init);
    };
    var init = function init() {
        var drag = options.drag;
        disable(!drag);
        isFree = drag === "free";
    };
    var onPointerDown = function onPointerDown(e) {
        clickPrevented = false;
        if (!disabled) {
            var isTouch = isTouchEvent(e);
            if (isDraggable(e.target) && (isTouch || !e.button)) {
                if (!_$Controller.isBusy()) {
                    target = isTouch ? track : window;
                    dragging = state.is([
                        $15b6935538b1baf3$var$MOVING,
                        $15b6935538b1baf3$var$SCROLLING
                    ]);
                    prevBaseEvent = null;
                    bind(target, $15b6935538b1baf3$var$POINTER_MOVE_EVENTS, onPointerMove, $15b6935538b1baf3$var$SCROLL_LISTENER_OPTIONS);
                    bind(target, $15b6935538b1baf3$var$POINTER_UP_EVENTS, onPointerUp, $15b6935538b1baf3$var$SCROLL_LISTENER_OPTIONS);
                    _$Move.cancel();
                    _$Scroll.cancel();
                    save(e);
                } else $15b6935538b1baf3$var$prevent(e, true);
            }
        }
    };
    var onPointerMove = function onPointerMove(e) {
        if (!state.is($15b6935538b1baf3$var$DRAGGING)) {
            state.set($15b6935538b1baf3$var$DRAGGING);
            emit($15b6935538b1baf3$export$e84bf5065c9087ac);
        }
        if (e.cancelable) {
            if (dragging) {
                _$Move.translate(basePosition + constrain(diffCoord(e)));
                var expired = diffTime(e) > $15b6935538b1baf3$var$LOG_INTERVAL;
                var hasExceeded = exceeded !== (exceeded = exceededLimit());
                if (expired || hasExceeded) save(e);
                clickPrevented = true;
                emit($15b6935538b1baf3$export$8e9f636d2c722196);
                $15b6935538b1baf3$var$prevent(e);
            } else if (isSliderDirection(e)) {
                dragging = shouldStart(e);
                $15b6935538b1baf3$var$prevent(e);
            }
        }
    };
    var onClick = function onClick(e) {
        if (!disabled && clickPrevented) $15b6935538b1baf3$var$prevent(e, true);
    };
    var save = function save(e) {
        prevBaseEvent = baseEvent;
        baseEvent = e;
        basePosition = getPosition();
    };
    var move = function move(e) {
        var velocity = computeVelocity(e);
        var destination = computeDestination(velocity);
        var rewind = options.rewind && options.rewindByDrag;
        reduce(false);
        if (isFree) _$Controller.scroll(destination, 0, options.snap);
        else if (Splide2.is($15b6935538b1baf3$export$742b62a5690c060)) _$Controller.go(orient($15b6935538b1baf3$var$sign(velocity)) < 0 ? rewind ? "<" : "-" : rewind ? ">" : "+");
        else if (Splide2.is($15b6935538b1baf3$export$e5a58a5ee5b54c22) && exceeded && rewind) _$Controller.go(exceededLimit(true) ? ">" : "<");
        else _$Controller.go(_$Controller.toDest(destination), true);
        reduce(true);
    };
    var shouldStart = function shouldStart(e) {
        var thresholds = options.dragMinThreshold;
        var isObj = $15b6935538b1baf3$var$isObject(thresholds);
        var mouse = isObj && thresholds.mouse || 0;
        var touch = (isObj ? thresholds.touch : +thresholds) || 10;
        return $15b6935538b1baf3$var$abs(diffCoord(e)) > (isTouchEvent(e) ? touch : mouse);
    };
    var isSliderDirection = function isSliderDirection(e) {
        return $15b6935538b1baf3$var$abs(diffCoord(e)) > $15b6935538b1baf3$var$abs(diffCoord(e, true));
    };
    var computeVelocity = function computeVelocity(e) {
        if (Splide2.is($15b6935538b1baf3$export$f42383286ed1223d) || !exceeded) {
            var time = diffTime(e);
            if (time && time < $15b6935538b1baf3$var$LOG_INTERVAL) return diffCoord(e) / time;
        }
        return 0;
    };
    var computeDestination = function computeDestination(velocity) {
        return getPosition() + $15b6935538b1baf3$var$sign(velocity) * $15b6935538b1baf3$var$min($15b6935538b1baf3$var$abs(velocity) * (options.flickPower || 600), isFree ? Infinity : Components2.Layout.listSize() * (options.flickMaxPages || 1));
    };
    var diffCoord = function diffCoord(e, orthogonal) {
        return coordOf(e, orthogonal) - coordOf(getBaseEvent(e), orthogonal);
    };
    var diffTime = function diffTime(e) {
        return $15b6935538b1baf3$var$timeOf(e) - $15b6935538b1baf3$var$timeOf(getBaseEvent(e));
    };
    var getBaseEvent = function getBaseEvent(e) {
        return baseEvent === e && prevBaseEvent || baseEvent;
    };
    var coordOf = function coordOf(e, orthogonal) {
        return (isTouchEvent(e) ? e.changedTouches[0] : e)["page" + resolve(orthogonal ? "Y" : "X")];
    };
    var constrain = function constrain(diff) {
        return diff / (exceeded && Splide2.is($15b6935538b1baf3$export$e5a58a5ee5b54c22) ? $15b6935538b1baf3$var$FRICTION : 1);
    };
    var isDraggable = function isDraggable(target2) {
        var noDrag = options.noDrag;
        return !$15b6935538b1baf3$var$matches(target2, "." + $15b6935538b1baf3$export$52f2cca6a5eee805 + ", ." + $15b6935538b1baf3$export$516e7d18e13a2dca) && (!noDrag || !$15b6935538b1baf3$var$matches(target2, noDrag));
    };
    var isTouchEvent = function isTouchEvent(e) {
        return typeof TouchEvent !== "undefined" && e instanceof TouchEvent;
    };
    var isDragging = function isDragging() {
        return dragging;
    };
    var disable = function disable(value) {
        disabled = value;
    };
    var _EventInterface9 = $15b6935538b1baf3$export$f188226459c8a3ff(Splide2), on = _EventInterface9.on, emit = _EventInterface9.emit, bind = _EventInterface9.bind, unbind = _EventInterface9.unbind;
    var state = Splide2.state;
    var _$Move = Components2.Move, _$Scroll = Components2.Scroll, _$Controller = Components2.Controller, track = Components2.Elements.track, reduce = Components2.Media.reduce;
    var _Components2$Directio2 = Components2.Direction, resolve = _Components2$Directio2.resolve, orient = _Components2$Directio2.orient;
    var getPosition = _$Move.getPosition, exceededLimit = _$Move.exceededLimit;
    var basePosition;
    var baseEvent;
    var prevBaseEvent;
    var isFree;
    var dragging;
    var exceeded = false;
    var clickPrevented;
    var disabled;
    var target;
    function onPointerUp(e) {
        if (state.is($15b6935538b1baf3$var$DRAGGING)) {
            state.set($15b6935538b1baf3$var$IDLE);
            emit($15b6935538b1baf3$export$90ea576bd3fdeb60);
        }
        if (dragging) {
            move(e);
            $15b6935538b1baf3$var$prevent(e);
        }
        unbind(target, $15b6935538b1baf3$var$POINTER_MOVE_EVENTS, onPointerMove);
        unbind(target, $15b6935538b1baf3$var$POINTER_UP_EVENTS, onPointerUp);
        dragging = false;
    }
    return {
        mount: mount,
        disable: disable,
        isDragging: isDragging
    };
}
var $15b6935538b1baf3$var$NORMALIZATION_MAP = {
    Spacebar: " ",
    Right: $15b6935538b1baf3$var$ARROW_RIGHT,
    Left: $15b6935538b1baf3$var$ARROW_LEFT,
    Up: $15b6935538b1baf3$var$ARROW_UP,
    Down: $15b6935538b1baf3$var$ARROW_DOWN
};
function $15b6935538b1baf3$var$normalizeKey(key) {
    key = $15b6935538b1baf3$var$isString(key) ? key : key.key;
    return $15b6935538b1baf3$var$NORMALIZATION_MAP[key] || key;
}
var $15b6935538b1baf3$var$KEYBOARD_EVENT = "keydown";
function $15b6935538b1baf3$var$Keyboard(Splide2, Components2, options) {
    var mount = function mount() {
        init();
        on($15b6935538b1baf3$export$db40ab7c0855fa5c, destroy);
        on($15b6935538b1baf3$export$db40ab7c0855fa5c, init);
        on($15b6935538b1baf3$export$2aa493d7c3275167, onMove);
    };
    var init = function init() {
        var keyboard = options.keyboard;
        if (keyboard) {
            target = keyboard === "global" ? window : root;
            bind(target, $15b6935538b1baf3$var$KEYBOARD_EVENT, onKeydown);
        }
    };
    var destroy = function destroy() {
        unbind(target, $15b6935538b1baf3$var$KEYBOARD_EVENT);
    };
    var disable = function disable(value) {
        disabled = value;
    };
    var onMove = function onMove() {
        var _disabled = disabled;
        disabled = true;
        $15b6935538b1baf3$var$nextTick(function() {
            disabled = _disabled;
        });
    };
    var onKeydown = function onKeydown(e) {
        if (!disabled) {
            var key = $15b6935538b1baf3$var$normalizeKey(e);
            if (key === resolve($15b6935538b1baf3$var$ARROW_LEFT)) Splide2.go("<");
            else if (key === resolve($15b6935538b1baf3$var$ARROW_RIGHT)) Splide2.go(">");
        }
    };
    var _EventInterface10 = $15b6935538b1baf3$export$f188226459c8a3ff(Splide2), on = _EventInterface10.on, bind = _EventInterface10.bind, unbind = _EventInterface10.unbind;
    var root = Splide2.root;
    var resolve = Components2.Direction.resolve;
    var target;
    var disabled;
    return {
        mount: mount,
        destroy: destroy,
        disable: disable
    };
}
var $15b6935538b1baf3$var$SRC_DATA_ATTRIBUTE = $15b6935538b1baf3$var$DATA_ATTRIBUTE + "-lazy";
var $15b6935538b1baf3$var$SRCSET_DATA_ATTRIBUTE = $15b6935538b1baf3$var$SRC_DATA_ATTRIBUTE + "-srcset";
var $15b6935538b1baf3$var$IMAGE_SELECTOR = "[" + $15b6935538b1baf3$var$SRC_DATA_ATTRIBUTE + "], [" + $15b6935538b1baf3$var$SRCSET_DATA_ATTRIBUTE + "]";
function $15b6935538b1baf3$var$LazyLoad(Splide2, Components2, options) {
    var mount = function mount() {
        if (options.lazyLoad) {
            init();
            on($15b6935538b1baf3$export$7f4701ac5e05e39f, init);
        }
    };
    var init = function init() {
        $15b6935538b1baf3$var$empty(entries);
        register();
        if (isSequential) loadNext();
        else {
            off(events);
            on(events, check);
            check();
        }
    };
    var register = function register() {
        Components2.Slides.forEach(function(Slide) {
            $15b6935538b1baf3$var$queryAll(Slide.slide, $15b6935538b1baf3$var$IMAGE_SELECTOR).forEach(function(img) {
                var src = $15b6935538b1baf3$var$getAttribute(img, $15b6935538b1baf3$var$SRC_DATA_ATTRIBUTE);
                var srcset = $15b6935538b1baf3$var$getAttribute(img, $15b6935538b1baf3$var$SRCSET_DATA_ATTRIBUTE);
                if (src !== img.src || srcset !== img.srcset) {
                    var className = options.classes.spinner;
                    var parent = img.parentElement;
                    var spinner = $15b6935538b1baf3$var$child(parent, "." + className) || $15b6935538b1baf3$var$create("span", className, parent);
                    entries.push([
                        img,
                        Slide,
                        spinner
                    ]);
                    img.src || $15b6935538b1baf3$var$display(img, "none");
                }
            });
        });
    };
    var check = function check() {
        entries = entries.filter(function(data) {
            var distance = options.perPage * ((options.preloadPages || 1) + 1) - 1;
            return data[1].isWithin(Splide2.index, distance) ? load(data) : true;
        });
        entries.length || off(events);
    };
    var load = function load(data) {
        var img = data[0];
        $15b6935538b1baf3$var$addClass(data[1].slide, $15b6935538b1baf3$export$d22ec4ccb7996ba2);
        bind(img, "load error", $15b6935538b1baf3$var$apply(onLoad, data));
        $15b6935538b1baf3$var$setAttribute(img, "src", $15b6935538b1baf3$var$getAttribute(img, $15b6935538b1baf3$var$SRC_DATA_ATTRIBUTE));
        $15b6935538b1baf3$var$setAttribute(img, "srcset", $15b6935538b1baf3$var$getAttribute(img, $15b6935538b1baf3$var$SRCSET_DATA_ATTRIBUTE));
        $15b6935538b1baf3$var$removeAttribute(img, $15b6935538b1baf3$var$SRC_DATA_ATTRIBUTE);
        $15b6935538b1baf3$var$removeAttribute(img, $15b6935538b1baf3$var$SRCSET_DATA_ATTRIBUTE);
    };
    var onLoad = function onLoad(data, e) {
        var img = data[0], Slide = data[1];
        $15b6935538b1baf3$var$removeClass(Slide.slide, $15b6935538b1baf3$export$d22ec4ccb7996ba2);
        if (e.type !== "error") {
            $15b6935538b1baf3$var$remove(data[2]);
            $15b6935538b1baf3$var$display(img, "");
            emit($15b6935538b1baf3$export$9f64346e17f0ec8e, img, Slide);
            emit($15b6935538b1baf3$export$7e019dae5103a285);
        }
        isSequential && loadNext();
    };
    var loadNext = function loadNext() {
        entries.length && load(entries.shift());
    };
    var _EventInterface11 = $15b6935538b1baf3$export$f188226459c8a3ff(Splide2), on = _EventInterface11.on, off = _EventInterface11.off, bind = _EventInterface11.bind, emit = _EventInterface11.emit;
    var isSequential = options.lazyLoad === "sequential";
    var events = [
        $15b6935538b1baf3$export$fe5802204b967f0d,
        $15b6935538b1baf3$export$ff8164bff3202b9
    ];
    var entries = [];
    return {
        mount: mount,
        destroy: $15b6935538b1baf3$var$apply($15b6935538b1baf3$var$empty, entries),
        check: check
    };
}
function $15b6935538b1baf3$var$Pagination(Splide2, Components2, options) {
    var destroy = function destroy() {
        if (list) {
            $15b6935538b1baf3$var$remove(placeholder ? $15b6935538b1baf3$var$slice(list.children) : list);
            $15b6935538b1baf3$var$removeClass(list, paginationClasses);
            $15b6935538b1baf3$var$empty(items);
            list = null;
        }
        event.destroy();
    };
    var createPagination = function createPagination() {
        var length = Splide2.length;
        var classes = options.classes, i18n = options.i18n, perPage = options.perPage;
        var max = hasFocus() ? _$Controller.getEnd() + 1 : $15b6935538b1baf3$var$ceil(length / perPage);
        list = placeholder || $15b6935538b1baf3$var$create("ul", classes.pagination, _$Elements.track.parentElement);
        $15b6935538b1baf3$var$addClass(list, paginationClasses = $15b6935538b1baf3$export$cbf8e5a0ab95eda3 + "--" + getDirection());
        $15b6935538b1baf3$var$setAttribute(list, $15b6935538b1baf3$var$ROLE, "tablist");
        $15b6935538b1baf3$var$setAttribute(list, $15b6935538b1baf3$var$ARIA_LABEL, i18n.select);
        $15b6935538b1baf3$var$setAttribute(list, $15b6935538b1baf3$var$ARIA_ORIENTATION, getDirection() === $15b6935538b1baf3$export$97170d9824b89709 ? "vertical" : "");
        for(var i = 0; i < max; i++){
            var li = $15b6935538b1baf3$var$create("li", null, list);
            var button = $15b6935538b1baf3$var$create("button", {
                class: classes.page,
                type: "button"
            }, li);
            var controls = _$Slides.getIn(i).map(function(Slide) {
                return Slide.slide.id;
            });
            var text = !hasFocus() && perPage > 1 ? i18n.pageX : i18n.slideX;
            bind(button, "click", $15b6935538b1baf3$var$apply(onClick, i));
            if (options.paginationKeyboard) bind(button, "keydown", $15b6935538b1baf3$var$apply(onKeydown, i));
            $15b6935538b1baf3$var$setAttribute(li, $15b6935538b1baf3$var$ROLE, "presentation");
            $15b6935538b1baf3$var$setAttribute(button, $15b6935538b1baf3$var$ROLE, "tab");
            $15b6935538b1baf3$var$setAttribute(button, $15b6935538b1baf3$var$ARIA_CONTROLS, controls.join(" "));
            $15b6935538b1baf3$var$setAttribute(button, $15b6935538b1baf3$var$ARIA_LABEL, $15b6935538b1baf3$var$format(text, i + 1));
            $15b6935538b1baf3$var$setAttribute(button, $15b6935538b1baf3$var$TAB_INDEX, -1);
            items.push({
                li: li,
                button: button,
                page: i
            });
        }
    };
    var onClick = function onClick(page) {
        go(">" + page, true);
    };
    var onKeydown = function onKeydown(page, e) {
        var length = items.length;
        var key = $15b6935538b1baf3$var$normalizeKey(e);
        var dir = getDirection();
        var nextPage = -1;
        if (key === resolve($15b6935538b1baf3$var$ARROW_RIGHT, false, dir)) nextPage = ++page % length;
        else if (key === resolve($15b6935538b1baf3$var$ARROW_LEFT, false, dir)) nextPage = (--page + length) % length;
        else if (key === "Home") nextPage = 0;
        else if (key === "End") nextPage = length - 1;
        var item = items[nextPage];
        if (item) {
            $15b6935538b1baf3$var$focus(item.button);
            go(">" + nextPage);
            $15b6935538b1baf3$var$prevent(e, true);
        }
    };
    var getDirection = function getDirection() {
        return options.paginationDirection || options.direction;
    };
    var getAt = function getAt(index) {
        return items[_$Controller.toPage(index)];
    };
    var update = function update() {
        var prev = getAt(getIndex(true));
        var curr = getAt(getIndex());
        if (prev) {
            var button = prev.button;
            $15b6935538b1baf3$var$removeClass(button, $15b6935538b1baf3$export$72d36ecf3758cb4b);
            $15b6935538b1baf3$var$removeAttribute(button, $15b6935538b1baf3$var$ARIA_SELECTED);
            $15b6935538b1baf3$var$setAttribute(button, $15b6935538b1baf3$var$TAB_INDEX, -1);
        }
        if (curr) {
            var _button = curr.button;
            $15b6935538b1baf3$var$addClass(_button, $15b6935538b1baf3$export$72d36ecf3758cb4b);
            $15b6935538b1baf3$var$setAttribute(_button, $15b6935538b1baf3$var$ARIA_SELECTED, true);
            $15b6935538b1baf3$var$setAttribute(_button, $15b6935538b1baf3$var$TAB_INDEX, "");
        }
        emit($15b6935538b1baf3$export$eb2019082ed6de0b, {
            list: list,
            items: items
        }, prev, curr);
    };
    var event = $15b6935538b1baf3$export$f188226459c8a3ff(Splide2);
    var on = event.on, emit = event.emit, bind = event.bind;
    var _$Slides = Components2.Slides, _$Elements = Components2.Elements, _$Controller = Components2.Controller;
    var hasFocus = _$Controller.hasFocus, getIndex = _$Controller.getIndex, go = _$Controller.go;
    var resolve = Components2.Direction.resolve;
    var placeholder = _$Elements.pagination;
    var items = [];
    var list;
    var paginationClasses;
    function mount() {
        destroy();
        on([
            $15b6935538b1baf3$export$db40ab7c0855fa5c,
            $15b6935538b1baf3$export$7f4701ac5e05e39f,
            $15b6935538b1baf3$export$28dea85f216954dc
        ], mount);
        var enabled = options.pagination;
        placeholder && $15b6935538b1baf3$var$display(placeholder, enabled ? "" : "none");
        if (enabled) {
            on([
                $15b6935538b1baf3$export$2aa493d7c3275167,
                $15b6935538b1baf3$export$49801896908b5e33,
                $15b6935538b1baf3$export$ff8164bff3202b9
            ], update);
            createPagination();
            update();
            emit($15b6935538b1baf3$export$bf89a4e4349c9778, {
                list: list,
                items: items
            }, getAt(Splide2.index));
        }
    }
    return {
        items: items,
        mount: mount,
        destroy: destroy,
        getAt: getAt,
        update: update
    };
}
var $15b6935538b1baf3$var$TRIGGER_KEYS = [
    " ",
    "Enter"
];
function $15b6935538b1baf3$var$Sync(Splide2, Components2, options) {
    var mount = function mount() {
        Splide2.splides.forEach(function(target) {
            if (!target.isParent) {
                sync(Splide2, target.splide);
                sync(target.splide, Splide2);
            }
        });
        if (isNavigation) navigate();
    };
    var destroy = function destroy() {
        events.forEach(function(event) {
            event.destroy();
        });
        $15b6935538b1baf3$var$empty(events);
    };
    var remount = function remount() {
        destroy();
        mount();
    };
    var sync = function sync(splide, target) {
        var event = $15b6935538b1baf3$export$f188226459c8a3ff(splide);
        event.on($15b6935538b1baf3$export$2aa493d7c3275167, function(index, prev, dest) {
            target.go(target.is($15b6935538b1baf3$export$f42383286ed1223d) ? dest : index);
        });
        events.push(event);
    };
    var navigate = function navigate() {
        var event = $15b6935538b1baf3$export$f188226459c8a3ff(Splide2);
        var on = event.on;
        on($15b6935538b1baf3$export$5adb665701eda1ce, onClick);
        on($15b6935538b1baf3$export$6d5af59619d10e6a, onKeydown);
        on([
            $15b6935538b1baf3$export$d300dc1a2634364b,
            $15b6935538b1baf3$export$db40ab7c0855fa5c
        ], update);
        events.push(event);
        event.emit($15b6935538b1baf3$export$84015c33508f94ec, Splide2.splides);
    };
    var update = function update() {
        $15b6935538b1baf3$var$setAttribute(Components2.Elements.list, $15b6935538b1baf3$var$ARIA_ORIENTATION, options.direction === $15b6935538b1baf3$export$97170d9824b89709 ? "vertical" : "");
    };
    var onClick = function onClick(Slide) {
        Splide2.go(Slide.index);
    };
    var onKeydown = function onKeydown(Slide, e) {
        if ($15b6935538b1baf3$var$includes($15b6935538b1baf3$var$TRIGGER_KEYS, $15b6935538b1baf3$var$normalizeKey(e))) {
            onClick(Slide);
            $15b6935538b1baf3$var$prevent(e);
        }
    };
    var isNavigation = options.isNavigation, slideFocus = options.slideFocus;
    var events = [];
    return {
        setup: $15b6935538b1baf3$var$apply(Components2.Media.set, {
            slideFocus: $15b6935538b1baf3$var$isUndefined(slideFocus) ? isNavigation : slideFocus
        }, true),
        mount: mount,
        destroy: destroy,
        remount: remount
    };
}
function $15b6935538b1baf3$var$Wheel(Splide2, Components2, options) {
    var mount = function mount() {
        if (options.wheel) bind(Components2.Elements.track, "wheel", onWheel, $15b6935538b1baf3$var$SCROLL_LISTENER_OPTIONS);
    };
    var onWheel = function onWheel(e) {
        if (e.cancelable) {
            var deltaY = e.deltaY;
            var backwards = deltaY < 0;
            var timeStamp = $15b6935538b1baf3$var$timeOf(e);
            var _min = options.wheelMinThreshold || 0;
            var sleep = options.wheelSleep || 0;
            if ($15b6935538b1baf3$var$abs(deltaY) > _min && timeStamp - lastTime > sleep) {
                Splide2.go(backwards ? "<" : ">");
                lastTime = timeStamp;
            }
            shouldPrevent(backwards) && $15b6935538b1baf3$var$prevent(e);
        }
    };
    var shouldPrevent = function shouldPrevent(backwards) {
        return !options.releaseWheel || Splide2.state.is($15b6935538b1baf3$var$MOVING) || Components2.Controller.getAdjacent(backwards) !== -1;
    };
    var _EventInterface12 = $15b6935538b1baf3$export$f188226459c8a3ff(Splide2), bind = _EventInterface12.bind;
    var lastTime = 0;
    return {
        mount: mount
    };
}
var $15b6935538b1baf3$var$SR_REMOVAL_DELAY = 90;
function $15b6935538b1baf3$var$Live(Splide2, Components2, options) {
    var mount = function mount() {
        if (enabled) {
            disable(!Components2.Autoplay.isPaused());
            $15b6935538b1baf3$var$setAttribute(track, $15b6935538b1baf3$var$ARIA_ATOMIC, true);
            sr.textContent = "…";
            on($15b6935538b1baf3$export$23663268a31b79e2, $15b6935538b1baf3$var$apply(disable, true));
            on($15b6935538b1baf3$export$16a1e4f3d0368265, $15b6935538b1baf3$var$apply(disable, false));
            on([
                $15b6935538b1baf3$export$fe5802204b967f0d,
                $15b6935538b1baf3$export$ff8164bff3202b9
            ], $15b6935538b1baf3$var$apply(toggle, true));
        }
    };
    var toggle = function toggle(active) {
        $15b6935538b1baf3$var$setAttribute(track, $15b6935538b1baf3$var$ARIA_BUSY, active);
        if (active) {
            $15b6935538b1baf3$var$append(track, sr);
            interval.start();
        } else {
            $15b6935538b1baf3$var$remove(sr);
            interval.cancel();
        }
    };
    var destroy = function destroy() {
        $15b6935538b1baf3$var$removeAttribute(track, [
            $15b6935538b1baf3$var$ARIA_LIVE,
            $15b6935538b1baf3$var$ARIA_ATOMIC,
            $15b6935538b1baf3$var$ARIA_BUSY
        ]);
        $15b6935538b1baf3$var$remove(sr);
    };
    var disable = function disable(disabled) {
        if (enabled) $15b6935538b1baf3$var$setAttribute(track, $15b6935538b1baf3$var$ARIA_LIVE, disabled ? "off" : "polite");
    };
    var _EventInterface13 = $15b6935538b1baf3$export$f188226459c8a3ff(Splide2), on = _EventInterface13.on;
    var track = Components2.Elements.track;
    var enabled = options.live && !options.isNavigation;
    var sr = $15b6935538b1baf3$var$create("span", $15b6935538b1baf3$export$bb78d7c200da8960);
    var interval = $15b6935538b1baf3$export$46ad21b25b6dccf0($15b6935538b1baf3$var$SR_REMOVAL_DELAY, $15b6935538b1baf3$var$apply(toggle, false));
    return {
        mount: mount,
        disable: disable,
        destroy: destroy
    };
}
var $15b6935538b1baf3$var$ComponentConstructors = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    Media: $15b6935538b1baf3$var$Media,
    Direction: $15b6935538b1baf3$var$Direction,
    Elements: $15b6935538b1baf3$var$Elements,
    Slides: $15b6935538b1baf3$var$Slides,
    Layout: $15b6935538b1baf3$var$Layout,
    Clones: $15b6935538b1baf3$var$Clones,
    Move: $15b6935538b1baf3$var$Move,
    Controller: $15b6935538b1baf3$var$Controller,
    Arrows: $15b6935538b1baf3$var$Arrows,
    Autoplay: $15b6935538b1baf3$var$Autoplay,
    Cover: $15b6935538b1baf3$var$Cover,
    Scroll: $15b6935538b1baf3$var$Scroll,
    Drag: $15b6935538b1baf3$var$Drag,
    Keyboard: $15b6935538b1baf3$var$Keyboard,
    LazyLoad: $15b6935538b1baf3$var$LazyLoad,
    Pagination: $15b6935538b1baf3$var$Pagination,
    Sync: $15b6935538b1baf3$var$Sync,
    Wheel: $15b6935538b1baf3$var$Wheel,
    Live: $15b6935538b1baf3$var$Live
});
var $15b6935538b1baf3$var$I18N = {
    prev: "Previous slide",
    next: "Next slide",
    first: "Go to first slide",
    last: "Go to last slide",
    slideX: "Go to slide %s",
    pageX: "Go to page %s",
    play: "Start autoplay",
    pause: "Pause autoplay",
    carousel: "carousel",
    slide: "slide",
    select: "Select a slide to show",
    slideLabel: "%s of %s"
};
var $15b6935538b1baf3$export$f484e977a69c6ba6 = {
    type: "slide",
    role: "region",
    speed: 400,
    perPage: 1,
    cloneStatus: true,
    arrows: true,
    pagination: true,
    paginationKeyboard: true,
    interval: 5e3,
    pauseOnHover: true,
    pauseOnFocus: true,
    resetProgress: true,
    easing: "cubic-bezier(0.25, 1, 0.5, 1)",
    drag: true,
    direction: "ltr",
    trimSpace: true,
    focusableNodes: "a, button, textarea, input, select, iframe",
    live: true,
    classes: $15b6935538b1baf3$export$ba41d43e4a419565,
    i18n: $15b6935538b1baf3$var$I18N,
    reducedMotion: {
        speed: 0,
        rewindSpeed: 0,
        autoplay: "pause"
    }
};
function $15b6935538b1baf3$var$Fade(Splide2, Components2, options) {
    var mount = function mount() {
        $15b6935538b1baf3$export$f188226459c8a3ff(Splide2).on([
            $15b6935538b1baf3$export$d300dc1a2634364b,
            $15b6935538b1baf3$export$7f4701ac5e05e39f
        ], init);
    };
    var init = function init() {
        _$Slides.forEach(function(Slide) {
            Slide.style("transform", "translateX(-" + 100 * Slide.index + "%)");
        });
    };
    var start = function start(index, done) {
        _$Slides.style("transition", "opacity " + options.speed + "ms " + options.easing);
        $15b6935538b1baf3$var$nextTick(done);
    };
    var _$Slides = Components2.Slides;
    return {
        mount: mount,
        start: start,
        cancel: $15b6935538b1baf3$var$noop
    };
}
function $15b6935538b1baf3$var$Slide(Splide2, Components2, options) {
    var mount = function mount() {
        $15b6935538b1baf3$export$f188226459c8a3ff(Splide2).bind(list, "transitionend", function(e) {
            if (e.target === list && endCallback) {
                cancel();
                endCallback();
            }
        });
    };
    var start = function start(index, done) {
        var destination = _$Move.toPosition(index, true);
        var position = _$Move.getPosition();
        var speed = getSpeed(index);
        if ($15b6935538b1baf3$var$abs(destination - position) >= 1 && speed >= 1) {
            if (options.useScroll) _$Scroll.scroll(destination, speed, false, done);
            else {
                transition("transform " + speed + "ms " + options.easing);
                _$Move.translate(destination, true);
                endCallback = done;
            }
        } else {
            _$Move.jump(index);
            done();
        }
    };
    var cancel = function cancel() {
        transition("");
        _$Scroll.cancel();
    };
    var getSpeed = function getSpeed(index) {
        var rewindSpeed = options.rewindSpeed;
        if (Splide2.is($15b6935538b1baf3$export$e5a58a5ee5b54c22) && rewindSpeed) {
            var prev = _$Controller.getIndex(true);
            var end = _$Controller.getEnd();
            if (prev === 0 && index >= end || prev >= end && index === 0) return rewindSpeed;
        }
        return options.speed;
    };
    var _$Move = Components2.Move, _$Controller = Components2.Controller, _$Scroll = Components2.Scroll;
    var list = Components2.Elements.list;
    var transition = $15b6935538b1baf3$var$apply($15b6935538b1baf3$var$style, list, "transition");
    var endCallback;
    return {
        mount: mount,
        start: start,
        cancel: cancel
    };
}
var $15b6935538b1baf3$var$_Splide = /*#__PURE__*/ function() {
    function _Splide(target, options) {
        this.event = $15b6935538b1baf3$export$f188226459c8a3ff();
        this.Components = {};
        this.state = $15b6935538b1baf3$export$7254cc27399e90bd($15b6935538b1baf3$var$CREATED);
        this.splides = [];
        this._o = {};
        this._E = {};
        var root = $15b6935538b1baf3$var$isString(target) ? $15b6935538b1baf3$var$query(document, target) : target;
        $15b6935538b1baf3$var$assert(root, root + " is invalid.");
        this.root = root;
        options = $15b6935538b1baf3$var$merge({
            label: $15b6935538b1baf3$var$getAttribute(root, $15b6935538b1baf3$var$ARIA_LABEL) || "",
            labelledby: $15b6935538b1baf3$var$getAttribute(root, $15b6935538b1baf3$var$ARIA_LABELLEDBY) || ""
        }, $15b6935538b1baf3$export$f484e977a69c6ba6, _Splide.defaults, options || {});
        try {
            $15b6935538b1baf3$var$merge(options, JSON.parse($15b6935538b1baf3$var$getAttribute(root, $15b6935538b1baf3$var$DATA_ATTRIBUTE)));
        } catch (e) {
            $15b6935538b1baf3$var$assert(false, "Invalid JSON");
        }
        this._o = Object.create($15b6935538b1baf3$var$merge({}, options));
    }
    var _proto = _Splide.prototype;
    _proto.mount = function mount(Extensions, Transition) {
        var _this = this;
        var state = this.state, Components2 = this.Components;
        $15b6935538b1baf3$var$assert(state.is([
            $15b6935538b1baf3$var$CREATED,
            $15b6935538b1baf3$var$DESTROYED
        ]), "Already mounted!");
        state.set($15b6935538b1baf3$var$CREATED);
        this._C = Components2;
        this._T = Transition || this._T || (this.is($15b6935538b1baf3$export$742b62a5690c060) ? $15b6935538b1baf3$var$Fade : $15b6935538b1baf3$var$Slide);
        this._E = Extensions || this._E;
        var Constructors = $15b6935538b1baf3$var$assign({}, $15b6935538b1baf3$var$ComponentConstructors, this._E, {
            Transition: this._T
        });
        $15b6935538b1baf3$var$forOwn(Constructors, function(Component, key) {
            var component = Component(_this, Components2, _this._o);
            Components2[key] = component;
            component.setup && component.setup();
        });
        $15b6935538b1baf3$var$forOwn(Components2, function(component) {
            component.mount && component.mount();
        });
        this.emit($15b6935538b1baf3$export$d300dc1a2634364b);
        $15b6935538b1baf3$var$addClass(this.root, $15b6935538b1baf3$export$7761661e2d5b9388);
        state.set($15b6935538b1baf3$var$IDLE);
        this.emit($15b6935538b1baf3$export$d8dac49b4532735a);
        return this;
    };
    _proto.sync = function sync(splide) {
        this.splides.push({
            splide: splide
        });
        splide.splides.push({
            splide: this,
            isParent: true
        });
        if (this.state.is($15b6935538b1baf3$var$IDLE)) {
            this._C.Sync.remount();
            splide.Components.Sync.remount();
        }
        return this;
    };
    _proto.go = function go(control) {
        this._C.Controller.go(control);
        return this;
    };
    _proto.on = function on(events, callback) {
        this.event.on(events, callback);
        return this;
    };
    _proto.off = function off(events) {
        this.event.off(events);
        return this;
    };
    _proto.emit = function emit(event) {
        var _this$event;
        (_this$event = this.event).emit.apply(_this$event, [
            event
        ].concat($15b6935538b1baf3$var$slice(arguments, 1)));
        return this;
    };
    _proto.add = function add(slides, index) {
        this._C.Slides.add(slides, index);
        return this;
    };
    _proto.remove = function remove(matcher) {
        this._C.Slides.remove(matcher);
        return this;
    };
    _proto.is = function is(type) {
        return this._o.type === type;
    };
    _proto.refresh = function refresh() {
        this.emit($15b6935538b1baf3$export$7f4701ac5e05e39f);
        return this;
    };
    _proto.destroy = function destroy(completely) {
        if (completely === void 0) completely = true;
        var event = this.event, state = this.state;
        if (state.is($15b6935538b1baf3$var$CREATED)) $15b6935538b1baf3$export$f188226459c8a3ff(this).on($15b6935538b1baf3$export$d8dac49b4532735a, this.destroy.bind(this, completely));
        else {
            $15b6935538b1baf3$var$forOwn(this._C, function(component) {
                component.destroy && component.destroy(completely);
            }, true);
            event.emit($15b6935538b1baf3$export$88c4cf7419e470cd);
            event.destroy();
            completely && $15b6935538b1baf3$var$empty(this.splides);
            state.set($15b6935538b1baf3$var$DESTROYED);
        }
        return this;
    };
    $15b6935538b1baf3$var$_createClass(_Splide, [
        {
            key: "options",
            get: function get() {
                return this._o;
            },
            set: function set(options) {
                this._C.Media.set(options, true, true);
            }
        },
        {
            key: "length",
            get: function get() {
                return this._C.Slides.getLength(true);
            }
        },
        {
            key: "index",
            get: function get() {
                return this._C.Controller.getIndex();
            }
        }
    ]);
    return _Splide;
}();
var $15b6935538b1baf3$export$24494c7438c070bf = $15b6935538b1baf3$var$_Splide;
$15b6935538b1baf3$export$24494c7438c070bf.defaults = {};
$15b6935538b1baf3$export$24494c7438c070bf.STATES = $15b6935538b1baf3$var$STATES;
var $15b6935538b1baf3$var$CLASS_RENDERED = "is-rendered";
var $15b6935538b1baf3$var$RENDERER_DEFAULT_CONFIG = {
    listTag: "ul",
    slideTag: "li"
};
var $15b6935538b1baf3$var$Style = /*#__PURE__*/ function() {
    var Style = function Style(id, options) {
        this.styles = {};
        this.id = id;
        this.options = options;
    };
    var _proto2 = Style.prototype;
    _proto2.rule = function rule(selector, prop, value, breakpoint) {
        breakpoint = breakpoint || "default";
        var selectors = this.styles[breakpoint] = this.styles[breakpoint] || {};
        var styles = selectors[selector] = selectors[selector] || {};
        styles[prop] = value;
    };
    _proto2.build = function build() {
        var _this2 = this;
        var css = "";
        if (this.styles.default) css += this.buildSelectors(this.styles.default);
        Object.keys(this.styles).sort(function(n, m) {
            return _this2.options.mediaQuery === "min" ? +n - +m : +m - +n;
        }).forEach(function(breakpoint) {
            if (breakpoint !== "default") {
                css += "@media screen and (max-width: " + breakpoint + "px) {";
                css += _this2.buildSelectors(_this2.styles[breakpoint]);
                css += "}";
            }
        });
        return css;
    };
    _proto2.buildSelectors = function buildSelectors(selectors) {
        var _this3 = this;
        var css = "";
        $15b6935538b1baf3$var$forOwn(selectors, function(styles, selector) {
            selector = ("#" + _this3.id + " " + selector).trim();
            css += selector + " {";
            $15b6935538b1baf3$var$forOwn(styles, function(value, prop) {
                if (value || value === 0) css += prop + ": " + value + ";";
            });
            css += "}";
        });
        return css;
    };
    return Style;
}();
var $15b6935538b1baf3$export$c0daaea79e41d7df = /*#__PURE__*/ function() {
    var SplideRenderer = function SplideRenderer(contents, options, config, defaults) {
        this.slides = [];
        this.options = {};
        this.breakpoints = [];
        $15b6935538b1baf3$var$merge($15b6935538b1baf3$export$f484e977a69c6ba6, defaults || {});
        $15b6935538b1baf3$var$merge($15b6935538b1baf3$var$merge(this.options, $15b6935538b1baf3$export$f484e977a69c6ba6), options || {});
        this.contents = contents;
        this.config = $15b6935538b1baf3$var$assign({}, $15b6935538b1baf3$var$RENDERER_DEFAULT_CONFIG, config || {});
        this.id = this.config.id || $15b6935538b1baf3$var$uniqueId("splide");
        this.Style = new $15b6935538b1baf3$var$Style(this.id, this.options);
        this.Direction = $15b6935538b1baf3$var$Direction(null, null, this.options);
        $15b6935538b1baf3$var$assert(this.contents.length, "Provide at least 1 content.");
        this.init();
    };
    SplideRenderer.clean = function clean(splide) {
        var _EventInterface14 = $15b6935538b1baf3$export$f188226459c8a3ff(splide), on = _EventInterface14.on;
        var root = splide.root;
        var clones = $15b6935538b1baf3$var$queryAll(root, "." + $15b6935538b1baf3$export$2c1ba4a4f1aa4947);
        on($15b6935538b1baf3$export$d300dc1a2634364b, function() {
            $15b6935538b1baf3$var$remove($15b6935538b1baf3$var$child(root, "style"));
        });
        $15b6935538b1baf3$var$remove(clones);
    };
    var _proto3 = SplideRenderer.prototype;
    _proto3.init = function init() {
        this.parseBreakpoints();
        this.initSlides();
        this.registerRootStyles();
        this.registerTrackStyles();
        this.registerSlideStyles();
        this.registerListStyles();
    };
    _proto3.initSlides = function initSlides() {
        var _this4 = this;
        $15b6935538b1baf3$var$push(this.slides, this.contents.map(function(content, index) {
            content = $15b6935538b1baf3$var$isString(content) ? {
                html: content
            } : content;
            content.styles = content.styles || {};
            content.attrs = content.attrs || {};
            _this4.cover(content);
            var classes = _this4.options.classes.slide + " " + (index === 0 ? $15b6935538b1baf3$export$72d36ecf3758cb4b : "");
            $15b6935538b1baf3$var$assign(content.attrs, {
                class: (classes + " " + (content.attrs.class || "")).trim(),
                style: _this4.buildStyles(content.styles)
            });
            return content;
        }));
        if (this.isLoop()) this.generateClones(this.slides);
    };
    _proto3.registerRootStyles = function registerRootStyles() {
        var _this5 = this;
        this.breakpoints.forEach(function(_ref2) {
            var width = _ref2[0], options = _ref2[1];
            _this5.Style.rule(" ", "max-width", $15b6935538b1baf3$var$unit(options.width), width);
        });
    };
    _proto3.registerTrackStyles = function registerTrackStyles() {
        var _this6 = this;
        var Style2 = this.Style;
        var selector = "." + $15b6935538b1baf3$export$7738b09ac0a98952;
        this.breakpoints.forEach(function(_ref3) {
            var width = _ref3[0], options = _ref3[1];
            Style2.rule(selector, _this6.resolve("paddingLeft"), _this6.cssPadding(options, false), width);
            Style2.rule(selector, _this6.resolve("paddingRight"), _this6.cssPadding(options, true), width);
            Style2.rule(selector, "height", _this6.cssTrackHeight(options), width);
        });
    };
    _proto3.registerListStyles = function registerListStyles() {
        var _this7 = this;
        var Style2 = this.Style;
        var selector = "." + $15b6935538b1baf3$export$19cc2a5451235cae;
        this.breakpoints.forEach(function(_ref4) {
            var width = _ref4[0], options = _ref4[1];
            Style2.rule(selector, "transform", _this7.buildTranslate(options), width);
            if (!_this7.cssSlideHeight(options)) Style2.rule(selector, "aspect-ratio", _this7.cssAspectRatio(options), width);
        });
    };
    _proto3.registerSlideStyles = function registerSlideStyles() {
        var _this8 = this;
        var Style2 = this.Style;
        var selector = "." + $15b6935538b1baf3$export$8d922915837a38d3;
        this.breakpoints.forEach(function(_ref5) {
            var width = _ref5[0], options = _ref5[1];
            Style2.rule(selector, "width", _this8.cssSlideWidth(options), width);
            Style2.rule(selector, "height", _this8.cssSlideHeight(options) || "100%", width);
            Style2.rule(selector, _this8.resolve("marginRight"), $15b6935538b1baf3$var$unit(options.gap) || "0px", width);
            Style2.rule(selector + " > img", "display", options.cover ? "none" : "inline", width);
        });
    };
    _proto3.buildTranslate = function buildTranslate(options) {
        var _this$Direction = this.Direction, resolve = _this$Direction.resolve, orient = _this$Direction.orient;
        var values = [];
        values.push(this.cssOffsetClones(options));
        values.push(this.cssOffsetGaps(options));
        if (this.isCenter(options)) {
            values.push(this.buildCssValue(orient(-50), "%"));
            values.push.apply(values, this.cssOffsetCenter(options));
        }
        return values.filter(Boolean).map(function(value) {
            return "translate" + resolve("X") + "(" + value + ")";
        }).join(" ");
    };
    _proto3.cssOffsetClones = function cssOffsetClones(options) {
        var _this$Direction2 = this.Direction, resolve = _this$Direction2.resolve, orient = _this$Direction2.orient;
        var cloneCount = this.getCloneCount();
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue.value, unit2 = _this$parseCssValue.unit;
            return this.buildCssValue(orient(value) * cloneCount, unit2);
        }
        var percent = 100 * cloneCount / options.perPage;
        return orient(percent) + "%";
    };
    _proto3.cssOffsetCenter = function cssOffsetCenter(options) {
        var _this$Direction3 = this.Direction, resolve = _this$Direction3.resolve, orient = _this$Direction3.orient;
        if (this.isFixedWidth(options)) {
            var _this$parseCssValue2 = this.parseCssValue(options[resolve("fixedWidth")]), value = _this$parseCssValue2.value, unit2 = _this$parseCssValue2.unit;
            return [
                this.buildCssValue(orient(value / 2), unit2)
            ];
        }
        var values = [];
        var perPage = options.perPage, gap = options.gap;
        values.push(orient(50 / perPage) + "%");
        if (gap) {
            var _this$parseCssValue3 = this.parseCssValue(gap), _value = _this$parseCssValue3.value, _unit = _this$parseCssValue3.unit;
            var gapOffset = (_value / perPage - _value) / 2;
            values.push(this.buildCssValue(orient(gapOffset), _unit));
        }
        return values;
    };
    _proto3.cssOffsetGaps = function cssOffsetGaps(options) {
        var cloneCount = this.getCloneCount();
        if (cloneCount && options.gap) {
            var orient = this.Direction.orient;
            var _this$parseCssValue4 = this.parseCssValue(options.gap), value = _this$parseCssValue4.value, unit2 = _this$parseCssValue4.unit;
            if (this.isFixedWidth(options)) return this.buildCssValue(orient(value * cloneCount), unit2);
            var perPage = options.perPage;
            var gaps = cloneCount / perPage;
            return this.buildCssValue(orient(gaps * value), unit2);
        }
        return "";
    };
    _proto3.resolve = function resolve(prop) {
        return $15b6935538b1baf3$var$camelToKebab(this.Direction.resolve(prop));
    };
    _proto3.cssPadding = function cssPadding(options, right) {
        var padding = options.padding;
        var prop = this.Direction.resolve(right ? "right" : "left", true);
        return padding && $15b6935538b1baf3$var$unit(padding[prop] || ($15b6935538b1baf3$var$isObject(padding) ? 0 : padding)) || "0px";
    };
    _proto3.cssTrackHeight = function cssTrackHeight(options) {
        var height = "";
        if (this.isVertical()) {
            height = this.cssHeight(options);
            $15b6935538b1baf3$var$assert(height, '"height" is missing.');
            height = "calc(" + height + " - " + this.cssPadding(options, false) + " - " + this.cssPadding(options, true) + ")";
        }
        return height;
    };
    _proto3.cssHeight = function cssHeight(options) {
        return $15b6935538b1baf3$var$unit(options.height);
    };
    _proto3.cssSlideWidth = function cssSlideWidth(options) {
        return options.autoWidth ? "" : $15b6935538b1baf3$var$unit(options.fixedWidth) || (this.isVertical() ? "" : this.cssSlideSize(options));
    };
    _proto3.cssSlideHeight = function cssSlideHeight(options) {
        return $15b6935538b1baf3$var$unit(options.fixedHeight) || (this.isVertical() ? options.autoHeight ? "" : this.cssSlideSize(options) : this.cssHeight(options));
    };
    _proto3.cssSlideSize = function cssSlideSize(options) {
        var gap = $15b6935538b1baf3$var$unit(options.gap);
        return "calc((100%" + (gap && " + " + gap) + ")/" + (options.perPage || 1) + (gap && " - " + gap) + ")";
    };
    _proto3.cssAspectRatio = function cssAspectRatio(options) {
        var heightRatio = options.heightRatio;
        return heightRatio ? "" + 1 / heightRatio : "";
    };
    _proto3.buildCssValue = function buildCssValue(value, unit2) {
        return "" + value + unit2;
    };
    _proto3.parseCssValue = function parseCssValue(value) {
        if ($15b6935538b1baf3$var$isString(value)) {
            var number = parseFloat(value) || 0;
            var unit2 = value.replace(/\d*(\.\d*)?/, "") || "px";
            return {
                value: number,
                unit: unit2
            };
        }
        return {
            value: value,
            unit: "px"
        };
    };
    _proto3.parseBreakpoints = function parseBreakpoints() {
        var _this9 = this;
        var breakpoints = this.options.breakpoints;
        this.breakpoints.push([
            "default",
            this.options
        ]);
        if (breakpoints) $15b6935538b1baf3$var$forOwn(breakpoints, function(options, width) {
            _this9.breakpoints.push([
                width,
                $15b6935538b1baf3$var$merge($15b6935538b1baf3$var$merge({}, _this9.options), options)
            ]);
        });
    };
    _proto3.isFixedWidth = function isFixedWidth(options) {
        return !!options[this.Direction.resolve("fixedWidth")];
    };
    _proto3.isLoop = function isLoop() {
        return this.options.type === $15b6935538b1baf3$export$f42383286ed1223d;
    };
    _proto3.isCenter = function isCenter(options) {
        if (options.focus === "center") {
            if (this.isLoop()) return true;
            if (this.options.type === $15b6935538b1baf3$export$e5a58a5ee5b54c22) return !this.options.trimSpace;
        }
        return false;
    };
    _proto3.isVertical = function isVertical() {
        return this.options.direction === $15b6935538b1baf3$export$97170d9824b89709;
    };
    _proto3.buildClasses = function buildClasses() {
        var options = this.options;
        return [
            $15b6935538b1baf3$export$93b21159ad85c843,
            $15b6935538b1baf3$export$93b21159ad85c843 + "--" + options.type,
            $15b6935538b1baf3$export$93b21159ad85c843 + "--" + options.direction,
            options.drag && $15b6935538b1baf3$export$93b21159ad85c843 + "--draggable",
            options.isNavigation && $15b6935538b1baf3$export$93b21159ad85c843 + "--nav",
            $15b6935538b1baf3$export$72d36ecf3758cb4b,
            !this.config.hidden && $15b6935538b1baf3$var$CLASS_RENDERED
        ].filter(Boolean).join(" ");
    };
    _proto3.buildAttrs = function buildAttrs(attrs) {
        var attr = "";
        $15b6935538b1baf3$var$forOwn(attrs, function(value, key) {
            attr += value ? " " + $15b6935538b1baf3$var$camelToKebab(key) + '="' + value + '"' : "";
        });
        return attr.trim();
    };
    _proto3.buildStyles = function buildStyles(styles) {
        var style = "";
        $15b6935538b1baf3$var$forOwn(styles, function(value, key) {
            style += " " + $15b6935538b1baf3$var$camelToKebab(key) + ":" + value + ";";
        });
        return style.trim();
    };
    _proto3.renderSlides = function renderSlides() {
        var _this10 = this;
        var tag = this.config.slideTag;
        return this.slides.map(function(content) {
            return "<" + tag + " " + _this10.buildAttrs(content.attrs) + ">" + (content.html || "") + "</" + tag + ">";
        }).join("");
    };
    _proto3.cover = function cover(content) {
        var styles = content.styles, _content$html = content.html, html = _content$html === void 0 ? "" : _content$html;
        if (this.options.cover && !this.options.lazyLoad) {
            var src = html.match(/<img.*?src\s*=\s*(['"])(.+?)\1.*?>/);
            if (src && src[2]) styles.background = "center/cover no-repeat url('" + src[2] + "')";
        }
    };
    _proto3.generateClones = function generateClones(contents) {
        var classes = this.options.classes;
        var count = this.getCloneCount();
        var slides = contents.slice();
        while(slides.length < count)$15b6935538b1baf3$var$push(slides, slides);
        $15b6935538b1baf3$var$push(slides.slice(-count).reverse(), slides.slice(0, count)).forEach(function(content, index) {
            var attrs = $15b6935538b1baf3$var$assign({}, content.attrs, {
                class: content.attrs.class + " " + classes.clone
            });
            var clone = $15b6935538b1baf3$var$assign({}, content, {
                attrs: attrs
            });
            index < count ? contents.unshift(clone) : contents.push(clone);
        });
    };
    _proto3.getCloneCount = function getCloneCount() {
        if (this.isLoop()) {
            var options = this.options;
            if (options.clones) return options.clones;
            var perPage = $15b6935538b1baf3$var$max.apply(void 0, this.breakpoints.map(function(_ref6) {
                var options2 = _ref6[1];
                return options2.perPage;
            }));
            return perPage * ((options.flickMaxPages || 1) + 1);
        }
        return 0;
    };
    _proto3.renderArrows = function renderArrows() {
        var html = "";
        html += '<div class="' + this.options.classes.arrows + '">';
        html += this.renderArrow(true);
        html += this.renderArrow(false);
        html += "</div>";
        return html;
    };
    _proto3.renderArrow = function renderArrow(prev) {
        var _this$options = this.options, classes = _this$options.classes, i18n = _this$options.i18n;
        var attrs = {
            class: classes.arrow + " " + (prev ? classes.prev : classes.next),
            type: "button",
            ariaLabel: prev ? i18n.prev : i18n.next
        };
        return "<button " + this.buildAttrs(attrs) + '><svg xmlns="' + $15b6935538b1baf3$var$XML_NAME_SPACE + '" viewBox="0 0 ' + $15b6935538b1baf3$var$SIZE + " " + $15b6935538b1baf3$var$SIZE + '" width="' + $15b6935538b1baf3$var$SIZE + '" height="' + $15b6935538b1baf3$var$SIZE + '"><path d="' + (this.options.arrowPath || $15b6935538b1baf3$var$PATH) + '" /></svg></button>';
    };
    _proto3.html = function html() {
        var _this$config = this.config, rootClass = _this$config.rootClass, listTag = _this$config.listTag, arrows = _this$config.arrows, beforeTrack = _this$config.beforeTrack, afterTrack = _this$config.afterTrack, slider = _this$config.slider, beforeSlider = _this$config.beforeSlider, afterSlider = _this$config.afterSlider;
        var html = "";
        html += '<div id="' + this.id + '" class="' + this.buildClasses() + " " + (rootClass || "") + '">';
        html += "<style>" + this.Style.build() + "</style>";
        if (slider) {
            html += beforeSlider || "";
            html += '<div class="splide__slider">';
        }
        html += beforeTrack || "";
        if (arrows) html += this.renderArrows();
        html += '<div class="splide__track">';
        html += "<" + listTag + ' class="splide__list">';
        html += this.renderSlides();
        html += "</" + listTag + ">";
        html += "</div>";
        html += afterTrack || "";
        if (slider) {
            html += "</div>";
            html += afterSlider || "";
        }
        html += "</div>";
        return html;
    };
    return SplideRenderer;
}();


/*!
 * @splidejs/splide-extension-auto-scroll
 * Version  : 0.5.3
 * License  : MIT
 * Copyright: 2022 Naotoshi Fujita
 */ 
var $2b6Uo = parcelRequire("2b6Uo");

var $22yUM = parcelRequire("22yUM");
function $86c9ea0cfb0ba07b$var$empty(array) {
    array.length = 0;
}
function $86c9ea0cfb0ba07b$var$slice$1(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $86c9ea0cfb0ba07b$var$apply$1(func) {
    return func.bind.apply(func, [
        null
    ].concat($86c9ea0cfb0ba07b$var$slice$1(arguments, 1)));
}
function $86c9ea0cfb0ba07b$var$raf(func) {
    return requestAnimationFrame(func);
}
function $86c9ea0cfb0ba07b$var$typeOf$1(type, subject) {
    return (typeof subject === "undefined" ? "undefined" : (0, $22yUM._)(subject)) === type;
}
var $86c9ea0cfb0ba07b$var$isArray$1 = Array.isArray;
$86c9ea0cfb0ba07b$var$apply$1($86c9ea0cfb0ba07b$var$typeOf$1, "function");
$86c9ea0cfb0ba07b$var$apply$1($86c9ea0cfb0ba07b$var$typeOf$1, "string");
$86c9ea0cfb0ba07b$var$apply$1($86c9ea0cfb0ba07b$var$typeOf$1, "undefined");
function $86c9ea0cfb0ba07b$var$toArray$1(value) {
    return $86c9ea0cfb0ba07b$var$isArray$1(value) ? value : [
        value
    ];
}
function $86c9ea0cfb0ba07b$var$forEach$1(values, iteratee) {
    $86c9ea0cfb0ba07b$var$toArray$1(values).forEach(iteratee);
}
var $86c9ea0cfb0ba07b$var$ownKeys$1 = Object.keys;
function $86c9ea0cfb0ba07b$var$forOwn$1(object, iteratee, right) {
    if (object) {
        var keys = $86c9ea0cfb0ba07b$var$ownKeys$1(object);
        keys = right ? keys.reverse() : keys;
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "__proto__") {
                if (iteratee(object[key], key) === false) break;
            }
        }
    }
    return object;
}
function $86c9ea0cfb0ba07b$var$assign$1(object) {
    $86c9ea0cfb0ba07b$var$slice$1(arguments, 1).forEach(function(source) {
        $86c9ea0cfb0ba07b$var$forOwn$1(source, function(value, key) {
            object[key] = source[key];
        });
    });
    return object;
}
var $86c9ea0cfb0ba07b$var$min$1 = Math.min;
function $86c9ea0cfb0ba07b$var$EventBinder() {
    var bind = function bind(targets, events, callback, options) {
        forEachEvent(targets, events, function(target, event, namespace) {
            var isEventTarget = "addEventListener" in target;
            var remover = isEventTarget ? target.removeEventListener.bind(target, event, callback, options) : target["removeListener"].bind(target, callback);
            isEventTarget ? target.addEventListener(event, callback, options) : target["addListener"](callback);
            listeners.push([
                target,
                event,
                namespace,
                callback,
                remover
            ]);
        });
    };
    var unbind = function unbind(targets, events, callback) {
        forEachEvent(targets, events, function(target, event, namespace) {
            listeners = listeners.filter(function(listener) {
                if (listener[0] === target && listener[1] === event && listener[2] === namespace && (!callback || listener[3] === callback)) {
                    listener[4]();
                    return false;
                }
                return true;
            });
        });
    };
    var dispatch = function dispatch(target, type, detail) {
        var e;
        var bubbles = true;
        if (typeof CustomEvent === "function") e = new CustomEvent(type, {
            bubbles: bubbles,
            detail: detail
        });
        else {
            e = document.createEvent("CustomEvent");
            e.initCustomEvent(type, bubbles, false, detail);
        }
        target.dispatchEvent(e);
        return e;
    };
    var forEachEvent = function forEachEvent(targets, events, iteratee) {
        $86c9ea0cfb0ba07b$var$forEach$1(targets, function(target) {
            target && $86c9ea0cfb0ba07b$var$forEach$1(events, function(events2) {
                events2.split(" ").forEach(function(eventNS) {
                    var fragment = eventNS.split(".");
                    iteratee(target, fragment[0], fragment[1]);
                });
            });
        });
    };
    var destroy = function destroy() {
        listeners.forEach(function(data) {
            data[4]();
        });
        $86c9ea0cfb0ba07b$var$empty(listeners);
    };
    var listeners = [];
    return {
        bind: bind,
        unbind: unbind,
        dispatch: dispatch,
        destroy: destroy
    };
}
var $86c9ea0cfb0ba07b$var$EVENT_MOVE = "move";
var $86c9ea0cfb0ba07b$var$EVENT_MOVED = "moved";
var $86c9ea0cfb0ba07b$var$EVENT_UPDATED = "updated";
var $86c9ea0cfb0ba07b$var$EVENT_DRAG = "drag";
var $86c9ea0cfb0ba07b$var$EVENT_DRAGGED = "dragged";
var $86c9ea0cfb0ba07b$var$EVENT_SCROLL = "scroll";
var $86c9ea0cfb0ba07b$var$EVENT_SCROLLED = "scrolled";
var $86c9ea0cfb0ba07b$var$EVENT_DESTROY = "destroy";
function $86c9ea0cfb0ba07b$var$EventInterface(Splide2) {
    var on = function on(events, callback) {
        binder.bind(bus, $86c9ea0cfb0ba07b$var$toArray$1(events).join(" "), function(e) {
            callback.apply(callback, $86c9ea0cfb0ba07b$var$isArray$1(e.detail) ? e.detail : []);
        });
    };
    var emit = function emit(event) {
        binder.dispatch(bus, event, $86c9ea0cfb0ba07b$var$slice$1(arguments, 1));
    };
    var bus = Splide2 ? Splide2.event.bus : document.createDocumentFragment();
    var binder = $86c9ea0cfb0ba07b$var$EventBinder();
    if (Splide2) Splide2.event.on($86c9ea0cfb0ba07b$var$EVENT_DESTROY, binder.destroy);
    return $86c9ea0cfb0ba07b$var$assign$1(binder, {
        bus: bus,
        on: on,
        off: $86c9ea0cfb0ba07b$var$apply$1(binder.unbind, bus),
        emit: emit
    });
}
function $86c9ea0cfb0ba07b$var$RequestInterval(interval, onInterval, onUpdate, limit) {
    var start = function start(resume) {
        !resume && cancel();
        startTime = now() - (resume ? rate * interval : 0);
        paused = false;
        $86c9ea0cfb0ba07b$var$raf(update);
    };
    var pause = function pause() {
        paused = true;
    };
    var rewind = function rewind() {
        startTime = now();
        rate = 0;
        if (onUpdate) onUpdate(rate);
    };
    var cancel = function cancel() {
        id && cancelAnimationFrame(id);
        rate = 0;
        id = 0;
        paused = true;
    };
    var set = function set(time) {
        interval = time;
    };
    var isPaused = function isPaused() {
        return paused;
    };
    var now = Date.now;
    var startTime;
    var rate = 0;
    var id;
    var paused = true;
    var count = 0;
    function update() {
        if (!paused) {
            rate = interval ? $86c9ea0cfb0ba07b$var$min$1((now() - startTime) / interval, 1) : 1;
            onUpdate && onUpdate(rate);
            if (rate >= 1) {
                onInterval();
                startTime = now();
                if (limit && ++count >= limit) return pause();
            }
            $86c9ea0cfb0ba07b$var$raf(update);
        }
    }
    return {
        start: start,
        rewind: rewind,
        pause: pause,
        cancel: cancel,
        set: set,
        isPaused: isPaused
    };
}
function $86c9ea0cfb0ba07b$var$Throttle(func, duration) {
    var throttled = function throttled() {
        if (!interval) {
            interval = $86c9ea0cfb0ba07b$var$RequestInterval(duration || 0, function() {
                func();
                interval = null;
            }, null, 1);
            interval.start();
        }
    };
    var interval;
    return throttled;
}
var $86c9ea0cfb0ba07b$var$CLASS_ACTIVE = "is-active";
var $86c9ea0cfb0ba07b$var$SLIDE = "slide";
var $86c9ea0cfb0ba07b$var$FADE = "fade";
function $86c9ea0cfb0ba07b$var$slice(arrayLike, start, end) {
    return Array.prototype.slice.call(arrayLike, start, end);
}
function $86c9ea0cfb0ba07b$var$apply(func) {
    var _func;
    return (_func = func).bind.apply(_func, [
        null
    ].concat((0, $2b6Uo._)($86c9ea0cfb0ba07b$var$slice(arguments, 1))));
}
function $86c9ea0cfb0ba07b$var$typeOf(type, subject) {
    return (typeof subject === "undefined" ? "undefined" : (0, $22yUM._)(subject)) === type;
}
function $86c9ea0cfb0ba07b$var$isObject(subject) {
    return !$86c9ea0cfb0ba07b$var$isNull(subject) && $86c9ea0cfb0ba07b$var$typeOf("object", subject);
}
var $86c9ea0cfb0ba07b$var$isArray = Array.isArray;
$86c9ea0cfb0ba07b$var$apply($86c9ea0cfb0ba07b$var$typeOf, "function");
$86c9ea0cfb0ba07b$var$apply($86c9ea0cfb0ba07b$var$typeOf, "string");
var $86c9ea0cfb0ba07b$var$isUndefined = $86c9ea0cfb0ba07b$var$apply($86c9ea0cfb0ba07b$var$typeOf, "undefined");
function $86c9ea0cfb0ba07b$var$isNull(subject) {
    return subject === null;
}
function $86c9ea0cfb0ba07b$var$toArray(value) {
    return $86c9ea0cfb0ba07b$var$isArray(value) ? value : [
        value
    ];
}
function $86c9ea0cfb0ba07b$var$forEach(values, iteratee) {
    $86c9ea0cfb0ba07b$var$toArray(values).forEach(iteratee);
}
function $86c9ea0cfb0ba07b$var$toggleClass(elm, classes, add) {
    if (elm) $86c9ea0cfb0ba07b$var$forEach(classes, function(name) {
        if (name) elm.classList[add ? "add" : "remove"](name);
    });
}
var $86c9ea0cfb0ba07b$var$ownKeys = Object.keys;
function $86c9ea0cfb0ba07b$var$forOwn(object, iteratee, right) {
    if (object) {
        var keys = $86c9ea0cfb0ba07b$var$ownKeys(object);
        keys = right ? keys.reverse() : keys;
        for(var i = 0; i < keys.length; i++){
            var key = keys[i];
            if (key !== "__proto__") {
                if (iteratee(object[key], key) === false) break;
            }
        }
    }
    return object;
}
function $86c9ea0cfb0ba07b$var$assign(object) {
    $86c9ea0cfb0ba07b$var$slice(arguments, 1).forEach(function(source) {
        $86c9ea0cfb0ba07b$var$forOwn(source, function(value, key) {
            object[key] = source[key];
        });
    });
    return object;
}
function $86c9ea0cfb0ba07b$var$removeAttribute(elms, attrs) {
    $86c9ea0cfb0ba07b$var$forEach(elms, function(elm) {
        $86c9ea0cfb0ba07b$var$forEach(attrs, function(attr) {
            elm && elm.removeAttribute(attr);
        });
    });
}
function $86c9ea0cfb0ba07b$var$setAttribute(elms, attrs, value) {
    if ($86c9ea0cfb0ba07b$var$isObject(attrs)) $86c9ea0cfb0ba07b$var$forOwn(attrs, function(value2, name) {
        $86c9ea0cfb0ba07b$var$setAttribute(elms, name, value2);
    });
    else $86c9ea0cfb0ba07b$var$forEach(elms, function(elm) {
        $86c9ea0cfb0ba07b$var$isNull(value) || value === "" ? $86c9ea0cfb0ba07b$var$removeAttribute(elm, attrs) : elm.setAttribute(attrs, String(value));
    });
}
var $86c9ea0cfb0ba07b$var$min = Math.min, $86c9ea0cfb0ba07b$var$max = Math.max, $86c9ea0cfb0ba07b$var$floor = Math.floor, $86c9ea0cfb0ba07b$var$ceil = Math.ceil, $86c9ea0cfb0ba07b$var$abs = Math.abs;
function $86c9ea0cfb0ba07b$var$clamp(number, x, y) {
    var minimum = $86c9ea0cfb0ba07b$var$min(x, y);
    var maximum = $86c9ea0cfb0ba07b$var$max(x, y);
    return $86c9ea0cfb0ba07b$var$min($86c9ea0cfb0ba07b$var$max(minimum, number), maximum);
}
var $86c9ea0cfb0ba07b$var$DEFAULTS = {
    speed: 1,
    autoStart: true,
    pauseOnHover: true,
    pauseOnFocus: true
};
var $86c9ea0cfb0ba07b$var$I18N = {
    startScroll: "Start auto scroll",
    pauseScroll: "Pause auto scroll"
};
function $86c9ea0cfb0ba07b$export$3fb39aee5567f02e(Splide2, Components2, options) {
    var setup = function setup() {
        var autoScroll = options.autoScroll;
        autoScrollOptions = $86c9ea0cfb0ba07b$var$assign({}, $86c9ea0cfb0ba07b$var$DEFAULTS, $86c9ea0cfb0ba07b$var$isObject(autoScroll) ? autoScroll : {});
    };
    var mount = function mount() {
        if (!Splide2.is($86c9ea0cfb0ba07b$var$FADE)) {
            if (!interval && options.autoScroll !== false) {
                interval = $86c9ea0cfb0ba07b$var$RequestInterval(0, move);
                listen();
                autoStart();
            }
        }
    };
    var destroy = function destroy() {
        if (interval) {
            interval.cancel();
            interval = null;
            currPosition = void 0;
            off([
                $86c9ea0cfb0ba07b$var$EVENT_MOVE,
                $86c9ea0cfb0ba07b$var$EVENT_DRAG,
                $86c9ea0cfb0ba07b$var$EVENT_SCROLL,
                $86c9ea0cfb0ba07b$var$EVENT_MOVED,
                $86c9ea0cfb0ba07b$var$EVENT_SCROLLED
            ]);
            unbind(root, "mouseenter mouseleave focusin focusout");
            unbind(toggle, "click");
        }
    };
    var listen = function listen() {
        if (autoScrollOptions.pauseOnHover) bind(root, "mouseenter mouseleave", function(e) {
            hovered = e.type === "mouseenter";
            autoToggle();
        });
        if (autoScrollOptions.pauseOnFocus) bind(root, "focusin focusout", function(e) {
            focused = e.type === "focusin";
            autoToggle();
        });
        if (autoScrollOptions.useToggleButton) bind(toggle, "click", function() {
            stopped ? play() : pause();
        });
        on($86c9ea0cfb0ba07b$var$EVENT_UPDATED, update);
        on([
            $86c9ea0cfb0ba07b$var$EVENT_MOVE,
            $86c9ea0cfb0ba07b$var$EVENT_DRAG,
            $86c9ea0cfb0ba07b$var$EVENT_SCROLL
        ], function() {
            busy = true;
            pause(false);
        });
        on([
            $86c9ea0cfb0ba07b$var$EVENT_MOVED,
            $86c9ea0cfb0ba07b$var$EVENT_DRAGGED,
            $86c9ea0cfb0ba07b$var$EVENT_SCROLLED
        ], function() {
            busy = false;
            autoToggle();
        });
    };
    var update = function update() {
        var autoScroll = options.autoScroll;
        if (autoScroll !== false) {
            autoScrollOptions = $86c9ea0cfb0ba07b$var$assign({}, autoScrollOptions, $86c9ea0cfb0ba07b$var$isObject(autoScroll) ? autoScroll : {});
            mount();
        } else destroy();
        if (interval && !$86c9ea0cfb0ba07b$var$isUndefined(currPosition)) translate(currPosition);
    };
    var autoStart = function autoStart() {
        if (autoScrollOptions.autoStart) {
            if (document.readyState === "complete") play();
            else bind(window, "load", play);
        }
    };
    var play = function play() {
        if (isPaused()) {
            interval.start(true);
            Live.disable(true);
            focused = hovered = stopped = false;
            updateButton();
        }
    };
    var pause = function pause() {
        var stop = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
        if (!stopped) {
            stopped = stop;
            updateButton();
            if (!isPaused()) {
                interval.pause();
                Live.disable(false);
            }
        }
    };
    var autoToggle = function autoToggle() {
        if (!stopped) hovered || focused || busy ? pause(false) : play();
    };
    var move = function move() {
        var position = getPosition();
        var destination = computeDestination(position);
        if (position !== destination) {
            translate(destination);
            updateIndex(currPosition = getPosition());
        } else {
            pause(false);
            if (autoScrollOptions.rewind) Splide2.go(autoScrollOptions.speed > 0 ? 0 : Components2.Controller.getEnd());
        }
        throttledUpdateArrows();
    };
    var computeDestination = function computeDestination(position) {
        var speed = autoScrollOptions.speed || 1;
        position += orient(speed);
        if (Splide2.is($86c9ea0cfb0ba07b$var$SLIDE)) position = $86c9ea0cfb0ba07b$var$clamp(position, getLimit(false), getLimit(true));
        return position;
    };
    var updateIndex = function updateIndex(position) {
        var length = Splide2.length;
        var index = (toIndex(position) + length) % length;
        if (index !== getIndex()) {
            setIndex(index);
            Components2.Slides.update();
            Components2.Pagination.update();
            options.lazyLoad === "nearby" && Components2.LazyLoad.check();
        }
    };
    var updateButton = function updateButton() {
        if (toggle) {
            var key = stopped ? "startScroll" : "pauseScroll";
            $86c9ea0cfb0ba07b$var$toggleClass(toggle, $86c9ea0cfb0ba07b$var$CLASS_ACTIVE, !stopped);
            $86c9ea0cfb0ba07b$var$setAttribute(toggle, "aria-label", options.i18n[key] || $86c9ea0cfb0ba07b$var$I18N[key]);
        }
    };
    var isPaused = function isPaused() {
        return !interval || interval.isPaused();
    };
    var _EventInterface = $86c9ea0cfb0ba07b$var$EventInterface(Splide2), on = _EventInterface.on, off = _EventInterface.off, bind = _EventInterface.bind, unbind = _EventInterface.unbind;
    var _Components2_Move = Components2.Move, translate = _Components2_Move.translate, getPosition = _Components2_Move.getPosition, toIndex = _Components2_Move.toIndex, getLimit = _Components2_Move.getLimit;
    var _Components2_Controller = Components2.Controller, setIndex = _Components2_Controller.setIndex, getIndex = _Components2_Controller.getIndex;
    var orient = Components2.Direction.orient;
    var toggle = Components2.Elements.toggle;
    var Live = Components2.Live;
    var root = Splide2.root;
    var throttledUpdateArrows = $86c9ea0cfb0ba07b$var$Throttle(Components2.Arrows.update, 500);
    var autoScrollOptions = {};
    var interval;
    var stopped;
    var hovered;
    var focused;
    var busy;
    var currPosition;
    return {
        setup: setup,
        mount: mount,
        destroy: destroy,
        play: play,
        pause: pause,
        isPaused: isPaused
    };
}


if (document.querySelectorAll(".imageswiper").length) {
    var $8cfad7ce32335808$var$splide = new (0, $15b6935538b1baf3$export$24494c7438c070bf)(".imageswiper", {
        type: "loop",
        drag: "free",
        focus: "center",
        perPage: 2.5,
        pauseOnFocus: false,
        gap: 10,
        autoScroll: {
            speed: 2,
            autoStart: true
        },
        breakpoints: {
            768: {
                perPage: 1
            },
            1200: {
                perPage: 1.5
            }
        }
    });
    $8cfad7ce32335808$var$splide.mount({
        AutoScroll: (0, $86c9ea0cfb0ba07b$export$3fb39aee5567f02e)
    });
}



})();
//# sourceMappingURL=modules.js.map
